webpackJsonp([1],{

/***/ "+tD/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UNASSIGNED_VALUE = exports.REMOVE_SELECT_VALUE = exports.COPY_SELECT_VALUE = exports.MOVE_SELECT_VALUE = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Components


// Actions


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _linguiCdn = __webpack_require__("siuH");

var _selectLabel = __webpack_require__("4H+z");

var _selectLabel2 = _interopRequireDefault(_selectLabel);

var _consoleActions = __webpack_require__("SC2c");

var _consoleActions2 = _interopRequireDefault(_consoleActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var MOVE_SELECT_VALUE = exports.MOVE_SELECT_VALUE = 'move';
var COPY_SELECT_VALUE = exports.COPY_SELECT_VALUE = 'copy';
var REMOVE_SELECT_VALUE = exports.REMOVE_SELECT_VALUE = 'remove';
var UNASSIGNED_VALUE = exports.UNASSIGNED_VALUE = '0';
var EMPTY_SELECT_VALUE = '';

function MoveListBody(props) {
    var _this = this;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var userId = props.userId,
        userGroupId = props.userGroupId,
        fullName = props.fullName,
        updateMoveStudentList = props.updateMoveStudentList,
        availableClasses = props.availableClasses,
        productId = props.productId,
        currentClassId = props.currentClassId,
        getAddStudentClasses = props.getAddStudentClasses,
        isSelectAllInUse = props.isSelectAllInUse,
        setIsSelectAllInUse = props.setIsSelectAllInUse;

    // Select variables

    var _useState = (0, _react.useState)(EMPTY_SELECT_VALUE),
        _useState2 = _slicedToArray(_useState, 2),
        actionDropdownValue = _useState2[0],
        setActionDropdownValue = _useState2[1];

    var _useState3 = (0, _react.useState)(EMPTY_SELECT_VALUE),
        _useState4 = _slicedToArray(_useState3, 2),
        classDropdownValue = _useState4[0],
        setClassDropdownValue = _useState4[1];

    var _useState5 = (0, _react.useState)(EMPTY_SELECT_VALUE),
        _useState6 = _slicedToArray(_useState5, 2),
        groupDropdownValue = _useState6[0],
        setGroupDropdownValue = _useState6[1];

    // Reset actions select if not "all Students" and "all student" is being used


    (0, _react.useEffect)(function () {
        if (userId !== 0 && isSelectAllInUse) {
            setActionDropdownValue(EMPTY_SELECT_VALUE);
        }
    }, [isSelectAllInUse]);

    // DEFAULT VALUES
    var DEFAULT_CLASS_VALUE = {
        id: EMPTY_SELECT_VALUE,
        name: i18n._( /*i18n*/{
            id: 'Move Modal - select classes default'
        })
    };
    var DEFAULT_GROUP_VALUE = {
        id: EMPTY_SELECT_VALUE,
        name: i18n._( /*i18n*/{
            id: 'Move Modal - select groups default'
        })
    };

    // Select - dropdown values
    var actionsList = [{ value: EMPTY_SELECT_VALUE, label: i18n._( /*i18n*/{
            id: 'Move Modal - select actions default'
        }) }, { value: MOVE_SELECT_VALUE, label: i18n._( /*i18n*/{
            id: 'Move Modal - select actions move'
        }) }, { value: COPY_SELECT_VALUE, label: i18n._( /*i18n*/{
            id: 'Move Modal - select actions copy'
        }) }, { value: REMOVE_SELECT_VALUE, label: i18n._( /*i18n*/{
            id: 'Move Modal - select actions remove'
        }) }];

    var _useState7 = (0, _react.useState)([DEFAULT_CLASS_VALUE]),
        _useState8 = _slicedToArray(_useState7, 2),
        classesList = _useState8[0],
        setClassesList = _useState8[1];

    var _useState9 = (0, _react.useState)([DEFAULT_GROUP_VALUE]),
        _useState10 = _slicedToArray(_useState9, 2),
        groupsList = _useState10[0],
        setGroupsList = _useState10[1];

    var _useState11 = (0, _react.useState)(true),
        _useState12 = _slicedToArray(_useState11, 2),
        isGroupListDisabled = _useState12[0],
        setIsGroupListDisabled = _useState12[1];

    var isAllStudentsLine = userId === 0;

    // Handlers
    var selectHandlerActions = function selectHandlerActions(e) {
        var actionValue = e.target.value;
        setActionDropdownValue(actionValue);

        // In case user deals with "All students" select
        if (isAllStudentsLine) {
            setIsSelectAllInUse(true);
        }
        updateMoveStudentList({
            userId: userId,
            actionType: actionValue,
            isForAllStudents: isAllStudentsLine
        });
    };

    var selectHandlerClasses = function selectHandlerClasses(e) {
        var classValue = e.target.value;
        setClassDropdownValue(classValue);

        if (classValue === UNASSIGNED_VALUE) {
            updateMoveStudentList({
                userId: userId,
                actionType: actionDropdownValue,
                actionProperties: {
                    destinationClassId: classValue,
                    destinationGroupId: userGroupId
                },
                isForAllStudents: isAllStudentsLine
            });
        }
    };
    var selectHandlerGroups = function selectHandlerGroups(e) {
        var groupValue = e.target.value;
        setGroupDropdownValue(groupValue);
        updateMoveStudentList({
            userId: userId,
            actionType: actionDropdownValue,
            actionProperties: {
                destinationClassId: classDropdownValue,
                destinationGroupId: groupValue
            },
            isForAllStudents: isAllStudentsLine
        });
    };

    // Fetch the group resources
    (0, _react.useEffect)(function () {
        var isCancelled = false;
        var fetchStudentClasses = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var newStudentClassData, classGroups, revisedClassGroups, filteredGroups;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return getAddStudentClasses({
                                    productId: productId,
                                    classId: classDropdownValue
                                });

                            case 2:
                                newStudentClassData = _context.sent;
                                classGroups = newStudentClassData.classGroups;

                                // To make the classgroups object suitable for select box input

                                revisedClassGroups = classGroups.map(function (item) {
                                    return { id: item.groupId, name: item.name };
                                });

                                if (!isCancelled && newStudentClassData) {
                                    // Remove the item that has the id of 0, which indicates "all groups"
                                    filteredGroups = revisedClassGroups.filter(function (group) {
                                        return group.id !== 0;
                                    });

                                    // Set the appropriate data for Student Management

                                    setGroupsList([DEFAULT_GROUP_VALUE].concat(_toConsumableArray(filteredGroups)));
                                    setIsGroupListDisabled(false);
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function fetchStudentClasses() {
                return _ref.apply(this, arguments);
            };
        }();

        // Reset the group dropdown value whenever the class value changes
        setGroupDropdownValue(EMPTY_SELECT_VALUE);

        // For the case when the value of the classDropdownValue is unassigned, disable the group list dropdown
        if (classDropdownValue === UNASSIGNED_VALUE) {
            setIsGroupListDisabled(true);
            setGroupsList([DEFAULT_GROUP_VALUE]);
        } else if (classDropdownValue !== EMPTY_SELECT_VALUE) {
            fetchStudentClasses();
        }

        return function () {
            isCancelled = true;
        };
    }, [classDropdownValue]);

    (0, _react.useEffect)(function () {
        // Reset the class/group dropdown so that they have to go back and change their preferences
        setClassDropdownValue(EMPTY_SELECT_VALUE);
        setGroupDropdownValue(EMPTY_SELECT_VALUE);

        // To make the available classlist object suitable for select box input
        var revisedAvailableClasses = availableClasses.map(function (item) {
            return { id: item.classId, name: item.name };
        });
        // If it's either a MOVE or copy, change the class list
        switch (actionDropdownValue) {
            case MOVE_SELECT_VALUE:
                {
                    /**
                     * MOVE must include the current class, as the user can move around the student in the
                     * current class instead of changing a group one-by-one
                     */
                    var filteredAvailableClasses = revisedAvailableClasses.filter(function (item) {
                        return item.id !== parseInt(UNASSIGNED_VALUE, 10);
                    });
                    setClassesList([DEFAULT_CLASS_VALUE].concat(_toConsumableArray(filteredAvailableClasses)));
                    break;
                }
            case COPY_SELECT_VALUE:
                {
                    // COPY must NOT include the current class
                    var _filteredAvailableClasses = revisedAvailableClasses.filter(function (item) {
                        return item.id !== currentClassId && item.id !== parseInt(UNASSIGNED_VALUE, 10);
                    });
                    setClassesList([DEFAULT_CLASS_VALUE].concat(_toConsumableArray(_filteredAvailableClasses)));
                    break;
                }
            default:
        }
    }, [actionDropdownValue, availableClasses]);

    var additionalClassName = userId === 0 ? 'table__row--all-students' : '';
    var displayName = fullName === ', ' ? i18n._( /*i18n*/{
        id: 'Move Modal - For all students'
    }) : fullName;
    return _react2.default.createElement(
        'tr',
        { className: 'table__row ' + additionalClassName },
        _react2.default.createElement(
            'td',
            { className: 'table__cell table__cell--name' },
            _react2.default.createElement(
                'span',
                { title: displayName, className: 'text-ellipsis' },
                displayName
            )
        ),
        _react2.default.createElement(
            'td',
            { className: 'table__cell table__cell--actions' },
            _react2.default.createElement(_selectLabel2.default, {
                id: 'move-actions-' + userId,
                srLabel: i18n._( /*i18n*/{
                    id: 'Move Modal - select actions label'
                }) + ' ' + displayName,
                listOfOptions: actionsList,
                propertyName: 'value',
                visibleProperty: 'label',
                value: actionDropdownValue,
                isSelectDisabled: userId !== 0 && isSelectAllInUse,
                selectHandler: selectHandlerActions })
        ),
        actionDropdownValue === REMOVE_SELECT_VALUE ? _react2.default.createElement(
            'td',
            { colSpan: 2, className: 'table__cell table__cell--actions' },
            _react2.default.createElement(_react3.Trans, { id: 'Move Modal - select remove info' })
        ) : _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'td',
                { className: 'table__cell table__cell--actions table__cell--class-detail' },
                _react2.default.createElement(_selectLabel2.default, {
                    id: 'move-classes-' + userId,
                    srLabel: i18n._( /*i18n*/{
                        id: 'Move Modal - select classes label'
                    }) + ' ' + displayName,
                    listOfOptions: classesList,
                    propertyName: 'id',
                    visibleProperty: 'name',
                    value: classDropdownValue,
                    isSelectDisabled: actionDropdownValue === EMPTY_SELECT_VALUE,
                    selectHandler: selectHandlerClasses })
            ),
            _react2.default.createElement(
                'td',
                { className: 'table__cell table__cell--actions table__cell--class-detail' },
                _react2.default.createElement(_selectLabel2.default, {
                    id: 'move-groups-' + userId,
                    srLabel: i18n._( /*i18n*/{
                        id: 'Move Modal - select groups label'
                    }) + ' ' + displayName,
                    listOfOptions: groupsList,
                    propertyName: 'id',
                    visibleProperty: 'name',
                    value: groupDropdownValue,
                    isSelectDisabled: actionDropdownValue === EMPTY_SELECT_VALUE || classDropdownValue === EMPTY_SELECT_VALUE || isGroupListDisabled,
                    selectHandler: selectHandlerGroups })
            )
        )
    );
}

MoveListBody.propTypes = {
    userId: _propTypes2.default.number,
    userGroupId: _propTypes2.default.number,
    fullName: _propTypes2.default.string,
    updateMoveStudentList: _propTypes2.default.func,
    availableClasses: _propTypes2.default.array,
    // State
    productId: _propTypes2.default.number,
    currentClassId: _propTypes2.default.number,
    // Action functions
    getAddStudentClasses: _propTypes2.default.func,
    isSelectAllInUse: _propTypes2.default.bool,
    setIsSelectAllInUse: _propTypes2.default.func
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from MessageModalCombinedReducers.
 */
function mapStateToProps(state) {
    var _state$consoleReducer = state.consoleReducer,
        productId = _state$consoleReducer.productId,
        currentClassId = _state$consoleReducer.currentClassId;


    return {
        productId: productId,
        currentClassId: currentClassId
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getAddStudentClasses: _consoleActions2.default.getAddStudentClasses,
        getAddStudentDetails: _consoleActions2.default.getAddStudentDetails,
        assignClassStudent: _consoleActions2.default.assignClassStudent
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MoveListBody);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "+x4p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Styles


// Components


// Context


// Helpers


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _linguiCdn = __webpack_require__("siuH");

__webpack_require__("UalU");

var _groupActions = __webpack_require__("e4+b");

var _form = __webpack_require__("oS56");

var _form2 = _interopRequireDefault(_form);

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _checkbox = __webpack_require__("0yfC");

var _checkbox2 = _interopRequireDefault(_checkbox);

var _selectCourse = __webpack_require__("e1q7");

var _selectCourse2 = _interopRequireDefault(_selectCourse);

var _schoolCourseContext = __webpack_require__("3C3e");

var _schoolCourseContext2 = _interopRequireDefault(_schoolCourseContext);

var _enums = __webpack_require__("royT");

var _utils = __webpack_require__("6QRH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function GroupModal(props) {
    var _this = this;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    // Props


    var currentId = props.currentId,
        productId = props.productId,
        initialName = props.initialName,
        saveHandler = props.saveHandler,
        closeHandler = props.closeHandler,
        deleteHandler = props.deleteHandler,
        inputId = props.inputId,
        showDeleteButton = props.showDeleteButton,
        setCountryHandler = props.setCountryHandler,
        countrySelectValue = props.countrySelectValue,
        countrySelectOptions = props.countrySelectOptions,
        setYearHandler = props.setYearHandler,
        yearSelectValue = props.yearSelectValue,
        yearSelectOptions = props.yearSelectOptions,
        setCourseHandler = props.setCourseHandler,
        courseSelectValue = props.courseSelectValue,
        courseSelectOptions = props.courseSelectOptions,
        setUPFCourseHandler = props.setUPFCourseHandler,
        upfCourseSelectValue = props.upfCourseSelectValue,
        upfCourseSelectOptions = props.upfCourseSelectOptions,
        setNewCourseHandler = props.setNewCourseHandler,
        newCourseSelectValue = props.newCourseSelectValue,
        newCourseSelectOptions = props.newCourseSelectOptions,
        showNewCourses = props.showNewCourses,
        isNewGroup = props.isNewGroup;

    // State variables

    var _useState = (0, _react.useState)(''),
        _useState2 = _slicedToArray(_useState, 2),
        name = _useState2[0],
        setName = _useState2[1];

    var _useState3 = (0, _react.useState)(null),
        _useState4 = _slicedToArray(_useState3, 2),
        errorMessage = _useState4[0],
        setErrorMessage = _useState4[1];

    var _useState5 = (0, _react.useState)(null),
        _useState6 = _slicedToArray(_useState5, 2),
        bottomErrorMessage = _useState6[0],
        setBottomErrorMessage = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        _useState8 = _slicedToArray(_useState7, 2),
        isDeleteButtonDisabled = _useState8[0],
        setIsDeleteButtonDisabled = _useState8[1];

    var trimmedName = name.trim();

    var _useState9 = (0, _react.useState)(false),
        _useState10 = _slicedToArray(_useState9, 2),
        newCoursesAvailable = _useState10[0],
        setNewCoursesAvailable = _useState10[1];

    // School Course Related


    var _useContext = (0, _react.useContext)(_schoolCourseContext2.default),
        groupCountryCode = _useContext.groupCountryCode,
        isSchoolCoursesEnabled = _useContext.isSchoolCoursesEnabled,
        setIsSchoolCoursesEnabled = _useContext.setIsSchoolCoursesEnabled;

    var schoolCourseClickHandler = function schoolCourseClickHandler() {
        setIsSchoolCoursesEnabled(function (prevState) {
            return !prevState;
        });
    };

    // Effects
    (0, _react.useEffect)(function () {
        setName(initialName);
    }, [initialName]);

    (0, _react.useEffect)(function () {
        var country = isSchoolCoursesEnabled ? groupCountryCode : countrySelectValue;
        setNewCoursesAvailable((0, _utils.areNewCoursesAvailable)(yearSelectValue, country));
    }, [yearSelectValue, countrySelectValue, isSchoolCoursesEnabled]);

    // Handlers
    var localInputHandler = function localInputHandler(e) {
        // Reset the error messages
        if (errorMessage !== null) {
            setErrorMessage(null);
        }
        if (bottomErrorMessage !== null) {
            setBottomErrorMessage(null);
        }

        // Otherwise continue forward
        var newName = e.target.value;
        setName(newName);
    };
    var localSaveHandler = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
            var value, message, _message;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            // Prevent redirect from the default behaviour of a form
                            e.preventDefault();

                            _context.next = 3;
                            return saveHandler({
                                name: trimmedName
                            });

                        case 3:
                            value = _context.sent;

                            if (!(value && value.status === 500)) {
                                _context.next = 9;
                                break;
                            }

                            message = _react2.default.createElement(_react3.Trans, { id: 'Error Message - Unable to proceed' });

                            setBottomErrorMessage(message);
                            _context.next = 15;
                            break;

                        case 9:
                            if (!(value === true)) {
                                _context.next = 14;
                                break;
                            }

                            _context.next = 12;
                            return closeHandler();

                        case 12:
                            _context.next = 15;
                            break;

                        case 14:
                            if (value && value.message) {
                                _message = (0, _utils.getCorrectErrorMessage)(value, i18n);

                                setErrorMessage(_message);
                            }

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function localSaveHandler(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    var localDeleteHandler = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var value;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return deleteHandler();

                        case 2:
                            value = _context2.sent;

                            if (!(value && value.code === _enums.ERROR_CODES.UnexpectedResponseContent)) {
                                _context2.next = 9;
                                break;
                            }

                            _context2.next = 6;
                            return setBottomErrorMessage(_react2.default.createElement(_react3.Trans, { id: 'Group Modal - label - delete error - existing students' }));

                        case 6:
                            setIsDeleteButtonDisabled(true);
                            _context2.next = 12;
                            break;

                        case 9:
                            if (!(value && value.status === 500)) {
                                _context2.next = 12;
                                break;
                            }

                            _context2.next = 12;
                            return setBottomErrorMessage(i18n._( /*i18n*/{
                                id: 'Error Message - Unable to proceed'
                            }));

                        case 12:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function localDeleteHandler() {
            return _ref2.apply(this, arguments);
        };
    }();

    var isSelectDropdownDisabled = function isSelectDropdownDisabled(values, propertyName) {
        return values[0][propertyName] === '' && values.length === 1;
    };

    // Creating a list of components in the form
    var countrySelectComponent = _react2.default.createElement(_selectCourse2.default, {
        id: 'select-country-' + currentId,
        importedClasses: 'select-group',
        handler: setCountryHandler,
        isDisabled: isSchoolCoursesEnabled,
        title: _react2.default.createElement(_react3.Trans, { id: 'Group Modal - label - Select country' }),
        value: countrySelectValue,
        options: countrySelectOptions,
        selectLabelProps: {
            propertyName: 'code'
        }
    });
    var yearSelectComponent = _react2.default.createElement(_selectCourse2.default, {
        id: 'select-grade-' + currentId,
        importedClasses: 'select-group',
        handler: setYearHandler,
        isDisabled: isSelectDropdownDisabled(yearSelectOptions, 'yearGroupId'),
        title: _react2.default.createElement(_react3.Trans, { id: 'Group Modal - label - Select course grade' }),
        value: yearSelectValue,
        options: yearSelectOptions,
        selectLabelProps: {
            propertyName: 'yearGroupEnum',
            visibleProperty: 'longName'
        }
    });
    var upfCourseSelectComponent = _react2.default.createElement(_selectCourse2.default, {
        id: 'select-upfcourse-' + currentId,
        importedClasses: 'select-group',
        handler: setUPFCourseHandler,
        isDisabled: upfCourseSelectOptions.length === 1,
        title: _react2.default.createElement(_react3.Trans, { id: 'Group Modal - label - Skill Quests' }),
        value: upfCourseSelectValue,
        isRequired: false,
        options: upfCourseSelectOptions,
        selectLabelProps: {
            propertyName: 'id'
        }
    });

    var newCourseSelectComponent = _react2.default.createElement(_selectCourse2.default, {
        id: 'select-newcourse-' + currentId,
        importedClasses: 'select-group',
        handler: setNewCourseHandler,
        isDisabled: newCourseSelectOptions.length === 1 && newCoursesAvailable || !newCoursesAvailable,
        title: _react2.default.createElement(_react3.Trans, { id: 'Group Modal - label - New Course' }),
        value: newCourseSelectValue,
        isRequired: newCoursesAvailable,
        options: newCourseSelectOptions,
        selectLabelProps: {
            propertyName: 'id'
        }
    });

    var courseSelectComponent = _react2.default.createElement(_selectCourse2.default, {
        id: 'select-course-' + currentId,
        importedClasses: 'select-group',
        handler: setCourseHandler,
        isDisabled: isSelectDropdownDisabled(courseSelectOptions, 'id'),
        title: _react2.default.createElement(_react3.Trans, { id: 'Group Modal - label - Select course' }),
        value: courseSelectValue,
        options: courseSelectOptions,
        selectLabelProps: {
            propertyName: 'id'
        }
    });
    var inputNameComponent = _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            'label',
            { htmlFor: inputId, className: 'edit-group-input' },
            _react2.default.createElement(_react3.Trans, { id: 'Group Modal - label - group name' })
        ),
        _react2.default.createElement('input', {
            id: inputId,
            className: 'form__input',
            autoComplete: 'off'
            // eslint-disable-next-line jsx-a11y/no-autofocus
            , autoFocus: true,
            required: true,
            placeholder: i18n._( /*i18n*/{
                id: 'Group Modal - new - name placeholder'
            }),
            maxLength: _enums.CONFIG_VARS.groupNameMaxLength,
            value: name,
            onChange: localInputHandler })
    );

    /**
     * This particular component is only shown for Mathletics, this particular user story mentions that Readiwriter
     * is excluded from seeing this display school courses section. As outlined below:
     *      - https://mathletics.atlassian.net/browse/RR-1186
     */
    var displaySchoolCourseComponent = productId === _enums.PRODUCT_IDS.Mathletics ? _react2.default.createElement(
        'div',
        { className: 'form__row flex-grid flex-grid--split' },
        _react2.default.createElement(
            'span',
            { className: 'form__label edit-group-input' },
            _react2.default.createElement(_react3.Trans, { id: 'Group Modal - label - group course' })
        ),
        _react2.default.createElement(_checkbox2.default, {
            isEditGroupCheckBox: true,
            key: 'school-courses-' + currentId,
            uid: 'school-courses-' + currentId,
            inputType: _checkbox.LABEL_STYLES.visible,
            isChecked: isSchoolCoursesEnabled,
            callback: schoolCourseClickHandler,
            labelText: _react2.default.createElement(_react3.Trans, { id: 'Group Modal - label - Display school courses' })
        })
    ) : '';

    // Disabled variables
    var isSchoolCourseAvailable = isSchoolCoursesEnabled ? isSchoolCoursesEnabled === true && yearSelectValue !== '' && courseSelectValue !== '' : countrySelectValue !== '' && isSchoolCoursesEnabled === false;

    var isEmpty = function isEmpty(v) {
        return v === '' || v === undefined;
    };

    var isSubmitButtonDisabled = isEmpty(trimmedName) || !isSchoolCourseAvailable || isEmpty(yearSelectValue) || isEmpty(courseSelectValue) || newCoursesAvailable && showNewCourses && newCourseSelectOptions.length > 1 && (isEmpty(newCourseSelectValue) || newCourseSelectValue === _groupActions.DEFAULT_NEW_COURSE_ID) || upfCourseSelectOptions.length > 1 && isEmpty(upfCourseSelectValue);

    return _react2.default.createElement(
        _form2.default,
        { formHandler: localSaveHandler },
        _react2.default.createElement(
            'div',
            { className: 'form__row' },
            inputNameComponent
        ),
        errorMessage ? _react2.default.createElement(
            'div',
            { className: 'form__row' },
            _react2.default.createElement(
                'p',
                { className: 'form__error-message' },
                errorMessage
            )
        ) : '',
        _react2.default.createElement('hr', { className: 'divider' }),
        displaySchoolCourseComponent,
        _react2.default.createElement(
            'div',
            { className: 'flex-grid flex-grid--occupy' },
            _react2.default.createElement(
                'div',
                { className: 'form__row form__row--selects' },
                countrySelectComponent
            ),
            _react2.default.createElement(
                'div',
                { className: 'form__row form__row--selects' },
                yearSelectComponent
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'form__row' },
            _react2.default.createElement(
                'h3',
                { className: 'form__title form__title--section modal__edit-groups' },
                _react2.default.createElement(_react3.Trans, { id: 'Group Modal - label - Default Courses' })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'flex-grid flex-grid--occupy' },
            _react2.default.createElement(
                'div',
                { className: 'form__row' },
                courseSelectComponent
            ),
            showNewCourses ? _react2.default.createElement(
                'div',
                { className: 'form__row' },
                newCourseSelectComponent
            ) : '',
            productId === _enums.PRODUCT_IDS.Mathletics ? _react2.default.createElement(
                'div',
                { className: 'form__row' },
                upfCourseSelectComponent
            ) : ''
        ),
        _react2.default.createElement(
            'div',
            { className: 'form__row form__row--buttons' },
            showDeleteButton ? _react2.default.createElement(_button2.default, {
                showDeleteButton: true,
                isEditGroupCheckBox: true,
                visibleText: _react2.default.createElement(_react3.Trans, { id: 'Group Modal - Delete' }),
                isBtnDisabled: isDeleteButtonDisabled,
                importedClasses: 'button--error',
                callback: localDeleteHandler
            }) : '',
            _react2.default.createElement(_button2.default, {
                isEditGroupCheckBox: true,
                visibleText: isNewGroup ? _react2.default.createElement(_react3.Trans, { id: 'Groups - New group' }) : _react2.default.createElement(_react3.Trans, { id: 'Group Modal - Save' }),
                isBtnDisabled: isSubmitButtonDisabled,
                buttonType: 'submit'
            })
        ),
        bottomErrorMessage ? _react2.default.createElement(
            'div',
            { className: 'form__row' },
            _react2.default.createElement(
                'p',
                { className: 'form__error-message form__error-message--bottom' },
                bottomErrorMessage
            )
        ) : ''
    );
}

GroupModal.propTypes = {
    productId: _propTypes2.default.number.isRequired,
    currentId: _propTypes2.default.number,
    initialName: _propTypes2.default.string.isRequired,
    inputId: _propTypes2.default.string.isRequired,
    closeHandler: _propTypes2.default.func.isRequired,
    saveHandler: _propTypes2.default.func.isRequired,
    deleteHandler: _propTypes2.default.func,
    showDeleteButton: _propTypes2.default.bool,
    // Course Specific
    setCountryHandler: _propTypes2.default.func.isRequired,
    countrySelectValue: _propTypes2.default.string.isRequired,
    countrySelectOptions: _propTypes2.default.array.isRequired,
    setYearHandler: _propTypes2.default.func.isRequired,
    yearSelectValue: _propTypes2.default.string.isRequired,
    yearSelectOptions: _propTypes2.default.array.isRequired,
    setCourseHandler: _propTypes2.default.func.isRequired,
    courseSelectValue: _propTypes2.default.string.isRequired,
    courseSelectOptions: _propTypes2.default.array.isRequired,
    setUPFCourseHandler: _propTypes2.default.func.isRequired,
    upfCourseSelectValue: _propTypes2.default.string,
    upfCourseSelectOptions: _propTypes2.default.array,
    setNewCourseHandler: _propTypes2.default.func.isRequired,
    newCourseSelectValue: _propTypes2.default.string,
    newCourseSelectOptions: _propTypes2.default.array,
    showNewCourses: _propTypes2.default.bool,
    isNewGroup: _propTypes2.default.bool
};

exports.default = GroupModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "/T4H":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/903a54f9a912b96b3fb05c94240ccb6c.svg";

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "08kL":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".radio-button {\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  width: calc(2px + 1em);\n  height: calc(2px + 1em);\n  opacity: 0; }\n  .radio-button__item {\n    display: inline-block;\n    position: relative;\n    margin-left: 0.5em;\n    min-height: 1em;\n    padding-left: 1em;\n    line-height: calc(2px + 1em); }\n  .radio-button__item--disabled .radio-button__label-text {\n      opacity: 0.4; }\n  .radio-button__label {\n    display: inline-block;\n    padding: 0 0.33333em; }\n  .radio-button__label::before {\n      position: absolute;\n      left: 0;\n      top: 0;\n      border: 1px solid #c2c2c2;\n      border-radius: 50%;\n      width: 1em;\n      height: 1em;\n      background-color: transparent;\n      content: ''; }\n  .radio-button__label::after {\n      position: absolute;\n      left: calc(0.16667em + 1px);\n      top: calc(0.16667em + 1px);\n      border-radius: 50%;\n      width: 0.66667em;\n      height: 0.66667em;\n      background-color: currentColor;\n      opacity: 0;\n      content: ''; }\n  .radio-button:not(:disabled):hover + .radio-button__label::before,\n    .radio-button:not(:disabled):focus + .radio-button__label::before {\n      border-color: #000; }\n  .radio-button:not(:disabled):active + .radio-button__label::before {\n      border-color: #374e60;\n      background-color: #374e60; }\n  .radio-button:not(:disabled):checked + .radio-button__label::after {\n      background-color: #00a5ff;\n      opacity: 1; }\n  .radio-button:disabled:checked + .radio-button__label::after {\n      background-color: #00a5ff;\n      opacity: 0.4; }\n  .radio-button:not(:disabled):checked:active + .radio-button__label::after {\n      background-color: #fff; }\n", ""]);
// Exports
exports.locals = {
	"radio-button": "radio-button",
	"radio-button__item": "radio-button__item",
	"radio-button__item--disabled": "radio-button__item--disabled",
	"radio-button__label-text": "radio-button__label-text",
	"radio-button__label": "radio-button__label"
};
module.exports = exports;


/***/ }),

/***/ "0TaB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Styles


// Components


// Context


// Helpers


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

__webpack_require__("SxYr");

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _genericModal = __webpack_require__("51N/");

var _genericModal2 = _interopRequireDefault(_genericModal);

var _addStudents = __webpack_require__("ffwl");

var _addStudents2 = _interopRequireDefault(_addStudents);

var _consoleModalContext = __webpack_require__("U07W");

var _consoleModalContext2 = _interopRequireDefault(_consoleModalContext);

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _portalCommunications = __webpack_require__("DMUb");

var _portalCommunications2 = _interopRequireDefault(_portalCommunications);

var _utils = __webpack_require__("6QRH");

var _useIsOneRosterActivatedSchool = __webpack_require__("rSj7");

var _useIsOneRosterActivatedSchool2 = _interopRequireDefault(_useIsOneRosterActivatedSchool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function ActionList(_ref) {
    var _this = this;

    var forwardRef = _ref.forwardRef,
        studentsLength = _ref.studentsLength,
        currentClassName = _ref.currentClassName,
        currentClassId = _ref.currentClassId,
        closeActionList = _ref.closeActionList,
        exportStudents = _ref.exportStudents,
        isSisSchool = _ref.isSisSchool;

    var _useContext = (0, _react.useContext)(_consoleModalContext2.default),
        showConsoleModal = _useContext.showConsoleModal,
        setShowConsoleModal = _useContext.setShowConsoleModal,
        setConsoleModalContent = _useContext.setConsoleModalContent;
    // Configuration item for the certificate module, which is being configured in the config manager


    var _useState = (0, _react.useState)(null),
        _useState2 = _slicedToArray(_useState, 2),
        certificateModuleId = _useState2[0],
        setCertificateModuleId = _useState2[1];

    var isOneRosterActivatedSchool = (0, _useIsOneRosterActivatedSchool2.default)();

    // ComponentDidMount
    (0, _react.useEffect)(function () {
        // retrieve the value for girl ids for the info modal
        var retrieveConfigItem = function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var configValue;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _resources2.default.getConfigurationItem('CertificateModuleId');

                            case 2:
                                configValue = _context.sent;

                                setCertificateModuleId(configValue);

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function retrieveConfigItem() {
                return _ref2.apply(this, arguments);
            };
        }();

        retrieveConfigItem();
    }, []);

    // Add Students Modal
    var closeAddModal = function closeAddModal() {
        setShowConsoleModal(false);
    };
    var titleTrans = function titleTrans() {
        return isOneRosterActivatedSchool ? _react2.default.createElement(_react3.Trans, { id: 'Move/Copy Modal - Title' }) : _react2.default.createElement(_react3.Trans, { id: 'Move/Copy Modal - Title - {currentClassName}', defaults: 'placeholderMessage {currentClassName}',
            values: {
                currentClassName: currentClassName
            }
        });
    };
    var showAddModal = function showAddModal() {
        setShowConsoleModal(!showConsoleModal);
        setConsoleModalContent(_react2.default.createElement(
            _genericModal2.default,
            {
                title: titleTrans(),
                closeHandler: closeAddModal,
                parentClasses: 'add-students',
                isOneRosterActivatedSchool: isOneRosterActivatedSchool,
                type: _genericModal.MODAL_TYPE.floating },
            _react2.default.createElement(_addStudents2.default, {
                currentClassId: currentClassId
            })
        ));
        closeActionList();
    };

    var certificatesCallback = function certificatesCallback() {
        if (certificateModuleId !== null) {
            var productId = (0, _utils.getParam)('productId');
            var productKey = 'product-' + productId;
            _portalCommunications2.default.requestModuleChange(certificateModuleId[productKey], {
                productId: productId
            });
        }
    };

    var moveCopyStudentsOption = function moveCopyStudentsOption() {
        if (isSisSchool) return null;

        return _react2.default.createElement(
            'li',
            { className: 'action-list__item' },
            _react2.default.createElement(_button2.default, {
                importedClasses: 'action-list__button',
                buttonStyle: _button.BUTTON_STYLES.iconText,
                iconName: 'movecopy',
                callback: showAddModal,
                visibleText: _react2.default.createElement(_react3.Trans, { id: 'Action List - Move/Copy Students' }) })
        );
    };

    return _react2.default.createElement(
        'ul',
        { ref: forwardRef, className: 'action-list' },
        _react2.default.createElement(
            'li',
            { className: 'action-list__item' },
            _react2.default.createElement(_button2.default, {
                importedClasses: 'action-list__button action-list__button--excel',
                buttonStyle: _button.BUTTON_STYLES.iconText,
                iconName: 'excel',
                isBtnDisabled: studentsLength === 0,
                visibleText: _react2.default.createElement(_react3.Trans, { id: 'Action List - Excel' }),
                callback: exportStudents })
        ),
        moveCopyStudentsOption(),
        _react2.default.createElement(
            'li',
            { className: 'action-list__item' },
            _react2.default.createElement(_button2.default, {
                importedClasses: 'action-list__button',
                buttonStyle: _button.BUTTON_STYLES.iconText,
                iconName: 'certificates',
                visibleText: _react2.default.createElement(_react3.Trans, { id: 'Action List - Certificates' }),
                callback: certificatesCallback
            })
        )
    );
}

ActionList.propTypes = {
    forwardRef: _propTypes2.default.any,
    studentsLength: _propTypes2.default.number,
    currentClassName: _propTypes2.default.string,
    currentClassId: _propTypes2.default.number,
    closeActionList: _propTypes2.default.func,
    exportStudents: _propTypes2.default.func,
    isSisSchool: _propTypes2.default.bool
};

exports.default = _react2.default.forwardRef(function (props, ref) {
    return _react2.default.createElement(ActionList, _extends({ forwardRef: ref }, props));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "0WBn":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/25b09596a1a720b806ba472ae718480c.svg";

/***/ }),

/***/ "0X7W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _utils = __webpack_require__("6QRH");

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _threeEssentailsButton = __webpack_require__("Lgqb");

var _threeEssentailsButton2 = _interopRequireDefault(_threeEssentailsButton);

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var SignInCardsButton = function SignInCardsButton(_ref) {
    var isOneRosterActivatedSchool = _ref.isOneRosterActivatedSchool,
        classGroupStudents = _ref.classGroupStudents,
        numOfSelectedStudents = _ref.numOfSelectedStudents,
        hasStudents = _ref.hasStudents,
        openModal = _ref.openModal;

    var downloadOneRosterSignInCards = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _resources2.default.getConfigurationItem('THREE_ESSENTIALS_SIGN_IN_CARDS').then(function (signInUrl) {
                                var uidsQueryString = classGroupStudents.map(function (_ref3) {
                                    var oneRosterUserId = _ref3.oneRosterUserId;
                                    return 'uids[]=' + encodeURIComponent(oneRosterUserId);
                                }).join('&');
                                var fullUrl = signInUrl + '?' + uidsQueryString;
                                window.open(fullUrl);
                            });

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function downloadOneRosterSignInCards() {
            return _ref2.apply(this, arguments);
        };
    }();

    var pluralLabel = _react2.default.createElement(_react3.Trans, {
        id: 'Footer - download sign-in - button title - {numOfSelectedStudents}',
        defaults: '{numOfSelectedStudents, plural, =0 {Download sign-in cards} one {Download sign-in cards (#)} other {Download sign-in cards (#)}}',
        values: {
            numOfSelectedStudents: numOfSelectedStudents
        }
    });

    if (isOneRosterActivatedSchool) {
        return _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(_threeEssentailsButton2.default, {
                clickHandler: downloadOneRosterSignInCards,
                title: pluralLabel,
                show3EIcon: (0, _utils.isValidMarketRegion)(),
                buttonClassName: 'footer-download'
            })
        );
    }

    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_button2.default, {
            buttonStyle: _button.BUTTON_STYLES.iconText,
            iconName: 'download',
            isBtnDisabled: !hasStudents,
            visibleText: pluralLabel,
            importedClasses: 'footer__button',
            callback: openModal
        })
    );
};

SignInCardsButton.propTypes = {
    isOneRosterActivatedSchool: _propTypes2.default.bool.isRequired,
    classGroupStudents: _propTypes2.default.array.isRequired,
    numOfSelectedStudents: _propTypes2.default.number.isRequired,
    hasStudents: _propTypes2.default.bool.isRequired,
    openModal: _propTypes2.default.func.isRequired
};

exports.default = SignInCardsButton;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "0fXh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Styles


// Components


// Context


// Helpers


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _linguiCdn = __webpack_require__("siuH");

__webpack_require__("Atdy");

var _newGroupItem = __webpack_require__("L8mK");

var _newGroupItem2 = _interopRequireDefault(_newGroupItem);

var _groupSelectionItem = __webpack_require__("aoyJ");

var _groupSelectionItem2 = _interopRequireDefault(_groupSelectionItem);

var _schoolCourseContext = __webpack_require__("3C3e");

var _schoolCourseContext2 = _interopRequireDefault(_schoolCourseContext);

var _courseInformationContext = __webpack_require__("EJJB");

var _courseInformationContext2 = _interopRequireDefault(_courseInformationContext);

var _enums = __webpack_require__("royT");

var _imageAsset = __webpack_require__("hB8d");

var _imageAsset2 = _interopRequireDefault(_imageAsset);

var _oneRosterOrganiseClassGroups = __webpack_require__("fVnV");

var _oneRosterOrganiseClassGroups2 = _interopRequireDefault(_oneRosterOrganiseClassGroups);

var _useIsOneRosterActivatedSchool = __webpack_require__("rSj7");

var _useIsOneRosterActivatedSchool2 = _interopRequireDefault(_useIsOneRosterActivatedSchool);

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function GroupSelection(props) {
    var _this = this;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var forwardRef = props.forwardRef,
        currentClassId = props.currentClassId,
        productId = props.productId,
        classGroups = props.classGroups,
        importedClasses = props.importedClasses,
        resetEditInformationHandler = props.resetEditInformationHandler,
        isFetchingEditInformation = props.isFetchingEditInformation,
        showNewCourses = props.showNewCourses,
        newCoursesAvailabilityCriteria = props.newCoursesAvailabilityCriteria,
        editGroupHandler = props.editGroupHandler,
        deleteGroupHandler = props.deleteGroupHandler,
        newGroupHandler = props.newGroupHandler,
        getDefaultCourseInformation = props.getDefaultCourseInformation,
        getEditGroupCourseInformation = props.getEditGroupCourseInformation,
        getCourseYears = props.getCourseYears,
        getDefaultCourse = props.getDefaultCourse,
        getCourses = props.getCourses,
        resetYearOptions = props.resetYearOptions,
        updateGroupCheckbox = props.updateGroupCheckbox,
        setShownPassword = props.setShownPassword,
        hasContentLoaded = props.hasContentLoaded,
        createMultiYearGroups = props.createMultiYearGroups,
        resetMultiYearGroupFetch = props.resetMultiYearGroupFetch,
        updateCurrentClassId = props.updateCurrentClassId;

    // State variables to handle the visibility of a modal relative to the group that is selected

    var _useState = (0, _react.useState)(_enums.DEFAULT_GROUP_MODAL_ID),
        _useState2 = _slicedToArray(_useState, 2),
        groupModalId = _useState2[0],
        setGroupModalId = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        groupModalVisibility = _useState4[0],
        setGroupModalVisibility = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isSchoolCoursesEnabled = _useState6[0],
        setIsSchoolCoursesEnabled = _useState6[1];

    var _useState7 = (0, _react.useState)(''),
        _useState8 = _slicedToArray(_useState7, 2),
        groupCountryCode = _useState8[0],
        setGroupCountryCode = _useState8[1];

    var _useState9 = (0, _react.useState)(false),
        _useState10 = _slicedToArray(_useState9, 2),
        isEditingMode = _useState10[0],
        setIsEditingMode = _useState10[1];

    var _useState11 = (0, _react.useState)(false),
        _useState12 = _slicedToArray(_useState11, 2),
        isNewGroupModal = _useState12[0],
        setIsNewGroupModal = _useState12[1];

    var newButtonRef = (0, _react.useRef)(null);

    var isOneRosterActivatedSchool = (0, _useIsOneRosterActivatedSchool2.default)();
    var classroomId = currentClassId;
    // Context variables

    var _useContext = (0, _react.useContext)(_courseInformationContext2.default),
        countrySelectValue = _useContext.countrySelectValue,
        yearSelectValue = _useContext.yearSelectValue;

    // Handler


    var showModal = function showModal(_ref) {
        var modalId = _ref.modalId,
            isClosing = _ref.isClosing,
            setEditMode = _ref.setEditMode;

        if (isSchoolCoursesEnabled === true) {
            setIsSchoolCoursesEnabled(false);
        }
        setGroupModalId(modalId);

        if (isClosing) {
            setGroupModalVisibility(false);
        } else {
            setGroupModalVisibility(function (prevState) {
                return !prevState;
            });
        }

        if (setEditMode && isEditingMode === false && modalId === -1) {
            // to set the flag for new group button clicked
            setIsNewGroupModal(true);
            setIsEditingMode(true);
        } else if (setEditMode && isEditingMode === false) {
            setIsEditingMode(true);
        } else {
            setIsEditingMode(false);
        }
    };
    var localNewGroupHandler = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
            var name = _ref3.name;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', newGroupHandler({ name: name }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function localNewGroupHandler(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    // Effects
    // - Retrieve the list of countries
    (0, _react.useEffect)(function () {
        var getEditGroupCourseInfo = function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var information;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return getEditGroupCourseInformation({
                                    classId: currentClassId,
                                    productId: productId,
                                    groupId: groupModalId
                                });

                            case 2:
                                information = _context2.sent;
                                _context2.next = 5;
                                return setGroupCountryCode(information.groupCountryCode);

                            case 5:
                                if (!(information && information.isSchoolCoursesEnabled)) {
                                    _context2.next = 8;
                                    break;
                                }

                                _context2.next = 8;
                                return setIsSchoolCoursesEnabled(information.isSchoolCoursesEnabled);

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }));

            return function getEditGroupCourseInfo() {
                return _ref4.apply(this, arguments);
            };
        }();

        var getDefaulCourseInfo = function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var countryResponse, defaultData, information;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return getDefaultCourse({
                                    productId: productId,
                                    classId: currentClassId
                                });

                            case 2:
                                countryResponse = _context3.sent;

                                if (!(countryResponse && countryResponse.valid)) {
                                    _context3.next = 15;
                                    break;
                                }

                                defaultData = {
                                    data: countryResponse.data
                                };
                                _context3.next = 7;
                                return getDefaultCourseInformation({
                                    defaultData: defaultData
                                });

                            case 7:
                                information = _context3.sent;
                                _context3.next = 10;
                                return setGroupCountryCode(information.groupCountryCode);

                            case 10:
                                if (!(information && information.isSchoolCoursesEnabled)) {
                                    _context3.next = 13;
                                    break;
                                }

                                _context3.next = 13;
                                return setIsSchoolCoursesEnabled(information.isSchoolCoursesEnabled);

                            case 13:
                                _context3.next = 15;
                                break;

                            case 15:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this);
            }));

            return function getDefaulCourseInfo() {
                return _ref5.apply(this, arguments);
            };
        }();

        if (isEditingMode === true && groupModalVisibility === true && isNewGroupModal === true) {
            // Get the auto-populated fields for the country + grade + course for new group
            getDefaulCourseInfo();
            setIsNewGroupModal(false);
        } else if (isEditingMode === true && groupModalVisibility === true) {
            // code to get data for EDIT group
            getEditGroupCourseInfo();
        }
    }, [groupModalVisibility, productId]);

    // Reset the selection for years and courses when school course is enabled
    (0, _react.useEffect)(function () {
        if (isSchoolCoursesEnabled === false) {
            resetYearOptions();
        }
    }, [isSchoolCoursesEnabled]);

    // - Retrieve the list of years
    (0, _react.useEffect)(function () {
        var countryValidValue = countrySelectValue !== '' && isFetchingEditInformation === false;
        var isNewGroupCourseEnabled = isSchoolCoursesEnabled === true && isFetchingEditInformation === false;

        // Either there's a valid country value or school course was selected, then retrieve the list of countries
        if (countryValidValue || isNewGroupCourseEnabled) {
            var countryCode = isSchoolCoursesEnabled ? undefined : countrySelectValue;
            getCourseYears({
                countryCode: countryCode
            });
        }
    }, [countrySelectValue, isSchoolCoursesEnabled, productId]);

    // - Retrieve the list of courses
    (0, _react.useEffect)(function () {
        if (yearSelectValue !== '' && isFetchingEditInformation === false) {
            var countryCode = isSchoolCoursesEnabled ? undefined : countrySelectValue;
            getCourses({
                countryCode: countryCode,
                yearGroup: yearSelectValue,
                productId: productId,
                noCourseText: i18n._( /*i18n*/{
                    id: 'Group Modal - label - Select no courses'
                })
            });
        }
    }, [yearSelectValue, productId]);

    var resetEditFetchInformation = function resetEditFetchInformation(value) {
        resetEditInformationHandler();
        setIsSchoolCoursesEnabled(value);
    };

    var showCurrentEditGroupModal = function showCurrentEditGroupModal() {
        showModal({ modalId: _enums.NEW_GROUP_MODAL_ID, setEditMode: true });
    };
    var isBtnDisabled = classGroups.length === _enums.MAX_GROUP_LENGTH + 1;
    var isModalVisible = isEditingMode && showModal;

    return _react2.default.createElement(
        'div',
        { ref: forwardRef, className: 'groups__filters ' + importedClasses },
        _react2.default.createElement(
            _schoolCourseContext2.default.Provider,
            { value: {
                    isSchoolCoursesEnabled: isSchoolCoursesEnabled,
                    setIsSchoolCoursesEnabled: resetEditFetchInformation,
                    groupCountryCode: groupCountryCode
                } },
            _react2.default.createElement(
                'div',
                { className: 'groups__container' },
                _react2.default.createElement(_imageAsset2.default, { type: 'groupIcon', parentTitle: 'group-icon' }),
                _react2.default.createElement(
                    'div',
                    { className: 'groups__group-heading' },
                    i18n._( /*i18n*/{
                        id: 'Class Group Selection - header'
                    })
                ),
                !isModalVisible && _react2.default.createElement(_button2.default, {
                    ref: newButtonRef,
                    buttonStyle: 'text',
                    visibleText: _react2.default.createElement(_react3.Trans, { id: 'Groups - New group' }),
                    importedClasses: 'button--new-group',
                    ariaProps: isBtnDisabled ? { title: i18n._( /*i18n*/{
                            id: 'Groups - New group - disabled'
                        }) } : null,
                    isBtnDisabled: isEditingMode,
                    callback: showCurrentEditGroupModal
                })
            ),
            _react2.default.createElement(
                'div',
                { className: 'groups__subHeadingText' },
                i18n._( /*i18n*/{
                    id: 'Class Group Selection - subText'
                })
            ),
            _react2.default.createElement(_newGroupItem2.default, {
                showModal: showModal,
                currentGroupId: _enums.NEW_GROUP_MODAL_ID,
                groupModalVisibility: groupModalVisibility,
                groupModalId: groupModalId,
                productId: productId,
                newGroupHandler: localNewGroupHandler,
                showNewCourses: showNewCourses,
                newCoursesAvailabilityCriteria: newCoursesAvailabilityCriteria
            }),
            classGroups && classGroups.map(function (classGroupItem, index) {
                return _react2.default.createElement(_groupSelectionItem2.default, {
                    key: classGroupItem.name,
                    classGroupItem: classGroupItem,
                    showModal: showModal,
                    getDefaultCourseInformation: getDefaultCourseInformation,
                    getEditGroupCourseInformation: getEditGroupCourseInformation,
                    index: index,
                    groupModalVisibility: groupModalVisibility,
                    groupModalId: groupModalId,
                    productId: productId,
                    editGroupHandler: editGroupHandler,
                    deleteGroupHandler: deleteGroupHandler,
                    updateGroupCheckbox: updateGroupCheckbox,
                    setShownPassword: setShownPassword,
                    showNewCourses: showNewCourses,
                    newCoursesAvailabilityCriteria: newCoursesAvailabilityCriteria
                });
            }),
            isOneRosterActivatedSchool && _react2.default.createElement(
                'div',
                { className: 'groups__one-roster-autoselect-container' },
                _react2.default.createElement(
                    'div',
                    { className: 'groups__divider' },
                    'OR'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'groups__one-roster-autoselect-header-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'groups__one-roster-autoselect-header' },
                        _react2.default.createElement(_imageAsset2.default, {
                            type: 'lightningBoltIcon',
                            parentTitle: 'lightning-bolt-icon',
                            parentClass: 'groups__one-roster-autoselect-bolt-icon'
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'groups__one-roster-autoselect-header-text' },
                            i18n._( /*i18n*/{
                                id: 'One Roster - Organise class groups'
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'groups__one-roster-autoselect-content' },
                        i18n._( /*i18n*/{
                            id: 'One Roster - Organise class groups - text'
                        }),
                        _react2.default.createElement(
                            'span',
                            { className: 'groups__one-roster-autoselect-content-subtext' },
                            i18n._( /*i18n*/{
                                id: 'One Roster - Organise class groups - subText'
                            })
                        )
                    ),
                    _react2.default.createElement(_oneRosterOrganiseClassGroups2.default, {
                        isGroupModal: true,
                        createMultiYearGroups: createMultiYearGroups,
                        classroomId: classroomId,
                        updateCurrentClassId: updateCurrentClassId,
                        hasContentLoaded: hasContentLoaded,
                        resetMultiYearGroupFetch: resetMultiYearGroupFetch
                    })
                )
            )
        )
    );
}

GroupSelection.propTypes = {
    forwardRef: _propTypes2.default.any,
    currentClassId: _propTypes2.default.number,
    productId: _propTypes2.default.number,
    classGroups: _propTypes2.default.array,
    importedClasses: _propTypes2.default.string,
    isFetchingEditInformation: _propTypes2.default.bool,
    showNewCourses: _propTypes2.default.bool,
    newCoursesAvailabilityCriteria: _propTypes2.default.object,
    // Handlers
    getDefaultCourseInformation: _propTypes2.default.func,
    getEditGroupCourseInformation: _propTypes2.default.func.isRequired,
    getDefaultCourse: _propTypes2.default.func.isRequired,
    getCourseYears: _propTypes2.default.func.isRequired,
    getCourses: _propTypes2.default.func.isRequired,
    newGroupHandler: _propTypes2.default.func.isRequired,
    editGroupHandler: _propTypes2.default.func.isRequired,
    deleteGroupHandler: _propTypes2.default.func.isRequired,
    resetYearOptions: _propTypes2.default.func.isRequired,
    resetEditInformationHandler: _propTypes2.default.func,
    updateGroupCheckbox: _propTypes2.default.func.isRequired,
    setShownPassword: _propTypes2.default.func,
    createMultiYearGroups: _propTypes2.default.func,
    resetMultiYearGroupFetch: _propTypes2.default.func,
    updateCurrentClassId: _propTypes2.default.func,
    hasContentLoaded: _propTypes2.default.bool
    // resetCreateEditGroup: PropTypes.func
};

exports.default = _react2.default.forwardRef(function (props, ref) {
    return _react2.default.createElement(GroupSelection, _extends({}, props, { forwardRef: ref }));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "0yfC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LABEL_STYLES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * @todo add/update JSDoc tags to document your code
                                                                                                                                                                                                                                                                   * (see http://usejsdoc.org/ for information on JSDoc tags),
                                                                                                                                                                                                                                                                   * then remove this comment block.
                                                                                                                                                                                                                                                                   */

/** Checkbox functional (stateless) component */


// Styles


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("M4fF");

__webpack_require__("8+rk");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LABEL_STYLES = exports.LABEL_STYLES = {
    hidden: 'hidden',
    visible: 'visible'
};

/**
 * Checkbox pro-forma template for stateless component
 * @todo - add a proper description of the component
 *
 * @access public
 * @param {string} text string describing the component
 * @returns JSX render of the component
 */
var Checkbox = function Checkbox(_ref) {
    var uid = _ref.uid,
        labelForwardRef = _ref.labelForwardRef,
        inputType = _ref.inputType,
        isChecked = _ref.isChecked,
        labelText = _ref.labelText,
        parentClasses = _ref.parentClasses,
        labelProps = _ref.labelProps,
        importedClasses = _ref.importedClasses,
        isDisabled = _ref.isDisabled,
        callback = _ref.callback,
        value = _ref.value,
        numberOfStudents = _ref.numberOfStudents,
        isGroupCheckbox = _ref.isGroupCheckbox,
        isEditGroupCheckBox = _ref.isEditGroupCheckBox,
        children = _ref.children;

    var containerClasses = 'checkbox__container ' + (parentClasses || '') + ' ' + (isEditGroupCheckBox ? 'margin-top' : '');
    var inputClasses = 'checkbox ' + importedClasses;
    var labelClasses = 'checkbox__label ' + (inputType === LABEL_STYLES.hidden ? 'checkbox__label--hidden' : '');

    var callbackAction = function callbackAction(e) {
        if (callback && !isDisabled) {
            callback(e);
        }
    };
    var label = _react2.default.createElement(
        'label',
        _extends({ ref: labelForwardRef, htmlFor: 'check-' + uid, className: labelClasses }, labelProps),
        _react2.default.createElement(
            'span',
            { className: 'checkbox__inner-label ' + (isEditGroupCheckBox ? 'checkbox__inner-label--edit-group' : '') },
            labelText
        )
    );

    var labelForGroup = _react2.default.createElement(
        'label',
        _extends({ ref: labelForwardRef, htmlFor: 'check-' + uid, className: labelClasses }, labelProps),
        labelProps && labelProps.title === 'All groups' ? _react2.default.createElement(
            'span',
            { className: 'checkbox__inner-label' },
            labelText
        ) : _react2.default.createElement(
            'span',
            { className: 'checkbox__inner-label' },
            labelText,
            ' (',
            numberOfStudents,
            ')'
        )
    );

    return _react2.default.createElement(
        'div',
        { className: containerClasses },
        _react2.default.createElement('input', {
            type: 'checkbox',
            id: 'check-' + uid,
            'data-value': value,
            disabled: isDisabled,
            checked: isChecked,
            className: inputClasses,
            onChange: callbackAction,
            'aria-label': labelProps && labelProps.title ? labelProps.title : null
        }),
        isGroupCheckbox ? labelForGroup : label,
        children
    );
};

/**
 * Define the default values for the properties being used
 */
Checkbox.defaultProps = {
    inputType: 'visible',
    importedClasses: '',
    isDisabled: false
};

var STYLES_NAMES = (0, _lodash.keys)(LABEL_STYLES);
/**
 * Define the type of properties that can be set on this component
 */
Checkbox.propTypes = {
    uid: _propTypes2.default.string.isRequired,
    inputType: _propTypes2.default.oneOf(STYLES_NAMES),
    isChecked: _propTypes2.default.bool,
    labelText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
    parentClasses: _propTypes2.default.string,
    labelProps: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
    numberOfStudents: _propTypes2.default.number,
    isGroupCheckbox: _propTypes2.default.bool,
    isEditGroupCheckBox: _propTypes2.default.bool,
    importedClasses: _propTypes2.default.string,
    isDisabled: _propTypes2.default.bool,
    callback: _propTypes2.default.func,
    labelForwardRef: _propTypes2.default.any,
    value: _propTypes2.default.any, // value to use when a callback is used
    children: _propTypes2.default.any
};

exports.default = Checkbox;

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("x4K0");


/***/ }),

/***/ "12dE":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/d55e0c977385f080b82cffa2f80c3140.svg";

/***/ }),

/***/ "1YY9":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/9887cc8e9a4ae5c4c0dde2e5abb925dd.svg";

/***/ }),

/***/ "1uEC":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/3490cc759e1a3f0380461dba72a73a6b.svg";

/***/ }),

/***/ "1yAK":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/b4f93075afbf79328945ae36479c9d93.svg";

/***/ }),

/***/ "2C6i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("QruM");

var _react2 = __webpack_require__("GiK3");

var _react3 = _interopRequireDefault(_react2);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("Zo+M");

var _threeEssentailsButton = __webpack_require__("Lgqb");

var _threeEssentailsButton2 = _interopRequireDefault(_threeEssentailsButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OrganiseClassGroupsModal(_ref) {
    var title = _ref.title,
        description = _ref.description,
        closeHandler = _ref.closeHandler,
        containerStyle = _ref.containerStyle,
        clickHandler = _ref.clickHandler;

    return _react3.default.createElement(
        'aside',
        { className: 'modal__overlay' },
        _react3.default.createElement(
            'div',
            { style: _extends({}, containerStyle), className: 'modal modal--floating' },
            _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'div',
                    { className: 'modal__header' },
                    _react3.default.createElement(
                        'h2',
                        { className: 'modal__title' },
                        title
                    )
                ),
                _react3.default.createElement(
                    'h2',
                    { className: 'modal__description' },
                    description
                ),
                _react3.default.createElement(
                    'h2',
                    { className: 'modal__button-container' },
                    _react3.default.createElement(_threeEssentailsButton2.default, {
                        clickHandler: closeHandler,
                        title: _react3.default.createElement(_react.Trans, { id: 'Modal - Cancel' }),
                        show3EIcon: false,
                        showArrow: false,
                        buttonClassName: 'modal__button-container__button-style'
                    }),
                    _react3.default.createElement(_threeEssentailsButton2.default, {
                        clickHandler: clickHandler,
                        title: _react3.default.createElement(_react.Trans, { id: 'Modal - Continue' }),
                        show3EIcon: false,
                        showArrow: false,
                        buttonClassName: 'modal__button-container__button-style'
                    })
                )
            )
        )
    );
}

OrganiseClassGroupsModal.propTypes = {
    title: _propTypes2.default.string,
    description: _propTypes2.default.string,
    closeHandler: _propTypes2.default.func.isRequired,
    clickHandler: _propTypes2.default.func.isRequired,
    containerStyle: _propTypes2.default.object
};

exports.default = OrganiseClassGroupsModal;

/***/ }),

/***/ "2z6x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// For local development, we can use mock-rest-server (or a similar REST server like json-server)
//
// You should be able to use this code as is, apart from perhaps changing MOCK_SERVICE_PORT to whatever
// port you're using for your mock server.

var MOCK_SERVICES_PORT = 4321; // TODO: 2. DEFINE THE PORT YOUR MOCK SERVER IS LISTENING ON

var MOCK_SERVICES_HOST = 'localhost';
var MOCK_SERVICES_URL = 'http://' + MOCK_SERVICES_HOST + ':' + MOCK_SERVICES_PORT;

// The app's configuration will have a base URL for each service we use.  For local testing, we define
// the configuration to point to our local server.
//
// For each resource, we have a constant for the base URL, as it would be in production. For example,
// below we have "AvatarAdminBaseUrl" which represents the base of the URL for access to all of
// the Avatar Admin application's resources.  Replace that with the resource(s) your application uses.

var localConfig = {
    BaseName: '',
    AvatarAdminBaseUrl: MOCK_SERVICES_URL + '/avatar/v1' // TODO: 3. REPLACE THIS WITH YOUR ACTUAL SERVICES
};

exports.default = localConfig;

/***/ }),

/***/ "3AWt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var dispatch = _ref.dispatch,
        showAction = _ref.showAction,
        hideAction = _ref.hideAction;

    var env = _resources2.default.env;

    function requestInterceptor() {
        dispatch(showAction());
    }

    function responseInterceptor(response) {
        var hasPendingRequest = env.havePendingRequests();
        var action = hasPendingRequest ? showAction() : hideAction();

        dispatch(action);

        return response;
    }

    if (env) {
        env.addRequestInterceptor(requestInterceptor);
        env.addResponseInterceptor(responseInterceptor);
    }
};

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "3C3e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("GiK3");

var SchoolCourseContext = (0, _react.createContext)(null);

exports.default = SchoolCourseContext;

/***/ }),

/***/ "3C4M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("FOJt");

var _imageAsset = __webpack_require__("hB8d");

var _imageAsset2 = _interopRequireDefault(_imageAsset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * @param badgeId {string} The id that will ne given to the occurrence, to position it individually
 * @param iconName {string} One of the possible icons of ImageAsset component
 * @param assetTitle {string} The "title" on hover
 * @param visibleText {string} The visible text
 * @param imageClassName {string} An additional class put on the ImageAsset Component if needed
 * @returns {*}
 * @constructor
 */


// Styles
function Badge(_ref) {
    var badgeId = _ref.badgeId,
        iconName = _ref.iconName,
        assetTitle = _ref.assetTitle,
        visibleText = _ref.visibleText,
        imageClassName = _ref.imageClassName;

    return _react2.default.createElement(
        'div',
        { className: 'badge', id: badgeId },
        _react2.default.createElement(_imageAsset2.default, { parentClass: imageClassName, type: iconName, parentTitle: assetTitle }),
        visibleText ? _react2.default.createElement(
            'span',
            { className: 'badge__text' },
            visibleText
        ) : ''
    );
}

/**
 * Define the default values for the properties being used
 */


// Components
Badge.defaultProps = {
    iconName: 'newIcon',
    imageClassName: null
};

/**
 * Define the type of properties that can be set on this component
 */
Badge.propTypes = {
    badgeId: _propTypes2.default.string,
    iconName: _propTypes2.default.string,
    assetTitle: _propTypes2.default.string,
    visibleText: _propTypes2.default.string,
    imageClassName: _propTypes2.default.string
};

exports.default = Badge;

/***/ }),

/***/ "3IvT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiCdn = __webpack_require__("siuH");

var _oneRosterManageStudents = __webpack_require__("3ccH");

var _oneRosterManageStudents2 = _interopRequireDefault(_oneRosterManageStudents);

var _closeButton = __webpack_require__("Cfio");

var _closeButton2 = _interopRequireDefault(_closeButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EditGroupContainer(_ref) {
    var title = _ref.title,
        children = _ref.children,
        closeHandler = _ref.closeHandler,
        containerStyle = _ref.containerStyle,
        isOneRosterActivatedSchool = _ref.isOneRosterActivatedSchool;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var getOneRosterStyles = function getOneRosterStyles() {
        if (isOneRosterActivatedSchool) {
            return {
                padding: '20px 24px',
                border: '2px solid #f7d064',
                borderRadius: '16px'
            };
        }
        return null;
    };

    return _react2.default.createElement(
        'div',
        {
            style: _extends({}, containerStyle, getOneRosterStyles()),
            className: 'edit-group-container'
        },
        isOneRosterActivatedSchool ? _react2.default.createElement(_oneRosterManageStudents2.default, { i18n: i18n, title: title }) : _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'modal__header' },
                _react2.default.createElement(
                    'h2',
                    { className: 'modal__title modal__edit-groups' },
                    title
                ),
                _react2.default.createElement(_closeButton2.default, { closeHandler: closeHandler, i18n: i18n })
            ),
            children
        )
    );
}

EditGroupContainer.propTypes = {
    title: _propTypes2.default.object,
    children: _propTypes2.default.any,
    closeHandler: _propTypes2.default.func.isRequired,
    containerStyle: _propTypes2.default.object,
    isOneRosterActivatedSchool: _propTypes2.default.bool
};

exports.default = EditGroupContainer;

/***/ }),

/***/ "3Y2X":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/19158094b5114d48520aae4bc1bc93c9.svg";

/***/ }),

/***/ "3ccH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__("6QRH");

var _threeEssentailsButton = __webpack_require__("Lgqb");

var _threeEssentailsButton2 = _interopRequireDefault(_threeEssentailsButton);

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _imageAsset = __webpack_require__("hB8d");

var _imageAsset2 = _interopRequireDefault(_imageAsset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OneRosterManageStudents = function OneRosterManageStudents(_ref) {
    var i18n = _ref.i18n,
        title = _ref.title;

    var _useState = (0, _react.useState)(''),
        _useState2 = _slicedToArray(_useState, 2),
        moduleLink = _useState2[0],
        setModuleLink = _useState2[1];

    (0, _react.useEffect)(function () {
        _resources2.default.getConfigurationItem('THREE_ESSENTIALS_REMOVE_STUDENT').then(function (manageStudentsUrl) {
            return setModuleLink(manageStudentsUrl);
        });
    });

    return _react2.default.createElement(
        'div',
        { className: 'modal__manage_students_container' },
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_imageAsset2.default, { type: 'manageStudents' })
        ),
        _react2.default.createElement(
            'div',
            { className: 'modal__manage_students_container__manage_students' },
            _react2.default.createElement(
                'h1',
                null,
                title
            ),
            _react2.default.createElement(
                'span',
                null,
                i18n._( /*i18n*/{
                    id: 'OneRoster - Manage students'
                })
            ),
            _react2.default.createElement(_threeEssentailsButton2.default, {
                show3EIcon: (0, _utils.isValidMarketRegion)(),
                buttonClassName: 'modal_manage',
                clickHandler: function clickHandler() {
                    return window.open(moduleLink);
                },
                title: i18n._( /*i18n*/{
                    id: 'OneRoster - manage'
                }) })
        )
    );
};

OneRosterManageStudents.propTypes = {
    i18n: _propTypes2.default.object,
    title: _propTypes2.default.string
};

exports.default = OneRosterManageStudents;

/***/ }),

/***/ "3lbZ":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/e9e1d777d8487e62d7d8f48d196b1ce9.svg";

/***/ }),

/***/ "41oH":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/ae6111f55adff7057982ed08fa500128.svg";

/***/ }),

/***/ "4BpE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SELECT_ALL_CHECKBOX_STUDENT = exports.SELECT_CHECKBOX_STUDENT = undefined;

var _utils = __webpack_require__("6QRH");

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Checkbox
var SELECT_CHECKBOX_STUDENT = exports.SELECT_CHECKBOX_STUDENT = 'SELECT_CHECKBOX_STUDENT';
var SELECT_ALL_CHECKBOX_STUDENT = exports.SELECT_ALL_CHECKBOX_STUDENT = 'SELECT_ALL_CHECKBOX_STUDENT';

var selectCheckboxStudent = function selectCheckboxStudent(profileId) {
    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
            var selectStudentAction;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            selectStudentAction = (0, _utils.actionCreator)(SELECT_CHECKBOX_STUDENT, {
                                data: profileId
                            });

                            dispatch(selectStudentAction);

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
};

var selectAllCheckboxStudent = function selectAllCheckboxStudent() {
    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
            var selectAllStudentAction;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            selectAllStudentAction = (0, _utils.actionCreator)(SELECT_ALL_CHECKBOX_STUDENT);

                            dispatch(selectAllStudentAction);

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function (_x2) {
            return _ref2.apply(this, arguments);
        };
    }();
};

exports.default = {
    selectCheckboxStudent: selectCheckboxStudent,
    selectAllCheckboxStudent: selectAllCheckboxStudent
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "4H+z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("wo/1");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectLabel(_ref) {
    var id = _ref.id,
        srLabel = _ref.srLabel,
        value = _ref.value,
        ariaProps = _ref.ariaProps,
        listOfOptions = _ref.listOfOptions,
        propertyName = _ref.propertyName,
        visibleProperty = _ref.visibleProperty,
        selectHandler = _ref.selectHandler,
        isSelectDisabled = _ref.isSelectDisabled,
        isRequired = _ref.isRequired,
        importedClasses = _ref.importedClasses;

    var selectClasses = 'select ' + importedClasses;
    return _react2.default.createElement(
        _react.Fragment,
        null,
        srLabel ? _react2.default.createElement(
            'label',
            { htmlFor: id },
            _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                srLabel
            )
        ) : '',
        _react2.default.createElement(
            'select',
            {
                id: id,
                value: value,
                className: selectClasses,
                'aria-labelledby': ariaProps && ariaProps.ariaLabelledBy,
                disabled: isSelectDisabled,
                required: isRequired,
                onChange: selectHandler,
                autoComplete: 'off' },
            listOfOptions.map(function (group) {
                return _react2.default.createElement(
                    'option',
                    { key: id + '-' + group[propertyName], value: group[propertyName] },
                    group[visibleProperty]
                );
            })
        )
    );
}

// Styles


SelectLabel.defaultProps = {
    visibleProperty: 'name',
    importedClasses: ''
};

SelectLabel.propTypes = {
    id: _propTypes2.default.string,
    srLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    ariaProps: _propTypes2.default.object,
    listOfOptions: _propTypes2.default.array,
    propertyName: _propTypes2.default.string,
    visibleProperty: _propTypes2.default.string,
    isSelectDisabled: _propTypes2.default.bool,
    isRequired: _propTypes2.default.bool,
    selectHandler: _propTypes2.default.func.isRequired,
    importedClasses: _propTypes2.default.string
};

exports.default = SelectLabel;

/***/ }),

/***/ "4MiP":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/1bf7488c747587e036db2316cb6e6aae.svg";

/***/ }),

/***/ "5/30":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/68d43675a08746362caacb721419fe43.svg";

/***/ }),

/***/ "5/v9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FETCHING_COURSE_CONTENT = exports.GET_NEW_COURSE_AVAILABILITY_CRITERIA = exports.INITIALISE_COURSE_SELECT_OPTIONS = exports.RESET_COURSE_YEARS = exports.GET_NEW_COURSE = exports.GET_UPF_COURSE = exports.GET_COURSE = exports.GET_COURSE_YEARS = exports.GET_COURSE_COUNTRIES = exports.GET_DEFAULT_COURSE = exports.SET_NEW_COURSE = exports.SET_UPF_COURSE = exports.SET_COURSE = exports.SET_COURSE_YEAR = exports.SET_COURSE_COUNTRIES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__("6QRH");

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _enums = __webpack_require__("royT");

var _toastActions = __webpack_require__("sFKd");

var _toastActions2 = _interopRequireDefault(_toastActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// SETTERS
var SET_COURSE_COUNTRIES = exports.SET_COURSE_COUNTRIES = 'SET_COURSE_COUNTRIES';
var SET_COURSE_YEAR = exports.SET_COURSE_YEAR = 'SET_COURSE_YEAR';
var SET_COURSE = exports.SET_COURSE = 'SET_COURSE';
var SET_UPF_COURSE = exports.SET_UPF_COURSE = 'SET_UPF_COURSE';
var SET_NEW_COURSE = exports.SET_NEW_COURSE = 'SET_NEW_COURSE';
// GETTERS
var GET_DEFAULT_COURSE = exports.GET_DEFAULT_COURSE = 'GET_DEFAULT_COURSE';
var GET_COURSE_COUNTRIES = exports.GET_COURSE_COUNTRIES = 'GET_COURSE_COUNTRIES';
var GET_COURSE_YEARS = exports.GET_COURSE_YEARS = 'GET_COURSE_YEARS';
var GET_COURSE = exports.GET_COURSE = 'GET_COURSE';
var GET_UPF_COURSE = exports.GET_UPF_COURSE = 'GET_UPF_COURSE';
var GET_NEW_COURSE = exports.GET_NEW_COURSE = 'GET_NEW_COURSE';
var RESET_COURSE_YEARS = exports.RESET_COURSE_YEARS = 'RESET_COURSE_YEARS';

var INITIALISE_COURSE_SELECT_OPTIONS = exports.INITIALISE_COURSE_SELECT_OPTIONS = 'INITIALISE_COURSE_SELECT_OPTIONS';
var GET_NEW_COURSE_AVAILABILITY_CRITERIA = exports.GET_NEW_COURSE_AVAILABILITY_CRITERIA = 'GET_NEW_COURSE_AVAILABILITY_CRITERIA';

var FETCHING_COURSE_CONTENT = exports.FETCHING_COURSE_CONTENT = 'FETCHING_COURSE_CONTENT';

/**
 * NOTE: Courses are not localised - i.e. we get courses based on country but the names are not localised
 * If in the future we localise them, we should pass the locale in the header for the course APIs
 */

var setCountryHandler = function setCountryHandler(value) {
    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
            var getCourseCountriesAction;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            getCourseCountriesAction = (0, _utils.actionCreator)(SET_COURSE_COUNTRIES, { data: value });

                            dispatch(getCourseCountriesAction);

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
};

var setYearHandler = function setYearHandler(value) {
    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
            var getCourseYearAction;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            getCourseYearAction = (0, _utils.actionCreator)(SET_COURSE_YEAR, { data: value });

                            dispatch(getCourseYearAction);

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function (_x2) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var setCourseHandler = function setCourseHandler(value) {
    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
            var getCourseAction;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            getCourseAction = (0, _utils.actionCreator)(SET_COURSE, { data: value });

                            dispatch(getCourseAction);

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined);
        }));

        return function (_x3) {
            return _ref3.apply(this, arguments);
        };
    }();
};

var setUPFCourseHandler = function setUPFCourseHandler(value) {
    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
            var getUPFCourseAction;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            getUPFCourseAction = (0, _utils.actionCreator)(SET_UPF_COURSE, { data: value });

                            dispatch(getUPFCourseAction);

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, undefined);
        }));

        return function (_x4) {
            return _ref4.apply(this, arguments);
        };
    }();
};

var setNewCourseHandler = function setNewCourseHandler(value) {
    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch) {
            var setNewCourseAction;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            setNewCourseAction = (0, _utils.actionCreator)(SET_NEW_COURSE, { data: value });

                            dispatch(setNewCourseAction);

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, undefined);
        }));

        return function (_x5) {
            return _ref5.apply(this, arguments);
        };
    }();
};

// To get default courses when we click ADD NEW GROUP button
/**
 * prerequisite:
 * @param productId
 * @param classId
 */
var getDefaultCourse = function getDefaultCourse(_ref6) {
    var productId = _ref6.productId,
        classId = _ref6.classId;
    return function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch) {
            var getDefaultCourseResponse, message, error, _getDefaultCourseResp, groupCourse, defaultCountry, defaultYear, defaultCourse, upfCourses, conquestCourses, countries, yearGroups, courses, countryCode, year, course, upfCourse, newCourse, getCourseCountriesAction;

            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            if (_resources2.default.getDefaultCourse) {
                                _context6.next = 2;
                                break;
                            }

                            throw new Error('Default course resource is not available');

                        case 2:
                            _context6.prev = 2;
                            _context6.next = 5;
                            return _resources2.default.getDefaultCourse.get({
                                classId: classId,
                                productId: productId
                            }).withParams({
                                includeGlobalCourses: true
                            }).headers({ Locale: (0, _utils.getLocale)() }).send();

                        case 5:
                            getDefaultCourseResponse = _context6.sent;

                            if (!(!getDefaultCourseResponse.valid || getDefaultCourseResponse.status >= 400 && getDefaultCourseResponse.status <= 599)) {
                                _context6.next = 12;
                                break;
                            }

                            message = getDefaultCourseResponse && getDefaultCourseResponse.data && getDefaultCourseResponse.data.message || getDefaultCourseResponse && getDefaultCourseResponse.error && getDefaultCourseResponse.error.message || 'Failed to edit group. Status: ' + getDefaultCourseResponse.status;
                            error = new Error(message);

                            error.status = getDefaultCourseResponse.status;
                            error.response = getDefaultCourseResponse;

                            throw error;

                        case 12:

                            // To display rest of the data in select box if any one of the data(Country/Year/Course)
                            // is missing from BE

                            _getDefaultCourseResp = getDefaultCourseResponse.data, groupCourse = _getDefaultCourseResp.groupCourse, defaultCountry = _getDefaultCourseResp.defaultCountry, defaultYear = _getDefaultCourseResp.defaultYear, defaultCourse = _getDefaultCourseResp.defaultCourse, upfCourses = _getDefaultCourseResp.upfCourses, conquestCourses = _getDefaultCourseResp.conquestCourses, countries = _getDefaultCourseResp.countries, yearGroups = _getDefaultCourseResp.yearGroups, courses = _getDefaultCourseResp.courses;
                            countryCode = defaultCountry.code !== null ? defaultCountry.code : '';
                            year = defaultYear !== null ? defaultYear.yearGroupEnum.toString() : '';
                            course = defaultCourse !== null ? defaultCourse.id.toString() : '';
                            upfCourse = productId === _enums.PRODUCT_IDS.Mathletics && upfCourses.length > 0 ? upfCourses[0].id.toString() : '';
                            newCourse = conquestCourses.length > 0 ? (conquestCourses.find(function (c) {
                                return c.isDefault;
                            }) || {}).id || '' : '';
                            getCourseCountriesAction = (0, _utils.actionCreator)(GET_DEFAULT_COURSE, {
                                countryCode: countryCode,
                                countryList: countries,
                                course: course,
                                courseList: courses,
                                currentCourse: groupCourse,
                                upfCourse: upfCourse,
                                upfCourseList: productId === _enums.PRODUCT_IDS.Mathletics ? upfCourses : '',
                                newCourse: newCourse,
                                newCourseList: conquestCourses,
                                year: year,
                                yearList: yearGroups
                            });


                            dispatch(getCourseCountriesAction);

                            return _context6.abrupt('return', getDefaultCourseResponse);

                        case 23:
                            _context6.prev = 23;
                            _context6.t0 = _context6['catch'](2);

                            dispatch(_toastActions2.default.showToast({
                                variant: 'error',
                                messageId: 'Error Updating Group',
                                autoCloseMs: 6000
                            }));
                            throw _context6.t0;

                        case 27:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, undefined, [[2, 23]]);
        }));

        return function (_x6) {
            return _ref7.apply(this, arguments);
        };
    }();
};

/**
 * prerequisite:
 * - this action must be followed by the "getCourseCountries" in order for the countryCode to be populated
 * @param countryCode
 */
var getCourseYears = function getCourseYears(_ref8) {
    var countryCode = _ref8.countryCode;
    return function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch) {
            var getCourseYearsResponse, message, error, getCourseYearsAction;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            if (_resources2.default.getCourseYears) {
                                _context7.next = 2;
                                break;
                            }

                            throw new Error('GetCourseYears resource is not available');

                        case 2:
                            _context7.prev = 2;
                            getCourseYearsResponse = _resources2.default.getCourseYears.get().headers({ Locale: (0, _utils.getLocale)() });

                            /**
                             * If there's countryCode available send it with the countryCode,
                             * otherwise send it without a country code (applicable for school courses
                             */

                            if (!countryCode) {
                                _context7.next = 10;
                                break;
                            }

                            _context7.next = 7;
                            return getCourseYearsResponse.withParams({
                                countryCode: countryCode
                            }).headers({ Locale: (0, _utils.getLocale)() }).send();

                        case 7:
                            getCourseYearsResponse = _context7.sent;
                            _context7.next = 13;
                            break;

                        case 10:
                            _context7.next = 12;
                            return getCourseYearsResponse.send();

                        case 12:
                            getCourseYearsResponse = _context7.sent;

                        case 13:
                            if (!(!getCourseYearsResponse.valid || getCourseYearsResponse.status >= 400 && getCourseYearsResponse.status <= 599)) {
                                _context7.next = 19;
                                break;
                            }

                            message = getCourseYearsResponse && getCourseYearsResponse.data && getCourseYearsResponse.data.message || getCourseYearsResponse && getCourseYearsResponse.error && getCourseYearsResponse.error.message || 'Failed to edit group. Status: ' + getCourseYearsResponse.status;
                            error = new Error(message);

                            error.status = getCourseYearsResponse.status;
                            error.response = getCourseYearsResponse;

                            throw error;

                        case 19:
                            getCourseYearsAction = (0, _utils.actionCreator)(GET_COURSE_YEARS, {
                                data: getCourseYearsResponse.data
                            });

                            dispatch(getCourseYearsAction);
                            _context7.next = 27;
                            break;

                        case 23:
                            _context7.prev = 23;
                            _context7.t0 = _context7['catch'](2);

                            dispatch(_toastActions2.default.showToast({
                                variant: 'error',
                                messageId: 'Error Updating Group',
                                autoCloseMs: 6000
                            }));
                            throw _context7.t0;

                        case 27:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, undefined, [[2, 23]]);
        }));

        return function (_x7) {
            return _ref9.apply(this, arguments);
        };
    }();
};

/**
 * prerequisite:
 *      - this action must be followed by the "getCourseCountries" AND "getCourseYears" in order for
 *      both the countryCode and yearGroup to be populated
 * @param countryCode
 * @param yearGroup
 * @param productId
 * @param noCourseText
 */
var getCourses = function getCourses(_ref10) {
    var countryCode = _ref10.countryCode,
        yearGroup = _ref10.yearGroup,
        productId = _ref10.productId,
        noCourseText = _ref10.noCourseText;
    return function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch) {
            var isSchoolCourse, response, getCoursesResponse, _getCourseAction, message, error, getCourseAction, getNewCourseAction, getUPFCourseAction;

            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            if (_resources2.default.getCourses) {
                                _context8.next = 2;
                                break;
                            }

                            throw new Error('getCourses resource is not available');

                        case 2:
                            _context8.prev = 2;

                            // If there's no country code, retrieve the schoolCourses endpoint instead
                            isSchoolCourse = !(countryCode !== '' && countryCode !== undefined);
                            response = isSchoolCourse ? _resources2.default.getSchoolCourses.get().withParams({
                                yearGroup: yearGroup,
                                productId: productId,
                                includeGlobalCourses: true
                            }) : _resources2.default.getCourses.get().withParams({
                                countryCode: countryCode,
                                yearGroup: yearGroup,
                                productId: productId,
                                includeGlobalCourses: true
                            });
                            _context8.next = 7;
                            return response.send();

                        case 7:
                            getCoursesResponse = _context8.sent;


                            if (getCoursesResponse.status === 404) {
                                _getCourseAction = (0, _utils.actionCreator)(GET_COURSE, {
                                    data: {
                                        id: '',
                                        name: noCourseText
                                    },
                                    notFound: true
                                });

                                dispatch(_getCourseAction);
                            }

                            if (!(!getCoursesResponse.valid || getCoursesResponse.status >= 500 && getCoursesResponse.status <= 599)) {
                                _context8.next = 15;
                                break;
                            }

                            message = getCoursesResponse && getCoursesResponse.data && getCoursesResponse.data.message || getCoursesResponse && getCoursesResponse.error && getCoursesResponse.error.message || 'Failed to edit group. Status: ' + getCoursesResponse.status;
                            error = new Error(message);

                            error.status = getCoursesResponse.status;
                            error.response = getCoursesResponse;

                            throw error;

                        case 15:
                            getCourseAction = (0, _utils.actionCreator)(GET_COURSE, {
                                data: getCoursesResponse.data
                            });

                            dispatch(getCourseAction);

                            // when isSchoolCourse is true, countryCode will be undefined. Need to pass groupCountryCode in this case
                            // TODO how to pass groupCountryCode? through state?
                            getNewCourseAction = (0, _utils.actionCreator)(GET_NEW_COURSE, {
                                data: _extends({}, getCoursesResponse.data, {
                                    isSchoolCourse: isSchoolCourse
                                })
                            });

                            dispatch(getNewCourseAction);

                            getUPFCourseAction = (0, _utils.actionCreator)(GET_UPF_COURSE, {
                                data: getCoursesResponse.data
                            });

                            dispatch(getUPFCourseAction);
                            _context8.next = 27;
                            break;

                        case 23:
                            _context8.prev = 23;
                            _context8.t0 = _context8['catch'](2);

                            dispatch(_toastActions2.default.showToast({
                                variant: 'error',
                                messageId: 'Error Updating Group',
                                autoCloseMs: 6000
                            }));
                            throw _context8.t0;

                        case 27:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, undefined, [[2, 23]]);
        }));

        return function (_x8) {
            return _ref11.apply(this, arguments);
        };
    }();
};

var resetYearOptions = function resetYearOptions() {
    return function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(dispatch) {
            var getCourseAction;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            getCourseAction = (0, _utils.actionCreator)(RESET_COURSE_YEARS);

                            dispatch(getCourseAction);

                        case 2:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, undefined);
        }));

        return function (_x9) {
            return _ref12.apply(this, arguments);
        };
    }();
};

var initialiseCourseSelectOptions = function initialiseCourseSelectOptions(_ref13) {
    var countryOption = _ref13.countryOption,
        yearOption = _ref13.yearOption,
        allYearsOption = _ref13.allYearsOption,
        courseOption = _ref13.courseOption,
        upfCourseOption = _ref13.upfCourseOption,
        newCourseOption = _ref13.newCourseOption,
        noNewCourseFoundOption = _ref13.noNewCourseFoundOption,
        noUPFCourseFoundOption = _ref13.noUPFCourseFoundOption,
        upfCourseAdminSelectionOption = _ref13.upfCourseAdminSelectionOption,
        upfCurrentCourseSuffix = _ref13.upfCurrentCourseSuffix;
    return function () {
        var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(dispatch) {
            var teacherAction;
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            teacherAction = (0, _utils.actionCreator)(INITIALISE_COURSE_SELECT_OPTIONS, {
                                data: {
                                    countryOption: countryOption,
                                    yearOption: yearOption,
                                    allYearsOption: allYearsOption,
                                    courseOption: courseOption,
                                    upfCourseOption: upfCourseOption,
                                    newCourseOption: newCourseOption,
                                    noNewCourseFoundOption: noNewCourseFoundOption,
                                    noUPFCourseFoundOption: noUPFCourseFoundOption,
                                    upfCourseAdminSelectionOption: upfCourseAdminSelectionOption,
                                    upfCurrentCourseSuffix: upfCurrentCourseSuffix
                                }
                            });

                            dispatch(teacherAction);

                        case 2:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, undefined);
        }));

        return function (_x10) {
            return _ref14.apply(this, arguments);
        };
    }();
};
// Retrieve the New Courses availability criteria i.e. if new courses are available for a range of year groups
// defined in config. New courses will be rolled out progressively for various countries and grades.
// The config is to be updated as and when new courses are available for a year group / country
var getNewCoursesAvailabilityCriteria = function getNewCoursesAvailabilityCriteria() {
    return function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(dispatch) {
            var setConfig;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            if (_resources2.default.getConfigurationItem) {
                                setConfig = function setConfig(config) {
                                    var _ref16 = config || {},
                                        _ref16$yearGroups = _ref16.yearGroups,
                                        yearGroups = _ref16$yearGroups === undefined ? [] : _ref16$yearGroups,
                                        _ref16$countryCodes = _ref16.countryCodes,
                                        countryCodes = _ref16$countryCodes === undefined ? [] : _ref16$countryCodes;

                                    var configAction = (0, _utils.actionCreator)(GET_NEW_COURSE_AVAILABILITY_CRITERIA, {
                                        newCoursesAvailabilityCriteria: { yearGroups: yearGroups, countryCodes: countryCodes }
                                    });
                                    dispatch(configAction);
                                };

                                _resources2.default.getConfigurationItem('newCoursesAvailabilityCriteria').then(setConfig);
                            }

                        case 1:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, undefined);
        }));

        return function (_x11) {
            return _ref15.apply(this, arguments);
        };
    }();
};

exports.default = {
    setCountryHandler: setCountryHandler,
    getDefaultCourse: getDefaultCourse,
    setYearHandler: setYearHandler,
    getCourseYears: getCourseYears,
    setCourseHandler: setCourseHandler,
    setUPFCourseHandler: setUPFCourseHandler,
    setNewCourseHandler: setNewCourseHandler,
    getCourses: getCourses,
    resetYearOptions: resetYearOptions,
    initialiseCourseSelectOptions: initialiseCourseSelectOptions,
    getNewCoursesAvailabilityCriteria: getNewCoursesAvailabilityCriteria
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "51N/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MODAL_TYPE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Hooks


// Styles


// Components


// Helpers


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusTrapReact = __webpack_require__("ZQBc");

var _focusTrapReact2 = _interopRequireDefault(_focusTrapReact);

var _linguiCdn = __webpack_require__("siuH");

var _useKeyPress3 = __webpack_require__("shXg");

var _useKeyPress4 = _interopRequireDefault(_useKeyPress3);

var _useOutsideClick = __webpack_require__("hnRf");

var _useOutsideClick2 = _interopRequireDefault(_useOutsideClick);

__webpack_require__("xW01");

var _closeButton = __webpack_require__("Cfio");

var _closeButton2 = _interopRequireDefault(_closeButton);

var _oneRosterManageStudents = __webpack_require__("3ccH");

var _oneRosterManageStudents2 = _interopRequireDefault(_oneRosterManageStudents);

var _enums = __webpack_require__("royT");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODAL_TYPE = exports.MODAL_TYPE = {
    floating: 'floating'
};

/**
 *
 * @param title
 * @param children: content of the pop-up
 * @param closeHandler: action to perform on close
 * @param parentClasses: additional classes to apply to the modal
 * @param containerStyle: inline styles to apply to the modal
 * @param type:
 *  -'floating': will display a centered pop-up with an overlay behind
 * @returns {*}
 * @constructor
 */
function GenericModal(_ref) {
    var title = _ref.title,
        children = _ref.children,
        closeHandler = _ref.closeHandler,
        parentClasses = _ref.parentClasses,
        containerStyle = _ref.containerStyle,
        type = _ref.type,
        isOneRosterActivatedSchool = _ref.isOneRosterActivatedSchool;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var _useKeyPress = (0, _useKeyPress4.default)({
        targetKeyName: _enums.ESCAPE_KEY_NAME,
        targetKeyCode: _enums.ESCAPE_KEY_CODE
    }),
        _useKeyPress2 = _slicedToArray(_useKeyPress, 1),
        escapeKeyPressed = _useKeyPress2[0];

    // Effect for handling escape key press


    (0, _react.useEffect)(function () {
        if (escapeKeyPressed && closeHandler) {
            closeHandler();
        }
    }, [escapeKeyPressed]);

    var containerClasses = 'modal' + (type && type === MODAL_TYPE.floating ? ' modal--floating' : '') + ' ' + (parentClasses || '');

    // Click outside
    var modalContainerRef = (0, _react.useRef)(null);
    (0, _useOutsideClick2.default)([modalContainerRef], closeHandler);

    var getOneRosterStyles = function getOneRosterStyles() {
        if (isOneRosterActivatedSchool) {
            return {
                padding: '20px 24px',
                border: '2px solid #f7d064',
                borderRadius: '16px'
            };
        }
        return null;
    };

    var modalTemplate = _react2.default.createElement(
        'div',
        { ref: modalContainerRef },
        _react2.default.createElement(
            _focusTrapReact2.default,
            null,
            _react2.default.createElement(
                'div',
                {
                    style: _extends({}, containerStyle, getOneRosterStyles()),
                    className: containerClasses },
                isOneRosterActivatedSchool ? _react2.default.createElement(_oneRosterManageStudents2.default, { i18n: i18n, title: title }) : _react2.default.createElement(
                    _react.Fragment,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'modal__header' },
                        _react2.default.createElement(
                            'h2',
                            { className: 'modal__title' },
                            title
                        ),
                        _react2.default.createElement(_closeButton2.default, { closeHandler: closeHandler, i18n: i18n })
                    ),
                    children
                )
            )
        )
    );

    return type === MODAL_TYPE.floating ? _react2.default.createElement(
        'aside',
        { className: 'modal__overlay' },
        modalTemplate
    ) : modalTemplate;
}

GenericModal.propTypes = {
    title: _propTypes2.default.object,
    children: _propTypes2.default.any,
    closeHandler: _propTypes2.default.func.isRequired,
    containerStyle: _propTypes2.default.object,
    parentClasses: _propTypes2.default.string,
    type: _propTypes2.default.string,
    isOneRosterActivatedSchool: _propTypes2.default.bool
};

exports.default = GenericModal;

/***/ }),

/***/ "5eev":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Components


// Others


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _linguiCdn = __webpack_require__("siuH");

var _form = __webpack_require__("oS56");

var _form2 = _interopRequireDefault(_form);

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _enums = __webpack_require__("royT");

var _utils = __webpack_require__("6QRH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function EditClass(_ref) {
    var _this = this;

    var currentClassId = _ref.currentClassId,
        currentClassName = _ref.currentClassName,
        editClassName = _ref.editClassName,
        closeHandler = _ref.closeHandler;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    // State variables


    var _useState = (0, _react.useState)(''),
        _useState2 = _slicedToArray(_useState, 2),
        className = _useState2[0],
        setClassName = _useState2[1]; // this variable is the one that gets updated locally


    var _useState3 = (0, _react.useState)(null),
        _useState4 = _slicedToArray(_useState3, 2),
        errorMessage = _useState4[0],
        setErrorMessage = _useState4[1];

    var _useState5 = (0, _react.useState)(null),
        _useState6 = _slicedToArray(_useState5, 2),
        bottomErrorMessage = _useState6[0],
        setBottomErrorMessage = _useState6[1];

    var trimmedClassName = className.trim();

    // Effects
    (0, _react.useEffect)(function () {
        setClassName(currentClassName);
    }, [currentClassName]);

    // Handlers
    var localInputHandler = function localInputHandler(e) {
        // Reset the error messages
        if (errorMessage !== null) {
            setErrorMessage(null);
        }
        if (bottomErrorMessage !== null) {
            setBottomErrorMessage(null);
        }

        // Otherwise continue forward
        var name = e.target.value;
        setClassName(name);
    };
    var saveHandler = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
            var value, message, _message;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            // Prevent redirect from the default behaviour of a form
                            e.preventDefault();

                            _context.next = 3;
                            return editClassName({
                                classroomId: currentClassId,
                                name: trimmedClassName
                            });

                        case 3:
                            value = _context.sent;

                            if (!(value && value.status === 500)) {
                                _context.next = 10;
                                break;
                            }

                            message = _react2.default.createElement(_react3.Trans, { id: 'Error Message - Unable to proceed' });
                            _context.next = 8;
                            return setBottomErrorMessage(message);

                        case 8:
                            _context.next = 11;
                            break;

                        case 10:
                            if (value === true) {
                                // Afterwards this handler should close the modal
                                closeHandler();
                            } else if (value.message) {
                                _message = (0, _utils.getCorrectErrorMessage)(value, i18n);

                                setErrorMessage(_message);
                            }

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function saveHandler(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    // This variable describes if the submit button will be disabled or not
    var isFormButtonDisabled = trimmedClassName === '' || currentClassName === className || currentClassName === trimmedClassName;

    return _react2.default.createElement(
        _form2.default,
        { formHandler: saveHandler },
        _react2.default.createElement(
            'div',
            { className: 'form__row' },
            _react2.default.createElement(
                'label',
                { htmlFor: 'edit-class-input' },
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    _react2.default.createElement(_react3.Trans, { id: 'Class Dropdown - header' })
                )
            ),
            _react2.default.createElement('input', {
                id: 'edit-class-input',
                className: 'form__input'
                // eslint-disable-next-line jsx-a11y/no-autofocus
                , autoFocus: true,
                required: true,
                maxLength: _enums.CONFIG_VARS.classNameMaxLength,
                value: className,
                placeholder: i18n._( /*i18n*/{
                    id: 'Class edit - name placeholder'
                }),
                onChange: localInputHandler })
        ),
        errorMessage ? _react2.default.createElement(
            'div',
            { className: 'form__row' },
            _react2.default.createElement(
                'p',
                { className: 'form__error-message' },
                errorMessage
            )
        ) : '',
        _react2.default.createElement(
            'div',
            { className: 'form__row form__row--buttons' },
            _react2.default.createElement(_button2.default, {
                visibleText: _react2.default.createElement(_react3.Trans, { id: 'Class edit - Save' }),
                isBtnDisabled: isFormButtonDisabled,
                buttonType: 'submit'
            })
        ),
        bottomErrorMessage ? _react2.default.createElement(
            'div',
            { className: 'form__row' },
            _react2.default.createElement(
                'p',
                { className: 'form__error-message form__error-message--bottom' },
                bottomErrorMessage
            )
        ) : ''
    );
}

EditClass.propTypes = {
    currentClassId: _propTypes2.default.number,
    currentClassName: _propTypes2.default.string,
    closeHandler: _propTypes2.default.func,
    editClassName: _propTypes2.default.func
};

exports.default = EditClass;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "5knn":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".badge {\n  position: absolute;\n  width: 25px;\n  height: 25px; }\n  .badge__text {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    -webkit-transform: translate(-50%, -50%) rotate(-30deg);\n            transform: translate(-50%, -50%) rotate(-30deg);\n    text-transform: uppercase;\n    font-size: 6.25px;\n    color: #fff; }\n  #tableGroupHeader {\n  margin-left: -25px; }\n", ""]);
// Exports
exports.locals = {
	"badge": "badge",
	"badge__text": "badge__text",
	"tableGroupHeader": "tableGroupHeader"
};
module.exports = exports;


/***/ }),

/***/ "5opF":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/3df17861c6e19a36a9f33d6b4b650aa1.svg";

/***/ }),

/***/ "6QRH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.areNewCoursesAvailable = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global document */


exports.handleDefaults = handleDefaults;
exports.log = log;
exports.stripCharacters = stripCharacters;
exports.actionCreator = actionCreator;
exports.getParam = getParam;
exports.resetGroupSectionScroll = resetGroupSectionScroll;
exports.getCorrectErrorMessage = getCorrectErrorMessage;
exports.compareByLastName = compareByLastName;
exports.compareValues = compareValues;
exports.getDefaultGroupName = getDefaultGroupName;
exports.getScreenMode = getScreenMode;
exports.mergeKeyWithCollection = mergeKeyWithCollection;
exports.getLocale = getLocale;
exports.getProductById = getProductById;
exports.getConfiguration = getConfiguration;
exports.isValidMarketRegion = isValidMarketRegion;

var _querystring = __webpack_require__("1nuA");

var _querystring2 = _interopRequireDefault(_querystring);

var _lodash = __webpack_require__("M4fF");

var _enums = __webpack_require__("royT");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function handleDefaults(defaultObj, dynamicObj) {
    for (var key in dynamicObj) {
        defaultObj[key] = dynamicObj[key];
    }
    return defaultObj;
}

function log() {}

function stripCharacters(currentString) {
    var characterToFind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';

    return currentString.split(characterToFind).join('');
}

function actionCreator(type, payload) {
    return {
        type: type,
        payload: payload
    };
}

function getParam(param) {
    var queryParams = window.location.search;
    var query = queryParams.replace('?', '');
    var params = _querystring2.default.parse(query);
    return params[param];
}

function resetGroupSectionScroll() {
    var groupRefElement = document.getElementsByClassName('groups__filters');
    if (groupRefElement.length > 0) {
        // As the focus of the group sets to newGroup or anything else, the scrollTop changes, as such reset them to 0
        groupRefElement[0].scrollTop = 0;
    }
}

function getCorrectErrorMessage(response, i18n) {
    var status = response.status,
        message = response.message,
        code = response.code;


    if (status === 409) {
        // TODO: If backend has localisation this should possibly be considered to be implemented differently
        if (code === 'DuplicateEntityFound') {
            return i18n._( /*i18n*/{
                id: 'Error Message - Duplicate Name'
            });
        }
    }

    if (status === 400) {
        // TODO: If backend has localisation this should possibly be considered to be implemented differently
        if (code === 'Validation') {
            return i18n._( /*i18n*/{
                id: 'Error Message - Minmax password'
            });
        }
    }

    // If we don't support the error, return whatever message is being sent
    return message;
}

function compareByLastName(firstStudent, secondStudent, isAscending) {
    var firstName = firstStudent.lastName.toLowerCase() + ' ' + firstStudent.firstName.toLowerCase() + '}';
    var secondName = secondStudent.lastName.toLowerCase() + ' ' + secondStudent.firstName.toLowerCase() + '}';

    if (firstName < secondName) {
        return isAscending ? 1 : -1;
    }
    if (firstName > secondName) {
        return isAscending ? -1 : 1;
    }
    return 0;
}

/**
 * This function sorts an array of object by ascending order of the key provided, by default.
 * @param key           The object key to sort on (No test about its existence)
 * @param isAscending   Setting this to false requests a descending order
 * @returns {function(*, *): number}
 * Usage:               const mySortedArray = myArray.sort(compareValues('myObjectKey', true);
 * Source:              https://www.sitepoint.com/sort-an-array-of-objects-in-javascript/#creatingadynamicsortingfunction
 */
function compareValues(key) {
    var isAscending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return function innerSort(a, b) {
        var comparison = 0;
        if (a[key].toLowerCase() > b[key].toLowerCase()) {
            comparison = 1;
        } else if (a[key].toLowerCase() < b[key].toLowerCase()) {
            comparison = -1;
        }
        return isAscending ? comparison : comparison * -1;
    };
}
function getDefaultGroupName(name) {
    return name.substring(0, name.length - 2);
}

/**
 * This function gets the value attributed to body::before in /styles/utils.scss, depending on the width of the screen
 * Not using CSS custom properties to support IE11.
 * @returns {string}    Possible values: ['tablet-portrait', 'tablet-landscape', 'laptop']
 *
 * https://andy-bell.design/wrote/get-css-custom-property-value-with-javascript/
 *
 * TODO: use custom properties as soon as IE is dropped and minimum browser is Edge 15.
 */
function getScreenMode() {
    // eslint-disable-next-line no-undef
    return window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/"/g, '');
}

/**
 * A function to merge keys from a source collection with the target collection based on a shared id
 * @param targetCollection
 * @param sourceCollection
 * @param key in second collection to merge into the first
 * @param id to match objects in the two collections
 * @returns {[]}
 */
function mergeKeyWithCollection(targetCollection, sourceCollection, key, id) {
    var mergeItem = void 0;
    return targetCollection.map(function (item) {
        mergeItem = (0, _lodash.find)(sourceCollection, [id, item[id]]);
        // Our eslint rules prohibit the use of 'hasOwnProperty'
        if (mergeItem && key in mergeItem) {
            mergeItem = mergeItem[key];
        }
        return _extends({}, item, _defineProperty({}, key, mergeItem));
    });
}

function getLocale(localeOverride) {
    var DEFAULT_LOCALE = 'en-AU';
    return localeOverride || getParam('locale') || DEFAULT_LOCALE;
}

/**
 * This parses the config keys to find keys that look like "ProductName_ThemeCssUrl", and if found adds a key in the
 * config: { ThemeCssUrl: "Value of ProductName_ThemeCssUrl for the current product" }
 * If the productId provided is not listed or has no config value, defaults to DEFAULT_PRODUCT_ID config (Mathletics)
 * @param config        the already populated config
 * @param productId     the productId of the current product (should come from the Url)
 * BA 2020-04-24
 */
function getProductById(config, productId) {
    var suffix = 'ThemeCssUrl';
    var separator = '_';
    /**
     * This dictionary MUST contain the product to be supported, otherwise theming will default to supplied default:
     * DEFAULT_PRODUCT_ID (which shoul;d be: 1 (Mathletics))
     * BA 2020-04-24
     */
    var productIdDictionary = {
        1: 'Mathletics',
        3: 'Spellodrome',
        8: 'Phonics',
        9: 'Mathletica',
        10: 'ReadiwriterSpelling',
        11: 'ReadiwriterWriting'
    };
    var dictionary = {};

    for (var configItem in config) {
        var _configItem$split = configItem.split(separator),
            _configItem$split2 = _slicedToArray(_configItem$split, 2),
            productName = _configItem$split2[0],
            theme = _configItem$split2[1];

        if (theme === suffix && productName === productIdDictionary[productId]) {
            dictionary[theme] = config[configItem];
        }
    }

    if (!dictionary.ThemeCssUrl) {
        dictionary.ThemeCssUrl = config['' + productIdDictionary[_enums.DEFAULT_PRODUCT_ID] + separator + suffix];
    }
    return _extends({}, config, dictionary);
}

var getUserCountryCode = function getUserCountryCode() {
    var _queryString$parse = _querystring2.default.parse(window.location.search),
        countryCode = _queryString$parse.countryCode;

    return countryCode ? countryCode.toUpperCase() : '';
};

// Determine if new courses are available for the selected country & year group in the group modal
// New courses are displayed in the group modal drop down list (DDL) (in edit and new group modals)
// New Courses are available only for AUS schools years 3-6 initially.
// All year grades DDL option has a value of -1
var areNewCoursesAvailable = exports.areNewCoursesAvailable = function areNewCoursesAvailable() {
    var yearGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var countryId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    // eslint-disable-next-line no-underscore-dangle
    var config = window._env_ || {};
    var newCoursesAvailability = config.newCoursesAvailabilityCriteria ? config.newCoursesAvailabilityCriteria : {};
    var userCountryCode = countryId || getUserCountryCode();

    return newCoursesAvailability[userCountryCode] && newCoursesAvailability[userCountryCode].yearGroups.includes(parseInt(yearGroup, 10));
};

function getConfiguration(name) {
    // eslint-disable-next-line no-underscore-dangle
    if (window._env_) {
        // eslint-disable-next-line no-underscore-dangle
        return window._env_[name];
    }

    return '';
}

function isValidMarketRegion() {
    var marketRegionId = getParam('marketRegionId') || '';

    var hiddenThreeEssentialsRegions = ['AMER'];

    return !hiddenThreeEssentialsRegions.includes(marketRegionId);
}

/***/ }),

/***/ "6jOx":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("mrq4");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "7vkv":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".modal {\n  position: absolute;\n  z-index: 1;\n  background-color: #fff;\n  border: 1px solid #c2c2c2;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 2px 10px -3px rgba(0, 0, 0, .2);\n          box-shadow: 0 2px 10px -3px rgba(0, 0, 0, .2);\n  padding: 16px;\n  padding: 1rem; }\n  .modal__overlay {\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, .5); }\n  .modal--floating {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    left: 50%;\n    top: 50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    width: 750px;\n    max-height: 65vh;\n    overflow-y: scroll; }\n  .modal--floating::before, .modal--floating::after {\n      display: none; }\n  .modal--floating .modal__title {\n      margin-bottom: 16px;\n      margin-bottom: 1rem; }\n  .modal--floating .modal__text {\n      margin-bottom: 1em;\n      text-align: center; }\n  .modal--floating .form__row--buttons {\n      margin-top: 24px;\n      margin-top: 1.5rem; }\n  .modal--small {\n    width: 320px;\n    width: 20rem; }\n  .modal__header {\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start; }\n  .modal__title {\n    line-height: 1.666em;\n    font-size: 18px;\n    font-size: 1.125rem;\n    color: #374e60;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content; }\n  .modal__edit-groups {\n    color: #001937 !important;\n    font-size: 18px !important;\n    font-style: normal;\n    font-weight: 600 !important;\n    line-height: 28px !important; }\n  .modal__variable-height {\n    -ms-flex-negative: 1;\n        flex-shrink: 1;\n    /* stylelint-disable */\n    /* IE11 doesn't support the short-hand property \"flex\" properly, 40vh is a semi-magic number. BA 2020-02-25 */\n    -webkit-box-flex: 0;\n        -ms-flex-positive: 0;\n            flex-grow: 0;\n    -ms-flex-preferred-size: 40vh;\n        flex-basis: 40vh;\n    /* stylelint-enable */\n    /* This is what other browsers apply, basically leaving them do the math. BA 2020-02-25 */\n    overflow-y: auto;\n    padding-bottom: 1px; }\n  @supports (flex-basis: calc(70vh - 5px)) {\n      .modal__variable-height {\n        -ms-flex-preferred-size: auto;\n            flex-basis: auto; } }\n  .modal__message {\n    font-size: 12px;\n    font-size: 0.75rem;\n    text-align: center; }\n  .modal__text--error {\n    color: #bb1616; }\n  .modal__manage_students_container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    min-height: 90px;\n    margin-bottom: 4px;\n    width: 100%; }\n  .modal__manage_students_container__manage_students {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      gap: 24px;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-flex: 1;\n          -ms-flex: 1;\n              flex: 1;\n      font-size: 22px;\n      color: #004786;\n      font-weight: 400;\n      line-height: 140%;\n      letter-spacing: -0.2px;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center; }\n  .modal__manage_students_container__manage_students > h1 {\n        font-size: 40px;\n        font-weight: 400;\n        line-height: 52px; }\n  .modal__manage_students_container__manage_students > span {\n        font-size: 20px;\n        color: #5c6c7f;\n        font-weight: 400; }\n", ""]);
// Exports
exports.locals = {
	"modal": "modal",
	"modal__overlay": "modal__overlay",
	"modal--floating": "modal--floating",
	"modal__title": "modal__title",
	"modal__text": "modal__text",
	"form__row--buttons": "form__row--buttons",
	"modal--small": "modal--small",
	"modal__header": "modal__header",
	"modal__edit-groups": "modal__edit-groups",
	"modal__variable-height": "modal__variable-height",
	"modal__message": "modal__message",
	"modal__text--error": "modal__text--error",
	"modal__manage_students_container": "modal__manage_students_container",
	"modal__manage_students_container__manage_students": "modal__manage_students_container__manage_students"
};
module.exports = exports;


/***/ }),

/***/ "8+rk":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("WNej");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "87Sf":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/b5f6a74c72df3558d640d7465fdfbd95.svg";

/***/ }),

/***/ "8QCl":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
var ___CSS_LOADER_GET_URL_IMPORT___ = __webpack_require__("LsW0");
var ___CSS_LOADER_URL_IMPORT_0___ = __webpack_require__("W3S+");
var ___CSS_LOADER_URL_IMPORT_1___ = __webpack_require__("bFbq");
var ___CSS_LOADER_URL_IMPORT_2___ = __webpack_require__("yG5+");
var ___CSS_LOADER_URL_IMPORT_3___ = __webpack_require__("/T4H");
var ___CSS_LOADER_URL_IMPORT_4___ = __webpack_require__("jU6I");
var ___CSS_LOADER_URL_IMPORT_5___ = __webpack_require__("4MiP");
var ___CSS_LOADER_URL_IMPORT_6___ = __webpack_require__("wBpP");
var ___CSS_LOADER_URL_IMPORT_7___ = __webpack_require__("SZZ6");
var ___CSS_LOADER_URL_IMPORT_8___ = __webpack_require__("CPch");
var ___CSS_LOADER_URL_IMPORT_9___ = __webpack_require__("TwFx");
var ___CSS_LOADER_URL_IMPORT_10___ = __webpack_require__("OHZ+");
var ___CSS_LOADER_URL_IMPORT_11___ = __webpack_require__("nPBh");
var ___CSS_LOADER_URL_IMPORT_12___ = __webpack_require__("otLx");
var ___CSS_LOADER_URL_IMPORT_13___ = __webpack_require__("JPJw");
var ___CSS_LOADER_URL_IMPORT_14___ = __webpack_require__("kpGz");
var ___CSS_LOADER_URL_IMPORT_15___ = __webpack_require__("oHFR");
var ___CSS_LOADER_URL_IMPORT_16___ = __webpack_require__("3Y2X");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
// Module
exports.push([module.i, "/**\n * SCSS for IconButton component\n *\n * component-specific CSS must be defined inside the .component namespace block\n */\n.button {\n  border: none;\n  border-radius: 1.25em;\n  min-width: 8em;\n  background-color: #374e60;\n  padding: 0 1.667em;\n  line-height: 2.5em;\n  white-space: nowrap;\n  font-family: Poppins, sans-serif;\n  font-weight: 500 !important;\n  font-size: 12px;\n  font-size: 0.75rem;\n  color: #fff;\n  /* Colour variations:\n     *  - secondary,\n     *  - tertiary-cold\n     *  - tertiary-cool\n     *  - tertiary-warm\n     */ }\n.button:not(:disabled):hover, .button:not(:disabled):focus {\n    outline: none;\n    background-color: #bfd5e2;\n    color: #000; }\n.button:not(:disabled):hover svg g, .button:not(:disabled):focus svg g {\n      fill: #374e60; }\n.button:not(:disabled):active {\n    background-color: #000 !important;\n    color: #fff !important; }\n.button:not(:disabled):active svg g {\n      fill: currentColor !important; }\n.button:disabled {\n    opacity: 0.5 !important; }\n.button svg {\n    display: block;\n    margin: 0 auto; }\n.button svg g {\n      fill: currentColor; }\n.button--hidden {\n    position: absolute;\n    margin: -1px;\n    border: 0;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n    -webkit-clip-path: polygon(0 0, 0 0, 0 0);\n            clip-path: polygon(0 0, 0 0, 0 0);\n    padding: 0;\n    white-space: nowrap; }\n.button--icon-text {\n    position: relative;\n    padding: 0 1.2em 0 3em; }\n.button--icon-text .image-asset {\n      position: absolute;\n      top: 50%;\n      left: 1.5em;\n      -webkit-transform: translate(-50%, -50%);\n              transform: translate(-50%, -50%); }\n.button--icon-text .editIcon-image {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: row;\n              flex-direction: row; }\n.button--icon-svg {\n    width: 2.5em;\n    height: 2.5em;\n    min-width: 0;\n    padding: 0;\n    text-align: center; }\n.button--icon-background {\n    width: 2.5em;\n    height: 2.5em;\n    min-width: 0;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    padding: 0;\n    text-align: center; }\n.button--classes {\n    font-size: 10px;\n    font-size: 0.625rem; }\n.button--classes svg g {\n      fill: #dbe3e9; }\n.button--close {\n    margin: 0 -6px 0 0;\n    background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n    background-color: transparent !important; }\n.button--close:not(:disabled):hover, .button--close:not(:disabled):focus {\n      background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ");\n      background-color: #f2f5f7 !important; }\n.button--close:not(:disabled):active {\n      background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ");\n      background-color: transparent !important; }\n.button--edit {\n    background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_3___ + "); }\n.button--edit:hover, .button--edit:focus {\n      background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_4___ + "); }\n.button--edit:active {\n      background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_5___ + "); }\n.button--edit-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 6px;\n    position: relative;\n    color: #0063a7 !important;\n    min-width: 32px;\n    min-width: 2rem;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0;\n    background-color: transparent;\n    vertical-align: bottom;\n    background-image: none;\n    padding: 2px 8px;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n    -ms-flex-item-align: center;\n        align-self: center; }\n.button--edit-group:not(:disabled):hover, .button--edit-group:not(:disabled):focus {\n      cursor: pointer;\n      border-radius: 6px;\n      background-color: #ecf9fe;\n      background-repeat: no-repeat; }\n.button--edit-group:not(:disabled):active {\n      color: #0063a7 !important;\n      background-color: transparent !important;\n      background-repeat: no-repeat; }\n.button--eye-visible {\n    background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_6___ + "); }\n.button--eye-visible:hover, .button--eye-visible:focus {\n      background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_7___ + "); }\n.button--eye-visible:active {\n      background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_8___ + "); }\n.button--eye-hidden {\n    background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_9___ + "); }\n.button--eye-hidden:hover, .button--eye-hidden:focus {\n      background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_10___ + "); }\n.button--eye-hidden:active {\n      background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_11___ + "); }\n.button--info {\n    vertical-align: text-bottom;\n    font-size: 8px;\n    font-size: 0.5rem;\n    background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_12___ + "); }\n.button--info:not(:active):hover, .button--info:not(:active):focus {\n      background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_13___ + "); }\n.button--tick {\n    background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_14___ + "); }\n.button--tick:hover, .button--tick:focus {\n      background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_15___ + "); }\n.button--tick:active {\n      background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_16___ + "); }\n.button--actions {\n    border: 1px solid transparent; }\n.button--actions:not(:disabled):hover, .button--actions:not(:disabled):focus {\n      border-color: #374e60; }\n.button--actions:not(:disabled):active {\n      border-color: #000; }\n.button--actions.button--expanded {\n      border-color: #374e60;\n      background-color: #bfd5e2;\n      color: #000; }\n.button--actions.button--expanded:not(:disabled):hover, .button--actions.button--expanded:not(:disabled):focus {\n        background-color: #374e60;\n        color: #fff; }\n.button--actions.button--expanded:not(:disabled):hover svg g, .button--actions.button--expanded:not(:disabled):focus svg g {\n          fill: currentColor; }\n.button--actions.button--expanded svg g {\n        fill: #374e60; }\n.button--new-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 196px;\n    height: 40px;\n    padding: 8px 16px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 8px;\n    color: #0063a7;\n    border-radius: 12px;\n    border: 1px solid #4dc4ef;\n    background: rgba(255, 255, 255, .8);\n    opacity: 0;\n    -webkit-transition: 0.1s ease-in-out 0.6s;\n    transition: 0.1s ease-in-out 0.6s; }\n.groups__filters--expanded .button--new-group {\n      opacity: 1; }\n.button--new-group:hover {\n      background: #ecf9fe !important;\n      color: #0063a7 !important; }\n.button--secondary {\n    background-color: #bfd5e2;\n    color: #000; }\n.button--secondary:not(:disabled):hover, .button--secondary:not(:disabled):focus {\n      background-color: #374e60;\n      color: #fff; }\n.button--secondary:not(:disabled):hover svg g, .button--secondary:not(:disabled):focus svg g {\n        fill: currentColor; }\n.button--secondary svg g {\n      fill: #374e60; }\n.button--tertiary-cold {\n    background-color: #00a5ff; }\n.button--tertiary-cool {\n    background-color: #24853a; }\n.button--tertiary-warm {\n    background-color: #f06b0c; }\n.button--error {\n    background-color: #bb1616; }\n.button--tertiary-cold, .button--tertiary-cool, .button--tertiary-warm, .button--error {\n    color: #fff; }\n.button--tertiary-cold:not(:disabled):hover, .button--tertiary-cold:not(:disabled):focus, .button--tertiary-cool:not(:disabled):hover, .button--tertiary-cool:not(:disabled):focus, .button--tertiary-warm:not(:disabled):hover, .button--tertiary-warm:not(:disabled):focus, .button--error:not(:disabled):hover, .button--error:not(:disabled):focus {\n      background-color: #374e60;\n      color: #fff; }\n.button--tertiary-cold:not(:disabled):hover svg g, .button--tertiary-cold:not(:disabled):focus svg g, .button--tertiary-cool:not(:disabled):hover svg g, .button--tertiary-cool:not(:disabled):focus svg g, .button--tertiary-warm:not(:disabled):hover svg g, .button--tertiary-warm:not(:disabled):focus svg g, .button--error:not(:disabled):hover svg g, .button--error:not(:disabled):focus svg g {\n        fill: currentColor; }\n.edit-group {\n  width: 100%;\n  border-radius: 40px;\n  border: 1px solid #99ddf6;\n  padding: 8px 32px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  margin: 0 !important; }\n.edit-group-save-button {\n    color: #fff !important;\n    border: none;\n    background: linear-gradient(104deg, #00abe8 -2.03%, #007acc 43.7%, #0063a7 105.46%); }\n.edit-group-save-button:hover {\n      background: linear-gradient(102deg, #007acc 0%, #014b8b 100%); }\n.edit-group-delete-button {\n    background: rgba(255, 255, 255, .8);\n    color: #007acc; }\n.edit-group-delete-button:hover {\n      border: 1px solid #4dc4ef;\n      background: #eef8fe !important;\n      color: #007acc !important; }\n", ""]);
// Exports
exports.locals = {
	"button": "button",
	"button--hidden": "button--hidden",
	"button--icon-text": "button--icon-text",
	"image-asset": "image-asset",
	"editIcon-image": "editIcon-image",
	"button--icon-svg": "button--icon-svg",
	"button--icon-background": "button--icon-background",
	"button--classes": "button--classes",
	"button--close": "button--close",
	"button--edit": "button--edit",
	"button--edit-group": "button--edit-group",
	"button--eye-visible": "button--eye-visible",
	"button--eye-hidden": "button--eye-hidden",
	"button--info": "button--info",
	"button--tick": "button--tick",
	"button--actions": "button--actions",
	"button--expanded": "button--expanded",
	"button--new-group": "button--new-group",
	"groups__filters--expanded": "groups__filters--expanded",
	"button--secondary": "button--secondary",
	"button--tertiary-cold": "button--tertiary-cold",
	"button--tertiary-cool": "button--tertiary-cool",
	"button--tertiary-warm": "button--tertiary-warm",
	"button--error": "button--error",
	"edit-group": "edit-group",
	"edit-group-save-button": "edit-group-save-button",
	"edit-group-delete-button": "edit-group-delete-button"
};
module.exports = exports;


/***/ }),

/***/ "9VLZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _react3 = __webpack_require__("QruM");

var _toast = __webpack_require__("cEic");

var _toast2 = _interopRequireDefault(_toast);

var _toastActions = __webpack_require__("sFKd");

var _toastActions2 = _interopRequireDefault(_toastActions);

var _ico_success = __webpack_require__("0WBn");

var _ico_success2 = _interopRequireDefault(_ico_success);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ToastHost(_ref) {
    var items = _ref.items,
        hideToast = _ref.hideToast;

    (0, _react.useEffect)(function () {
        var timers = items.map(function (t) {
            if (!t.autoCloseMs) return null;
            return window.setTimeout(function () {
                return hideToast(t.id);
            }, t.autoCloseMs);
        });

        return function () {
            return timers.forEach(function (timer) {
                return timer && window.clearTimeout(timer);
            });
        };
    }, [items]);

    if (!items.length) return null;

    var toast = items[items.length - 1];

    console.log('toast variant', toast.variant);

    return _react2.default.createElement(_toast2.default, {
        variant: toast.variant,
        icon: toast.variant === 'success' ? _ico_success2.default : null,
        showToast: true,
        hideIcon: toast.variant === 'success',
        message: _react2.default.createElement(_react3.Trans, { id: toast.messageId, values: toast.values }),
        onClose: function onClose() {
            return hideToast(toast.id);
        },
        showCloseButton: true
    });
}

ToastHost.propTypes = {
    items: _propTypes2.default.array,
    hideToast: _propTypes2.default.func
};

function mapStateToProps(state) {
    return {
        items: state.toast.items
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, _toastActions2.default)(ToastHost);

/***/ }),

/***/ "Atdy":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("PYID");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "BUg0":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".console {\n  padding: 0 16px 58px;\n  padding: 0 1rem 3.625rem; }\n  .console__tools {\n    position: relative;\n    margin-bottom: 16px;\n    margin-bottom: 1rem;\n    z-index: 2; }\n  .console__groups-actions-container {\n    position: absolute;\n    top: 0;\n    left: 208px;\n    left: 13rem;\n    z-index: 1;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    width: calc(100% - 13rem); }\n  .console__tool {\n    margin-right: 8px;\n    margin-right: 0.5rem;\n    border: 1px solid #c2c2c2;\n    height: 24px;\n    height: 1.5rem;\n    background-color: #fff;\n    padding: 8px 16px 16px;\n    padding: 0.5rem 1rem 1rem; }\n  .console__tool--classes {\n      position: relative;\n      width: calc(10.5rem - 2px);\n      height: calc(1.5rem - 2.5em);\n      padding-bottom: calc(1rem + 2.5em - 6px); }\n  .console__tool--classes .button--info {\n        position: absolute;\n        top: 50%;\n        right: 0;\n        -webkit-transform: translateY(-50%);\n                transform: translateY(-50%); }\n  .console__tool--groups {\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n      -ms-flex-negative: 0;\n          flex-shrink: 0;\n      display: -ms-grid;\n      display: grid;\n      -ms-grid-columns: max-content 2rem 1fr;\n      grid-template-columns: -webkit-max-content 1fr;\n      grid-template-columns: max-content 1fr;\n      grid-template-areas: \"title filters\";\n      grid-column-gap: 2rem;\n      width: calc(100% - 15.75rem - 2px);\n      min-height: 32px;\n      min-height: 2rem;\n      height: auto;\n      padding-bottom: 2px; }\n  .console__tool--groups .console__title {\n        -ms-grid-row: 1;\n        -ms-grid-column: 1;\n        grid-area: title; }\n  .console__tool--groups .button--info {\n        margin-left: 8px;\n        margin-left: 0.5rem; }\n  .console__tool--actions {\n      -ms-flex-preferred-size: 30px;\n          flex-basis: 30px;\n      width: -webkit-min-content;\n      width: -moz-min-content;\n      width: min-content;\n      border: none;\n      background-color: transparent;\n      padding: 0 0 0 8px;\n      padding: 0 0 0 0.5rem; }\n  @media (min-width: 1025px) {\n        .console__tool--actions {\n          -ms-flex-preferred-size: 180px;\n              flex-basis: 180px;\n          padding: 0 1rem; }\n          .console__tool--actions .button {\n            display: inline-block; } }\n  .console__tool--actions .button {\n        display: block;\n        margin-bottom: 8px;\n        margin-bottom: 0.5rem; }\n  .console__title {\n    position: relative;\n    z-index: 2;\n    margin: 0 0 -1px auto;\n    border: 1px solid #c2c2c2;\n    border-radius: 0.25rem;\n    background-color: #fff;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n    padding: 1px 48px 1px 6px;\n    padding: 1px 3rem 1px 6px;\n    line-height: 26px;\n    line-height: 1.625rem;\n    font-family: Poppins, sans-serif;\n    font-weight: 400 !important;\n    font-size: 12px;\n    font-size: 0.75rem; }\n  .console__title--expanded {\n      border-bottom-color: #fff; }\n", ""]);
// Exports
exports.locals = {
	"console": "console",
	"console__tools": "console__tools",
	"console__groups-actions-container": "console__groups-actions-container",
	"console__tool": "console__tool",
	"console__tool--classes": "console__tool--classes",
	"button--info": "button--info",
	"console__tool--groups": "console__tool--groups",
	"console__title": "console__title",
	"console__tool--actions": "console__tool--actions",
	"button": "button",
	"console__title--expanded": "console__title--expanded"
};
module.exports = exports;


/***/ }),

/***/ "CPch":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/9c2224c23703d260612fcfabb8425577.svg";

/***/ }),

/***/ "Cfio":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _react3 = __webpack_require__("QruM");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(_ref) {
    var closeHandler = _ref.closeHandler,
        i18n = _ref.i18n;
    return _react2.default.createElement(_button2.default, {
        buttonStyle: _button.BUTTON_STYLES.iconBackground,
        importedClasses: 'button--close',
        callback: closeHandler,
        ariaProps: { 'aria-label': i18n._( /*i18n*/{
                id: 'Modal - Close pop-up'
            }) },
        title: _react2.default.createElement(_react3.Trans, { id: 'Modal - Close pop-up' }) });
};

CloseButton.propTypes = {
    i18n: _propTypes2.default.object,
    closeHandler: _propTypes2.default.func.isRequired
};

exports.default = CloseButton;

/***/ }),

/***/ "DMUb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mathleticsPortalCommunicationService = __webpack_require__("UTT2");

var _mathleticsPortalCommunicationService2 = _interopRequireDefault(_mathleticsPortalCommunicationService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PortalCommunication = function () {
    function PortalCommunication() {
        _classCallCheck(this, PortalCommunication);
    }

    _createClass(PortalCommunication, null, [{
        key: 'loadingSpinnerOff',
        value: function loadingSpinnerOff() {
            _mathleticsPortalCommunicationService2.default.requestLoadingSpinner(false);
        }

        // invoke this method to let the 3p-portal know
        // that we want to navigate to current module landing screen

    }, {
        key: 'navigateToLandingScreen',
        value: function navigateToLandingScreen() {
            var moduleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            _mathleticsPortalCommunicationService2.default.requestNavigateToLanding(moduleName);
        }
    }, {
        key: 'serverError',
        value: function serverError(error) {
            _mathleticsPortalCommunicationService2.default.requestServerError(error);
        }
    }, {
        key: 'requestModuleChange',
        value: function requestModuleChange(moduleId, moduleParameters) {
            _mathleticsPortalCommunicationService2.default.requestModuleChange(moduleId, moduleParameters);
        }
    }, {
        key: 'requestLoadingSpinner',
        value: function requestLoadingSpinner(bool) {
            _mathleticsPortalCommunicationService2.default.requestLoadingSpinner(bool);
        }
    }, {
        key: 'requestInfoModal',
        value: function requestInfoModal(girlIds) {
            _mathleticsPortalCommunicationService2.default.requestDucsModal(girlIds);
        }
    }, {
        key: 'informClassGroupSelection',
        value: function informClassGroupSelection(classId) {
            _mathleticsPortalCommunicationService2.default.informClassGroupSelection(classId);
        }
    }]);

    return PortalCommunication;
}();

exports.default = PortalCommunication;

/***/ }),

/***/ "Dys2":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
var ___CSS_LOADER_GET_URL_IMPORT___ = __webpack_require__("LsW0");
var ___CSS_LOADER_URL_IMPORT_0___ = __webpack_require__("1uEC");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.i, ".add-students__tick {\n  display: inline-block;\n  height: 1.6em;\n  width: 1.6em;\n  font-size: 1em;\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat 50% 50% #33a64d;\n  border-radius: 50%;\n  vertical-align: middle; }\n\n.add-students__search .table__cell {\n  width: 250px; }\n\n.add-students .select--content {\n  width: 250px; }\n", ""]);
// Exports
exports.locals = {
	"add-students__tick": "add-students__tick",
	"add-students__search": "add-students__search",
	"table__cell": "table__cell",
	"add-students": "add-students",
	"select--content": "select--content"
};
module.exports = exports;


/***/ }),

/***/ "EJJB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("GiK3");

var CourseInformationContext = (0, _react.createContext)(null);

exports.default = CourseInformationContext;

/***/ }),

/***/ "EUcZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Styles


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("Vp9z");

var _utils = __webpack_require__("6QRH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param id
 * @param srLabel: the accessible "question" to which the radio buttons answer (alternatively, provide an
 *          "aria-describedBy" in ariaProps
 * @param groupName: name of the group of radio buttons
 * @param value
 * @param listOfButtons
 * @param propertyName: the name of the key representing the value to give to the radio button
 * @param visibleProperty: the name of the property representing the visible label text of the radio buttons
 * @param selectHandler
 * @param isDisabled
 * @param ariaProps:
 *          - if no srLabel is provided, provide at least "aria-describedBy" with the id of the element describing the
 *          question to which the radio buttons answer
 * @param isRequired
 * @returns {*}
 * @constructor
 */
function RadioButton(_ref) {
    var id = _ref.id,
        srLabel = _ref.srLabel,
        groupName = _ref.groupName,
        value = _ref.value,
        listOfButtons = _ref.listOfButtons,
        propertyName = _ref.propertyName,
        visibleProperty = _ref.visibleProperty,
        changeHandler = _ref.changeHandler,
        isDisabled = _ref.isDisabled,
        ariaProps = _ref.ariaProps,
        isRequired = _ref.isRequired,
        parentClasses = _ref.parentClasses,
        importedClasses = _ref.importedClasses;

    var callbackAction = function callbackAction(e) {
        if (changeHandler && !isDisabled) {
            changeHandler(e);
        }
    };
    var containerClasses = 'radio-button__item ' + (parentClasses || '');
    var inputClasses = 'radio-button ' + (importedClasses || '');

    return _react2.default.createElement(
        _react.Fragment,
        null,
        srLabel ? _react2.default.createElement(
            'span',
            { className: 'sr-only' },
            srLabel
        ) : '',
        listOfButtons.map(function (button, index) {
            var radioId = 'radio-' + id + '-' + (0, _utils.stripCharacters)(groupName) + '-' + index;
            return _react2.default.createElement(
                'div',
                {
                    key: 'radio-' + groupName + '-' + button[propertyName],
                    className: containerClasses + ' ' + (button.isDisabled ? 'radio-button__item--disabled' : '') },
                _react2.default.createElement('input', _extends({
                    type: 'radio',
                    id: radioId,
                    name: groupName,
                    value: button[propertyName],
                    className: inputClasses,
                    onChange: callbackAction,
                    disabled: isDisabled || button.isDisabled,
                    required: isRequired,
                    checked: value === button[propertyName]
                }, ariaProps)),
                _react2.default.createElement(
                    'label',
                    { htmlFor: radioId, className: 'radio-button__label' },
                    _react2.default.createElement(
                        'span',
                        { className: 'radio-button__label-text' },
                        button[visibleProperty]
                    )
                )
            );
        })
    );
}

RadioButton.defaultProps = {
    propertyName: 'value',
    visibleProperty: 'name',
    importedClasses: ''
};

RadioButton.propTypes = {
    id: _propTypes2.default.string,
    srLabel: _propTypes2.default.string,
    groupName: _propTypes2.default.string,
    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    listOfButtons: _propTypes2.default.array,
    propertyName: _propTypes2.default.string,
    visibleProperty: _propTypes2.default.string,
    isDisabled: _propTypes2.default.bool,
    ariaProps: _propTypes2.default.object,
    isRequired: _propTypes2.default.bool,
    changeHandler: _propTypes2.default.func.isRequired,
    parentClasses: _propTypes2.default.string,
    importedClasses: _propTypes2.default.string
};

exports.default = RadioButton;

/***/ }),

/***/ "EnPQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Styles


// Components


// Context


// Actions


// Action Type for moving students


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _linguiCdn = __webpack_require__("siuH");

__webpack_require__("YkNq");

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _moveList = __webpack_require__("WAiw");

var _moveList2 = _interopRequireDefault(_moveList);

var _moveListBody = __webpack_require__("+tD/");

var _genericModal = __webpack_require__("51N/");

var _genericModal2 = _interopRequireDefault(_genericModal);

var _consoleModalContext = __webpack_require__("U07W");

var _consoleModalContext2 = _interopRequireDefault(_consoleModalContext);

var _consoleActions = __webpack_require__("SC2c");

var _consoleActions2 = _interopRequireDefault(_consoleActions);

var _enums = __webpack_require__("royT");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function MoveStudents(props) {
    var _this = this;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    // Props


    var classGroupStudents = props.classGroupStudents,
        mainSelectedStudentIds = props.mainSelectedStudentIds,
        closeHandler = props.closeHandler,
        updateCurrentClassId = props.updateCurrentClassId,
        assignClassStudent = props.assignClassStudent,
        productId = props.productId,
        currentClassId = props.currentClassId;

    // State variables

    var _useState = (0, _react.useState)(null),
        _useState2 = _slicedToArray(_useState, 2),
        bottomErrorMessage = _useState2[0],
        setBottomErrorMessage = _useState2[1];

    var _useState3 = (0, _react.useState)({}),
        _useState4 = _slicedToArray(_useState3, 2),
        studentsToUpdate = _useState4[0],
        setStudentsToUpdate = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isApplyButtonDisabled = _useState6[0],
        setIsApplyButtonDisabled = _useState6[1];

    var _useState7 = (0, _react.useState)([]),
        _useState8 = _slicedToArray(_useState7, 2),
        selectedStudents = _useState8[0],
        setSelectedStudents = _useState8[1];

    // ComponentDidMount


    (0, _react.useEffect)(function () {
        var newStudents = classGroupStudents.filter(function (student) {
            return mainSelectedStudentIds.includes(student.userProfileId);
        });
        setSelectedStudents(newStudents);
    }, [classGroupStudents, mainSelectedStudentIds]);

    // Context

    var _useContext = (0, _react.useContext)(_consoleModalContext2.default),
        setShowConsoleModal = _useContext.setShowConsoleModal,
        setConsoleModalContent = _useContext.setConsoleModalContent;

    // Handlers


    var closeConfirmationModal = function closeConfirmationModal() {
        setShowConsoleModal(false);
        closeHandler();
    };

    // This handler will determine which type of student requires to be updated based on their actionType
    var updateMoveStudentList = function updateMoveStudentList(_ref) {
        var userId = _ref.userId,
            actionType = _ref.actionType,
            actionProperties = _ref.actionProperties,
            isForAllStudents = _ref.isForAllStudents;

        var tempUpdateStudents = _extends({}, studentsToUpdate);
        if (isForAllStudents) {
            if (actionType === _moveListBody.REMOVE_SELECT_VALUE) {
                mainSelectedStudentIds.map(function (studentId) {
                    tempUpdateStudents[studentId] = {
                        sourceClassId: currentClassId,
                        studentProfileId: studentId,
                        actionType: _enums.actionTypeIds[actionType]
                    };
                    return true;
                });
            } else if ((actionType === _moveListBody.COPY_SELECT_VALUE || actionType === _moveListBody.MOVE_SELECT_VALUE) && actionProperties) {
                mainSelectedStudentIds.map(function (studentId) {
                    tempUpdateStudents[studentId] = {
                        destinationClassId: parseInt(actionProperties.destinationClassId, 10),
                        destinationGroupId: parseInt(actionProperties.destinationGroupId, 10),
                        sourceClassId: currentClassId,
                        studentProfileId: studentId,
                        actionType: _enums.actionTypeIds[actionType]
                    };
                    return true;
                });
            } else {
                // If nothing is applicable, clean the list of students (will disable apply button)
                for (var student in tempUpdateStudents) {
                    delete tempUpdateStudents[student];
                }
            }

            // Following `else if` rules apply to NOT ALL STUDENTS.
        } else if (actionType === _moveListBody.REMOVE_SELECT_VALUE) {
            tempUpdateStudents[userId] = {
                sourceClassId: currentClassId,
                studentProfileId: userId,
                actionType: _enums.actionTypeIds[actionType]
            };
        } else if ((actionType === _moveListBody.COPY_SELECT_VALUE || actionType === _moveListBody.MOVE_SELECT_VALUE) && actionProperties) {
            tempUpdateStudents[userId] = {
                destinationClassId: parseInt(actionProperties.destinationClassId, 10),
                destinationGroupId: parseInt(actionProperties.destinationGroupId, 10),
                sourceClassId: currentClassId,
                studentProfileId: userId,
                actionType: _enums.actionTypeIds[actionType]
            };
        } else if (actionType === '' || actionProperties === undefined) {
            // if the actionType is empty or the property itself is undefined
            delete tempUpdateStudents[userId];
        }

        setStudentsToUpdate(tempUpdateStudents);
    };

    var saveHandler = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
            var listOfStudentsToUpdate, assignStudents, assignStudentsBody, requests;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            /**
                             * TODO: as the Back-end handles all the different actions to perform from one single set of data,
                             * TODO: and only a single response is sent, what can happen is: if part of the actions are successful but other
                             * TODO: parts are failing, the back-end response will be "failure". Which is misleading as EVERYTHING hasn't
                             * TODO: failed.
                             *
                             * TODO: Back-end should report what is successful and what isn't so that Front-End can display accurate
                             * TODO: information.
                             * BA 2020-07-01 (accurate as to release 1.16.0)
                             */
                            // Prevent redirect from the default behaviour of a form
                            e.preventDefault();
                            setBottomErrorMessage(false);

                            listOfStudentsToUpdate = Object.keys(studentsToUpdate);
                            assignStudents = listOfStudentsToUpdate.map(function (student) {
                                return studentsToUpdate[student];
                            });
                            assignStudentsBody = {
                                assignStudents: assignStudents
                            };
                            _context.next = 7;
                            return assignClassStudent(assignStudentsBody);

                        case 7:
                            requests = _context.sent;


                            // Success/Error handling
                            if (requests !== false) {
                                setConsoleModalContent(_react2.default.createElement(
                                    _genericModal2.default,
                                    {
                                        title: _react2.default.createElement(_react3.Trans, { id: 'Move Modal - Title' }),
                                        closeHandler: closeConfirmationModal,
                                        parentClasses: 'modal--small',
                                        type: _genericModal.MODAL_TYPE.floating },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form__message' },
                                        _react2.default.createElement(_react3.Trans, { id: 'Add Modal - Success Message' }),
                                        ' ',
                                        _react2.default.createElement('span', { className: 'add-students__tick' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form__row form__row--buttons' },
                                        _react2.default.createElement(_button2.default, {
                                            callback: closeConfirmationModal,
                                            visibleText: i18n._( /*i18n*/{
                                                id: 'Button - Ok'
                                            }) })
                                    )
                                ));
                                updateCurrentClassId({ productId: productId, classId: currentClassId });
                            } else {
                                setBottomErrorMessage(i18n._( /*i18n*/{
                                    id: 'Update students - Error message'
                                }));
                            }

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function saveHandler(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    /**
     * This effect will determine whether the student to update has valid value,
     * and check if the user can apply their changes
     */
    (0, _react.useEffect)(function () {
        var listOfStudentsToUpdate = Object.keys(studentsToUpdate);
        setIsApplyButtonDisabled(listOfStudentsToUpdate.length === 0);
    }, [studentsToUpdate]);

    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            'div',
            { className: 'modal__variable-height' },
            _react2.default.createElement(_moveList2.default, {
                studentsList: selectedStudents,
                updateMoveStudentList: updateMoveStudentList
            })
        ),
        _react2.default.createElement(_react3.Trans, { id: 'Add or Move Modal - note message - product ' + productId, defaults: '<0><1>Title</1>Message</0>',
            components: [_react2.default.createElement('p', { className: 'form__message' }), _react2.default.createElement('span', { className: 'form__note' })]
        }),
        _react2.default.createElement(
            'div',
            { className: 'form__row form__row--buttons' },
            _react2.default.createElement(_button2.default, {
                callback: closeConfirmationModal,
                visibleText: i18n._( /*i18n*/{
                    id: 'Modal - Cancel'
                }) }),
            _react2.default.createElement(_button2.default, {
                callback: saveHandler,
                isBtnDisabled: isApplyButtonDisabled,
                visibleText: i18n._( /*i18n*/{
                    id: 'Move Modal - Apply'
                }) })
        ),
        bottomErrorMessage ? _react2.default.createElement(
            'div',
            { className: 'form__row' },
            _react2.default.createElement(
                'p',
                { className: 'form__error-message form__error-message--bottom' },
                bottomErrorMessage
            )
        ) : ''
    );
}

MoveStudents.propTypes = {
    closeHandler: _propTypes2.default.func,
    // Action
    updateCurrentClassId: _propTypes2.default.func,
    assignClassStudent: _propTypes2.default.func,
    // State
    productId: _propTypes2.default.number,
    currentClassId: _propTypes2.default.number,
    classGroupStudents: _propTypes2.default.array,
    mainSelectedStudentIds: _propTypes2.default.array
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from MessageModalCombinedReducers.
 */
function mapStateToProps(state) {
    var _state$consoleReducer = state.consoleReducer,
        productId = _state$consoleReducer.productId,
        classGroupStudents = _state$consoleReducer.classGroupStudents,
        mainSelectedStudentIds = _state$consoleReducer.mainSelectedStudentIds,
        currentClassId = _state$consoleReducer.currentClassId;


    return {
        productId: productId,
        currentClassId: currentClassId,
        classGroupStudents: classGroupStudents,
        mainSelectedStudentIds: mainSelectedStudentIds
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        updateCurrentClassId: _consoleActions2.default.updateCurrentClassId,
        assignClassStudent: _consoleActions2.default.assignClassStudent
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MoveStudents);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "FLtZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Other imports


var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ErrorHandling = function () {
    function ErrorHandling() {
        _classCallCheck(this, ErrorHandling);
    }

    _createClass(ErrorHandling, null, [{
        key: 'addResourceResponseErrorInterceptor',
        value: function addResourceResponseErrorInterceptor(dispatch) {
            // The interceptor needs access to dispatch() so that it can
            // initiate the opening of a model dialog, so we bind it in
            // as the first parameter.

            var interceptor = ErrorHandling.handleErrors.bind(this, dispatch);

            _resources2.default.env.addResponseInterceptor(interceptor);
        }

        // This is a function that looks at the response status and interact accordingly

    }, {
        key: 'handleErrors',
        value: function handleErrors(dispatch, result) {
            var valid = true;

            switch (result.status) {
                case 0: // OPTIONS ERROR
                case 400:
                case 401: // BE expired token
                case 403: // FORBIDDEN ERROR
                case 404: // NOT FOUND
                case 409: // CONFLICT ERROR
                case 500:
                    // SERVER ERROR
                    valid = false;
                    break;
                default:
            }

            result.valid = valid;

            return result;
        }
    }]);

    return ErrorHandling;
}();

exports.default = ErrorHandling;

/***/ }),

/***/ "FOJt":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("5knn");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "FjEf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = consoleReducer;

var _isEqual = __webpack_require__("hygk");

var _isEqual2 = _interopRequireDefault(_isEqual);

var _consoleActions = __webpack_require__("SC2c");

var _coursesActions = __webpack_require__("5/v9");

var _groupActions = __webpack_require__("e4+b");

var _studentSelectionActions = __webpack_require__("4BpE");

var _enums = __webpack_require__("royT");

var _utils = __webpack_require__("6QRH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
// Actions


// Helpers


// Initial State
var initialState = {
    isSisSchool: null,
    classGroups: [],
    classGroupStudents: [],
    classes: [],
    currentClassName: '',
    currentClassId: 0,
    groupCountryCode: '',
    // Student Selection values
    mainCheckAllIsSelected: false,
    mainSelectedStudentIds: [],
    /*
        allCurrentStudentIds will determine the selectAll checkbox,
        if there are filters then it's only applicable for the view the user is currently in
    */
    mainAllCurrentStudentIds: [],
    // Course Specific values
    countrySelectValue: '',
    countrySelectOptions: [],
    yearSelectValue: '',
    yearSelectOptions: [],
    courseSelectValue: '',
    courseSelectOptions: [],
    upfCourseSelectOptions: [],
    upfCurrentCourseSuffix: '',
    newCourseSelectOptions: [],
    defaultCountryOption: {},
    defaultYearOption: {},
    defaultAllYearsOption: {},
    defaultCourseOption: {},
    defaultNewCourseOption: {},
    defaultNoNewCourseFoundOption: {},
    upfCourseAdminSelectionOption: {},
    noUPFCourseFoundOption: {},
    groupUpfCourseOption: null,
    groupCourseOption: null,
    groupNewCourseOption: null,
    defaultSelectOptions: {},
    // Other
    hasContentLoaded: false,
    productId: null,
    isFetchingEditInformation: false,
    newCoursesAvailabilityCriteria: {},
    isMultiLevelGroupsCreated: false,
    isNewGroupsCreated: false,
    createdMultiLevelGroupsCount: 0
};

// By default, all groups should be selected + add in allGroups when there's only 1 group
function setGroupVisibleProperty(groups) {
    var existingGroups = groups;
    if (groups.length === 1) {
        existingGroups = [{
            groupId: _enums.ALL_GROUP_ID,
            name: 'All groups', // This is translated within the component itself
            isDefault: false
        }].concat(_toConsumableArray(existingGroups));
    }
    return existingGroups.map(function (group) {
        return _extends({}, group, {
            isSelected: true
        });
    });
}

function getUpfCourseSelectOptions(state, groupUpfCourse, upfCourseList) {
    var upfCourseAdminSelectionOption = state.upfCourseAdminSelectionOption,
        noUPFCourseFoundOption = state.noUPFCourseFoundOption,
        upfCurrentCourseSuffix = state.upfCurrentCourseSuffix;

    var noUPFCourseFound = [noUPFCourseFoundOption];
    var updatedUpfCourseList = [].concat(_toConsumableArray(upfCourseList));
    var upfCourseSelectDefaultOptions = [upfCourseAdminSelectionOption];

    if (groupUpfCourse) {
        upfCourseSelectDefaultOptions.push({
            id: groupUpfCourse.id,
            name: groupUpfCourse.name + ' (' + upfCurrentCourseSuffix + ')'
        });

        var existingUpfCourseIndex = updatedUpfCourseList.findIndex(function (course) {
            return course.id === groupUpfCourse.id;
        });

        if (existingUpfCourseIndex !== -1) {
            updatedUpfCourseList.splice(existingUpfCourseIndex, 1);
        }
    }

    if (upfCourseList.length === 0) {
        return [].concat(noUPFCourseFound, _toConsumableArray(updatedUpfCourseList));
    }

    return [].concat(upfCourseSelectDefaultOptions, _toConsumableArray(updatedUpfCourseList));
}

function getCourseSelectOptions(state, groupCourse, courseList) {
    var defaultCourseOption = state.defaultCourseOption,
        upfCurrentCourseSuffix = state.upfCurrentCourseSuffix;

    var updatedCourseList = [].concat(_toConsumableArray(courseList));
    var courseSelectDefaultOptions = [defaultCourseOption];

    if (groupCourse) {
        courseSelectDefaultOptions.push({
            id: groupCourse.id,
            name: groupCourse.name + ' (' + upfCurrentCourseSuffix + ')'
        });

        var existingCourseIndex = updatedCourseList.findIndex(function (course) {
            return course.id === groupCourse.id;
        });

        if (existingCourseIndex !== -1) {
            updatedCourseList.splice(existingCourseIndex, 1);
        }
    }

    return [].concat(courseSelectDefaultOptions, _toConsumableArray(updatedCourseList));
}

function getNewCourseCurrentSelectValue(state, conquestCourses) {
    var groupNewCourseOption = state.groupNewCourseOption;

    var course = conquestCourses.find(function (c) {
        return c && (groupNewCourseOption && groupNewCourseOption.id === c.id || !groupNewCourseOption && c.isDefault === true);
    });

    return course && course.id ? course.id : _groupActions.DEFAULT_NEW_COURSE_ID;
}

function getNewCourseSelectOptions(state, groupNewCourse, newCourseList) {
    var defaultNoNewCourseFoundOption = state.defaultNoNewCourseFoundOption,
        upfCurrentCourseSuffix = state.upfCurrentCourseSuffix,
        defaultNewCourseOption = state.defaultNewCourseOption;

    // TODO Review the format of newCourseList and simplify the following to 'newCourseList || []' if always an array

    var updatedNewCourseList = Array.isArray(newCourseList) ? [].concat(_toConsumableArray(newCourseList)) : [];

    var newCourseSelectDefaultOptions = updatedNewCourseList.length > 0 ? [defaultNewCourseOption] : [defaultNoNewCourseFoundOption];

    // If we have a selected conquest course we push it to the top
    if (groupNewCourse) {
        newCourseSelectDefaultOptions.push({
            id: groupNewCourse.id,
            name: groupNewCourse.name + ' (' + upfCurrentCourseSuffix + ')'
        });

        var existingNewCourseIndex = updatedNewCourseList.findIndex(function (course) {
            return course.id === groupNewCourse.id;
        });

        if (existingNewCourseIndex !== -1) {
            updatedNewCourseList.splice(existingNewCourseIndex, 1);
        }
    }

    var defaultIndex = updatedNewCourseList.findIndex(function (c) {
        return c.isDefault === true;
    });

    // If we have a default course we push it to the top or underneath the assigned course
    if (defaultIndex !== -1) {
        var defaultCourse = updatedNewCourseList.splice(defaultIndex, 1)[0];
        var assignedIndex = -1;

        if (groupNewCourse) {
            assignedIndex = updatedNewCourseList.findIndex(function (c) {
                return c.id === groupNewCourse.id;
            });
        }

        if (assignedIndex !== -1) {
            updatedNewCourseList.splice(assignedIndex + 1, 0, defaultCourse);
        } else {
            updatedNewCourseList.unshift(defaultCourse);
        }
    }

    return [].concat(newCourseSelectDefaultOptions, _toConsumableArray(updatedNewCourseList));
}

function isGroupVisible(groupId, groups) {
    var currentGroup = groups.filter(function (group) {
        return group.groupId === groupId;
    });
    return currentGroup && currentGroup[0].isSelected;
}

function setUpAllCurrentStudents(students) {
    return students.map(function (groupStudent) {
        return groupStudent.userProfileId;
    });
}

function setUpStudentVisibility(students) {
    return students.map(function (student) {
        return _extends({}, student, {
            isVisible: true
        });
    });
}

function shouldAllGroupsUpdate(groups, updatedGroup) {
    var validGroupLength = groups.length - 1; // - 1 due to the all groups
    var isSelectedValues = updatedGroup.filter(function (group) {
        return group.isSelected;
    }).length;
    return isSelectedValues === validGroupLength;
}

function updateGroupVisibleProperties(groups, value, isSelected) {
    var parsedValue = parseInt(value, 10);
    var updatedGroup = groups.map(function (group) {
        // For AllGroups, set the value to whatever the value of isSelected is
        if (parsedValue === _enums.ALL_GROUP_ID) {
            return _extends({}, group, {
                isSelected: isSelected
            });
        }
        // As the selected value is not allGroups, set allGroups isSelected to be false
        if (group.groupId === _enums.ALL_GROUP_ID) {
            return _extends({}, group, {
                isSelected: false
            });
        }
        // Set the selected group, to be the inverse of what it was
        if (parsedValue === group.groupId) {
            return _extends({}, group, {
                isSelected: !group.isSelected
            });
        }
        return group;
    });

    // The logic below will determine whether allGroups will be selected when a group was not selected initially
    var selectAllGroups = shouldAllGroupsUpdate(groups, updatedGroup);
    if (selectAllGroups) {
        updatedGroup[0] = _extends({}, updatedGroup[0], {
            isSelected: true
        });
    }

    return updatedGroup;
}

function consoleReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];
    var type = action.type,
        payload = action.payload;


    switch (type) {
        case _coursesActions.FETCHING_COURSE_CONTENT:
            {
                return _extends({}, state, {
                    hasContentLoaded: true
                });
            }
        case _consoleActions.GET_TEACHER_CLASS:
            {
                var _payload$data = payload.data,
                    classGroups = _payload$data.classGroups,
                    classGroupStudents = _payload$data.classGroupStudents,
                    classes = _payload$data.classes,
                    externalClassroomId = _payload$data.externalClassroomId;

                var productId = payload.productId;
                var classIdParam = (0, _utils.getParam)('classId');
                var classId = classIdParam ? Number(classIdParam) : payload.data.classId;

                var currentClassName = classes.filter(function (item) {
                    return item.classId === classId;
                });
                var mainAllCurrentStudentIds = setUpAllCurrentStudents(classGroupStudents);
                var initialClassGroupStudents = setUpStudentVisibility(classGroupStudents);

                var resetCheckboxProperties = {
                    mainCheckAllIsSelected: false,
                    mainSelectedStudentIds: [],
                    mainAllCurrentStudentIds: mainAllCurrentStudentIds
                };

                return _extends({}, state, {
                    productId: productId,
                    classGroups: setGroupVisibleProperty(classGroups),
                    classGroupStudents: initialClassGroupStudents,
                    classes: classes,
                    hasContentLoaded: true,
                    currentClassName: currentClassName && currentClassName.length > 0 ? currentClassName[0].name : '',
                    currentClassId: classId,
                    externalClassroomId: externalClassroomId
                }, resetCheckboxProperties);
            }
        case _consoleActions.GET_UPDATED_TEACHER_CLASS:
            {
                var _payload$data2 = payload.data,
                    _classGroups = _payload$data2.classGroups,
                    _classGroupStudents = _payload$data2.classGroupStudents,
                    _classId = _payload$data2.classId,
                    _externalClassroomId = _payload$data2.externalClassroomId,
                    isSisSchool = _payload$data2.isSisSchool;


                var _currentClassName = state.classes.filter(function (item) {
                    return item.classId === _classId;
                });
                var _mainAllCurrentStudentIds = setUpAllCurrentStudents(_classGroupStudents);
                var _initialClassGroupStudents = setUpStudentVisibility(_classGroupStudents);

                var _resetCheckboxProperties = {
                    mainCheckAllIsSelected: false,
                    mainSelectedStudentIds: [],
                    mainAllCurrentStudentIds: _mainAllCurrentStudentIds
                };

                return _extends({}, state, {
                    classGroups: setGroupVisibleProperty(_classGroups),
                    classGroupStudents: _initialClassGroupStudents,
                    hasContentLoaded: true,
                    currentClassName: _currentClassName && _currentClassName.length > 0 ? _currentClassName[0].name : '',
                    currentClassId: _classId,
                    externalClassroomId: _externalClassroomId,
                    isSisSchool: isSisSchool,
                    // reset course information as well
                    countrySelectValue: '',
                    yearSelectValue: '',
                    courseSelectValue: ''
                }, _resetCheckboxProperties);
            }
        case _consoleActions.EDIT_CLASS_NAME:
            {
                var tempClasses = [].concat(_toConsumableArray(state.classes));

                var className = payload.name;
                var _classes = tempClasses.map(function (localClass) {
                    if (localClass.classId === state.currentClassId) {
                        return _extends({}, localClass, {
                            name: className
                        });
                    }
                    return localClass;
                });

                return _extends({}, state, {
                    currentClassName: className,
                    classes: _classes
                });
            }
        // ------- Course Actions ------- Start
        case _coursesActions.GET_DEFAULT_COURSE:
            {
                return _extends({}, state, {
                    countrySelectValue: '',
                    countrySelectOptions: [state.defaultCountryOption].concat(_toConsumableArray(payload.countryList)),
                    yearSelectValue: '',
                    yearSelectOptions: [state.defaultYearOption, state.defaultAllYearsOption].concat(_toConsumableArray(payload.yearList)),
                    courseSelectValue: '',
                    courseSelectOptions: getCourseSelectOptions(state, payload.groupCourse, payload.courseList),
                    newCourseSelectValue: payload.newCourse,
                    newCourseSelectOptions: getNewCourseSelectOptions(state, payload.groupNewCourse, payload.newCourseList),

                    upfCourseSelectValue: '-1',
                    upfCourseSelectOptions: getUpfCourseSelectOptions(state, payload.groupUpfCourse, payload.upfCourseList),
                    groupCountryCode: payload.countryCode
                });
            }
        case _coursesActions.GET_COURSE_COUNTRIES:
            {
                return _extends({}, state, {
                    countrySelectValue: '',
                    countrySelectOptions: [state.defaultCountryOption].concat(_toConsumableArray(payload.data)),
                    // reset the year dropdown option
                    yearSelectValue: '',
                    yearSelectOptions: [state.defaultYearOption],
                    // reset the courses dropdown option
                    courseSelectValue: '',
                    courseSelectOptions: [state.defaultCourseOption]
                });
            }
        case _coursesActions.SET_COURSE_COUNTRIES:
            {
                return _extends({}, state, {
                    countrySelectValue: payload.data,
                    // reset the year dropdown option
                    yearSelectValue: '',
                    yearSelectOptions: [state.defaultYearOption],
                    // reset the courses dropdown option
                    courseSelectOptions: [state.defaultCourseOption],
                    isFetchingEditInformation: false
                });
            }
        case _coursesActions.GET_COURSE_YEARS:
            {
                return _extends({}, state, {
                    yearSelectValue: '',
                    yearSelectOptions: [state.defaultYearOption, state.defaultAllYearsOption].concat(_toConsumableArray(payload.data)),
                    // reset the courses dropdown option
                    courseSelectOptions: [state.defaultCourseOption]
                });
            }
        case _coursesActions.SET_COURSE_YEAR:
            {
                return _extends({}, state, {
                    yearSelectValue: payload.data,
                    // reset the courses dropdown option
                    courseSelectOptions: [state.defaultCourseOption],
                    isFetchingEditInformation: false
                });
            }
        // This action is called when school courses is being selected
        case _coursesActions.RESET_COURSE_YEARS:
            {
                return _extends({}, state, {
                    yearSelectValue: '',
                    yearSelectOptions: [state.defaultYearOption],
                    // reset the courses dropdown option as well
                    courseSelectValue: '',
                    courseSelectOptions: [state.defaultCourseOption],
                    isFetchingEditInformation: false
                });
            }
        case _coursesActions.GET_COURSE:
            {
                if (payload.notFound === true) {
                    return _extends({}, state, {
                        courseSelectOptions: [payload.data]
                    });
                }
                return _extends({}, state, {
                    courseSelectOptions: getCourseSelectOptions(state, state.groupCourseOption, payload.data.courses)
                });
            }
        case _coursesActions.SET_COURSE:
            {
                return _extends({}, state, {
                    courseSelectValue: payload.data,
                    isFetchingEditInformation: false
                });
            }
        case _coursesActions.GET_UPF_COURSE:
            {
                if (payload.notFound === true) {
                    return _extends({}, state, {
                        upfCourseSelectOptions: [payload.data]
                    });
                }

                return _extends({}, state, {
                    upfCourseSelectValue: state.groupUpfCourseOption ? state.upfCourseSelectValue : '-1',
                    upfCourseSelectOptions: getUpfCourseSelectOptions(state, state.groupUpfCourseOption, payload.data.upfCourses)
                });
            }
        case _coursesActions.SET_UPF_COURSE:
            {
                return _extends({}, state, {
                    upfCourseSelectValue: payload.data,
                    isFetchingEditInformation: false
                });
            }
        case _coursesActions.GET_NEW_COURSE:
            {
                if (payload.notFound) {
                    return _extends({}, state, {
                        newCourseSelectOptions: [payload.data]
                    });
                }
                var conquestCourses = payload.data.conquestCourses;
                var groupNewCourseOption = state.groupNewCourseOption;

                return _extends({}, state, {
                    newCourseSelectValue: getNewCourseCurrentSelectValue(state, conquestCourses),
                    newCourseSelectOptions: getNewCourseSelectOptions(state, groupNewCourseOption, conquestCourses)
                });
            }
        case _coursesActions.SET_NEW_COURSE:
            {
                return _extends({}, state, {
                    newCourseSelectValue: payload.data,
                    isFetchingEditInformation: false
                });
            }
        case _coursesActions.INITIALISE_COURSE_SELECT_OPTIONS:
            {
                var _payload$data3 = payload.data,
                    countryOption = _payload$data3.countryOption,
                    yearOption = _payload$data3.yearOption,
                    allYearsOption = _payload$data3.allYearsOption,
                    courseOption = _payload$data3.courseOption,
                    newCourseOption = _payload$data3.newCourseOption,
                    noNewCourseFoundOption = _payload$data3.noNewCourseFoundOption,
                    noUPFCourseFoundOptionText = _payload$data3.noUPFCourseFoundOption,
                    upfCourseAdminSelectionOptionText = _payload$data3.upfCourseAdminSelectionOption,
                    upfCurrentCourseSuffix = _payload$data3.upfCurrentCourseSuffix;

                // A list of default course select options

                var defaultCountryOption = {
                    id: '',
                    code: '',
                    name: countryOption
                };
                var defaultYearOption = {
                    yearGroupId: '',
                    yearGroupEnum: '',
                    longName: yearOption
                };
                var defaultAllYearsOption = {
                    yearGroupId: '',
                    yearGroupEnum: '-1',
                    longName: allYearsOption
                };
                var defaultCourseOption = {
                    id: '',
                    name: courseOption
                };
                var defaultNewCourseOption = {
                    id: _groupActions.DEFAULT_NEW_COURSE_ID,
                    name: newCourseOption
                };
                var defaultNoNewCourseFoundOption = {
                    id: _groupActions.DEFAULT_NEW_COURSE_ID,
                    name: noNewCourseFoundOption
                };
                var upfCourseAdminSelectionOption = {
                    id: '-1',
                    name: upfCourseAdminSelectionOptionText
                };
                var noUPFCourseFoundOption = {
                    id: _groupActions.NO_UPF_COURSE_FOUND_ID,
                    name: noUPFCourseFoundOptionText
                };
                return _extends({}, state, {
                    defaultCountryOption: defaultCountryOption,
                    defaultYearOption: defaultYearOption,
                    defaultAllYearsOption: defaultAllYearsOption,
                    defaultCourseOption: defaultCourseOption,
                    defaultNewCourseOption: defaultNewCourseOption,
                    defaultNoNewCourseFoundOption: defaultNoNewCourseFoundOption,
                    upfCourseAdminSelectionOption: upfCourseAdminSelectionOption,
                    noUPFCourseFoundOption: noUPFCourseFoundOption,
                    defaultSelectOptions: payload.data,
                    upfCurrentCourseSuffix: upfCurrentCourseSuffix
                });
            }
        case _coursesActions.GET_NEW_COURSE_AVAILABILITY_CRITERIA:
            {
                var newCoursesAvailabilityCriteria = payload.newCoursesAvailabilityCriteria;

                return _extends({}, state, {
                    newCoursesAvailabilityCriteria: newCoursesAvailabilityCriteria
                });
            }
        case _groupActions.RESET_EDIT_INFORMATION:
            {
                return _extends({}, state, {
                    isFetchingEditInformation: false
                });
            }
        // ------- Course Actions ------- End
        // ------- Group Actions ------- Start
        case _groupActions.UPDATE_GROUP_SELECTION:
            {
                var value = payload.value,
                    isSelected = payload.isSelected;

                var _classGroups2 = updateGroupVisibleProperties(state.classGroups, value, isSelected);

                // Filter the students
                var _classGroupStudents2 = state.classGroupStudents.map(function (student) {
                    var isStudentVisible = isGroupVisible(student.groupId, _classGroups2);
                    return _extends({}, student, {
                        isVisible: isStudentVisible
                    });
                });
                var visibleStudents = _classGroupStudents2.filter(function (student) {
                    return student.isVisible;
                });

                // Filter the selectedStudents (if necessary)
                var initialSelectedStudentIds = state.mainSelectedStudentIds;
                // Find if the userProfileId is within the first selected students
                var validStudentIds = visibleStudents.filter(function (student) {
                    return initialSelectedStudentIds.includes(student.userProfileId);
                });
                var mainSelectedStudentIds = setUpAllCurrentStudents(validStudentIds);
                var _mainAllCurrentStudentIds2 = setUpAllCurrentStudents(visibleStudents);
                // As long as there's data, if there isn't... then set the check all to be off
                var mainCheckAllIsSelected = mainSelectedStudentIds.length > 0 ? (0, _isEqual2.default)(mainSelectedStudentIds, _mainAllCurrentStudentIds2) : false;

                var mainListBodyProperties = {
                    mainCheckAllIsSelected: mainCheckAllIsSelected,
                    mainSelectedStudentIds: mainSelectedStudentIds,
                    mainAllCurrentStudentIds: _mainAllCurrentStudentIds2
                };

                return _extends({}, state, {
                    classGroupStudents: _classGroupStudents2,
                    classGroups: _classGroups2
                }, mainListBodyProperties);
            }
        case _groupActions.EDIT_GROUP_INFORMATION_START:
            {
                return _extends({}, state, {
                    isFetchingEditInformation: true
                });
            }
        case _groupActions.EDIT_GROUP_INFORMATION_END:
            {
                var _payload$data4 = payload.data,
                    countrySelectValue = _payload$data4.countrySelectValue,
                    courseSelectValue = _payload$data4.courseSelectValue,
                    _payload$data4$groupC = _payload$data4.groupCourseOption,
                    groupCourseOption = _payload$data4$groupC === undefined ? null : _payload$data4$groupC,
                    newCourseSelectValue = _payload$data4.newCourseSelectValue,
                    _payload$data4$groupN = _payload$data4.groupNewCourseOption,
                    _groupNewCourseOption = _payload$data4$groupN === undefined ? null : _payload$data4$groupN,
                    _payload$data4$groupU = _payload$data4.groupUpfCourseOption,
                    groupUpfCourseOption = _payload$data4$groupU === undefined ? null : _payload$data4$groupU,
                    upfCourseSelectValue = _payload$data4.upfCourseSelectValue,
                    yearSelectValue = _payload$data4.yearSelectValue,
                    countryCode = _payload$data4.countryCode;

                return _extends({}, state, {
                    countrySelectValue: countrySelectValue,
                    courseSelectValue: courseSelectValue,
                    groupCourseOption: groupCourseOption,
                    groupUpfCourseOption: groupUpfCourseOption,
                    upfCourseSelectValue: upfCourseSelectValue,
                    newCourseSelectValue: newCourseSelectValue,
                    groupNewCourseOption: _groupNewCourseOption,
                    yearSelectValue: yearSelectValue,
                    countryCode: countryCode
                });
            }

        case _groupActions.CREATE_MULTI_YEAR_GROUPS:
            {
                return _extends({}, state, {
                    hasContentLoaded: false,
                    createdMultiLevelGroupsCount: 0
                });
            }

        case _groupActions.RESET_MULTI_YEAR_GROUPS_FETCH:
            {
                return _extends({}, state, {
                    isMultiLevelGroupsCreated: false
                });
            }

        case _groupActions.UPDATE_MULTI_YEAR_GROUPS_CREATED_COUNT:
            {
                var count = payload.data.count;


                return _extends({}, state, {
                    createdMultiLevelGroupsCount: count || 0,
                    isMultiLevelGroupsCreated: true
                });
            }
        // ------- Group Actions  ------- End
        // ------- Student Actions ------- Start
        case _studentSelectionActions.SELECT_CHECKBOX_STUDENT:
            {
                var userProfileId = payload.data;
                // Variables
                var tempSelectedStudentIds = [].concat(_toConsumableArray(state.mainSelectedStudentIds));
                var index = tempSelectedStudentIds.indexOf(userProfileId);

                // If there's already an item of the studentId in the currently selected student ids, then remove it
                if (index > -1) {
                    tempSelectedStudentIds.splice(index, 1);
                } else {
                    // Otherwise append the id to the list of selected students
                    tempSelectedStudentIds = [].concat(_toConsumableArray(state.mainSelectedStudentIds), [userProfileId]);
                }

                var _mainAllCurrentStudentIds3 = state.mainAllCurrentStudentIds;
                var _mainCheckAllIsSelected = (0, _isEqual2.default)(tempSelectedStudentIds, _mainAllCurrentStudentIds3);

                return _extends({}, state, {
                    mainCheckAllIsSelected: _mainCheckAllIsSelected,
                    mainSelectedStudentIds: tempSelectedStudentIds
                });
            }
        case _studentSelectionActions.SELECT_ALL_CHECKBOX_STUDENT:
            {
                var _mainSelectedStudentIds = (0, _isEqual2.default)(state.mainAllCurrentStudentIds, state.mainSelectedStudentIds) ? [] : state.mainAllCurrentStudentIds;
                return _extends({}, state, {
                    mainCheckAllIsSelected: !state.mainCheckAllIsSelected,
                    mainSelectedStudentIds: _mainSelectedStudentIds
                });
            }
        case _consoleActions.CHANGE_PASSWORD:
            {
                var tempStudents = [].concat(_toConsumableArray(state.classGroupStudents));
                var _userProfileId = payload.userProfileId;
                var password = payload.newPassword;

                var students = tempStudents.map(function (student) {
                    if (student.userProfileId === _userProfileId) {
                        return _extends({}, student, {
                            password: password
                        });
                    }
                    return student;
                });

                return _extends({}, state, {
                    classGroupStudents: students
                });
            }
        // ------- Student Actions ------- End

        default:
            return _extends({}, state);
    }
}

/***/ }),

/***/ "FnXm":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("Tlb1");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "Gylf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__("2KeS");

var _busyIndicatorReducer = __webpack_require__("OQud");

var _busyIndicatorReducer2 = _interopRequireDefault(_busyIndicatorReducer);

var _consoleReducer = __webpack_require__("FjEf");

var _consoleReducer2 = _interopRequireDefault(_consoleReducer);

var _toastReducer = __webpack_require__("ZuYy");

var _toastReducer2 = _interopRequireDefault(_toastReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CombinedReducers = (0, _redux.combineReducers)({
    busyIndicatorReducer: _busyIndicatorReducer2.default,
    consoleReducer: _consoleReducer2.default,
    toast: _toastReducer2.default
});

// Reducers
exports.default = CombinedReducers;

/***/ }),

/***/ "HeQm":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".checkbox__container--groups .flex-grid--occupy .form__label {\n  white-space: nowrap; }\n\n.checkbox__container--groups .flex-grid--occupy .form__row:last-child {\n  -webkit-box-flex: 2;\n      -ms-flex-positive: 2;\n          flex-grow: 2; }\n\n.modal--edit-groups {\n  width: 584px !important;\n  width: 36.5rem !important;\n  height: auto;\n  padding: 16px !important;\n  top: 40px !important;\n  top: 2.5rem !important;\n  left: 16px !important;\n  left: 1rem !important;\n  -webkit-transform: translateX(-50%) !important;\n          transform: translateX(-50%) !important;\n  font-size: 12px !important;\n  font-size: 0.75rem !important; }\n\n@media (min-width: 992px) {\n    .modal--edit-groups {\n      min-width: 32rem; } }\n\n.edit-group-container {\n  padding: 12px 16px 24px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: stretch;\n      align-self: stretch;\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n  border: 2px solid #dbe0e6;\n  background: #fff; }\n\n[id^=edit-group-input],\n[id^=new-group-input] {\n  border-radius: 8px;\n  border: 1px solid #cbd3dc;\n  background: #fff;\n  padding: 10px 0 10px 16px;\n  color: #33475f;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  width: calc(100% - 18px) !important; }\n\n.edit-group-input {\n  color: #001937;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 28px !important; }\n\n.divider {\n  margin: 12px 0; }\n\n.groups__filters .modal {\n  width: 512px;\n  width: 32rem; }\n\n.groups__filters .flex-grid--occupy .form__row {\n  min-width: calc(50% - 5px); }\n\n.groups__filters .form__row--selects {\n  display: inline-block;\n  width: calc(50% - 5px); }\n\n.groups__filters .form__row--selects:last-child {\n    margin-right: 0; }\n\n.groups__filters .form__title--section {\n  font-size: 14px;\n  font-size: 0.875rem;\n  color: #000;\n  margin-top: 24px; }\n\n@media (min-height: 600px) {\n  .groups__filters .modal {\n    width: 20rem;\n    min-width: 0; }\n  .groups__filters .flex-grid {\n    display: block; }\n  .groups__filters .flex-grid--occupy .form__row {\n    margin-right: 0; }\n  .groups__filters .flex-grid--occupy .form__row--selects {\n    margin: 10px 10px 0 0; }\n    .groups__filters .flex-grid--occupy .form__row--selects:last-child {\n      margin-right: 0; }\n  .groups__filters .form__label {\n    line-height: 1.5em; }\n  .groups__filters [id^=edit-group-input],\n  .groups__filters [id^=new-group-input] {\n    width: calc(100% - 0.37rem);\n    min-width: 0;\n    max-width: none; } }\n", ""]);
// Exports
exports.locals = {
	"checkbox__container--groups": "checkbox__container--groups",
	"flex-grid--occupy": "flex-grid--occupy",
	"form__label": "form__label",
	"form__row": "form__row",
	"modal--edit-groups": "modal--edit-groups",
	"edit-group-container": "edit-group-container",
	"edit-group-input": "edit-group-input",
	"divider": "divider",
	"groups__filters": "groups__filters",
	"modal": "modal",
	"form__row--selects": "form__row--selects",
	"form__title--section": "form__title--section",
	"flex-grid": "flex-grid"
};
module.exports = exports;


/***/ }),

/***/ "I2I3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Styles


// Components


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiCdn = __webpack_require__("siuH");

var _focusTrapReact = __webpack_require__("ZQBc");

var _focusTrapReact2 = _interopRequireDefault(_focusTrapReact);

__webpack_require__("y9tH");

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _enums = __webpack_require__("royT");

var _useKeyPress3 = __webpack_require__("shXg");

var _useKeyPress4 = _interopRequireDefault(_useKeyPress3);

var _useOutsideClick = __webpack_require__("hnRf");

var _useOutsideClick2 = _interopRequireDefault(_useOutsideClick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POSITIONS = {
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left'
};

/**
 *
 * @param visibleTexts  Array of strings with texts that will be displayed in the tooltip. Must be plain text.
 * @param position      The position of the tooltip compared to the Info button. Default is bottom.
 * @returns {boolean|*}
 * @constructor
 */
function Tooltip(_ref) {
    var visibleTexts = _ref.visibleTexts,
        position = _ref.position;

    if (!visibleTexts || visibleTexts.length < 1) {
        return false;
    }

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isTooltipVisible = _useState2[0],
        setShowTooltip = _useState2[1];

    var showTooltip = function showTooltip() {
        setShowTooltip(true);
    };

    var closeTooltip = function closeTooltip() {
        setShowTooltip(false);
    };

    var _useKeyPress = (0, _useKeyPress4.default)({
        targetKeyName: _enums.ESCAPE_KEY_NAME,
        targetKeyCode: _enums.ESCAPE_KEY_CODE
    }),
        _useKeyPress2 = _slicedToArray(_useKeyPress, 1),
        escapeKeyPressed = _useKeyPress2[0];

    // Effect for handling escape key press


    (0, _react.useEffect)(function () {
        if (escapeKeyPressed) {
            closeTooltip();
        }
    }, [escapeKeyPressed]);

    // Click outside
    var tooltipContainerRef = (0, _react.useRef)(null);
    (0, _useOutsideClick2.default)([tooltipContainerRef], closeTooltip);

    var positionClass = position in POSITIONS ? 'tooltip--' + position : '';

    return _react2.default.createElement(
        'div',
        { className: 'tooltip__container' },
        _react2.default.createElement(_button2.default, {
            buttonStyle: _button.BUTTON_STYLES.iconBackground,
            importedClasses: 'button--info',
            noTitle: true,
            ariaProps: { 'aria-label': i18n._( /*i18n*/{
                    id: 'Info - Get more info'
                }) },
            callback: showTooltip
        }),
        isTooltipVisible ? _react2.default.createElement(
            'div',
            { ref: tooltipContainerRef },
            _react2.default.createElement(
                _focusTrapReact2.default,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'tooltip ' + positionClass },
                    _react2.default.createElement(_button2.default, {
                        buttonStyle: _button.BUTTON_STYLES.iconBackground,
                        importedClasses: 'button--hidden',
                        callback: closeTooltip
                    }),
                    visibleTexts.map(function (visibleText) {
                        return _react2.default.createElement(
                            'p',
                            { key: visibleText, className: 'tooltip__text' },
                            visibleText
                        );
                    })
                )
            )
        ) : ''
    );
}

/**
 * Define the default values for the properties being used
 */
Tooltip.defaultProps = {
    position: 'bottom'
};

/**
 * Define the type of properties that can be set on this component
 */
Tooltip.propTypes = {
    visibleTexts: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
    position: _propTypes2.default.string
};

exports.default = Tooltip;

/***/ }),

/***/ "IAqf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__("GiK3");

var _utils = __webpack_require__("6QRH");

var DEFAULT_SCREEN_MODE = '';

/**
 * This hook enables us to utilise the value of the screen mode from the helper function. The content is directly
 * related to the values in the body::before in utils.scss
 *
 * This just returns the actual value of the screen mode as mentioned previously
 * @returns {[null]}
 */
function useScreenMode() {
    var _useState = (0, _react.useState)(DEFAULT_SCREEN_MODE),
        _useState2 = _slicedToArray(_useState, 2),
        screenMode = _useState2[0],
        setScreenMode = _useState2[1];

    // This effect is only run once


    (0, _react.useEffect)(function () {
        if (screenMode === DEFAULT_SCREEN_MODE) {
            // this will run first, any subsequent resize will call the function again, due to the event listener.
            setScreenMode((0, _utils.getScreenMode)());
        }

        var resizeFunction = function resizeFunction() {
            return setScreenMode((0, _utils.getScreenMode)());
        };
        window.addEventListener('resize', resizeFunction);
        return function () {
            return window.removeEventListener('resize', resizeFunction);
        };
    }, []);

    return [screenMode];
}

exports.default = useScreenMode;

/***/ }),

/***/ "IPsy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Components


// Helpers


// Hooks


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _linguiCdn = __webpack_require__("siuH");

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _actionList = __webpack_require__("0TaB");

var _actionList2 = _interopRequireDefault(_actionList);

var _enums = __webpack_require__("royT");

var _portalCommunications = __webpack_require__("DMUb");

var _portalCommunications2 = _interopRequireDefault(_portalCommunications);

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _useOutsideClick = __webpack_require__("hnRf");

var _useOutsideClick2 = _interopRequireDefault(_useOutsideClick);

var _useKeyPress3 = __webpack_require__("shXg");

var _useKeyPress4 = _interopRequireDefault(_useKeyPress3);

var _useScreenMode3 = __webpack_require__("IAqf");

var _useScreenMode4 = _interopRequireDefault(_useScreenMode3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function Tools(_ref) {
    var _this = this;

    var parentClass = _ref.parentClass,
        classesLength = _ref.classesLength,
        studentsLength = _ref.studentsLength,
        currentClassName = _ref.currentClassName,
        currentClassId = _ref.currentClassId,
        exportStudents = _ref.exportStudents,
        isSisSchool = _ref.isSisSchool;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        showActions = _useState2[0],
        setShowActions = _useState2[1];
    // Configuration item for the info modal


    var _useState3 = (0, _react.useState)([]),
        _useState4 = _slicedToArray(_useState3, 2),
        girlIds = _useState4[0],
        setGirlIds = _useState4[1];

    var actionRef = (0, _react.useRef)(null);
    var actionButtonRef = (0, _react.useRef)(null);

    // Initialise the necessary information if escape key has been pressed

    var _useKeyPress = (0, _useKeyPress4.default)({
        targetKeyName: _enums.ESCAPE_KEY_NAME,
        targetKeyCode: _enums.ESCAPE_KEY_CODE
    }),
        _useKeyPress2 = _slicedToArray(_useKeyPress, 1),
        escapeKeyPressed = _useKeyPress2[0];

    // ComponentDidMount


    (0, _react.useEffect)(function () {
        // retrieve the value for girl ids for the info modal
        var retrieveConfigItems = function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var infoModalIds;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _resources2.default.getConfigurationItem('InfoModalGiRLids');

                            case 2:
                                infoModalIds = _context.sent;

                                setGirlIds(JSON.parse(infoModalIds || '[]'));

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function retrieveConfigItems() {
                return _ref2.apply(this, arguments);
            };
        }();

        retrieveConfigItems();
    }, []);

    // Handler
    var toggleActionVisibilityHandler = function toggleActionVisibilityHandler() {
        setShowActions(!showActions);
    };

    // Hook to check if the element has been clicked outside
    (0, _useOutsideClick2.default)([actionButtonRef, actionRef], toggleActionVisibilityHandler);

    // Effect for handling escape key press
    (0, _react.useEffect)(function () {
        // Only act on the escapeKey pressed when showActions is also set to true
        if (escapeKeyPressed && showActions && toggleActionVisibilityHandler) {
            toggleActionVisibilityHandler();
        }
    }, [escapeKeyPressed]);

    // Hook to make the tools responsive

    var _useScreenMode = (0, _useScreenMode4.default)(),
        _useScreenMode2 = _slicedToArray(_useScreenMode, 1),
        screenMode = _useScreenMode2[0];

    var buttonMode = screenMode.includes('extendedLaptop') ? _button.BUTTON_STYLES.iconText : _button.BUTTON_STYLES.iconSVG;

    var howDoesItWorkHandler = function howDoesItWorkHandler() {
        _portalCommunications2.default.requestInfoModal(girlIds);
    };

    return _react2.default.createElement(
        'div',
        { className: parentClass },
        girlIds.length > 0 ? _react2.default.createElement(_button2.default, {
            buttonStyle: buttonMode,
            visibleText: _react2.default.createElement(_react3.Trans, { id: 'Tools - how does this work?' }),
            importedClasses: 'button--secondary',
            iconName: 'infocircle',
            ariaProps: { 'aria-label': i18n._( /*i18n*/{
                    id: 'Tools - how does this work?'
                }) },
            isBtnDisabled: girlIds.length === 0,
            callback: howDoesItWorkHandler
        }) : '',
        _react2.default.createElement(_button2.default, {
            ref: actionButtonRef,
            buttonStyle: buttonMode,
            visibleText: _react2.default.createElement(_react3.Trans, { id: 'Tools - Actions' }),
            iconName: 'actions',
            ariaProps: {
                role: 'switch',
                'aria-label': i18n._( /*i18n*/{
                    id: 'Tools - Actions'
                }),
                'aria-checked': showActions
            },
            isBtnDisabled: classesLength === 0,
            importedClasses: 'button--actions button--expanded',
            callback: toggleActionVisibilityHandler
        }),
        showActions ? _react2.default.createElement(_actionList2.default, {
            ref: actionRef,
            studentsLength: studentsLength,
            currentClassName: currentClassName,
            currentClassId: currentClassId,
            closeActionList: function closeActionList() {
                return setShowActions(false);
            },
            exportStudents: exportStudents,
            isSisSchool: isSisSchool
        }) : null
    );
}

Tools.defaultProps = {
    classesLength: 0,
    studentsLength: 0
};

Tools.propTypes = {
    parentClass: _propTypes2.default.string,
    classesLength: _propTypes2.default.number,
    studentsLength: _propTypes2.default.number,
    currentClassName: _propTypes2.default.string,
    currentClassId: _propTypes2.default.number,
    exportStudents: _propTypes2.default.func,
    isSisSchool: _propTypes2.default.bool
};

exports.default = Tools;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "IjpL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Styles


// Components


// Actions


// Context


// Hooks


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _linguiCdn = __webpack_require__("siuH");

__webpack_require__("T3kN");

var _groupSelection = __webpack_require__("0fXh");

var _groupSelection2 = _interopRequireDefault(_groupSelection);

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _tooltip = __webpack_require__("I2I3");

var _tooltip2 = _interopRequireDefault(_tooltip);

var _consoleActions = __webpack_require__("SC2c");

var _consoleActions2 = _interopRequireDefault(_consoleActions);

var _coursesActions = __webpack_require__("5/v9");

var _coursesActions2 = _interopRequireDefault(_coursesActions);

var _groupActions = __webpack_require__("e4+b");

var _groupActions2 = _interopRequireDefault(_groupActions);

var _courseInformationContext = __webpack_require__("EJJB");

var _courseInformationContext2 = _interopRequireDefault(_courseInformationContext);

var _useOutsideClick = __webpack_require__("hnRf");

var _useOutsideClick2 = _interopRequireDefault(_useOutsideClick);

var _enums = __webpack_require__("royT");

var _toastActions = __webpack_require__("sFKd");

var _toastActions2 = _interopRequireDefault(_toastActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function Groups(props) {
    var _this = this;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    // Props


    var parentClass = props.parentClass,
        classGroups = props.classGroups,
        currentClassId = props.currentClassId,
        productId = props.productId,
        isFetchingEditInformation = props.isFetchingEditInformation,
        hasContentLoaded = props.hasContentLoaded,
        updateCurrentClassId = props.updateCurrentClassId,
        addNewGroup = props.addNewGroup,
        editGroupName = props.editGroupName,
        deleteExistingGroup = props.deleteExistingGroup,
        editGroupCourse = props.editGroupCourse,
        getDefaultCourseInformation = props.getDefaultCourseInformation,
        getEditGroupCourseInformation = props.getEditGroupCourseInformation,
        getDefaultCourse = props.getDefaultCourse,
        getCourseCountries = props.getCourseCountries,
        getCourseYears = props.getCourseYears,
        getCourses = props.getCourses,
        updateGroupCheckbox = props.updateGroupCheckbox,
        resetYearOptions = props.resetYearOptions,
        resetEditInformationHandler = props.resetEditInformationHandler,
        setCountryHandler = props.setCountryHandler,
        countrySelectValue = props.countrySelectValue,
        countrySelectOptions = props.countrySelectOptions,
        setYearHandler = props.setYearHandler,
        yearSelectValue = props.yearSelectValue,
        yearSelectOptions = props.yearSelectOptions,
        setCourseHandler = props.setCourseHandler,
        courseSelectValue = props.courseSelectValue,
        courseSelectOptions = props.courseSelectOptions,
        setUPFCourseHandler = props.setUPFCourseHandler,
        upfCourseSelectValue = props.upfCourseSelectValue,
        upfCourseSelectOptions = props.upfCourseSelectOptions,
        setNewCourseHandler = props.setNewCourseHandler,
        newCourseSelectValue = props.newCourseSelectValue,
        newCourseSelectOptions = props.newCourseSelectOptions,
        showNewCourses = props.showNewCourses,
        newCoursesAvailabilityCriteria = props.newCoursesAvailabilityCriteria,
        setShownPassword = props.setShownPassword,
        createMultiYearGroups = props.createMultiYearGroups,
        resetMultiYearGroupFetch = props.resetMultiYearGroupFetch,
        showToast = props.showToast;


    var groupRef = (0, _react.useRef)(null);

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isExpanded = _useState2[0],
        setIsExpanded = _useState2[1];

    var classroomId = currentClassId;

    var completeCallback = (0, _react.useCallback)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var updateResponse;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return updateCurrentClassId({
                            productId: productId,
                            classId: classroomId
                        });

                    case 2:
                        updateResponse = _context.sent;

                        if (!window.__SKIP_GROUP_COLLAPSE__) {
                            _context.next = 6;
                            break;
                        }

                        // eslint-disable-next-line no-underscore-dangle
                        window.__SKIP_GROUP_COLLAPSE__ = false;
                        return _context.abrupt('return');

                    case 6:

                        // If the button was pressed, reset it
                        if (isExpanded === true && updateResponse === true) {
                            setIsExpanded(false);
                        }

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    })), [classroomId, isExpanded]);

    // Handlers (local specifically)
    var expandButtonHandler = function expandButtonHandler() {
        setIsExpanded(function (prevState) {
            return !prevState;
        });
    };

    // To retrieve data for existing group when EDIT group is cliked
    var localGetGroupInformation = function localGetGroupInformation(_ref2) {
        var groupId = _ref2.groupId;
        return getEditGroupCourseInformation({
            classId: classroomId,
            productId: productId,
            groupId: groupId
        });
    };
    // to get default course data when NEW GROUP button is clicked
    var localDefaultCourseInformation = function localDefaultCourseInformation(_ref3) {
        var defaultData = _ref3.defaultData;
        return getDefaultCourseInformation({
            defaultData: defaultData
        });
    };

    // Responsible for handling the new group button
    var newGroupHandler = function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref5) {
            var name = _ref5.name;
            var response, isValid;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return addNewGroup({
                                classroomId: classroomId,
                                groupName: name,
                                courseId: parseInt(courseSelectValue, 10),
                                upfCourseId: upfCourseSelectOptions.length > 1 ? parseInt(upfCourseSelectValue, 10) : _enums.DEFAULT_UPF_COURSE_ID,
                                newCourseId: newCourseSelectValue
                            });

                        case 3:
                            response = _context2.sent;
                            isValid = response && response.status >= 200 && response.status < 300;

                            if (isValid) {
                                _context2.next = 7;
                                break;
                            }

                            throw new Error(response && response.data && response.data.message || response && response.error && response.error.message || 'Unable to edit group name.');

                        case 7:
                            _context2.next = 9;
                            return completeCallback();

                        case 9:
                            return _context2.abrupt('return', response);

                        case 12:
                            _context2.prev = 12;
                            _context2.t0 = _context2['catch'](0);

                            setIsExpanded(false);
                            showToast({
                                variant: 'error',
                                messageId: 'Error Updating Group',
                                autoCloseMs: 6000
                            });
                            return _context2.abrupt('return', false);

                        case 17:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this, [[0, 12]]);
        }));

        return function newGroupHandler(_x) {
            return _ref4.apply(this, arguments);
        };
    }();

    // Responsible for handling the edit group button
    var editGroupHandler = function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref7) {
            var name = _ref7.name,
                groupId = _ref7.groupId;
            var value, isExistingGroupValid, courseId, upfCourseId, newCourseId;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            value = void 0;

                            // Validate that the group name and new group name are the same, if they are, don't change the name

                            isExistingGroupValid = true;

                            if (!name) {
                                _context3.next = 8;
                                break;
                            }

                            _context3.next = 6;
                            return editGroupName({
                                classroomId: classroomId,
                                groupId: groupId,
                                groupName: name
                            });

                        case 6:
                            value = _context3.sent;


                            // Afterwards update the course of the group
                            isExistingGroupValid = value && value.status >= 200 && value.status < 300;

                        case 8:
                            if (isExistingGroupValid) {
                                _context3.next = 10;
                                break;
                            }

                            throw new Error(value && value.data && value.data.message || value && value.error && value.error.message || 'Unable to edit group name.');

                        case 10:
                            courseId = parseInt(courseSelectValue, 10);
                            upfCourseId = upfCourseSelectOptions.length > 1 ? parseInt(upfCourseSelectValue, 10) : _enums.DEFAULT_UPF_COURSE_ID;
                            newCourseId = newCourseSelectValue;
                            _context3.next = 15;
                            return editGroupCourse({
                                classroomId: classroomId,
                                groupId: groupId,
                                courseId: courseId,
                                upfCourseId: upfCourseId,
                                newCourseId: newCourseId
                            });

                        case 15:
                            value = _context3.sent;
                            _context3.next = 18;
                            return completeCallback();

                        case 18:
                            return _context3.abrupt('return', value);

                        case 21:
                            _context3.prev = 21;
                            _context3.t0 = _context3['catch'](0);

                            setIsExpanded(false);
                            showToast({
                                variant: 'error',
                                messageId: 'Error Updating Group',
                                autoCloseMs: 6000
                            });
                            return _context3.abrupt('return', false);

                        case 26:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this, [[0, 21]]);
        }));

        return function editGroupHandler(_x2) {
            return _ref6.apply(this, arguments);
        };
    }();
    var deleteGroupHandler = function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref9) {
            var groupId = _ref9.groupId;
            var response, isValidResponse;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.prev = 0;
                            _context4.next = 3;
                            return deleteExistingGroup({ classroomId: classroomId, groupId: groupId });

                        case 3:
                            response = _context4.sent;
                            isValidResponse = response && response.status >= 200 && response.status < 300;

                            if (isValidResponse) {
                                _context4.next = 7;
                                break;
                            }

                            throw new Error(response && response.data && response.data.message || response && response.error && response.error.message || 'Unable to edit group name.');

                        case 7:
                            _context4.next = 9;
                            return completeCallback();

                        case 9:
                            return _context4.abrupt('return', response);

                        case 12:
                            _context4.prev = 12;
                            _context4.t0 = _context4['catch'](0);

                            setIsExpanded(false);
                            showToast({
                                variant: 'error',
                                messageId: 'Error Updating Group',
                                autoCloseMs: 6000
                            });
                            return _context4.abrupt('return', false);

                        case 17:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this, [[0, 12]]);
        }));

        return function deleteGroupHandler(_x3) {
            return _ref8.apply(this, arguments);
        };
    }();

    var groupContainerRef = (0, _react.useRef)(null);
    (0, _useOutsideClick2.default)([groupContainerRef], function () {
        return setIsExpanded(false);
    });

    var courseInformationValues = {
        // Select Options
        // - Country
        setCountryHandler: setCountryHandler,
        countrySelectValue: countrySelectValue,
        countrySelectOptions: countrySelectOptions,
        // - Year
        setYearHandler: setYearHandler,
        yearSelectValue: yearSelectValue,
        yearSelectOptions: yearSelectOptions,
        // - Course
        setCourseHandler: setCourseHandler,
        courseSelectValue: courseSelectValue,
        courseSelectOptions: courseSelectOptions,
        // - UPF Course
        setUPFCourseHandler: setUPFCourseHandler,
        upfCourseSelectValue: upfCourseSelectValue,
        upfCourseSelectOptions: upfCourseSelectOptions,
        // - New Courses
        setNewCourseHandler: setNewCourseHandler,
        newCourseSelectValue: newCourseSelectValue,
        newCourseSelectOptions: newCourseSelectOptions
    };

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            'div',
            { ref: groupContainerRef, className: parentClass + ' groups' },
            _react2.default.createElement(
                'h2',
                { className: 'console__title ' + (isExpanded ? 'console__title--expanded' : '') },
                _react2.default.createElement(_react3.Trans, { id: 'Class Group Selection - header' }),
                _react2.default.createElement(_tooltip2.default, { visibleTexts: [i18n._( /*i18n*/{
                        id: 'Tooltips - groups'
                    })] })
            ),
            _react2.default.createElement(_button2.default, {
                importedClasses: 'groups__button ' + (isExpanded ? 'groups__button--expanded' : ''),
                buttonStyle: _button.BUTTON_STYLES.iconSVG,
                iconName: isExpanded ? 'groupminimise' : 'groupmaximise',
                ariaProps: {
                    'aria-hidden': true,
                    'aria-label': i18n._( /*i18n*/{
                        id: 'Groups - expand'
                    }),
                    tabIndex: -1
                },
                callback: expandButtonHandler
            }),
            _react2.default.createElement(
                _courseInformationContext2.default.Provider,
                { value: courseInformationValues },
                _react2.default.createElement(_groupSelection2.default, {
                    ref: groupRef,
                    productId: productId,
                    currentClassId: currentClassId,
                    importedClasses: isExpanded ? 'groups__filters--expanded' : '',
                    classGroups: classGroups,
                    isFetchingEditInformation: isFetchingEditInformation,
                    resetEditInformationHandler: resetEditInformationHandler,
                    showNewCourses: showNewCourses,
                    newCoursesAvailabilityCriteria: newCoursesAvailabilityCriteria
                    // Function Handlers
                    , newGroupHandler: newGroupHandler,
                    editGroupHandler: editGroupHandler,
                    deleteGroupHandler: deleteGroupHandler,
                    getCourseYears: getCourseYears,
                    getDefaultCourse: getDefaultCourse,
                    getCourseCountries: getCourseCountries,
                    getCourses: getCourses,
                    getDefaultCourseInformation: localDefaultCourseInformation,
                    getEditGroupCourseInformation: localGetGroupInformation,
                    resetYearOptions: resetYearOptions,
                    updateGroupCheckbox: updateGroupCheckbox,
                    setShownPassword: setShownPassword,
                    createMultiYearGroups: createMultiYearGroups,
                    updateCurrentClassId: updateCurrentClassId,
                    hasContentLoaded: hasContentLoaded,
                    resetMultiYearGroupFetch: resetMultiYearGroupFetch
                })
            )
        )
    );
}

Groups.propTypes = {
    parentClass: _propTypes2.default.string,
    classGroups: _propTypes2.default.array,
    productId: _propTypes2.default.number,
    currentClassId: _propTypes2.default.number,
    isFetchingEditInformation: _propTypes2.default.bool,
    hasContentLoaded: _propTypes2.default.bool,
    // Handlers
    updateGroupCheckbox: _propTypes2.default.func,
    updateCurrentClassId: _propTypes2.default.func,
    getDefaultCourseInformation: _propTypes2.default.func,
    getEditGroupCourseInformation: _propTypes2.default.func,
    getDefaultCourse: _propTypes2.default.func,
    getCourseCountries: _propTypes2.default.func,
    getCourseYears: _propTypes2.default.func,
    getCourses: _propTypes2.default.func,
    addNewGroup: _propTypes2.default.func,
    editGroupName: _propTypes2.default.func,
    deleteExistingGroup: _propTypes2.default.func,
    editGroupCourse: _propTypes2.default.func,
    resetYearOptions: _propTypes2.default.func,
    resetEditInformationHandler: _propTypes2.default.func,
    // Course Specific options
    // - Country
    setCountryHandler: _propTypes2.default.func,
    countrySelectValue: _propTypes2.default.string,
    countrySelectOptions: _propTypes2.default.array,
    // - Year
    setYearHandler: _propTypes2.default.func,
    yearSelectValue: _propTypes2.default.string,
    yearSelectOptions: _propTypes2.default.array,
    // - Course
    setCourseHandler: _propTypes2.default.func,
    courseSelectValue: _propTypes2.default.string,
    courseSelectOptions: _propTypes2.default.array,
    // - UPF Course
    setUPFCourseHandler: _propTypes2.default.func,
    upfCourseSelectValue: _propTypes2.default.string,
    upfCourseSelectOptions: _propTypes2.default.array,
    // - New Courses
    setNewCourseHandler: _propTypes2.default.func,
    newCourseSelectValue: _propTypes2.default.string,
    newCourseSelectOptions: _propTypes2.default.array,
    showNewCourses: _propTypes2.default.bool,
    newCoursesAvailabilityCriteria: _propTypes2.default.object,
    setShownPassword: _propTypes2.default.func,
    // -Groups
    createMultiYearGroups: _propTypes2.default.func,
    resetMultiYearGroupFetch: _propTypes2.default.func,
    showToast: _propTypes2.default.func
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from MessageModalCombinedReducers.
 */
function mapStateToProps(state) {
    var _state$consoleReducer = state.consoleReducer,
        countrySelectValue = _state$consoleReducer.countrySelectValue,
        countrySelectOptions = _state$consoleReducer.countrySelectOptions,
        yearSelectValue = _state$consoleReducer.yearSelectValue,
        yearSelectOptions = _state$consoleReducer.yearSelectOptions,
        courseSelectValue = _state$consoleReducer.courseSelectValue,
        courseSelectOptions = _state$consoleReducer.courseSelectOptions,
        upfCourseSelectValue = _state$consoleReducer.upfCourseSelectValue,
        upfCourseSelectOptions = _state$consoleReducer.upfCourseSelectOptions,
        newCourseSelectValue = _state$consoleReducer.newCourseSelectValue,
        newCourseSelectOptions = _state$consoleReducer.newCourseSelectOptions,
        currentClassId = _state$consoleReducer.currentClassId,
        productId = _state$consoleReducer.productId,
        isFetchingEditInformation = _state$consoleReducer.isFetchingEditInformation,
        hasContentLoaded = _state$consoleReducer.hasContentLoaded;


    return {
        productId: productId,
        currentClassId: currentClassId,
        countrySelectValue: countrySelectValue,
        countrySelectOptions: countrySelectOptions,
        yearSelectValue: yearSelectValue,
        yearSelectOptions: yearSelectOptions,
        courseSelectValue: courseSelectValue,
        courseSelectOptions: courseSelectOptions,
        upfCourseSelectValue: upfCourseSelectValue,
        upfCourseSelectOptions: upfCourseSelectOptions,
        newCourseSelectValue: newCourseSelectValue,
        newCourseSelectOptions: newCourseSelectOptions,
        isFetchingEditInformation: isFetchingEditInformation,
        hasContentLoaded: hasContentLoaded
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        updateCurrentClassId: _consoleActions2.default.updateCurrentClassId,
        setCountryHandler: _coursesActions2.default.setCountryHandler,
        setYearHandler: _coursesActions2.default.setYearHandler,
        setCourseHandler: _coursesActions2.default.setCourseHandler,
        setUPFCourseHandler: _coursesActions2.default.setUPFCourseHandler,
        setNewCourseHandler: _coursesActions2.default.setNewCourseHandler,
        getDefaultCourse: _coursesActions2.default.getDefaultCourse,
        getCourseCountries: _coursesActions2.default.getCourseCountries,
        getCourseYears: _coursesActions2.default.getCourseYears,
        resetYearOptions: _coursesActions2.default.resetYearOptions,
        getCourses: _coursesActions2.default.getCourses,
        addNewGroup: _groupActions2.default.addNewGroup,
        editGroupName: _groupActions2.default.editGroupName,
        deleteExistingGroup: _groupActions2.default.deleteExistingGroup,
        editGroupCourse: _groupActions2.default.editGroupCourse,
        updateGroupCheckbox: _groupActions2.default.updateGroupCheckbox,
        resetEditInformationHandler: _groupActions2.default.resetEditInformationHandler,
        getEditGroupCourseInformation: _groupActions2.default.getEditGroupCourseInformation,
        getDefaultCourseInformation: _groupActions2.default.getDefaultCourseInformation,
        createMultiYearGroups: _groupActions2.default.createMultiYearGroups,
        resetMultiYearGroupFetch: _groupActions2.default.resetMultiYearGroupFetch,
        showToast: _toastActions2.default.showToast
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Groups);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "JPJw":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/1d2c814e685e7338e51d368479f69bd9.svg";

/***/ }),

/***/ "JZJN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: group with other students lists in './components/students-lists'? BA 2020-01-14
function EmptyDataMessage(props) {
    var hasContentLoaded = props.hasContentLoaded,
        classesLength = props.classesLength,
        colSpan = props.colSpan,
        showInitialAddMessage = props.showInitialAddMessage,
        initialMessage = props.initialMessage;

    // To ensure that no unnecessary messages are shown, just display an empty span

    if (hasContentLoaded === false) {
        return _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement('td', null)
        );
    }

    if (showInitialAddMessage === true) {
        return _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
                'td',
                { colSpan: colSpan, className: 'table__cell table__cell--no-results' },
                _react2.default.createElement(
                    'p',
                    null,
                    initialMessage
                )
            )
        );
    }

    // Otherwise render the appropriate messages, depending on the state
    if (classesLength === 0) {
        return _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
                'td',
                { colSpan: colSpan, className: 'table__cell table__cell--no-results' },
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_react3.Trans, { id: 'Empty Data Message - No Classes - Title' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_react3.Trans, { id: 'Empty Data Message - No Classes - Message' })
                )
            )
        );
    }

    return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
            'td',
            { colSpan: colSpan, className: 'table__cell table__cell--no-results' },
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_react3.Trans, { id: 'Empty Data Message - No Students - Message' })
            )
        )
    );
}

EmptyDataMessage.defaultValue = {
    colSpan: 1
};

EmptyDataMessage.propTypes = {
    hasContentLoaded: _propTypes2.default.bool,
    showInitialAddMessage: _propTypes2.default.bool,
    initialMessage: _propTypes2.default.object,
    classesLength: _propTypes2.default.number,
    colSpan: _propTypes2.default.number
};

exports.default = EmptyDataMessage;

/***/ }),

/***/ "KOQ+":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/a09f1fd89f6320a31acc8db39149e0ec.svg";

/***/ }),

/***/ "L8mK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _editGroupModal = __webpack_require__("3IvT");

var _editGroupModal2 = _interopRequireDefault(_editGroupModal);

var _groupModal = __webpack_require__("+x4p");

var _groupModal2 = _interopRequireDefault(_groupModal);

var _courseInformationContext = __webpack_require__("EJJB");

var _courseInformationContext2 = _interopRequireDefault(_courseInformationContext);

var _utils = __webpack_require__("6QRH");

var _enums = __webpack_require__("royT");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Components


// Context


// Helpers


function NewGroupItem(props) {
    var _this = this;

    // Props
    var showModal = props.showModal,
        currentGroupId = props.currentGroupId,
        groupModalVisibility = props.groupModalVisibility,
        groupModalId = props.groupModalId,
        productId = props.productId,
        newGroupHandler = props.newGroupHandler,
        showNewCourses = props.showNewCourses,
        newCoursesAvailabilityCriteria = props.newCoursesAvailabilityCriteria;

    // Context Variables

    var _useContext = (0, _react.useContext)(_courseInformationContext2.default),
        setCountryHandler = _useContext.setCountryHandler,
        countrySelectValue = _useContext.countrySelectValue,
        countrySelectOptions = _useContext.countrySelectOptions,
        setYearHandler = _useContext.setYearHandler,
        yearSelectValue = _useContext.yearSelectValue,
        yearSelectOptions = _useContext.yearSelectOptions,
        setCourseHandler = _useContext.setCourseHandler,
        courseSelectValue = _useContext.courseSelectValue,
        courseSelectOptions = _useContext.courseSelectOptions,
        setUPFCourseHandler = _useContext.setUPFCourseHandler,
        upfCourseSelectValue = _useContext.upfCourseSelectValue,
        upfCourseSelectOptions = _useContext.upfCourseSelectOptions,
        setNewCourseHandler = _useContext.setNewCourseHandler,
        newCourseSelectValue = _useContext.newCourseSelectValue,
        newCourseSelectOptions = _useContext.newCourseSelectOptions;

    var closeHandler = function closeHandler() {
        (0, _utils.resetGroupSectionScroll)();
        setCountryHandler('');
        setYearHandler('');
        showModal({ modalId: _enums.DEFAULT_GROUP_MODAL_ID, isClosing: true });
    };
    var saveHandler = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
            var name = _ref2.name;
            var newGroupResponse;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return newGroupHandler({ name: name });

                        case 2:
                            newGroupResponse = _context.sent;


                            if (newGroupResponse.valid === true) {
                                closeHandler();
                            }
                            return _context.abrupt('return', true);

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function saveHandler(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    var localSetCountryHandler = function localSetCountryHandler(e) {
        var value = e.target.value;
        setCountryHandler(value);
    };
    var localSetYearHandler = function localSetYearHandler(e) {
        var value = e.target.value;
        setYearHandler(value);
    };
    var localSetCourseHandler = function localSetCourseHandler(e) {
        var value = e.target.value;
        setCourseHandler(value);
    };
    var localSetUPFCourseHandler = function localSetUPFCourseHandler(e) {
        var value = e.target.value;
        setUPFCourseHandler(value);
    };
    var localSetNewCourseHandler = function localSetNewCourseHandler(e) {
        var value = e.target.value;
        setNewCourseHandler(value);
    };

    // Course Specific props to handle the data/display
    var courseSpecificProps = {
        // Countries
        setCountryHandler: localSetCountryHandler,
        countrySelectValue: countrySelectValue,
        countrySelectOptions: countrySelectOptions,
        // Years/Grades
        setYearHandler: localSetYearHandler,
        yearSelectValue: yearSelectValue,
        yearSelectOptions: yearSelectOptions,
        // Courses
        setCourseHandler: localSetCourseHandler,
        courseSelectValue: courseSelectValue,
        courseSelectOptions: courseSelectOptions,
        // New Courses i.e. conquest courses
        setNewCourseHandler: localSetNewCourseHandler,
        newCourseSelectValue: newCourseSelectValue,
        newCourseSelectOptions: newCourseSelectOptions,
        // - UPF Course
        setUPFCourseHandler: localSetUPFCourseHandler,
        upfCourseSelectValue: upfCourseSelectValue,
        upfCourseSelectOptions: upfCourseSelectOptions
    };

    return _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        currentGroupId === groupModalId && groupModalVisibility ? _react2.default.createElement(
            _editGroupModal2.default,
            {
                title: _react2.default.createElement(_react3.Trans, { id: 'Group Modal - new - title' }),
                closeHandler: closeHandler,
                parentClasses: 'modal--edit-groups' },
            _react2.default.createElement(_groupModal2.default, _extends({
                inputId: 'new-group-input' + currentGroupId,
                initialName: '',
                currentId: currentGroupId,
                productId: productId,
                saveHandler: saveHandler,
                closeHandler: closeHandler,
                hasEdited: false // default value
                , showNewCourses: showNewCourses,
                newCoursesAvailabilityCriteria: newCoursesAvailabilityCriteria,
                isNewGroup: true
            }, courseSpecificProps))
        ) : ''
    );
}

NewGroupItem.propTypes = {
    showModal: _propTypes2.default.func,
    newGroupHandler: _propTypes2.default.func,
    currentGroupId: _propTypes2.default.number,
    groupModalVisibility: _propTypes2.default.bool,
    groupModalId: _propTypes2.default.number,
    productId: _propTypes2.default.number,
    showNewCourses: _propTypes2.default.bool,
    newCoursesAvailabilityCriteria: _propTypes2.default.object
};

exports.default = NewGroupItem;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "L9c/":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".action-list {\n  position: absolute;\n  right: 0;\n  z-index: 2;\n  width: 168px;\n  width: 10.5rem;\n  border-radius: 0.6em;\n  overflow: hidden;\n  background-color: #fff; }\n  .action-list__button {\n    width: 100%;\n    border-radius: 0;\n    padding-top: 0.5em;\n    padding-bottom: 0.5em;\n    border-bottom: 1px solid #fff; }\n  .action-list__button--excel svg path,\n    .action-list__button--excel svg polyline {\n      fill: #374e60; }\n  .action-list__button--excel:not(:disabled):hover svg path,\n    .action-list__button--excel:not(:disabled):hover svg polyline {\n      stroke: #374e60;\n      fill: #fff; }\n  .action-list__button--excel:not(:disabled):hover svg polygon {\n      fill: #374e60; }\n  .action-list__button.button {\n      text-align: left;\n      margin-bottom: 0; }\n  .action-list__item:last-child .action-list__button {\n    border-bottom: none; }\n", ""]);
// Exports
exports.locals = {
	"action-list": "action-list",
	"action-list__button": "action-list__button",
	"action-list__button--excel": "action-list__button--excel",
	"button": "button",
	"action-list__item": "action-list__item"
};
module.exports = exports;


/***/ }),

/***/ "LCX7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Styles


// Components


// Actions


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _linguiCdn = __webpack_require__("siuH");

__webpack_require__("ZowN");

var _genericModal = __webpack_require__("51N/");

var _genericModal2 = _interopRequireDefault(_genericModal);

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _selectLabel = __webpack_require__("4H+z");

var _selectLabel2 = _interopRequireDefault(_selectLabel);

var _radioButton = __webpack_require__("EUcZ");

var _radioButton2 = _interopRequireDefault(_radioButton);

var _consoleActions = __webpack_require__("SC2c");

var _consoleActions2 = _interopRequireDefault(_consoleActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var SELECTED_STUDENTS_VALUE = 1;
var WHOLE_CLASS_VALUE = 2;
var SELECT_GROUP_VALUE = 3;

// List of VALID QR format values
var qr3x3Format = 'QR_3x3';
var qr2x2Format = 'QR';
var qr2x5Format = '_2X5';
var qr2x7Format = '_2X7';
var qr3x8Format = '_3X8';

function DownloadSignInModal(props) {
    var _this = this;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    // Props


    var closeHandler = props.closeHandler,
        productId = props.productId,
        currentClassId = props.currentClassId,
        classGroups = props.classGroups,
        wholeClassStudents = props.wholeClassStudents,
        mainSelectedStudentIds = props.mainSelectedStudentIds,
        downloadSignInCardsHandler = props.downloadSignInCardsHandler,
        numOfSelectedStudents = props.numOfSelectedStudents;

    // Select Values

    var _useState = (0, _react.useState)(qr3x3Format),
        _useState2 = _slicedToArray(_useState, 2),
        qrFormatValue = _useState2[0],
        setQrFormatValue = _useState2[1];

    var _useState3 = (0, _react.useState)(numOfSelectedStudents ? 1 : 2),
        _useState4 = _slicedToArray(_useState3, 2),
        cardsSelection = _useState4[0],
        setSelection = _useState4[1];

    var _useState5 = (0, _react.useState)(''),
        _useState6 = _slicedToArray(_useState5, 2),
        groupValue = _useState6[0],
        setGroupValue = _useState6[1];

    var _useState7 = (0, _react.useState)(null),
        _useState8 = _slicedToArray(_useState7, 2),
        errorMessage = _useState8[0],
        setErrorMessage = _useState8[1];

    // Button


    var _useState9 = (0, _react.useState)(true),
        _useState10 = _slicedToArray(_useState9, 2),
        isDownloadDisabled = _useState10[0],
        setIsDownloadDisabled = _useState10[1];

    var numStudentsInClass = wholeClassStudents.length;
    // List of lists
    var listOfQRFormatOptions = [{
        id: '',
        name: i18n._( /*i18n*/{
            id: 'Download Sign-in - Select option label'
        })
    }, {
        id: qr3x3Format,
        name: i18n._( /*i18n*/{
            id: 'Download Sign-in - QR code 3 x 3 label'
        })
    }, {
        id: qr2x2Format,
        name: i18n._( /*i18n*/{
            id: 'Download Sign-in - QR code 2 x 2 label'
        })
    }, {
        id: qr2x5Format,
        name: i18n._( /*i18n*/{
            id: 'Download Sign-in - 2 x 5 label'
        })
    }, {
        id: qr2x7Format,
        name: i18n._( /*i18n*/{
            id: 'Download Sign-in - 2 x 7 label'
        })
    }, {
        id: qr3x8Format,
        name: i18n._( /*i18n*/{
            id: 'Download Sign-in - 3 x 8 label'
        })
    }];
    var listOfGroups = [{
        groupId: '',
        name: i18n._( /*i18n*/{
            id: 'Download Sign-in - Option group'
        })
    }].concat(_toConsumableArray(classGroups));
    // const groupToSelectLabel = <Trans id="Download Sign-in - Select Group Label" />;
    var listOfButtons = [{
        name: _react2.default.createElement(_react3.Trans, {
            id: 'Download Sign-in - Option selection - {numOfSelectedStudents}',
            defaults: '{numOfSelectedStudents, plural, =0 {Selected Students} one {Selected Student (#)} other {Selected Students (#)}}',
            values: {
                numOfSelectedStudents: numOfSelectedStudents
            }
        }),
        value: SELECTED_STUDENTS_VALUE,
        isDisabled: numOfSelectedStudents === 0
    }, {
        name: _react2.default.createElement(_react3.Trans, { id: 'Download Sign-in - Option class - {numStudentsInClass}', defaults: '{numStudentsInClass}',
            values: {
                numStudentsInClass: numStudentsInClass
            }
        }),
        value: WHOLE_CLASS_VALUE
    }, {
        name: _react2.default.createElement(_react3.Trans, { id: 'Download Sign-in - Option group' }),
        value: SELECT_GROUP_VALUE
    }];

    // Select/Radio handlers
    var handleGroupValue = function handleGroupValue(e) {
        setGroupValue(e.target.value);
    };
    var handleQRFormatValue = function handleQRFormatValue(e) {
        setQrFormatValue(e.target.value);
    };
    var radioButtonHandler = function radioButtonHandler(e) {
        var selectionValue = e.target.value;
        var value = parseInt(selectionValue, 10);
        setSelection(value);
    };

    // This function will determine what to send to the B/E
    var localDownloadSignInCardsHandler = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var signInCardPageSizeType, studentUserProfileIds, groupId, response, message;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            signInCardPageSizeType = qrFormatValue;
                            studentUserProfileIds = [];
                            groupId = '';
                            _context.t0 = cardsSelection;
                            _context.next = _context.t0 === SELECTED_STUDENTS_VALUE ? 6 : _context.t0 === WHOLE_CLASS_VALUE ? 8 : _context.t0 === SELECT_GROUP_VALUE ? 10 : 13;
                            break;

                        case 6:
                            // Selected Students
                            studentUserProfileIds = mainSelectedStudentIds;
                            return _context.abrupt('break', 13);

                        case 8:
                            // Whole Class
                            studentUserProfileIds = wholeClassStudents;
                            return _context.abrupt('break', 13);

                        case 10:
                            // Select a group
                            studentUserProfileIds = [];
                            groupId = parseInt(groupValue, 10);
                            return _context.abrupt('break', 13);

                        case 13:
                            _context.next = 15;
                            return downloadSignInCardsHandler({
                                signInCardPageSizeType: signInCardPageSizeType,
                                productId: productId,
                                groupId: groupId,
                                currentClassId: currentClassId,
                                studentUserProfileIds: studentUserProfileIds
                            });

                        case 15:
                            response = _context.sent;


                            if (response === false) {
                                message = _react2.default.createElement(_react3.Trans, { id: 'Error Message - Unable to proceed' });

                                setErrorMessage(message);
                            }

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function localDownloadSignInCardsHandler() {
            return _ref.apply(this, arguments);
        };
    }();

    // Effect to handle the button being disabled
    (0, _react.useEffect)(function () {
        var selectedStudentsValid = cardsSelection === SELECTED_STUDENTS_VALUE && mainSelectedStudentIds.length === 0;
        var groupSelectionValid = cardsSelection === SELECT_GROUP_VALUE && groupValue === '';

        var validateButton = qrFormatValue === '' || cardsSelection === '' || selectedStudentsValid || groupSelectionValid;

        setIsDownloadDisabled(validateButton);
    }, [groupValue, qrFormatValue, cardsSelection]);

    // Effect to set the list of groups to the default group
    (0, _react.useEffect)(function () {
        var defaultGroup = classGroups.find(function (element) {
            return element.isDefault === true;
        });
        setGroupValue(defaultGroup.groupId);
    }, [classGroups]);

    return _react2.default.createElement(
        _genericModal2.default,
        {
            title: _react2.default.createElement(_react3.Trans, { id: 'Download Sign-in - title' }),
            type: _genericModal.MODAL_TYPE.floating,
            parentClasses: 'modal--small download-signin-modal',
            closeHandler: closeHandler },
        _react2.default.createElement(
            'div',
            { className: 'form__row' },
            _react2.default.createElement(_radioButton2.default, {
                id: 'sign-in-selection',
                propertyName: 'value',
                groupName: 'sign-in',
                value: cardsSelection,
                listOfButtons: listOfButtons,
                changeHandler: radioButtonHandler }),
            _react2.default.createElement(_selectLabel2.default, {
                selectHandler: handleGroupValue,
                value: groupValue,
                ariaProps: {
                    /*
                        The following value is the id of the last radio button printed just above:
                            - 'radio-' (as any radio button),
                            - id,
                            - groupName,
                            - index
                    */
                    ariaLabelledBy: 'radio-sign-in-selection-sign-in-2'
                },
                propertyName: 'groupId',
                visibleProperty: 'name',
                importedClasses: 'select--groups',
                id: 'download-signin-select-groups',
                isSelectDisabled: cardsSelection !== 3,
                listOfOptions: listOfGroups
            })
        ),
        _react2.default.createElement(
            'div',
            { className: 'form__row' },
            _react2.default.createElement(
                'label',
                {
                    htmlFor: 'download-signin-select-qr-format',
                    className: 'form__label' },
                _react2.default.createElement(_react3.Trans, {
                    id: 'Download Sign-in - Format label'
                })
            ),
            _react2.default.createElement(_selectLabel2.default, {
                selectHandler: handleQRFormatValue,
                value: qrFormatValue,
                propertyName: 'id',
                visibleProperty: 'name',
                id: 'download-signin-select-qr-format',
                listOfOptions: listOfQRFormatOptions
            })
        ),
        _react2.default.createElement(
            'div',
            { className: 'form__row form__row--buttons' },
            _react2.default.createElement(_button2.default, {
                buttonStyle: _button.BUTTON_STYLES.text,
                callback: localDownloadSignInCardsHandler,
                isBtnDisabled: isDownloadDisabled,
                visibleText: _react2.default.createElement(_react3.Trans, { id: 'Download Sign-in - button' })
            })
        ),
        errorMessage ? _react2.default.createElement(
            'div',
            { className: 'form__row form__row--buttons' },
            _react2.default.createElement(
                'p',
                { className: 'form__error-message' },
                errorMessage
            )
        ) : ''
    );
}

DownloadSignInModal.propTypes = {
    closeHandler: _propTypes2.default.func,
    // State
    productId: _propTypes2.default.number,
    currentClassId: _propTypes2.default.number,
    classGroups: _propTypes2.default.array,
    wholeClassStudents: _propTypes2.default.array,
    mainSelectedStudentIds: _propTypes2.default.array,
    // Actions
    downloadSignInCardsHandler: _propTypes2.default.func,
    numOfSelectedStudents: _propTypes2.default.number
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from MessageModalCombinedReducers.
 */
function mapStateToProps(state) {
    var _state$consoleReducer = state.consoleReducer,
        productId = _state$consoleReducer.productId,
        currentClassId = _state$consoleReducer.currentClassId,
        classGroups = _state$consoleReducer.classGroups,
        classGroupStudents = _state$consoleReducer.classGroupStudents,
        mainSelectedStudentIds = _state$consoleReducer.mainSelectedStudentIds;


    return {
        productId: productId,
        currentClassId: currentClassId,
        classGroups: classGroups,
        wholeClassStudents: classGroupStudents.map(function (student) {
            return student.userProfileId;
        }),
        mainSelectedStudentIds: mainSelectedStudentIds
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        downloadSignInCardsHandler: _consoleActions2.default.downloadSignInCardsHandler
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DownloadSignInModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "LaDp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _linguiCdn = __webpack_require__("siuH");

var _table = __webpack_require__("ZaAk");

var _table2 = _interopRequireDefault(_table);

var _checkbox = __webpack_require__("0yfC");

var _checkbox2 = _interopRequireDefault(_checkbox);

var _utils = __webpack_require__("6QRH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AddStudentsList(_ref) {
    var listOfRows = _ref.listOfRows,
        selectAllValue = _ref.selectAllValue,
        selectAllCheckboxHandler = _ref.selectAllCheckboxHandler,
        numberOfStudents = _ref.numberOfStudents;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var listOfHeaders = [{
        key: (0, _utils.stripCharacters)(i18n._( /*i18n*/{
            id: 'Header - Select All'
        })),
        importedClasses: 'table__cell--checkbox',
        content: _react2.default.createElement(_checkbox2.default, {
            uid: 'addSelectAll',
            isChecked: selectAllValue,
            callback: selectAllCheckboxHandler,
            labelText: _react2.default.createElement(_react3.Trans, { id: 'Header - Select All' }),
            inputType: _checkbox.LABEL_STYLES.hidden
        })
    }, {
        key: (0, _utils.stripCharacters)(i18n._( /*i18n*/{
            id: 'Header - Students'
        })),
        content: _react2.default.createElement(_react3.Trans, { id: 'Header - Students with value - {numberOfStudents}', defaults: 'value {numberOfStudents}',
            values: {
                numberOfStudents: numberOfStudents
            }
        })
    }, {
        key: (0, _utils.stripCharacters)(i18n._( /*i18n*/{
            id: 'Header - Class name'
        })),
        content: _react2.default.createElement(_react3.Trans, { id: 'Header - Class name' })
    }, {
        key: (0, _utils.stripCharacters)(i18n._( /*i18n*/{
            id: 'Header - Group'
        })),
        content: _react2.default.createElement(_react3.Trans, { id: 'Header - Group' })
    }, {
        key: (0, _utils.stripCharacters)(i18n._( /*i18n*/{
            id: 'Header - Actions'
        })),
        content: _react2.default.createElement(_react3.Trans, { id: 'Header - Actions' })
    }];

    return _react2.default.createElement(_table2.default, {
        listOfHeaders: listOfHeaders,
        listOfRows: listOfRows
    });
}

// Helpers


// Components


AddStudentsList.propTypes = {
    listOfRows: _propTypes2.default.array.isRequired,
    selectAllValue: _propTypes2.default.bool,
    selectAllCheckboxHandler: _propTypes2.default.func,
    numberOfStudents: _propTypes2.default.number
};

exports.default = AddStudentsList;

/***/ }),

/***/ "Lgqb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("6jOx");

var _imageAsset = __webpack_require__("hB8d");

var _imageAsset2 = _interopRequireDefault(_imageAsset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThreeEssentailsButton = function ThreeEssentailsButton(_ref) {
    var clickHandler = _ref.clickHandler,
        title = _ref.title,
        _ref$show3EIcon = _ref.show3EIcon,
        show3EIcon = _ref$show3EIcon === undefined ? true : _ref$show3EIcon,
        buttonClassName = _ref.buttonClassName,
        _ref$showArrow = _ref.showArrow,
        showArrow = _ref$showArrow === undefined ? true : _ref$showArrow;
    return _react2.default.createElement(
        'button',
        {
            className: 'three_essentials_button ' + buttonClassName,
            onClick: clickHandler
        },
        show3EIcon && _react2.default.createElement(_imageAsset2.default, {
            parentClass: 'three_essentials_button__icon three_essentials_button__3e-icon',
            type: 'threeEssentials' }),
        title,
        showArrow && _react2.default.createElement(_imageAsset2.default, { parentClass: 'three_essentials_button__icon', type: 'arrow' })
    );
};

ThreeEssentailsButton.propTypes = {
    clickHandler: _propTypes2.default.func.isRequired,
    title: _propTypes2.default.string,
    show3EIcon: _propTypes2.default.bool,
    buttonClassName: _propTypes2.default.string,
    showArrow: _propTypes2.default.bool
};

exports.default = ThreeEssentailsButton;

/***/ }),

/***/ "Lh61":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".table {\n  border-color: #c2c2c2;\n  width: 100%; }\n  .table .tableHeader {\n    position: sticky;\n    top: -1px;\n    z-index: 1; }\n  .table__row--selected .table__cell {\n    background-color: #e4ecf0; }\n  .table__row--disabled .table__cell > * {\n    opacity: 0.5; }\n  .table__row--all-students .table__cell {\n    border-top: 1px solid #000;\n    border-bottom: 1px solid #000;\n    background-color: #9ba7b0;\n    font-weight: 600; }\n  .table__buttons-container {\n    position: relative;\n    float: right;\n    margin: -2px 0; }\n  .table__buttons-container--sort {\n      float: left; }\n  .table__buttons-container--center {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center; }\n  .table .button {\n    margin-left: 8px;\n    margin-left: 0.5rem; }\n  .table .button--password, .table .button--sort {\n      background-color: transparent;\n      font-size: 8px;\n      font-size: 0.5rem; }\n  .table .button--password svg, .table .button--sort svg {\n        margin-right: 8px;\n        margin-right: 0.5rem; }\n  .table .button--password svg g,\n        .table .button--password svg use, .table .button--sort svg g,\n        .table .button--sort svg use {\n          fill: #bfd5e2; }\n  .table .button--password:not(:disabled):hover, .table .button--password:not(:disabled):focus, .table .button--sort:not(:disabled):hover, .table .button--sort:not(:disabled):focus {\n        background-color: transparent; }\n  .table .button--password:not(:disabled):hover svg g,\n        .table .button--password:not(:disabled):hover svg use, .table .button--password:not(:disabled):focus svg g,\n        .table .button--password:not(:disabled):focus svg use, .table .button--sort:not(:disabled):hover svg g,\n        .table .button--sort:not(:disabled):hover svg use, .table .button--sort:not(:disabled):focus svg g,\n        .table .button--sort:not(:disabled):focus svg use {\n          fill: #374e60; }\n  .table .button--password:not(:disabled):active, .table .button--sort:not(:disabled):active {\n        background-color: transparent !important; }\n  .table .button--password:not(:disabled):active svg g,\n        .table .button--password:not(:disabled):active svg use, .table .button--sort:not(:disabled):active svg g,\n        .table .button--sort:not(:disabled):active svg use {\n          fill: #000 !important; }\n  .table .button--sort {\n      margin: -8px 0;\n      margin: -0.5rem 0;\n      text-align: left;\n      font-size: 12px;\n      font-size: 0.75rem;\n      font-weight: 400 !important;\n      color: #000; }\n  .table .button--sort .image-asset {\n        left: 2em; }\n  .table .button--sort:not(:disabled):active {\n        color: #000 !important; }\n  .table .button--sort-active {\n        font-weight: 600 !important; }\n  .table__cell {\n    border: 1px solid #c2c2c2;\n    height: 19.2px;\n    height: 1.2rem;\n    background-color: #fff;\n    background-clip: padding-box;\n    padding: 8px;\n    padding: 0.5rem;\n    font-size: 12px;\n    font-size: 0.75rem; }\n  .table__cell--header {\n      height: 16px;\n      height: 1rem;\n      background-color: #f5f5f5;\n      padding-right: 0;\n      text-align: left;\n      line-height: 16px;\n      line-height: 1rem;\n      font-weight: 400;\n      white-space: nowrap; }\n  .table__cell--header .table__buttons-container {\n        margin: -2px 8px -8px 0;\n        margin: -2px 0.5rem -8px 0; }\n  .table--sticky .table__cell--header {\n        position: sticky;\n        top: -1px;\n        z-index: 1;\n        -webkit-box-shadow: 0 2px 3px -3px #000;\n                box-shadow: 0 2px 3px -3px #000; }\n  .table__cell--header .button {\n        margin-left: 0; }\n  .table__cell--naked {\n      border-color: transparent; }\n  .table__cell--naked:first-child {\n        padding-left: 0; }\n  .table__cell--naked:last-child {\n        padding-right: 0; }\n  .table__cell--checkbox {\n      position: relative;\n      width: 16px;\n      width: 1rem;\n      background-color: #e6e9ea;\n      padding-right: 8px;\n      padding-right: 0.5rem;\n      text-align: left;\n      font-size: 10px;\n      font-size: 0.625rem; }\n  .table__cell--add-student {\n      max-width: 20ch; }\n  .table__cell--name {\n      max-width: 160px;\n      max-width: 10rem; }\n  @media (min-width: 1025px) {\n        .table__cell--name {\n          max-width: 16rem; } }\n  @media (min-width: 1201px) {\n        .table__cell--name {\n          max-width: 25rem; } }\n  .table__cell--detail {\n      white-space: nowrap; }\n  .table__cell--no-results {\n      height: 30vh;\n      text-align: center;\n      vertical-align: middle;\n      font-size: 14px;\n      font-size: 0.875rem; }\n  .table__cell--header-name {\n      width: -webkit-max-content;\n      width: -moz-max-content;\n      width: max-content;\n      padding: 0; }\n  .table__cell--header--detail {\n      width: -webkit-max-content;\n      width: -moz-max-content;\n      width: max-content; }\n  .table__cell--header-password {\n      min-width: 18ch;\n      border: none;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      border-top: 1px solid #c2c2c2;\n      -webkit-box-shadow: none;\n              box-shadow: none; }\n  .table__cell--header-password div {\n        -ms-flex-item-align: center;\n            align-self: center;\n        margin-right: 8px; }\n  .table__cell--header-group {\n      width: 304px;\n      width: 19rem;\n      min-width: 304px;\n      min-width: 19rem;\n      padding: 0; }\n  .table__cell--header-course {\n      min-width: 40%; }\n  .table__cell--actions {\n      border-right: none;\n      border-left: none; }\n  .table__cell--actions:nth-child(2) {\n        border-left: 1px solid #c2c2c2;\n        width: 20%; }\n  .table__cell--actions:last-child {\n        border-right: 1px solid #c2c2c2; }\n  .table__cell--class-detail {\n      width: 40%; }\n  .table__cell--upfcourse {\n      vertical-align: middle;\n      font-size: 10.8px;\n      font-size: 0.675rem;\n      padding: 5px; }\n  .table__cell--no-course-assigned {\n      color: #4f5c67;\n      display: block;\n      max-width: 100%; }\n  .table .form__input--password {\n    margin-top: -4px;\n    max-width: 9ch; }\n", ""]);
// Exports
exports.locals = {
	"table": "table",
	"tableHeader": "tableHeader",
	"table__row--selected": "table__row--selected",
	"table__cell": "table__cell",
	"table__row--disabled": "table__row--disabled",
	"table__row--all-students": "table__row--all-students",
	"table__buttons-container": "table__buttons-container",
	"table__buttons-container--sort": "table__buttons-container--sort",
	"table__buttons-container--center": "table__buttons-container--center",
	"button": "button",
	"button--password": "button--password",
	"button--sort": "button--sort",
	"image-asset": "image-asset",
	"button--sort-active": "button--sort-active",
	"table__cell--header": "table__cell--header",
	"table--sticky": "table--sticky",
	"table__cell--naked": "table__cell--naked",
	"table__cell--checkbox": "table__cell--checkbox",
	"table__cell--add-student": "table__cell--add-student",
	"table__cell--name": "table__cell--name",
	"table__cell--detail": "table__cell--detail",
	"table__cell--no-results": "table__cell--no-results",
	"table__cell--header-name": "table__cell--header-name",
	"table__cell--header--detail": "table__cell--header--detail",
	"table__cell--header-password": "table__cell--header-password",
	"table__cell--header-group": "table__cell--header-group",
	"table__cell--header-course": "table__cell--header-course",
	"table__cell--actions": "table__cell--actions",
	"table__cell--class-detail": "table__cell--class-detail",
	"table__cell--upfcourse": "table__cell--upfcourse",
	"table__cell--no-course-assigned": "table__cell--no-course-assigned",
	"form__input--password": "form__input--password"
};
module.exports = exports;


/***/ }),

/***/ "M8vz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Styles


// Components


// Context


// Actions


// Helpers


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _react3 = __webpack_require__("QruM");

var _linguiCdn = __webpack_require__("siuH");

__webpack_require__("onbX");

var _header = __webpack_require__("RfC5");

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__("YeqY");

var _footer2 = _interopRequireDefault(_footer);

var _mainList = __webpack_require__("YdaO");

var _mainList2 = _interopRequireDefault(_mainList);

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _genericModal = __webpack_require__("51N/");

var _genericModal2 = _interopRequireDefault(_genericModal);

var _consoleModalContext = __webpack_require__("U07W");

var _consoleModalContext2 = _interopRequireDefault(_consoleModalContext);

var _consoleActions = __webpack_require__("SC2c");

var _consoleActions2 = _interopRequireDefault(_consoleActions);

var _groupActions = __webpack_require__("e4+b");

var _groupActions2 = _interopRequireDefault(_groupActions);

var _studentSelectionActions = __webpack_require__("4BpE");

var _studentSelectionActions2 = _interopRequireDefault(_studentSelectionActions);

var _utils = __webpack_require__("6QRH");

var _portalCommunications = __webpack_require__("DMUb");

var _portalCommunications2 = _interopRequireDefault(_portalCommunications);

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function Console(props) {
    var _this = this;

    // State props
    var classGroupStudents = props.classGroupStudents,
        classGroups = props.classGroups,
        classes = props.classes,
        currentClassName = props.currentClassName,
        currentClassId = props.currentClassId,
        hasContentLoaded = props.hasContentLoaded,
        mainCheckAllIsSelected = props.mainCheckAllIsSelected,
        mainSelectedStudentIds = props.mainSelectedStudentIds,
        selectCheckboxStudent = props.selectCheckboxStudent,
        selectAllCheckboxStudent = props.selectAllCheckboxStudent,
        newCoursesAvailabilityCriteria = props.newCoursesAvailabilityCriteria,
        externalClassroomId = props.externalClassroomId,
        isSisSchool = props.isSisSchool;


    var productId = (0, _utils.getParam)('productId') || '1';
    var classId = (0, _utils.getParam)('classId') || '0';
    var countryCode = (0, _utils.getParam)('countryCode') || '';
    // Action props
    var updateStudentGroup = props.updateStudentGroup,
        updateCurrentClassId = props.updateCurrentClassId,
        getTeacherClasses = props.getTeacherClasses,
        editClassName = props.editClassName,
        initialiseCourseSelectOptions = props.initialiseCourseSelectOptions,
        getNewCoursesAvailabilityCriteria = props.getNewCoursesAvailabilityCriteria,
        changePassword = props.changePassword,
        exportStudents = props.exportStudents;

    // State

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        hasInitialError = _useState2[0],
        setHasInitialError = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        showNewCourses = _useState4[0],
        setShowNewCourses = _useState4[1];

    // ComponentDidMount


    (0, _react.useEffect)(function () {
        var isCancelled = false;
        var fetchTeacherClasses = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // Talk to the portal to hide their spinner
                                _portalCommunications2.default.requestLoadingSpinner(false);
                                _context.next = 3;
                                return getTeacherClasses(productId);

                            case 3:
                                response = _context.sent;
                                _context.next = 6;
                                return updateCurrentClassId({ productId: productId, classId: classId });

                            case 6:
                                if (!(response.valid === false && isCancelled)) {
                                    _context.next = 10;
                                    break;
                                }

                                setHasInitialError(true);
                                _context.next = 14;
                                break;

                            case 10:
                                _context.next = 12;
                                return getNewCoursesAvailabilityCriteria();

                            case 12:
                                _context.next = 14;
                                return initialiseCourseSelectOptions({
                                    countryOption: i18n._( /*i18n*/{
                                        id: 'Select - Default Country Option'
                                    }),
                                    yearOption: i18n._( /*i18n*/{
                                        id: 'Select - Default Year Option'
                                    }),
                                    allYearsOption: i18n._( /*i18n*/{
                                        id: 'Group Modal - Option - All grades'
                                    }),
                                    courseOption: i18n._( /*i18n*/{
                                        id: 'Select - Default Course Option'
                                    }),
                                    upfCourseOption: i18n._( /*i18n*/{
                                        id: 'Select - Default UPF Course Option'
                                    }),
                                    newCourseOption: i18n._( /*i18n*/{
                                        id: 'Select - Default Course Option'
                                    }),
                                    noNewCourseFoundOption: i18n._( /*i18n*/{
                                        id: 'Group Modal - label - Select no courses'
                                    }),
                                    upfCourseAdminSelectionOption: i18n._( /*i18n*/{
                                        id: 'Select - Use admin selection Option'
                                    }),
                                    upfCurrentCourseSuffix: i18n._( /*i18n*/{
                                        id: 'Select option - currently assigned'
                                    }),
                                    noUPFCourseFoundOption: i18n._( /*i18n*/{
                                        id: 'Group Modal - label - Select no courses'
                                    })
                                });

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function fetchTeacherClasses() {
                return _ref.apply(this, arguments);
            };
        }();
        // Set defaultProductId to be 1
        fetchTeacherClasses();

        return function () {
            isCancelled = true;
        };
    }, [productId]);

    // Determine if new courses should be displayed for the teacher based on region ID and country code
    // New courses data are displayed in the main grid and in the edit/create group modals
    (0, _react.useEffect)(function () {
        function setNewCoursesVisibility(config) {
            if (config) {
                var allowedCountryCodes = config.countryCodes || [];
                var allowedForAll = config.countryCodes.includes('ALL');
                var displayNewCourses = allowedForAll || allowedCountryCodes.includes(countryCode.toUpperCase());
                setShowNewCourses(displayNewCourses);
            }
        }
        _resources2.default.getConfigurationItem('newCoursesVisibilityCriteria').then(setNewCoursesVisibility);
    }, []);

    var closeErrorModal = (0, _react.useCallback)(function () {
        setHasInitialError(false);
    }, [hasInitialError]);

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        showConsoleModal = _useState6[0],
        setShowConsoleModal = _useState6[1];

    var _useState7 = (0, _react.useState)(null),
        _useState8 = _slicedToArray(_useState7, 2),
        consoleModalContent = _useState8[0],
        setConsoleModalContent = _useState8[1];

    var _useState9 = (0, _react.useState)(false),
        _useState10 = _slicedToArray(_useState9, 2),
        isMinimised = _useState10[0],
        setIsMinimised = _useState10[1];

    var _useState11 = (0, _react.useState)(''),
        _useState12 = _slicedToArray(_useState11, 2),
        shownPassword = _useState12[0],
        setShownPassword = _useState12[1];

    // Render


    return _react2.default.createElement(
        _consoleModalContext2.default.Provider,
        {
            value: {
                showConsoleModal: showConsoleModal, setShowConsoleModal: setShowConsoleModal, consoleModalContent: consoleModalContent, setConsoleModalContent: setConsoleModalContent
            }
        },
        _react2.default.createElement(_header2.default, {
            classes: classes,
            productId: productId,
            currentClassName: currentClassName,
            currentClassId: currentClassId,
            updateCurrentClassId: updateCurrentClassId,
            editClassName: editClassName,
            setIsMinimised: setIsMinimised,
            classGroups: classGroups,
            setShownPassword: setShownPassword,
            studentsLength: classGroupStudents.length,
            exportStudents: exportStudents,
            showNewCourses: showNewCourses,
            newCoursesAvailabilityCriteria: newCoursesAvailabilityCriteria,
            externalClassroomId: externalClassroomId,
            isSisSchool: isSisSchool
        }),
        _react2.default.createElement(
            'main',
            { className: 'console' },
            _react2.default.createElement(
                'div',
                { className: 'console__table' },
                _react2.default.createElement(_mainList2.default, {
                    hasContentLoaded: hasContentLoaded,
                    classesLength: classes.length,
                    classGroupStudents: classGroupStudents,
                    classGroups: classGroups,
                    changePassword: changePassword,
                    mainCheckAllIsSelected: mainCheckAllIsSelected,
                    mainSelectedStudentIds: mainSelectedStudentIds,
                    selectCheckboxStudent: selectCheckboxStudent,
                    selectAllCheckboxStudent: selectAllCheckboxStudent,
                    shownPassword: shownPassword,
                    setShownPassword: setShownPassword
                    // change group props
                    , updateCurrentClassId: updateCurrentClassId,
                    selectGroupHandler: updateStudentGroup,
                    currentClassId: currentClassId,
                    productId: productId,
                    showNewCourses: showNewCourses
                })
            )
        ),
        _react2.default.createElement(_footer2.default, {
            numOfClassStudents: classGroupStudents.length,
            numOfSelectedStudents: mainSelectedStudentIds.length,
            isMinimised: isMinimised,
            setIsMinimised: setIsMinimised,
            classGroupStudents: classGroupStudents
        }),
        showConsoleModal === true && consoleModalContent !== null ? consoleModalContent : '',
        hasInitialError && _react2.default.createElement(
            _genericModal2.default,
            {
                title: _react2.default.createElement(_react3.Trans, { id: 'Error Message - Title' }),
                type: _genericModal.MODAL_TYPE.floating,
                closeHandler: closeErrorModal },
            _react2.default.createElement(
                'p',
                { className: 'modal__text modal__text--error' },
                _react2.default.createElement(_react3.Trans, { id: 'Error Message - Unable to proceed' })
            ),
            _react2.default.createElement(
                'div',
                { className: 'form__row form__row--buttons' },
                _react2.default.createElement(_button2.default, {
                    buttonStyle: _button.BUTTON_STYLES.text,
                    callback: closeErrorModal,
                    visibleText: _react2.default.createElement(_react3.Trans, { id: 'Button - Ok' })
                })
            )
        )
    );
}

Console.propTypes = {
    // State
    classGroupStudents: _propTypes2.default.array,
    classGroups: _propTypes2.default.array,
    classes: _propTypes2.default.array,
    currentClassName: _propTypes2.default.string,
    currentClassId: _propTypes2.default.number,
    hasContentLoaded: _propTypes2.default.bool,
    mainCheckAllIsSelected: _propTypes2.default.bool,
    mainSelectedStudentIds: _propTypes2.default.array,
    newCoursesAvailabilityCriteria: _propTypes2.default.object,
    // Actions
    updateStudentGroup: _propTypes2.default.func,
    updateCurrentClassId: _propTypes2.default.func,
    initialiseCourseSelectOptions: _propTypes2.default.func,
    getNewCoursesAvailabilityCriteria: _propTypes2.default.func,
    getTeacherClasses: _propTypes2.default.func,
    editClassName: _propTypes2.default.func,
    selectCheckboxStudent: _propTypes2.default.func,
    selectAllCheckboxStudent: _propTypes2.default.func,
    changePassword: _propTypes2.default.func.isRequired,
    exportStudents: _propTypes2.default.func,
    externalClassroomId: _propTypes2.default.string,
    isSisSchool: _propTypes2.default.bool
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from MessageModalCombinedReducers.
 */
function mapStateToProps(state) {
    var _state$consoleReducer = state.consoleReducer,
        classGroupStudents = _state$consoleReducer.classGroupStudents,
        classGroups = _state$consoleReducer.classGroups,
        classes = _state$consoleReducer.classes,
        currentClassName = _state$consoleReducer.currentClassName,
        currentClassId = _state$consoleReducer.currentClassId,
        hasContentLoaded = _state$consoleReducer.hasContentLoaded,
        mainCheckAllIsSelected = _state$consoleReducer.mainCheckAllIsSelected,
        mainSelectedStudentIds = _state$consoleReducer.mainSelectedStudentIds,
        newCoursesAvailabilityCriteria = _state$consoleReducer.newCoursesAvailabilityCriteria,
        externalClassroomId = _state$consoleReducer.externalClassroomId,
        isSisSchool = _state$consoleReducer.isSisSchool;


    return {
        classGroupStudents: classGroupStudents,
        classGroups: classGroups,
        classes: classes,
        currentClassName: currentClassName,
        currentClassId: currentClassId,
        hasContentLoaded: hasContentLoaded,
        mainCheckAllIsSelected: mainCheckAllIsSelected,
        mainSelectedStudentIds: mainSelectedStudentIds,
        newCoursesAvailabilityCriteria: newCoursesAvailabilityCriteria,
        externalClassroomId: externalClassroomId,
        isSisSchool: isSisSchool
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)(_extends({}, _consoleActions2.default, {
        updateStudentGroup: _groupActions2.default.updateStudentGroup,
        selectCheckboxStudent: _studentSelectionActions2.default.selectCheckboxStudent,
        selectAllCheckboxStudent: _studentSelectionActions2.default.selectAllCheckboxStudent
    }), dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Console);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "MG2x":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".select {\n  border: 1px solid #c2c2c2;\n  border-radius: 0.25rem;\n  width: 100%;\n  padding: 2.96px;\n  padding: 0.185rem;\n  font-size: 12px;\n  font-size: 0.75rem; }\n  .select:not(:disabled):hover, .select:not(:disabled):focus {\n    outline: none;\n    border-color: #000; }\n  .select:not(:disabled):active {\n    border-color: #bfd5e2; }\n  .select:disabled {\n    background-color: #e6e9ea;\n    color: #666666; }\n  .select--content {\n    width: auto; }\n  .select--header {\n    margin: -4px 4px 0;\n    margin: -0.25rem 0.25rem 0;\n    width: auto;\n    max-width: 21ch; }\n  .select-group {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  padding: 8px 0 8px 16px;\n  color: #33475f;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; }\n", ""]);
// Exports
exports.locals = {
	"select": "select",
	"select--content": "select--content",
	"select--header": "select--header",
	"select-group": "select-group"
};
module.exports = exports;


/***/ }),

/***/ "MIN7":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("VW5b");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "MrJZ":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".download-signin-modal {\n  font-size: 12px;\n  font-size: 0.75rem; }\n  .download-signin-modal .radio-button__item {\n    display: block;\n    margin-bottom: 1em;\n    height: calc(1rem + 2px);\n    padding-left: calc(1rem + 2px); }\n  .download-signin-modal .radio-button__label {\n    font-size: 16px;\n    font-size: 1rem; }\n  .download-signin-modal .radio-button__label-text {\n    font-size: 12px;\n    font-size: 0.75rem; }\n  .download-signin-modal .select--groups {\n    margin-left: calc(1rem + 2px + 0.5em);\n    width: calc(100% - 1rem - 2px - 0.5em); }\n", ""]);
// Exports
exports.locals = {
	"download-signin-modal": "download-signin-modal",
	"radio-button__item": "radio-button__item",
	"radio-button__label": "radio-button__label",
	"radio-button__label-text": "radio-button__label-text",
	"select--groups": "select--groups"
};
module.exports = exports;


/***/ }),

/***/ "N5/L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    // The application name, to be used when asking the configuration system for settings
    appName: 'TeacherClassManagementHost',
    // These applications are referenced by the project in an unbuilt state, and require babel to also be run over them
    childApplications: []
};

/***/ }),

/***/ "O161":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hide = exports.show = exports.HIDE = exports.SHOW = undefined;

var _utils = __webpack_require__("6QRH");

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var SHOW = exports.SHOW = 'SHOW_BUSY_INDICATOR';
var HIDE = exports.HIDE = 'HIDE_BUSY_INDICATOR';

var show = exports.show = function show() {
    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
            var showAction;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            showAction = (0, _utils.actionCreator)(SHOW);

                            dispatch(showAction);

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
};

var hide = exports.hide = function hide() {
    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
            var hideAction;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            hideAction = (0, _utils.actionCreator)(HIDE);

                            dispatch(hideAction);

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function (_x2) {
            return _ref2.apply(this, arguments);
        };
    }();
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "OHZ+":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/b1fcdf162bdecb2fe66ae4abc827c874.svg";

/***/ }),

/***/ "OQud":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) {
        return state;
    }

    var type = action.type;

    switch (type) {
        case _busyIndicatorActions.SHOW:
            return _extends({}, state, {
                callCounter: state.callCounter + 1
            });
        case _busyIndicatorActions.HIDE:
            return _extends({}, state, {
                callCounter: state.callCounter > 0 ? state.callCounter - 1 : 0
            });
        default:
            return state;
    }
};

var _busyIndicatorActions = __webpack_require__("O161");

var defaultState = {
    callCounter: 0,
    message: 'Loading...'
};

/***/ }),

/***/ "Oi3E":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/7c39a9c1f746b3ce5b2f4f31bdec3ca2.svg";

/***/ }),

/***/ "PYID":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".groups__filters {\n  position: relative;\n  top: calc(100% - 1px);\n  right: 0;\n  -webkit-box-shadow: 0 0.25rem 0.25rem rgba(0, 0, 0, .5);\n          box-shadow: 0 0.25rem 0.25rem rgba(0, 0, 0, .5);\n  width: 500px;\n  max-width: 50vw;\n  max-height: 0;\n  overflow-y: hidden;\n  background-color: #fff;\n  padding: 0 16px 0 8px;\n  padding: 0 1rem 0 0.5rem; }\n  @supports ((width: -webkit-max-content) or (width: -moz-max-content) or (width: max-content)) {\n    .groups__filters {\n      width: -webkit-max-content;\n      width: -moz-max-content;\n      width: max-content; } }\n  .groups__filters--expanded {\n    padding: 40px 32px;\n    width: 632px;\n    height: auto;\n    border-radius: 12px;\n    border: 2px solid #dbe0e6;\n    background: #fff;\n    -webkit-box-shadow: 2px 2px 8px -1px rgba(0, 25, 55, .06);\n            box-shadow: 2px 2px 8px -1px rgba(0, 25, 55, .06);\n    max-height: -webkit-fit-content;\n    max-height: -moz-fit-content;\n    max-height: fit-content;\n    overflow-y: visible;\n    -webkit-transform: translate(48%, 18px);\n            transform: translate(48%, 18px);\n    margin-bottom: 70px; }\n  .groups__filters--expanded .checkbox__container--groups,\n    .groups__filters--expanded .groups__new-group-container {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: row;\n              flex-direction: row;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      opacity: 1 !important; }\n  .groups__filters--expanded::after {\n      position: absolute;\n      top: -14px;\n      content: '';\n      border-left: 14px solid transparent;\n      border-right: 14px solid transparent;\n      border-bottom: 28px solid #fff;\n      left: 50%;\n      -webkit-transform: translateX(-50%);\n              transform: translateX(-50%); }\n  .groups__group-count {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 10px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #1a304b;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: 0; }\n  .groups__group-edit-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  gap: 20px; }\n  .groups .checkbox__container--groups {\n  opacity: 0;\n  -webkit-transition: 0.1s ease-in-out 0.3s;\n  transition: 0.1s ease-in-out 0.3s; }\n  .groups__container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n  height: 40px;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 0px;\n          flex: 1 0 0;\n  color: #004786; }\n  .groups__group-heading {\n  width: 100%;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 28px;\n  letter-spacing: -0.24px; }\n  .groups__subHeadingText {\n  width: 100%;\n  color: #5c6c7f;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: -0.16px;\n  margin-bottom: 12px; }\n  .groups__group-student-count-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 6px; }\n  .groups__group-student-count {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  top: 3px; }\n  .groups__one-roster-autoselect-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 24px;\n  margin-top: 24px; }\n  .groups__divider {\n  color: #001937;\n  text-align: center;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: -0.32px; }\n  .groups__button-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%; }\n  .groups__one-roster-autoselect-header-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 20px 24px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: stretch;\n      align-self: stretch;\n  border-radius: 16px;\n  background: #ecf9fe; }\n  .groups__one-roster-autoselect-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n  -ms-flex-item-align: stretch;\n      align-self: stretch; }\n  .groups__one-roster-autoselect-header-text {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 40px;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    color: #004786;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 28px;\n    letter-spacing: -0.2px; }\n  .groups__one-roster-autoselect-content {\n  color: #5c6c7f;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: -0.16px;\n  margin-bottom: 24px; }\n  .groups__one-roster-autoselect-content-subtext {\n    color: #33475f;\n    font-weight: 600;\n    margin-left: 4px; }\n", ""]);
// Exports
exports.locals = {
	"groups__filters": "groups__filters",
	"groups__filters--expanded": "groups__filters--expanded",
	"checkbox__container--groups": "checkbox__container--groups",
	"groups__new-group-container": "groups__new-group-container",
	"groups__group-count": "groups__group-count",
	"groups__group-edit-container": "groups__group-edit-container",
	"groups": "groups",
	"groups__container": "groups__container",
	"groups__group-heading": "groups__group-heading",
	"groups__subHeadingText": "groups__subHeadingText",
	"groups__group-student-count-container": "groups__group-student-count-container",
	"groups__group-student-count": "groups__group-student-count",
	"groups__one-roster-autoselect-container": "groups__one-roster-autoselect-container",
	"groups__divider": "groups__divider",
	"groups__button-container": "groups__button-container",
	"groups__one-roster-autoselect-header-container": "groups__one-roster-autoselect-header-container",
	"groups__one-roster-autoselect-header": "groups__one-roster-autoselect-header",
	"groups__one-roster-autoselect-header-text": "groups__one-roster-autoselect-header-text",
	"groups__one-roster-autoselect-content": "groups__one-roster-autoselect-content",
	"groups__one-roster-autoselect-content-subtext": "groups__one-roster-autoselect-content-subtext"
};
module.exports = exports;


/***/ }),

/***/ "Qy98":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/e6f704237fad58d55a84c0ef7b05876c.svg";

/***/ }),

/***/ "RfC5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

__webpack_require__("MIN7");

var _classes = __webpack_require__("x2Ia");

var _classes2 = _interopRequireDefault(_classes);

var _groups = __webpack_require__("IjpL");

var _groups2 = _interopRequireDefault(_groups);

var _tools = __webpack_require__("IPsy");

var _tools2 = _interopRequireDefault(_tools);

var _toastHost = __webpack_require__("9VLZ");

var _toastHost2 = _interopRequireDefault(_toastHost);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Header(props) {
    var classes = props.classes,
        productId = props.productId,
        currentClassName = props.currentClassName,
        currentClassId = props.currentClassId,
        updateCurrentClassId = props.updateCurrentClassId,
        editClassName = props.editClassName,
        classGroups = props.classGroups,
        setShownPassword = props.setShownPassword,
        setIsMinimised = props.setIsMinimised,
        studentsLength = props.studentsLength,
        exportStudents = props.exportStudents,
        showNewCourses = props.showNewCourses,
        newCoursesAvailabilityCriteria = props.newCoursesAvailabilityCriteria,
        externalClassroomId = props.externalClassroomId,
        isSisSchool = props.isSisSchool;


    return _react2.default.createElement(
        'header',
        { className: 'header' },
        _react2.default.createElement(_toastHost2.default, null),
        _react2.default.createElement(
            'h1',
            { className: 'header__title' },
            _react2.default.createElement(_react3.Trans, { id: 'Page - Title' })
        ),
        _react2.default.createElement(
            'div',
            { className: 'header__tools' },
            _react2.default.createElement(
                'div',
                { className: 'header__tool header__tool--classes' },
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'consoleClassSelector' },
                    _react2.default.createElement(_react3.Trans, { id: 'Class Dropdown - header' })
                ),
                _react2.default.createElement(_classes2.default, {
                    externalClassroomId: externalClassroomId,
                    classes: classes,
                    productId: productId,
                    currentClassName: currentClassName,
                    currentClassId: currentClassId,
                    updateCurrentClassId: updateCurrentClassId,
                    editClassName: editClassName,
                    setIsMinimised: setIsMinimised,
                    isSisSchool: isSisSchool
                })
            ),
            _react2.default.createElement(_groups2.default, {
                parentClass: 'header__tool header__tool--groups',
                classGroups: classGroups,
                setShownPassword: setShownPassword,
                showNewCourses: showNewCourses,
                newCoursesAvailabilityCriteria: newCoursesAvailabilityCriteria
            })
        ),
        _react2.default.createElement(_tools2.default, {
            parentClass: 'header__tool header__tool--actions',
            classesLength: classes.length || 0,
            studentsLength: studentsLength,
            exportStudents: exportStudents,
            currentClassId: currentClassId,
            currentClassName: currentClassName,
            isSisSchool: isSisSchool
        })
    );
}

Header.propTypes = {
    classes: _propTypes2.default.array,
    productId: _propTypes2.default.string,
    currentClassName: _propTypes2.default.string,
    currentClassId: _propTypes2.default.number,
    editClassName: _propTypes2.default.func,
    updateCurrentClassId: _propTypes2.default.func,
    setIsMinimised: _propTypes2.default.func,
    isSisSchool: _propTypes2.default.bool,
    classGroups: _propTypes2.default.array,
    setShownPassword: _propTypes2.default.func,
    studentsLength: _propTypes2.default.number,
    exportStudents: _propTypes2.default.func,
    showNewCourses: _propTypes2.default.bool,
    newCoursesAvailabilityCriteria: _propTypes2.default.object,
    externalClassroomId: _propTypes2.default.string
};

exports.default = Header;

/***/ }),

/***/ "SAlD":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/383b43b2dcc616b7f4206e5d826d86cc.svg";

/***/ }),

/***/ "SC2c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CHANGE_PASSWORD = exports.EDIT_CLASS_NAME = exports.GET_UPDATED_TEACHER_CLASS = exports.GET_TEACHER_CLASS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _utils = __webpack_require__("6QRH");

var _coursesActions = __webpack_require__("5/v9");

var _coursesActions2 = _interopRequireDefault(_coursesActions);

var _portalCommunications = __webpack_require__("DMUb");

var _portalCommunications2 = _interopRequireDefault(_portalCommunications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Helpers


// Other


// List of action names
var GET_TEACHER_CLASS = exports.GET_TEACHER_CLASS = 'GET_TEACHER_CLASS';
var GET_UPDATED_TEACHER_CLASS = exports.GET_UPDATED_TEACHER_CLASS = 'GET_UPDATED_TEACHER_CLASS';
var EDIT_CLASS_NAME = exports.EDIT_CLASS_NAME = 'EDIT_CLASS_NAME';
var CHANGE_PASSWORD = exports.CHANGE_PASSWORD = 'CHANGE_PASSWORD';

var getTeacherClasses = function getTeacherClasses(productId) {
    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
            var getTeacherClassesResponse, teacherAction;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!_resources2.default.getTeacherClasses) {
                                _context.next = 10;
                                break;
                            }

                            _context.next = 3;
                            return _resources2.default.getTeacherClasses.get({ productId: productId }).headers({ Locale: (0, _utils.getLocale)() }).send();

                        case 3:
                            getTeacherClassesResponse = _context.sent;

                            if (!getTeacherClassesResponse.valid) {
                                _context.next = 9;
                                break;
                            }

                            teacherAction = (0, _utils.actionCreator)(GET_TEACHER_CLASS, {
                                data: getTeacherClassesResponse.data,
                                productId: parseInt(productId, 10)
                            });
                            _context.next = 8;
                            return dispatch(teacherAction);

                        case 8:
                            return _context.abrupt('return', true);

                        case 9:
                            return _context.abrupt('return', getTeacherClassesResponse);

                        case 10:
                            return _context.abrupt('return', false);

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
};

var editClassName = function editClassName(_ref2) {
    var classroomId = _ref2.classroomId,
        name = _ref2.name;
    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
            var editClassResponse, teacherAction;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!_resources2.default.editClassName) {
                                _context2.next = 9;
                                break;
                            }

                            _context2.next = 3;
                            return _resources2.default.editClassName.put({ classroomId: classroomId }).headers({ Locale: (0, _utils.getLocale)() }).withBody(name)
                            // .raw()
                            .send();

                        case 3:
                            editClassResponse = _context2.sent;

                            if (!editClassResponse.valid) {
                                _context2.next = 8;
                                break;
                            }

                            teacherAction = (0, _utils.actionCreator)(EDIT_CLASS_NAME, {
                                name: name
                            });

                            dispatch(teacherAction);

                            return _context2.abrupt('return', true);

                        case 8:
                            return _context2.abrupt('return', editClassResponse);

                        case 9:
                            return _context2.abrupt('return', false);

                        case 10:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function (_x2) {
            return _ref3.apply(this, arguments);
        };
    }();
};

var updateCurrentClassId = function updateCurrentClassId(_ref4) {
    var productId = _ref4.productId,
        classId = _ref4.classId;
    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
            var getTeacherClassesResponse, data, teacherAction, fetchingData;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!_resources2.default.getTeacherClasses) {
                                _context3.next = 14;
                                break;
                            }

                            _context3.next = 3;
                            return _resources2.default.getTeacherClasses.get({ productId: productId }).withParams({ classId: classId }).headers({ Locale: (0, _utils.getLocale)() }).send();

                        case 3:
                            getTeacherClassesResponse = _context3.sent;


                            // Inform change in ClassId to portal
                            _portalCommunications2.default.informClassGroupSelection(classId);
                            // Set the new data based on the class

                            if (!getTeacherClassesResponse.valid) {
                                _context3.next = 14;
                                break;
                            }

                            data = getTeacherClassesResponse.data;
                            teacherAction = (0, _utils.actionCreator)(GET_UPDATED_TEACHER_CLASS, {
                                data: data
                            });
                            _context3.next = 10;
                            return dispatch(teacherAction);

                        case 10:
                            fetchingData = (0, _utils.actionCreator)(_coursesActions.FETCHING_COURSE_CONTENT);
                            _context3.next = 13;
                            return dispatch(fetchingData);

                        case 13:
                            return _context3.abrupt('return', true);

                        case 14:
                            return _context3.abrupt('return', false);

                        case 15:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined);
        }));

        return function (_x3) {
            return _ref5.apply(this, arguments);
        };
    }();
};

var changePassword = function changePassword(_ref6) {
    var userProfileId = _ref6.userProfileId,
        newPassword = _ref6.newPassword;
    return function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
            var changePasswordResponse, teacherAction;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (!_resources2.default.changePassword) {
                                _context4.next = 9;
                                break;
                            }

                            _context4.next = 3;
                            return _resources2.default.changePassword.put().headers({ Locale: (0, _utils.getLocale)() }).withBody({
                                userProfileId: userProfileId,
                                newPassword: newPassword
                            }).send();

                        case 3:
                            changePasswordResponse = _context4.sent;

                            if (!changePasswordResponse.valid) {
                                _context4.next = 8;
                                break;
                            }

                            teacherAction = (0, _utils.actionCreator)(CHANGE_PASSWORD, {
                                userProfileId: userProfileId,
                                newPassword: newPassword
                            });

                            dispatch(teacherAction);

                            return _context4.abrupt('return', true);

                        case 8:
                            return _context4.abrupt('return', changePasswordResponse);

                        case 9:
                            return _context4.abrupt('return', false);

                        case 10:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, undefined);
        }));

        return function (_x4) {
            return _ref7.apply(this, arguments);
        };
    }();
};

// Add new students actions ---- start ----
// Get all students data while move/copy students through footer action
var getInitialStudentsForMoveCopy = function getInitialStudentsForMoveCopy(_ref8) {
    var productId = _ref8.productId;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var addNewStudentResponse;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        if (!_resources2.default.getStudentMoveCopyData) {
                            _context5.next = 7;
                            break;
                        }

                        _context5.next = 3;
                        return _resources2.default.getStudentMoveCopyData.get({ productId: productId || 1 }).headers({ Locale: (0, _utils.getLocale)() }).send();

                    case 3:
                        addNewStudentResponse = _context5.sent;

                        if (!addNewStudentResponse.valid) {
                            _context5.next = 6;
                            break;
                        }

                        return _context5.abrupt('return', addNewStudentResponse.data);

                    case 6:
                        return _context5.abrupt('return', addNewStudentResponse.valid);

                    case 7:
                        return _context5.abrupt('return', false);

                    case 8:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, undefined);
    }));
};

// Get all students data while move/copy students through ADD Students action
var getInitialAddStudent = function getInitialAddStudent(_ref10) {
    var productId = _ref10.productId,
        currentClassId = _ref10.currentClassId;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var addNewStudentResponse;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        if (!_resources2.default.getStudentManagementData) {
                            _context6.next = 7;
                            break;
                        }

                        _context6.next = 3;
                        return _resources2.default.getStudentManagementData.get({ productId: productId || 1 }).headers({ Locale: (0, _utils.getLocale)() }).withParams({ currentClassId: currentClassId }).send();

                    case 3:
                        addNewStudentResponse = _context6.sent;

                        if (!addNewStudentResponse.valid) {
                            _context6.next = 6;
                            break;
                        }

                        return _context6.abrupt('return', addNewStudentResponse.data);

                    case 6:
                        return _context6.abrupt('return', addNewStudentResponse.valid);

                    case 7:
                        return _context6.abrupt('return', false);

                    case 8:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, undefined);
    }));
};

// Get student management data for a particular class
var getAddStudentClasses = function getAddStudentClasses(_ref12) {
    var classId = _ref12.classId,
        productId = _ref12.productId;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var addNewStudentResponse;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        if (!_resources2.default.getAddStudentClasses) {
                            _context7.next = 7;
                            break;
                        }

                        _context7.next = 3;
                        return _resources2.default.getAddStudentClasses.get({ classId: classId, productId: productId }).headers({ Locale: (0, _utils.getLocale)() }).send();

                    case 3:
                        addNewStudentResponse = _context7.sent;

                        if (!addNewStudentResponse.valid) {
                            _context7.next = 6;
                            break;
                        }

                        return _context7.abrupt('return', addNewStudentResponse.data);

                    case 6:
                        return _context7.abrupt('return', addNewStudentResponse.valid);

                    case 7:
                        return _context7.abrupt('return', false);

                    case 8:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, undefined);
    }));
};

// Get student management data for a particular class & group
var getAddStudentDetails = function getAddStudentDetails(_ref14) {
    var productId = _ref14.productId,
        classId = _ref14.classId,
        groupId = _ref14.groupId;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var addNewStudentResponse;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        if (!_resources2.default.getAddStudentDetails) {
                            _context8.next = 7;
                            break;
                        }

                        _context8.next = 3;
                        return _resources2.default.getAddStudentDetails.get({ productId: productId, classId: classId, groupId: groupId }).headers({ Locale: (0, _utils.getLocale)() }).send();

                    case 3:
                        addNewStudentResponse = _context8.sent;

                        if (!addNewStudentResponse.valid) {
                            _context8.next = 6;
                            break;
                        }

                        return _context8.abrupt('return', addNewStudentResponse.data);

                    case 6:
                        return _context8.abrupt('return', addNewStudentResponse.valid);

                    case 7:
                        return _context8.abrupt('return', false);

                    case 8:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, undefined);
    }));
};

/**
 * This function will update a students relation to a particular class, the function to move/copy them is based on
 * the action(move/copy/remove) selected, as mentioned in the updateMoveStudentList method.
 *
 *      - Move will move the student from their current class (referred as sourceClassId) and to the new class and group
 *      - Copy will do the same thing as above, instead they will stay in their current class (sourceClassId)
 *      - Remove will remove the student from the particular class and group
 *
 * @param assignStudents
 */
var assignClassStudent = function assignClassStudent(_ref16) {
    var assignStudents = _ref16.assignStudents;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var cleanAssignStudents, assignClassStudentResponse;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        // Filters out any copy or move without a groupId
                        cleanAssignStudents = assignStudents.filter(function (student) {
                            return (student.actionType === 1 || student.actionType === 2) && Number.isInteger(student.destinationGroupId) || student.actionType === 3;
                        });

                        if (!_resources2.default.assignClassStudent) {
                            _context9.next = 8;
                            break;
                        }

                        _context9.next = 4;
                        return _resources2.default.assignClassStudent.patch().headers({ Locale: (0, _utils.getLocale)() }).withBody({
                            assignStudents: cleanAssignStudents
                        }).raw().send();

                    case 4:
                        assignClassStudentResponse = _context9.sent;

                        if (!assignClassStudentResponse.valid) {
                            _context9.next = 7;
                            break;
                        }

                        return _context9.abrupt('return', assignClassStudentResponse.valid);

                    case 7:
                        return _context9.abrupt('return', false);

                    case 8:
                        return _context9.abrupt('return', false);

                    case 9:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, undefined);
    }));
};

/**
 * This function will update a students relation to a particular class, in the table and
 * does not change the group in the footer modal
 *
 *      - Move the student to the selected group in the table
 *      - This is created using the new endpoint gateway
 *
 *
 * @param classId
 * @param groupId
 * @param studentProfileIds
 */
var assignGroup = function assignGroup(_ref18) {
    var classId = _ref18.classId,
        groupId = _ref18.groupId,
        studentProfileIds = _ref18.studentProfileIds;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var assignStudentResponse;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        if (!_resources2.default.assignGroup) {
                            _context10.next = 7;
                            break;
                        }

                        _context10.next = 3;
                        return _resources2.default.assignGroup.patch({ classId: classId, groupId: groupId }).headers({ Locale: (0, _utils.getLocale)() }).withBody(studentProfileIds).raw().send();

                    case 3:
                        assignStudentResponse = _context10.sent;

                        if (!assignStudentResponse.valid) {
                            _context10.next = 6;
                            break;
                        }

                        return _context10.abrupt('return', assignStudentResponse.data);

                    case 6:
                        return _context10.abrupt('return', false);

                    case 7:
                        return _context10.abrupt('return', false);

                    case 8:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee10, undefined);
    }));
};
// Add new students actions ---- end ----

var exportStudents = function exportStudents() {
    return function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(dispatch, getState) {
            var consoleReducer, productId, currentClassId, authToken, getExportStudents, endpointValue, service, url;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            consoleReducer = getState().consoleReducer;
                            productId = consoleReducer.productId, currentClassId = consoleReducer.currentClassId;
                            authToken = _resources2.default.env.authToken;
                            getExportStudents = _resources2.default.exportStudents;
                            endpointValue = 'StudentManagerGatewayEndpoint';
                            service = getExportStudents.configuration.values[endpointValue];
                            url = getExportStudents.path;

                            // replace the variables within the path of the key

                            url = url.replace('@' + endpointValue, service);
                            url = url.replace('{productId}', productId);
                            url = url.replace('{currentClassId}', currentClassId);
                            url = url.replace('{authToken}', authToken);
                            window.location.href = url;

                        case 12:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, undefined);
        }));

        return function (_x5, _x6) {
            return _ref20.apply(this, arguments);
        };
    }();
};

var downloadSignInCardsHandler = function downloadSignInCardsHandler(_ref21) {
    var signInCardPageSizeType = _ref21.signInCardPageSizeType,
        productId = _ref21.productId,
        groupId = _ref21.groupId,
        currentClassId = _ref21.currentClassId,
        studentUserProfileIds = _ref21.studentUserProfileIds;
    return function () {
        var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(dispatch) {
            var downloadBody, downloadStudentSignInResponse, downloadKey, getDownloadCards, url, endpointValue, service;
            return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            if (!_resources2.default.downloadStudentSignInCards) {
                                _context12.next = 8;
                                break;
                            }

                            downloadBody = {};


                            if (groupId === '') {
                                downloadBody = {
                                    SignInCardPageSizeType: signInCardPageSizeType,
                                    ClassroomId: currentClassId,
                                    StudentUserProfileIds: studentUserProfileIds
                                };
                            } else {
                                downloadBody = {
                                    SignInCardPageSizeType: signInCardPageSizeType,
                                    ClassroomId: currentClassId,
                                    GroupId: groupId,
                                    StudentUserProfileIds: studentUserProfileIds
                                };
                            }

                            _context12.next = 5;
                            return _resources2.default.downloadStudentSignInCards.post({ productId: productId }).headers({ Locale: (0, _utils.getLocale)() }).withBody(downloadBody).send();

                        case 5:
                            downloadStudentSignInResponse = _context12.sent;


                            if (downloadStudentSignInResponse.valid) {
                                downloadKey = downloadStudentSignInResponse.data;
                                getDownloadCards = _resources2.default.getDownloadStudentSignInCards;
                                url = getDownloadCards.path;
                                endpointValue = 'SignInCardGatewayEndpoint';
                                service = getDownloadCards.configuration.values[endpointValue];
                                // replace the variables within the path of the key

                                url = url.replace('@' + endpointValue, service);
                                url = url.replace('{productId}', productId);
                                url = url.replace('{downloadKey}', downloadKey);
                                window.location.href = url;

                                dispatch({
                                    type: 'SUCCESS_DOWNLOAD',
                                    payload: {
                                        downloadSuccess: true
                                    }
                                });
                            }

                            return _context12.abrupt('return', downloadStudentSignInResponse.valid);

                        case 8:
                            return _context12.abrupt('return', false);

                        case 9:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, undefined);
        }));

        return function (_x7) {
            return _ref22.apply(this, arguments);
        };
    }();
};

exports.default = _extends({
    getTeacherClasses: getTeacherClasses,
    editClassName: editClassName,
    updateCurrentClassId: updateCurrentClassId,
    changePassword: changePassword,
    getInitialAddStudent: getInitialAddStudent,
    getInitialStudentsForMoveCopy: getInitialStudentsForMoveCopy,
    getAddStudentClasses: getAddStudentClasses,
    getAddStudentDetails: getAddStudentDetails,
    assignClassStudent: assignClassStudent,
    assignGroup: assignGroup,
    downloadSignInCardsHandler: downloadSignInCardsHandler
}, _coursesActions2.default, {
    exportStudents: exportStudents
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "SZZ6":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/10820e64368b955f80a9e44459b9f815.svg";

/***/ }),

/***/ "SgkA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global window document */
/* eslint-disable no-console */

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxThunk = __webpack_require__("bEzl");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxPromise = __webpack_require__("po9w");

var _reduxPromise2 = _interopRequireDefault(_reduxPromise);

var _querystring = __webpack_require__("1nuA");

var _querystring2 = _interopRequireDefault(_querystring);

var _redux = __webpack_require__("2KeS");

var _linguiCdn = __webpack_require__("siuH");

var _utils = __webpack_require__("6QRH");

var _combinedReducers = __webpack_require__("Gylf");

var _combinedReducers2 = _interopRequireDefault(_combinedReducers);

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var createStoreWithMiddleware = (0, _redux.applyMiddleware)(_reduxThunk2.default, _reduxPromise2.default)(_redux.createStore);

var BasicApp = function () {
    function BasicApp(element, dynamicOptions) {
        _classCallCheck(this, BasicApp);

        BasicApp.configure();

        this.element = element;
        this.options = (0, _utils.handleDefaults)({}, dynamicOptions);

        this.renderElement();
    }

    _createClass(BasicApp, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'h1',
                null,
                'You should define a render() method for your subclass of BasicApp'
            );
        }

        // Implementation details.  You should not need to change any code past this point.

    }, {
        key: 'renderElement',
        value: function renderElement() {
            var _this = this;

            var store = createStoreWithMiddleware(_combinedReducers2.default,
            // eslint-disable-next-line no-underscore-dangle
            window.devToolsExtension ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
                return f;
            });
            var linguiCdnBaseUrl = (0, _utils.getConfiguration)('LocalisationCdnBaseUrl');
            var locales = linguiLocales();

            (0, _linguiCdn.getI18N)(linguiCdnBaseUrl, locales).then(function (i18n) {
                _reactDom2.default.render(_this.render(store, i18n), document.querySelector(_this.element));
            });
            function linguiLocales() {
                var query = window.location.search.slice(1);
                var match = query.match(/\blocale=([-a-zA-Z]+)\b/);
                var locale = match ? match[1] : 'en-AU';

                return [locale];
            }
        }
    }], [{
        key: 'configure',
        value: function configure() {
            // How we want to configure things depends on where this app is running,
            // and where the services we want to access live.
            //
            // 1. When running on a developer's machine, using a mock server, we want
            //    to use a hard-coded config from
            //
            //       helpers/local-resource-config.js
            //
            // 2. When running on a developer's machine, but we want to use back-end
            //    services on demo, QA or live, we want to get the configuration from
            //    the configuration of the host app.
            //
            // 3. When running on demo, QA or live, the configuration will be injected
            //    based on the host app's configuration, but can be overridden by query
            //    parameters.
            //
            // We determine which situation we have by looking at the window location
            // URL and the query parameters, and whether there is a pppAppConfig property
            // on the window object.

            var location = window.location;
            var runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);
            var queryParams = location.search;
            var query = queryParams.replace('?', '');
            var params = _querystring2.default.parse(query);

            if (runningOnDeveloperMachine) {
                BasicApp.configureForDeveloperMachine(params);
            } else {
                BasicApp.configureForRemoteHost(params);
            }
        }
    }, {
        key: 'configureForDeveloperMachine',
        value: function configureForDeveloperMachine(params) {
            var envName = params.env;

            if (!envName) {
                console.log('BasicApp.configureForDeveloperMachine() - you did not provide an "env" query' + ' parameter, so I am assuming you want to talk to live.');

                envName = 'live';
            }

            var credentials = BasicApp.getCredentials(params);

            if (envName === 'local' || BasicApp.weHaveUsableCredentials(credentials)) {
                _resources2.default.initialise(envName, credentials);
            }
        }
    }, {
        key: 'configureForRemoteHost',
        value: function configureForRemoteHost(params) {
            // eslint-disable-next-line no-underscore-dangle
            var config = window._env_;
            var envName = config.env || 'live';
            var credentials = BasicApp.getCredentials(params);

            if (!config.BaseName) {
                console.log('BasicApp.configureForRemoteHost() - your env does not' + ' include a BaseName item; we will assume it should be blank.');

                config.BaseName = '';
            }

            if (BasicApp.weHaveUsableCredentials(credentials)) {
                _resources2.default.initialise(envName, credentials);
                _resources2.default.env.setConfiguration(config);
            }
        }
    }, {
        key: 'getCredentials',
        value: function getCredentials(params) {
            var credentials = {};
            var items = ['authToken', 'username', 'password'];

            for (var paramName in params) {
                var value = params[paramName];

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        if (paramName.toLowerCase() === item.toLowerCase()) {
                            credentials[item] = value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            return credentials;
        }
    }, {
        key: 'weHaveUsableCredentials',
        value: function weHaveUsableCredentials(credentials) {
            var usableCredentials = false;

            if (credentials.authToken) {
                usableCredentials = true;
            } else if (credentials.username && credentials.password) {
                usableCredentials = true;
            }

            if (!usableCredentials) {
                console.error('EntryApp.configureForDeveloperMachine() - to execute, we need either an authToken or' + ' a username/password pair.  After combining data from window.env and the query' + ' parameters, I still do not have what I need. The app will probably not function correctly if' + ' it requires any 3P resources.');
            }

            return usableCredentials;
        }
    }]);

    return BasicApp;
}();

exports.default = BasicApp;

/***/ }),

/***/ "SxYr":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("L9c/");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "T0He":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/0416d3d1ed9748dfe37557895aa84a3e.svg";

/***/ }),

/***/ "T3kN":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("V2Qg");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "T7vb":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/ce78e4d8a89276d538f87b8a09051586.svg";

/***/ }),

/***/ "Tlb1":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".footer {\n  background: #94b4c9;\n  position: fixed;\n  left: 50%;\n  bottom: 0;\n  z-index: 1;\n  height: 42px;\n  height: 2.625rem;\n  width: 552px;\n  width: 34.5rem;\n  padding: 0 36px;\n  padding: 0 2.25rem;\n  border-radius: 10px 10px 0 0;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  -webkit-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  font-size: 12px;\n  font-size: 0.75rem; }\n  .footer__content {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    height: 100%; }\n  .footer__button {\n    margin: 0 10px; }\n  .footer--minimised {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    left: 85%;\n    -webkit-transform: translateX(-85%);\n            transform: translateX(-85%);\n    height: 21px;\n    height: 1.3125rem;\n    width: calc(9.625rem - 20px);\n    padding: 10px 10px 0 20px;\n    font-weight: bold; }\n  .footer--minimised .footer__content {\n      padding-bottom: 10px;\n      padding-left: 10px; }\n  .footer .tooltip__container {\n    position: absolute;\n    top: 0.5em;\n    left: 1em;\n    z-index: 1; }\n  .button.footer__button--toggle {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin-top: 5px;\n  margin-right: 5px;\n  color: #374e60;\n  background-color: transparent;\n  border: none; }\n  .button.footer__button--toggle:not(:disabled):focus, .button.footer__button--toggle:not(:disabled):active {\n    background-color: transparent !important;\n    outline: none; }\n  .button.footer__button--toggle:not(:disabled):hover, .button.footer__button--toggle:not(:disabled):focus {\n    background-color: transparent; }\n  .button.footer__button--toggle:not(:disabled):hover svg g, .button.footer__button--toggle:not(:disabled):focus svg g {\n      fill: #fff; }\n  .footer--minimised .button.footer__button--toggle {\n  top: 50%;\n  left: 0;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  margin: 0; }\n", ""]);
// Exports
exports.locals = {
	"footer": "footer",
	"footer__content": "footer__content",
	"footer__button": "footer__button",
	"footer--minimised": "footer--minimised",
	"tooltip__container": "tooltip__container",
	"button": "button",
	"footer__button--toggle": "footer__button--toggle"
};
module.exports = exports;


/***/ }),

/***/ "TwFx":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/d709e33922b34f6056736b4b4f505d5b.svg";

/***/ }),

/***/ "U07W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("GiK3");

var ConsoleModalContext = (0, _react.createContext)(null);

exports.default = ConsoleModalContext;

/***/ }),

/***/ "UalU":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("HeQm");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "V2Qg":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".groups {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  position: relative;\n  z-index: 1;\n  width: 144px;\n  width: 9rem;\n  overflow-x: visible; }\n  .groups__button {\n    position: absolute;\n    right: 3px;\n    bottom: 2px;\n    z-index: 2;\n    border-radius: 0.25rem;\n    height: 2em;\n    width: 2em; }\n  .groups__button svg use {\n      fill: #374e60; }\n  .groups__button:not(:disabled):hover svg use, .groups__button:not(:disabled):focus svg use {\n      fill: #fff; }\n  .groups__button:not(:disabled):active svg use {\n      fill: #fff; }\n  .groups__button--expanded {\n      top: 4px; }\n  .groups__new-group-container {\n    display: inline-block;\n    position: relative;\n    opacity: 0;\n    -webkit-transition: 0.1s ease-in-out 0.3s;\n    transition: 0.1s ease-in-out 0.3s; }\n  .flex-grid--occupy .form__label {\n  white-space: nowrap; }\n", ""]);
// Exports
exports.locals = {
	"groups": "groups",
	"groups__button": "groups__button",
	"groups__button--expanded": "groups__button--expanded",
	"groups__new-group-container": "groups__new-group-container",
	"flex-grid--occupy": "flex-grid--occupy",
	"form__label": "form__label"
};
module.exports = exports;


/***/ }),

/***/ "VW5b":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 16px;\n  margin-bottom: 1rem;\n  background: #dbe3e9;\n  padding: 12px 16px 12px 24px;\n  padding: 0.75rem 1rem 0.75rem 1.5rem; }\n  .header__title {\n    font-family: Poppins, sans-serif;\n    font-weight: 400 !important;\n    line-height: 28px;\n    line-height: 1.75rem;\n    white-space: nowrap;\n    font-size: 20px;\n    font-size: 1.25rem;\n    color: #4f5c67; }\n  .header__groups-actions-container {\n    position: absolute;\n    top: 0;\n    left: calc(318px + 0.5rem);\n    z-index: 1;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    width: calc(100% - 318px - 0.5rem); }\n  .header__tools {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    max-height: 32px;\n    max-height: 2rem;\n    overflow-y: visible;\n    z-index: 2; }\n  .header__tool {\n    margin-left: 8px;\n    margin-left: 0.5rem; }\n  .header__tool--classes {\n      display: -webkit-inline-box;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      position: relative;\n      /*\n            MacOS browsers seem to have difficulties in calculating space in this context, this provides for a\n            reserved space that allow elements to stay on a single line. BA 2020-07-08\n            */\n      min-width: 486px; }\n  .header__tool--groups .button--info {\n      margin: 0 0 -2px 8px;\n      margin: 0 0 -2px 0.5rem; }\n  .header__tool--actions {\n      position: relative;\n      margin: -1.5px 0 -7.5px; }\n  .header__tool--actions .button {\n        vertical-align: text-top; }\n  .header__tool--actions .button--actions {\n        margin: 0 0 8px 8px;\n        margin: 0 0 0.5rem 0.5rem; }\n", ""]);
// Exports
exports.locals = {
	"header": "header",
	"header__title": "header__title",
	"header__groups-actions-container": "header__groups-actions-container",
	"header__tools": "header__tools",
	"header__tool": "header__tool",
	"header__tool--classes": "header__tool--classes",
	"header__tool--groups": "header__tool--groups",
	"button--info": "button--info",
	"header__tool--actions": "header__tool--actions",
	"button": "button",
	"button--actions": "button--actions"
};
module.exports = exports;


/***/ }),

/***/ "Vnjy":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("wyHS");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "Vp9z":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("08kL");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "VrhF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BUTTON_STYLES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * @todo add/update JSDoc tags to document your code
                                                                                                                                                                                                                                                                   * (see http://usejsdoc.org/ for information on JSDoc tags),
                                                                                                                                                                                                                                                                   * then remove this comment block.
                                                                                                                                                                                                                                                                   */

/** IconButton functional (stateless) component */


// Styles


// Components


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("M4fF");

__webpack_require__("zZcj");

var _imageAsset = __webpack_require__("hB8d");

var _imageAsset2 = _interopRequireDefault(_imageAsset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Using those types:
 *      - iconSVG: inlines an SVG file's code in the HTML. Has a huge impact on quantity of code if repeated.
 *      - iconBackground: uses a class to show a specific icon. Classes have to be updated and hover and active images
 *      have to be created if needed, but has a low impact when used repeatedly.
 *      - iconText: similar to iconSVG but allows for a visible text after the image.
 *      - text: just display a regular button with text, no image.
 * @type {{iconText: string, iconSVG: string, text: string, iconBackground: string}}
 */
var BUTTON_STYLES = exports.BUTTON_STYLES = {
    iconSVG: 'iconSVG',
    iconBackground: 'iconBackground',
    iconText: 'iconText',
    text: 'text'
};
var STYLES_NAMES = (0, _lodash.keys)(BUTTON_STYLES);
/**
 * IconButton pro-forma template for stateless component
 * @todo - add a proper description of the component
 *
 * @access public
 * @param {string} text string describing the component
 * @returns JSX render of the component
 */
var Button = function Button(_ref) {
    var forwardRef = _ref.forwardRef,
        buttonType = _ref.buttonType,
        buttonStyle = _ref.buttonStyle,
        ariaProps = _ref.ariaProps,
        visibleText = _ref.visibleText,
        importedClasses = _ref.importedClasses,
        imageClassName = _ref.imageClassName,
        iconName = _ref.iconName,
        isBtnDisabled = _ref.isBtnDisabled,
        noTitle = _ref.noTitle,
        callback = _ref.callback,
        assetTitle = _ref.assetTitle,
        isEditGroupCheckBox = _ref.isEditGroupCheckBox,
        showDeleteButton = _ref.showDeleteButton;

    var isGroupSaveButton = isEditGroupCheckBox ? 'edit-group edit-group-save-button' : '';
    var isGroupDeleteButton = isEditGroupCheckBox && showDeleteButton ? 'edit-group edit-group-delete-button' : isGroupSaveButton;
    var btnClasses = 'button ' + importedClasses + ' ' + isGroupDeleteButton;

    var callbackAction = function callbackAction(e) {
        if (callback && !isBtnDisabled) {
            callback(e);
        }
    };

    /*
    By default, the content of Aria-Label is propagated to the title of icn buttons, unless stated otherwise through
    the `noTitle` flag.
     */
    var titleProps = !noTitle && ariaProps && ariaProps['aria-label'] ? { title: ariaProps['aria-label'] } : {};
    var buttonTemplate = '';
    switch (buttonStyle) {
        case BUTTON_STYLES.iconSVG:
            btnClasses = btnClasses + ' button--icon-svg';
            buttonTemplate = _react2.default.createElement(
                'button',
                _extends({
                    ref: forwardRef,
                    type: buttonType
                }, titleProps, ariaProps, {
                    disabled: isBtnDisabled,
                    onClick: callbackAction,
                    className: btnClasses }),
                _react2.default.createElement(_imageAsset2.default, { parentClass: imageClassName, type: iconName, parentTitle: assetTitle }),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    visibleText || ariaProps && ariaProps['aria-label']
                )
            );
            break;

        case BUTTON_STYLES.iconBackground:
            btnClasses = btnClasses + ' button--icon-background';
            buttonTemplate = _react2.default.createElement(
                'button',
                _extends({
                    ref: forwardRef,
                    type: buttonType
                }, titleProps, ariaProps, {
                    disabled: isBtnDisabled,
                    onClick: callbackAction,
                    className: btnClasses }),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    visibleText || ariaProps && ariaProps['aria-label']
                )
            );
            break;

        case BUTTON_STYLES.iconText:
            btnClasses = btnClasses + ' button--icon-text';
            buttonTemplate = _react2.default.createElement(
                'button',
                _extends({
                    ref: forwardRef,
                    type: buttonType
                }, ariaProps, {
                    disabled: isBtnDisabled,
                    onClick: callbackAction,
                    className: btnClasses }),
                _react2.default.createElement(_imageAsset2.default, { parentClass: imageClassName, type: iconName, parentTitle: assetTitle }),
                visibleText
            );
            break;

        case BUTTON_STYLES.text:
        default:
            buttonTemplate = _react2.default.createElement(
                'button',
                _extends({
                    ref: forwardRef,
                    type: buttonType
                }, ariaProps, {
                    disabled: isBtnDisabled,
                    onClick: callbackAction,
                    className: btnClasses }),
                visibleText
            );
    }

    return buttonTemplate;
};

/**
 * Define the default values for the properties being used
 */
Button.defaultProps = {
    buttonType: 'button',
    buttonStyle: BUTTON_STYLES.text,
    importedClasses: '',
    imageClassName: null,
    isBtnDisabled: false
};

/**
 * Define the type of properties that can be set on this component
 */
Button.propTypes = {
    forwardRef: _propTypes2.default.any,
    importedClasses: _propTypes2.default.string,
    buttonType: _propTypes2.default.string,
    buttonStyle: _propTypes2.default.oneOf(STYLES_NAMES),
    imageClassName: _propTypes2.default.string,
    iconName: _propTypes2.default.string,
    ariaProps: _propTypes2.default.object,
    visibleText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    isBtnDisabled: _propTypes2.default.bool,
    isEditGroupCheckBox: _propTypes2.default.bool,
    showDeleteButton: _propTypes2.default.bool,
    noTitle: _propTypes2.default.bool,
    callback: _propTypes2.default.func,
    assetTitle: _propTypes2.default.string
};

exports.default = _react2.default.forwardRef(function (props, ref) {
    return _react2.default.createElement(Button, _extends({ forwardRef: ref }, props));
});

/***/ }),

/***/ "W3S+":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/792871a6e9a3fdad7a5a71bfe9219010.svg";

/***/ }),

/***/ "WAiw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Components


// Actions


// Helpers


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _linguiCdn = __webpack_require__("siuH");

var _table = __webpack_require__("ZaAk");

var _table2 = _interopRequireDefault(_table);

var _moveListBody = __webpack_require__("+tD/");

var _moveListBody2 = _interopRequireDefault(_moveListBody);

var _emptyDataMessage = __webpack_require__("JZJN");

var _emptyDataMessage2 = _interopRequireDefault(_emptyDataMessage);

var _consoleActions = __webpack_require__("SC2c");

var _consoleActions2 = _interopRequireDefault(_consoleActions);

var _utils = __webpack_require__("6QRH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function MoveList(props) {
    var _this = this;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var studentsList = props.studentsList,
        updateMoveStudentList = props.updateMoveStudentList,
        productId = props.productId,
        getInitialStudentsForMoveCopy = props.getInitialStudentsForMoveCopy;

    var _useState = (0, _react.useState)([]),
        _useState2 = _slicedToArray(_useState, 2),
        availableClasses = _useState2[0],
        setAvailableClasses = _useState2[1];

    (0, _react.useEffect)(function () {
        var isCancelled = false;
        var fetchClasses = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var newStudentsData;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return getInitialStudentsForMoveCopy({
                                    productId: productId
                                });

                            case 2:
                                newStudentsData = _context.sent;


                                /*
                                    This list is independent of what class the teacher is in,
                                    it's dependent on the availableClasses which is class-agnostic
                                 */
                                if (!isCancelled && newStudentsData) {
                                    setAvailableClasses(newStudentsData.classrooms);
                                }

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function fetchClasses() {
                return _ref.apply(this, arguments);
            };
        }();

        fetchClasses();

        return function () {
            isCancelled = true;
        };
    }, []);

    var _useState3 = (0, _react.useState)(undefined),
        _useState4 = _slicedToArray(_useState3, 2),
        enhancedStudentsList = _useState4[0],
        setEnhancedStudentsList = _useState4[1];

    var allStudentsLine = {
        lastName: '',
        firstName: '',
        userProfileId: 0,
        groupId: 0
    };
    if (studentsList.length > 1 && !enhancedStudentsList) {
        studentsList.unshift(allStudentsLine);
        setEnhancedStudentsList(true);
    }

    // Number of students, count lines but ignore the "All students:" line
    var numberOfStudents = studentsList && studentsList.length > 1 && studentsList[0].userProfileId === 0 ? studentsList.length - 1 : studentsList.length;
    // Cell elements (header/body)
    var listOfHeaders = [{
        key: (0, _utils.stripCharacters)(i18n._( /*i18n*/{
            id: 'Header - Students'
        })),
        content: _react2.default.createElement(_react3.Trans, { id: 'Header - Students with value - {numberOfStudents}', defaults: 'value {numberOfStudents}',
            values: {
                numberOfStudents: numberOfStudents
            }
        })
    }, {
        key: (0, _utils.stripCharacters)(i18n._( /*i18n*/{
            id: 'Header - Actions'
        })),
        colSpan: 3,
        content: _react2.default.createElement(_react3.Trans, { id: 'Header - Actions' })
    }];

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isSelectAllInUse = _useState6[0],
        setIsSelectAllInUse = _useState6[1];

    var listOfRows = studentsList && studentsList.length > 0 ? studentsList.map(function (row, index) {
        return _react2.default.createElement(_moveListBody2.default, {
            key: 'move-students-' + row.userProfileId,
            userId: row.userProfileId,
            userGroupId: row.groupId,
            index: index,
            fullName: row.lastName + ', ' + row.firstName,
            availableClasses: availableClasses,
            updateMoveStudentList: updateMoveStudentList,
            isSelectAllInUse: isSelectAllInUse,
            setIsSelectAllInUse: setIsSelectAllInUse
        });
    }) : [_react2.default.createElement(_emptyDataMessage2.default, {
        key: 'emptyRow',
        colSpan: 4
    })];

    return _react2.default.createElement(_table2.default, {
        listOfHeaders: listOfHeaders,
        listOfRows: listOfRows
    });
}

MoveList.propTypes = {
    studentsList: _propTypes2.default.arrayOf(_propTypes2.default.object),
    updateMoveStudentList: _propTypes2.default.func,
    productId: _propTypes2.default.number,
    getInitialStudentsForMoveCopy: _propTypes2.default.func
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from MessageModalCombinedReducers.
 */
function mapStateToProps(state) {
    var productId = state.consoleReducer.productId;


    return {
        productId: productId
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getInitialStudentsForMoveCopy: _consoleActions2.default.getInitialStudentsForMoveCopy
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MoveList);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "WCb1":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/d3037cbb691672a1fe058ba507d7ddf9.svg";

/***/ }),

/***/ "WFW/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _linguiCdn = __webpack_require__("siuH");

var _checkbox = __webpack_require__("0yfC");

var _checkbox2 = _interopRequireDefault(_checkbox);

var _studentPassword = __webpack_require__("l3NX");

var _studentPassword2 = _interopRequireDefault(_studentPassword);

var _selectLabel = __webpack_require__("4H+z");

var _selectLabel2 = _interopRequireDefault(_selectLabel);

var _utils = __webpack_require__("6QRH");

var _enums = __webpack_require__("royT");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Helpers
function MainListBody(props) {
    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var userId = props.userId,
        firstName = props.firstName,
        lastName = props.lastName,
        index = props.index,
        username = props.username,
        password = props.password,
        changePassword = props.changePassword,
        shownPassword = props.shownPassword,
        setShownPassword = props.setShownPassword,
        filteredClassGroups = props.filteredClassGroups,
        groupId = props.groupId,
        courseName = props.courseName,
        upfCourseName = props.upfCourseName,
        conquestCourseName = props.conquestCourseName,
        isSelected = props.isSelected,
        selectHandler = props.selectHandler,
        productId = props.productId,
        checkboxHandler = props.checkboxHandler,
        showNewCourses = props.showNewCourses,
        oneRosterUserId = props.oneRosterUserId;


    var isMathletics = productId === _enums.PRODUCT_IDS.Mathletics.toString();
    var studentKey = 'studentRow' + firstName + lastName;
    var id = (0, _utils.stripCharacters)('' + studentKey + index);
    var changeGroupHandler = function changeGroupHandler(e) {
        var newGroupId = e.target.value;
        selectHandler({ newGroupId: newGroupId, userIds: [userId] });
    };
    var groupComponent = function groupComponent(user, group) {
        return _react2.default.createElement(_selectLabel2.default, {
            id: 'groups-' + user,
            srLabel: i18n._( /*i18n*/{
                id: 'Header - Group'
            }) + '-' + user,
            listOfOptions: filteredClassGroups,
            value: group,
            propertyName: 'groupId',
            isSelectDisabled: filteredClassGroups.length <= 1,
            selectHandler: changeGroupHandler
        });
    };

    var localCheckboxHandler = (0, _react.useCallback)(function () {
        checkboxHandler(userId);
    }, [userId]);
    var name = lastName + ', ' + firstName;

    return _react2.default.createElement(
        'tr',
        { className: 'table__row ' + (isSelected ? 'table__row--selected' : '') },
        _react2.default.createElement(
            'td',
            { className: 'table__cell table__cell--checkbox' },
            _react2.default.createElement(_checkbox2.default, {
                uid: id,
                isChecked: isSelected,
                callback: localCheckboxHandler,
                labelText: username + '-' + index,
                inputType: _checkbox.LABEL_STYLES.hidden
            })
        ),
        _react2.default.createElement(
            'td',
            { className: 'table__cell table__cell--name' },
            _react2.default.createElement(
                'span',
                { title: name, className: 'text-ellipsis' },
                name
            )
        ),
        _react2.default.createElement(
            'td',
            { className: 'table__cell table__cell--detail' },
            username
        ),
        _react2.default.createElement(
            'td',
            { className: 'table__cell table__cell--password' },
            _react2.default.createElement(_studentPassword2.default, {
                id: id,
                userId: userId,
                password: password,
                changePassword: changePassword,
                shownPassword: shownPassword,
                setShownPassword: setShownPassword,
                oneRosterUserId: oneRosterUserId
            })
        ),
        _react2.default.createElement(
            'td',
            { className: 'table__cell' },
            groupComponent(userId, groupId)
        ),
        _react2.default.createElement(
            'td',
            {
                className: 'table__cell table__cell--course ' + (isMathletics && courseName ? 'table__cell--upfcourse' : '')
            },
            _react2.default.createElement(
                'span',
                {
                    title: courseName,
                    className: '' + (courseName ? 'text-ellipsis' : 'table__cell--no-course-assigned') },
                _react2.default.createElement(_react3.Trans, { id: 'Course assigned - Activities' }),
                courseName
            ),
            showNewCourses && _react2.default.createElement(
                'span',
                {
                    title: conquestCourseName,
                    className: '' + (conquestCourseName ? 'text-ellipsis' : 'table__cell--no-course-assigned') },
                _react2.default.createElement(_react3.Trans, { id: 'Course assigned - New Courses' }),
                conquestCourseName || i18n._( /*i18n*/{
                    id: 'No course assigned'
                })
            ),
            isMathletics && _react2.default.createElement(
                'span',
                {
                    title: upfCourseName,
                    className: '' + (upfCourseName ? 'text-ellipsis' : 'table__cell--no-course-assigned') },
                _react2.default.createElement(_react3.Trans, { id: 'Course assigned - Skill Quests' }),
                upfCourseName || i18n._( /*i18n*/{
                    id: 'Group Modal - label - Select no courses'
                })
            )
        )
    );
}

// Components


MainListBody.propTypes = {
    userId: _propTypes2.default.number,
    firstName: _propTypes2.default.string,
    lastName: _propTypes2.default.string,
    index: _propTypes2.default.number,
    username: _propTypes2.default.string,
    password: _propTypes2.default.string,
    changePassword: _propTypes2.default.func.isRequired,
    shownPassword: _propTypes2.default.string,
    setShownPassword: _propTypes2.default.func,
    filteredClassGroups: _propTypes2.default.array,
    groupId: _propTypes2.default.number,
    courseName: _propTypes2.default.string,
    upfCourseName: _propTypes2.default.string,
    conquestCourseName: _propTypes2.default.string,
    isSelected: _propTypes2.default.bool,
    selectHandler: _propTypes2.default.func,
    productId: _propTypes2.default.string,
    checkboxHandler: _propTypes2.default.func,
    showNewCourses: _propTypes2.default.bool,
    oneRosterUserId: _propTypes2.default.string
};

exports.default = MainListBody;

/***/ }),

/***/ "WNej":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
var ___CSS_LOADER_GET_URL_IMPORT___ = __webpack_require__("LsW0");
var ___CSS_LOADER_URL_IMPORT_0___ = __webpack_require__("1uEC");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.i, ".checkbox {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 0;\n  height: 0;\n  opacity: 0; }\n  .checkbox__container {\n    color: #000; }\n  .checkbox__container--groups {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      width: 100%;\n      height: 48px;\n      border-bottom: 1px solid #cbd3dc;\n      background: #fff;\n      position: relative;\n      line-height: 2.5em;\n      font-size: 12px;\n      font-size: 0.75rem;\n      color: #fff; }\n  .checkbox__container--groups > .checkbox + .checkbox__label {\n        font-family: Poppins, sans-serif;\n        font-weight: 500 !important; }\n  .checkbox__container--groups > .checkbox + .checkbox__label::before {\n        border-color: transparent; }\n  .checkbox__container--groups > .checkbox:not(:disabled):hover + .checkbox__label::before,\n      .checkbox__container--groups > .checkbox:not(:disabled):focus + .checkbox__label::before {\n        border-color: transparent;\n        background-color: #00a5ff; }\n  .checkbox__container--groups > .checkbox:not(:disabled):checked + .checkbox__label::before {\n        background-color: #00abe8;\n        border-radius: 5.125px; }\n  .checkbox__container--groups > .checkbox:not(:disabled):checked:hover + .checkbox__label::before,\n      .checkbox__container--groups > .checkbox:not(:disabled):checked:focus + .checkbox__label::before {\n        border-color: transparent;\n        background-color: #00a5ff; }\n  .checkbox__container--groups > .checkbox:not(:disabled):active + .checkbox__label::before {\n        background-color: #00abe8; }\n  .checkbox__container--groups-all {\n      color: #001937; }\n  .checkbox__inner-label {\n    color: #001937;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 28px; }\n  .checkbox__inner-label--edit-group {\n      font-size: 14px !important;\n      font-weight: 400 !important; }\n  .checkbox__inner-label--edit-group {\n    color: #001937;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 28px; }\n  .checkbox__label {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 16px;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    line-height: 1.6em; }\n  .checkbox + .checkbox__label--hidden::before {\n      margin-right: 0 !important; }\n  .checkbox__label--hidden .checkbox__inner-label {\n      position: absolute;\n      margin: -1px;\n      border: 0;\n      width: 1px;\n      height: 1px;\n      overflow: hidden;\n      clip: rect(0 0 0 0);\n      -webkit-clip-path: polygon(0 0, 0 0, 0 0);\n              clip-path: polygon(0 0, 0 0, 0 0);\n      padding: 0;\n      white-space: nowrap; }\n  .checkbox + .checkbox__label::before {\n    display: inline-block;\n    border: 1px solid #c2c2c2;\n    border-radius: 2px;\n    width: calc(1.6em - 2px);\n    height: calc(1.6em - 2px);\n    background-color: #fff;\n    vertical-align: bottom;\n    content: '';\n    -webkit-transition: opacity 0.2s ease-in-out;\n    transition: opacity 0.2s ease-in-out; }\n  .checkbox:disabled + .checkbox__label::before {\n    opacity: 0.5; }\n  .checkbox:not(:disabled):hover + .checkbox__label::before,\n  .checkbox:not(:disabled):focus + .checkbox__label::before {\n    border-color: #000; }\n  .checkbox:not(:disabled):checked + .checkbox__label::before {\n    background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat 50% 50% #00a5ff;\n    background-size: 90% 90%;\n    border: 0.854px solid #00abe8;\n    width: 18px;\n    height: 18px; }\n  .checkbox:not(:disabled):checked:hover + .checkbox__label::before,\n  .checkbox:not(:disabled):checked:focus + .checkbox__label::before {\n    border-color: #000; }\n  .checkbox:not(:disabled):active + .checkbox__label::before {\n    background-color: #374e60; }\n  .margin-top {\n  margin-top: 8px; }\n", ""]);
// Exports
exports.locals = {
	"checkbox": "checkbox",
	"checkbox__container": "checkbox__container",
	"checkbox__container--groups": "checkbox__container--groups",
	"checkbox__label": "checkbox__label",
	"checkbox__container--groups-all": "checkbox__container--groups-all",
	"checkbox__inner-label": "checkbox__inner-label",
	"checkbox__inner-label--edit-group": "checkbox__inner-label--edit-group",
	"checkbox__label--hidden": "checkbox__label--hidden",
	"margin-top": "margin-top"
};
module.exports = exports;


/***/ }),

/***/ "YdaO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Components


// Helpers


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _linguiCdn = __webpack_require__("siuH");

var _table = __webpack_require__("ZaAk");

var _table2 = _interopRequireDefault(_table);

var _mainListBody = __webpack_require__("WFW/");

var _mainListBody2 = _interopRequireDefault(_mainListBody);

var _checkbox = __webpack_require__("0yfC");

var _checkbox2 = _interopRequireDefault(_checkbox);

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _emptyDataMessage = __webpack_require__("JZJN");

var _emptyDataMessage2 = _interopRequireDefault(_emptyDataMessage);

var _studentChangeGroup = __webpack_require__("nXVl");

var _studentChangeGroup2 = _interopRequireDefault(_studentChangeGroup);

var _utils = __webpack_require__("6QRH");

var _enums = __webpack_require__("royT");

var _selectLabel = __webpack_require__("4H+z");

var _selectLabel2 = _interopRequireDefault(_selectLabel);

var _tooltip = __webpack_require__("I2I3");

var _tooltip2 = _interopRequireDefault(_tooltip);

var _badge = __webpack_require__("3C4M");

var _badge2 = _interopRequireDefault(_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var initialLoad = true;

function MainList(props) {
    var _this = this;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var hasContentLoaded = props.hasContentLoaded,
        classesLength = props.classesLength,
        classGroupStudents = props.classGroupStudents,
        classGroups = props.classGroups,
        changePassword = props.changePassword,
        shownPassword = props.shownPassword,
        setShownPassword = props.setShownPassword,
        updateCurrentClassId = props.updateCurrentClassId,
        selectGroupHandler = props.selectGroupHandler,
        currentClassId = props.currentClassId,
        productId = props.productId,
        showNewCourses = props.showNewCourses,
        mainCheckAllIsSelected = props.mainCheckAllIsSelected,
        mainSelectedStudentIds = props.mainSelectedStudentIds,
        selectCheckboxStudent = props.selectCheckboxStudent,
        selectAllCheckboxStudent = props.selectAllCheckboxStudent;

    // Filtered states

    var _useState = (0, _react.useState)([]),
        _useState2 = _slicedToArray(_useState, 2),
        filteredClassGroups = _useState2[0],
        setFilteredClassGroups = _useState2[1];

    var _useState3 = (0, _react.useState)([]),
        _useState4 = _slicedToArray(_useState3, 2),
        filteredStudents = _useState4[0],
        setFilteredStudents = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        hasFiltered = _useState6[0],
        setHasFiltered = _useState6[1];

    var _useState7 = (0, _react.useState)(true),
        _useState8 = _slicedToArray(_useState7, 2),
        isNameFilterAscending = _useState8[0],
        setIsNameFilterAscending = _useState8[1];

    var _useState9 = (0, _react.useState)(true),
        _useState10 = _slicedToArray(_useState9, 2),
        isGroupFilterAscending = _useState10[0],
        setIsGroupFilterAscending = _useState10[1];

    var _useState11 = (0, _react.useState)(true),
        _useState12 = _slicedToArray(_useState11, 2),
        isSortedByName = _useState12[0],
        setIsSortedByName = _useState12[1];

    (0, _react.useEffect)(function () {
        var filtered = classGroupStudents.filter(function (student) {
            return student.isVisible;
        });
        setFilteredStudents(filtered);
    }, [classGroupStudents]);

    (0, _react.useEffect)(function () {
        // Variables
        var localFilteredClassGroups = classGroups.filter(function (group) {
            // Remove the instance of the "All groups" from the list of values in the student row
            if (group.groupId > _enums.ALL_GROUP_ID) {
                return group;
            }
            return false;
        });
        setFilteredClassGroups(localFilteredClassGroups);
    }, [classGroups]);

    var _useState13 = (0, _react.useState)(false),
        _useState14 = _slicedToArray(_useState13, 2),
        isChangeGroupModalVisible = _useState14[0],
        setIsChangeGroupModalVisible = _useState14[1];

    var _useState15 = (0, _react.useState)(false),
        _useState16 = _slicedToArray(_useState15, 2),
        isChangeGroupDisabled = _useState16[0],
        setIsChangeGroupDisabled = _useState16[1];

    var _useState17 = (0, _react.useState)(null),
        _useState18 = _slicedToArray(_useState17, 2),
        changeGroupErrorMessage = _useState18[0],
        setChangeGroupErrorMessage = _useState18[1];

    var _useState19 = (0, _react.useState)(null),
        _useState20 = _slicedToArray(_useState19, 2),
        changeGroupData = _useState20[0],
        setChangeGroupData = _useState20[1];
    // state to hide the modal


    var _useState21 = (0, _react.useState)(false),
        _useState22 = _slicedToArray(_useState21, 2),
        isModalVisible = _useState22[0],
        setIsModalVisible = _useState22[1];

    (0, _react.useEffect)(function () {
        setChangeGroupErrorMessage('');
    }, [isChangeGroupModalVisible]);

    var applyChangeGroupHandler = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var newGroupId, userIds, classId, cleanedUserIds, selectGroupResponse;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(changeGroupData !== null && isChangeGroupDisabled === false)) {
                                _context.next = 19;
                                break;
                            }

                            newGroupId = changeGroupData.newGroupId, userIds = changeGroupData.userIds, classId = changeGroupData.classId;
                            /*
                                In order to prevent multiple buttons to be clicked,
                                set the change group to be disabled, until it's completed
                             */

                            setIsChangeGroupDisabled(true);
                            cleanedUserIds = userIds.map(function (userId) {
                                return parseInt(userId, 10);
                            });
                            _context.next = 6;
                            return selectGroupHandler({
                                newGroupId: parseInt(newGroupId, 10),
                                userIds: cleanedUserIds,
                                classId: classId
                            });

                        case 6:
                            selectGroupResponse = _context.sent;

                            if (!(selectGroupResponse === true)) {
                                _context.next = 14;
                                break;
                            }

                            _context.next = 10;
                            return updateCurrentClassId({ productId: productId, classId: currentClassId });

                        case 10:
                            // Reset the modal + data
                            setIsChangeGroupModalVisible(false);
                            setChangeGroupData(null);
                            _context.next = 15;
                            break;

                        case 14:
                            setChangeGroupErrorMessage(i18n._( /*i18n*/{
                                id: 'Error Message - Unable to proceed'
                            }));

                        case 15:

                            // Resetting the select on its initial value. BA 2020-05-04
                            // TODO: passing through a ref?
                            // eslint-disable-next-line no-undef
                            document.getElementById('groupBulk').value = 0;
                            setIsChangeGroupDisabled(false);
                            _context.next = 19;
                            break;

                        case 19:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function applyChangeGroupHandler() {
            return _ref.apply(this, arguments);
        };
    }();

    var changeGroup = function changeGroup() {
        if (isModalVisible) {
            // To show modal for the first time only
            setIsChangeGroupModalVisible(true);
            // To hide modal after the first time
            setIsModalVisible(false);
        } else {
            // To apply changes in the group for the student without displaying modal
            applyChangeGroupHandler();
            // To retain the students list in desc order when the group is changed
            if (isSortedByName) {
                if (isNameFilterAscending === false) {
                    var filterStudentsByLastName = filteredStudents.sort(function () {
                        for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {
                            arg[_key] = arguments[_key];
                        }

                        return _utils.compareByLastName.apply(undefined, arg.concat([true]));
                    });
                    setFilteredStudents(filterStudentsByLastName);
                }
            } else {
                var filterStudentsByGroup = filteredStudents.sort((0, _utils.compareValues)('groupName', !isGroupFilterAscending));
                setFilteredStudents(filterStudentsByGroup);
            }
        }
    };

    (0, _react.useEffect)(function () {
        changeGroup();
    }, [changeGroupData]);

    var showChangeGroupBulkModal = function showChangeGroupBulkModal(_ref2) {
        var newGroupId = _ref2.newGroupId,
            userIds = _ref2.userIds;

        setChangeGroupData({ newGroupId: newGroupId, userIds: userIds, classId: currentClassId });
        if (initialLoad) {
            setIsModalVisible(true);
            initialLoad = false;
        }
        changeGroup();
    };

    var closeChangeGroupModal = function closeChangeGroupModal() {
        setChangeGroupData(null);
        setIsChangeGroupModalVisible(false);
    };

    // Sorting Handlers
    var sortingNameCallback = function sortingNameCallback() {
        var filterStudentsByLastName = filteredStudents.sort(function () {
            for (var _len2 = arguments.length, arg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                arg[_key2] = arguments[_key2];
            }

            return _utils.compareByLastName.apply(undefined, arg.concat([isNameFilterAscending]));
        });
        setFilteredStudents(filterStudentsByLastName);
        setHasFiltered(function (prevState) {
            return !prevState;
        });
        setIsNameFilterAscending(function (prevState) {
            return !prevState;
        });
        setIsSortedByName(true);
    };

    var sortingGroupCallback = function sortingGroupCallback() {
        var filterStudentsByGroup = filteredStudents.sort((0, _utils.compareValues)('groupName', isGroupFilterAscending));
        setFilteredStudents(filterStudentsByGroup);
        setHasFiltered(function (prevState) {
            return !prevState;
        });
        setIsGroupFilterAscending(function (prevState) {
            return !prevState;
        });
        setIsSortedByName(false);
    };

    var changeGroupBulkHandler = function changeGroupBulkHandler(e) {
        var newGroupId = e.target.value;
        if (newGroupId !== '0') {
            showChangeGroupBulkModal({ newGroupId: newGroupId, userIds: mainSelectedStudentIds });
        }
    };

    // Cell elements (header/body)
    var listOfHeaders = [{
        key: (0, _utils.stripCharacters)(i18n._( /*i18n*/{
            id: 'Header - Select All'
        })),
        importedClasses: 'table__cell--checkbox',
        content: _react2.default.createElement(_checkbox2.default, {
            uid: 'consoleSelectAll',
            labelText: _react2.default.createElement(_react3.Trans, { id: 'Header - Select All' }),
            inputType: _checkbox.LABEL_STYLES.hidden,
            isChecked: mainCheckAllIsSelected,
            callback: selectAllCheckboxStudent
        })
    }, {
        key: (0, _utils.stripCharacters)(i18n._( /*i18n*/{
            id: 'Header - Students'
        })),
        importedClasses: 'table__cell--header-name',
        ariaProps: {
            'aria-sort': isNameFilterAscending ? 'ascending' : 'descending'
        },
        content: _react2.default.createElement(_button2.default, {
            buttonStyle: _button.BUTTON_STYLES.iconText,
            importedClasses: 'button--sort sorting-cell' + (isSortedByName ? ' button--sort-active' : ''),
            callback: sortingNameCallback,
            visibleText: _react2.default.createElement(_react3.Trans, {
                id: 'Header - Students - Plural',
                defaults: '{0, plural, one {Student (#)} other {Students (#)}}',
                values: {
                    0: mainSelectedStudentIds.length
                }
            }),
            iconName: isNameFilterAscending ? 'sortup' : 'sortdown'
        })
    }, {
        key: (0, _utils.stripCharacters)(i18n._( /*i18n*/{
            id: 'Header - Username'
        })),
        importedClasses: 'table__cell--header-detail',
        content: _react2.default.createElement(_react3.Trans, { id: 'Header - Username' })
    }, {
        key: (0, _utils.stripCharacters)(i18n._( /*i18n*/{
            id: 'Info - Get more info'
        })),
        importedClasses: 'table__cell--header-password',
        content: _react2.default.createElement(_react3.Trans, { id: 'Header - Password' })
    }, {
        key: (0, _utils.stripCharacters)(i18n._( /*i18n*/{
            id: 'Header - Group'
        })),
        importedClasses: 'table__cell--header-group',
        ariaProps: {
            'aria-sort': isGroupFilterAscending ? 'ascending' : 'descending'
        },
        content: _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(_button2.default, {
                buttonStyle: _button.BUTTON_STYLES.iconText,
                importedClasses: 'button--sort sorting-cell' + (isSortedByName ? '' : ' button--sort-active'),
                callback: sortingGroupCallback,
                visibleText: _react2.default.createElement(_react3.Trans, { id: 'Header - Group' }),
                iconName: isGroupFilterAscending ? 'sortdown' : 'sortup'
            }),
            _react2.default.createElement(
                'div',
                { className: 'table__buttons-container' },
                _react2.default.createElement(_badge2.default, {
                    badgeId: 'tableGroupHeader',
                    assetTitle: '',
                    visibleText: i18n._( /*i18n*/{
                        id: 'Notification - New'
                    }) }),
                _react2.default.createElement(_selectLabel2.default, {
                    id: 'groupBulk',
                    srLabel: i18n._( /*i18n*/{
                        id: 'Groups - Change group for selected students'
                    }),
                    selectHandler: changeGroupBulkHandler,
                    propertyName: 'groupId',
                    visibleProperty: 'name',
                    listOfOptions: [{
                        groupId: 0,
                        name: i18n._( /*i18n*/{
                            id: 'Groups - Move selected'
                        }) + ' (' + mainSelectedStudentIds.length + ')'
                    }].concat(_toConsumableArray(filteredClassGroups)),
                    isSelectDisabled: mainSelectedStudentIds.length === 0,
                    importedClasses: 'select--header'
                }),
                _react2.default.createElement(_tooltip2.default, { visibleTexts: [i18n._( /*i18n*/{
                        id: 'Tooltips - main list - groups'
                    })] })
            )
        )
    }, {
        key: (0, _utils.stripCharacters)(i18n._( /*i18n*/{
            id: 'Header - Course'
        })),
        importedClasses: 'table__cell--header-course',
        content: _react2.default.createElement(_react3.Trans, { id: 'Header - Course' })
    }];

    var listOfRows = filteredStudents && filteredStudents.length > 0 ? filteredStudents.map(function (row, index) {
        return _react2.default.createElement(_mainListBody2.default, {
            key: hasFiltered + '-' + row.userProfileId,
            userId: row.userProfileId,
            index: index,
            courseName: row.courseName,
            upfCourseName: row.upfCourseName,
            conquestCourseName: row.conquestCourseName,
            showNewCourses: showNewCourses,
            username: row.username,
            password: row.password,
            productId: productId,
            changePassword: changePassword,
            shownPassword: shownPassword,
            setShownPassword: setShownPassword,
            filteredClassGroups: filteredClassGroups,
            groupId: row.groupId,
            firstName: row.firstName,
            lastName: row.lastName,
            oneRosterUserId: row.oneRosterUserId,
            isSelected: mainSelectedStudentIds && mainSelectedStudentIds.includes(row.userProfileId),
            selectHandler: showChangeGroupBulkModal,
            checkboxHandler: selectCheckboxStudent
        });
    }) : [_react2.default.createElement(_emptyDataMessage2.default, {
        key: 'emptyRow',
        hasContentLoaded: hasContentLoaded,
        classesLength: classesLength,
        colSpan: listOfHeaders.length
    })];

    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_table2.default, {
            listOfHeaders: listOfHeaders,
            listOfRows: listOfRows,
            importedClasses: 'table--sticky'
        }),
        isChangeGroupModalVisible ? _react2.default.createElement(_studentChangeGroup2.default, {
            closeHandler: closeChangeGroupModal,
            applyHandler: applyChangeGroupHandler,
            changeGroupErrorMessage: changeGroupErrorMessage,
            productId: productId
        }) : ''
    );
}

MainList.propTypes = {
    hasContentLoaded: _propTypes2.default.bool,
    classesLength: _propTypes2.default.number,
    classGroupStudents: _propTypes2.default.array.isRequired,
    classGroups: _propTypes2.default.array.isRequired,
    mainCheckAllIsSelected: _propTypes2.default.bool,
    mainSelectedStudentIds: _propTypes2.default.array,
    selectCheckboxStudent: _propTypes2.default.func,
    selectAllCheckboxStudent: _propTypes2.default.func,
    changePassword: _propTypes2.default.func.isRequired,
    shownPassword: _propTypes2.default.string,
    setShownPassword: _propTypes2.default.func,
    // change group props
    updateCurrentClassId: _propTypes2.default.func,
    selectGroupHandler: _propTypes2.default.func,
    currentClassId: _propTypes2.default.number,
    productId: _propTypes2.default.string,
    showNewCourses: _propTypes2.default.bool
};

exports.default = MainList;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "YeqY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Context


// Other


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _linguiCdn = __webpack_require__("siuH");

__webpack_require__("FnXm");

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _tooltip = __webpack_require__("I2I3");

var _tooltip2 = _interopRequireDefault(_tooltip);

var _genericModal = __webpack_require__("51N/");

var _genericModal2 = _interopRequireDefault(_genericModal);

var _consoleModalContext = __webpack_require__("U07W");

var _consoleModalContext2 = _interopRequireDefault(_consoleModalContext);

var _moveStudents = __webpack_require__("EnPQ");

var _moveStudents2 = _interopRequireDefault(_moveStudents);

var _useIsOneRosterActivatedSchool = __webpack_require__("rSj7");

var _useIsOneRosterActivatedSchool2 = _interopRequireDefault(_useIsOneRosterActivatedSchool);

var _signInCardsButton = __webpack_require__("0X7W");

var _signInCardsButton2 = _interopRequireDefault(_signInCardsButton);

var _downloadSigninModal = __webpack_require__("LCX7");

var _downloadSigninModal2 = _interopRequireDefault(_downloadSigninModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer(_ref) {
    var numOfClassStudents = _ref.numOfClassStudents,
        numOfSelectedStudents = _ref.numOfSelectedStudents,
        isMinimised = _ref.isMinimised,
        setIsMinimised = _ref.setIsMinimised,
        classGroupStudents = _ref.classGroupStudents;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        showDownloadSignInModal = _useState2[0],
        setShowDownloadSignInModal = _useState2[1];

    var isOneRosterActivatedSchool = (0, _useIsOneRosterActivatedSchool2.default)();

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var _useContext = (0, _react.useContext)(_consoleModalContext2.default),
        showConsoleModal = _useContext.showConsoleModal,
        setShowConsoleModal = _useContext.setShowConsoleModal,
        setConsoleModalContent = _useContext.setConsoleModalContent;

    /*
    TODO: if the story about the footer has a requirement to close the button wherever a
    click happens in a minimised state, it should expand
     */


    var toggleHandler = function toggleHandler() {
        setIsMinimised(!isMinimised);
    };
    var hasStudents = numOfClassStudents > 0;
    var hasSelectedStudents = numOfSelectedStudents > 0;

    var closeMoveModal = function closeMoveModal() {
        setShowConsoleModal(false);
    };
    var showMoveModal = function showMoveModal() {
        setShowConsoleModal(!showConsoleModal);
        setConsoleModalContent(_react2.default.createElement(
            _genericModal2.default,
            {
                title: _react2.default.createElement(_react3.Trans, { id: 'Move Modal - Title' }),
                closeHandler: closeMoveModal,
                isOneRosterActivatedSchool: isOneRosterActivatedSchool,
                type: _genericModal.MODAL_TYPE.floating },
            _react2.default.createElement(_moveStudents2.default, {
                closeHandler: closeMoveModal
            })
        ));
    };

    // ----- Components -----
    // Component to display the existing numbers as it was expanded
    var minimisedComponent = _react2.default.createElement(_react3.Trans, {
        id: 'Footer - minimised title - {numOfSelectedStudents}',
        defaults: '{numOfSelectedStudents, plural, =0 {No student selected} one {# student selected} other {# students selected}}',
        values: {
            numOfSelectedStudents: numOfSelectedStudents
        }
    });
    // Component for the existing mockup for action items on the page
    var expandedComponent = _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_button2.default, {
            buttonStyle: _button.BUTTON_STYLES.iconText,
            iconName: 'movedouble',
            isBtnDisabled: !hasSelectedStudents,
            visibleText: _react2.default.createElement(_react3.Trans, {
                id: 'Footer - Move class - button title - {numOfSelectedStudents}',
                defaults: '{numOfSelectedStudents, plural, =0 {Move/remove Students} one {Move/remove Students (#)} other {Move/remove Students (#)}}',
                values: {
                    numOfSelectedStudents: numOfSelectedStudents
                }
            }),
            importedClasses: 'footer__button',
            callback: showMoveModal
        }),
        _react2.default.createElement(_signInCardsButton2.default, {
            isOneRosterActivatedSchool: isOneRosterActivatedSchool,
            classGroupStudents: classGroupStudents,
            numOfSelectedStudents: numOfSelectedStudents,
            hasStudents: hasStudents,
            openModal: function openModal() {
                return setShowDownloadSignInModal(true);
            }
        })
    );

    return _react2.default.createElement(
        _react.Fragment,
        null,
        showDownloadSignInModal && _react2.default.createElement(_downloadSigninModal2.default, {
            numOfSelectedStudents: numOfSelectedStudents,
            closeHandler: function closeHandler() {
                return setShowDownloadSignInModal(false);
            }

        }),
        _react2.default.createElement(
            'footer',
            { className: 'footer ' + (isMinimised ? 'footer--minimised' : '') },
            isMinimised ? '' : _react2.default.createElement(_tooltip2.default, { visibleTexts: [i18n._( /*i18n*/{
                    id: 'Tooltips - footer'
                })], position: 'top' }),
            _react2.default.createElement(
                'div',
                { className: 'footer__content' },
                isMinimised ? minimisedComponent : expandedComponent
            ),
            _react2.default.createElement(_button2.default, {
                buttonStyle: _button.BUTTON_STYLES.iconSVG,
                importedClasses: 'footer__button footer__button--toggle',
                iconName: isMinimised ? 'maximise' : 'minimise',
                callback: toggleHandler,
                ariaProps: {
                    'aria-label': isMinimised ? i18n._( /*i18n*/{
                        id: 'Footer - Toggle footer - Open'
                    }) : i18n._( /*i18n*/{
                        id: 'Footer - Toggle footer - Close'
                    })
                }
            })
        )
    );
}

Footer.propTypes = {
    numOfClassStudents: _propTypes2.default.number,
    numOfSelectedStudents: _propTypes2.default.number,
    isMinimised: _propTypes2.default.bool,
    setIsMinimised: _propTypes2.default.func,
    classGroupStudents: _propTypes2.default.array
};

exports.default = Footer;

/***/ }),

/***/ "YkNq":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("hIya");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "Z88W":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".busy-indicator {\n  top: 0;\n  left: 0;\n  position: fixed;\n  z-index: 2000;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, .3); }\n", ""]);
// Exports
exports.locals = {
	"busy-indicator": "busy-indicator"
};
module.exports = exports;


/***/ }),

/***/ "Z9nB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _redux = __webpack_require__("2KeS");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _busyIndicatorActions = __webpack_require__("O161");

__webpack_require__("nhla");

var _busyIndicatorInterceptor = __webpack_require__("3AWt");

var _busyIndicatorInterceptor2 = _interopRequireDefault(_busyIndicatorInterceptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BusyIndicator(props) {
    var callCounter = props.busyIndicatorState.callCounter;

    if (callCounter < 1) {
        return null;
    }

    return _react2.default.createElement('div', { className: 'busy-indicator' });
}

BusyIndicator.propTypes = {
    busyIndicatorState: _propTypes2.default.object
};

function mapStateToProps(state) {
    return {
        busyIndicatorState: state.busyIndicatorReducer
    };
}

function mapDispatchToProps(dispatch) {
    (0, _busyIndicatorInterceptor2.default)({
        dispatch: dispatch,
        showAction: _busyIndicatorActions.show,
        hideAction: _busyIndicatorActions.hide
    });
    return (0, _redux.bindActionCreators)({
        show: _busyIndicatorActions.show,
        hide: _busyIndicatorActions.hide
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BusyIndicator);

/***/ }),

/***/ "ZaAk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Styles


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("qRV2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Table(_ref) {
    var listOfHeaders = _ref.listOfHeaders,
        listOfRows = _ref.listOfRows,
        importedClasses = _ref.importedClasses;

    var tableClasses = 'table ' + importedClasses;
    return _react2.default.createElement(
        'table',
        { className: tableClasses },
        listOfHeaders && _react2.default.createElement(
            'thead',
            { className: 'tableHeader' },
            _react2.default.createElement(
                'tr',
                null,
                listOfHeaders.map(function (header) {
                    var headerClasses = 'table__cell table__cell--header ' + (header.importedClasses || '');
                    return _react2.default.createElement(
                        'th',
                        _extends({}, header.ariaProps, {
                            key: header.key,
                            className: headerClasses,
                            colSpan: header.colSpan }),
                        header.content
                    );
                })
            )
        ),
        listOfRows && listOfRows.length > 0 && _react2.default.createElement(
            'tbody',
            null,
            listOfRows
        )
    );
}

Table.defaultProps = {
    importedClasses: ''
};

Table.propTypes = {
    listOfHeaders: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired,
        importedClasses: _propTypes2.default.string,
        colSpan: _propTypes2.default.number,
        content: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
    })),
    listOfRows: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])),
    importedClasses: _propTypes2.default.string
};

exports.default = Table;

/***/ }),

/***/ "Zo+M":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("o3FG");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "ZowN":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("MrJZ");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "ZuYy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = toastReducer;

var _toastActions = __webpack_require__("sFKd");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
    items: []
};

function toastReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _toastActions.SHOW_TOAST:
            return _extends({}, state, {
                items: [].concat(_toConsumableArray(state.items), [action.payload])
            });

        case _toastActions.HIDE_TOAST:
            return _extends({}, state, {
                items: state.items.filter(function (t) {
                    return t.id !== action.payload.id;
                })
            });

        default:
            return state;
    }
}

/***/ }),

/***/ "aoyJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Components


// Context


// Helpers


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _linguiCdn = __webpack_require__("siuH");

var _checkbox = __webpack_require__("0yfC");

var _checkbox2 = _interopRequireDefault(_checkbox);

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _groupModal = __webpack_require__("+x4p");

var _groupModal2 = _interopRequireDefault(_groupModal);

var _courseInformationContext = __webpack_require__("EJJB");

var _courseInformationContext2 = _interopRequireDefault(_courseInformationContext);

var _utils = __webpack_require__("6QRH");

var _enums = __webpack_require__("royT");

var _imageAsset = __webpack_require__("hB8d");

var _imageAsset2 = _interopRequireDefault(_imageAsset);

var _editGroupModal = __webpack_require__("3IvT");

var _editGroupModal2 = _interopRequireDefault(_editGroupModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function GroupSelectionItem(props) {
    var _this = this;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    // Props


    var productId = props.productId,
        classGroupItem = props.classGroupItem,
        showModal = props.showModal,
        index = props.index,
        groupModalVisibility = props.groupModalVisibility,
        groupModalId = props.groupModalId,
        editGroupHandler = props.editGroupHandler,
        deleteGroupHandler = props.deleteGroupHandler,
        updateGroupCheckbox = props.updateGroupCheckbox,
        setShownPassword = props.setShownPassword,
        showNewCourses = props.showNewCourses,
        newCoursesAvailabilityCriteria = props.newCoursesAvailabilityCriteria;


    var labelCheckboxRef = (0, _react.useRef)(null);

    // Variables
    var validUid = (0, _utils.stripCharacters)(classGroupItem.name, '*').replace(/\s/gi, '-');
    var currentGroupId = classGroupItem.groupId;
    var isShowAllGroup = currentGroupId === 0;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        hasEdited = _useState2[0],
        setHasEdited = _useState2[1];

    // Context Variables


    var _useContext = (0, _react.useContext)(_courseInformationContext2.default),
        setCountryHandler = _useContext.setCountryHandler,
        countrySelectValue = _useContext.countrySelectValue,
        countrySelectOptions = _useContext.countrySelectOptions,
        setYearHandler = _useContext.setYearHandler,
        yearSelectValue = _useContext.yearSelectValue,
        yearSelectOptions = _useContext.yearSelectOptions,
        setCourseHandler = _useContext.setCourseHandler,
        courseSelectValue = _useContext.courseSelectValue,
        courseSelectOptions = _useContext.courseSelectOptions,
        setUPFCourseHandler = _useContext.setUPFCourseHandler,
        upfCourseSelectValue = _useContext.upfCourseSelectValue,
        upfCourseSelectOptions = _useContext.upfCourseSelectOptions,
        setNewCourseHandler = _useContext.setNewCourseHandler,
        newCourseSelectValue = _useContext.newCourseSelectValue,
        newCourseSelectOptions = _useContext.newCourseSelectOptions;

    // Handlers


    var showCurrentEditGroupModal = function showCurrentEditGroupModal() {
        showModal({
            modalId: classGroupItem.groupId,
            setEditMode: true
        });

        // In case if it's been opened, reset the hasEdited field
        if (hasEdited === true) {
            setHasEdited(false);
        }
    };
    var groupFilterHandler = function groupFilterHandler(e) {
        var isSelected = e.target.checked;
        var checkboxDataset = e.target.dataset;
        setShownPassword('');
        updateGroupCheckbox({
            value: checkboxDataset.value,
            isSelected: isSelected
        });
    };
    var closeHandler = function closeHandler() {
        (0, _utils.resetGroupSectionScroll)();
        setCountryHandler('');
        setYearHandler('');
        showModal({ modalId: _enums.DEFAULT_GROUP_MODAL_ID, isClosing: true });
    };
    var localEditGroupHandler = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
            var name = _ref2.name;
            var newEditGroupName, groupName;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            newEditGroupName = name;
                            groupName = classGroupItem.name;

                            if (classGroupItem.isDefault) {
                                groupName = (0, _utils.getDefaultGroupName)(groupName);
                            }
                            /**
                             * Check if the existing name and the new name are the same,
                             * and if they are set the newGroupName to be undefined
                             */
                            if (name === groupName) {
                                newEditGroupName = undefined;
                            }

                            _context.prev = 4;
                            _context.next = 7;
                            return editGroupHandler({
                                name: newEditGroupName,
                                groupId: currentGroupId
                            });

                        case 7:
                            return _context.abrupt('return', true);

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](4);
                            return _context.abrupt('return', false);

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[4, 10]]);
        }));

        return function localEditGroupHandler(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    var localDeleteHandler = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return deleteGroupHandler({
                                groupId: currentGroupId
                            });

                        case 3:

                            closeHandler();
                            return _context2.abrupt('return', true);

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2['catch'](0);
                            return _context2.abrupt('return', false);

                        case 10:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this, [[0, 7]]);
        }));

        return function localDeleteHandler() {
            return _ref3.apply(this, arguments);
        };
    }();
    var handleChange = function handleChange(value, isCourse, isUPFCourse) {
        if (isCourse && value !== '') {
            setHasEdited(true);
        } else if (!isCourse && value === '') {
            setHasEdited(false);
        } else if (isUPFCourse && value !== '') {
            setHasEdited(true);
        } else {
            setHasEdited(false);
        }
    };
    var localSetCountryHandler = function localSetCountryHandler(e) {
        var countryValue = e.target.value;
        handleChange(countryValue);
        setCountryHandler(countryValue);
    };
    var localSetYearHandler = function localSetYearHandler(e) {
        var yearValue = e.target.value;
        handleChange(yearValue);
        setYearHandler(yearValue);
    };
    var localSetCourseHandler = function localSetCourseHandler(e) {
        var courseValue = e.target.value;
        var isCourse = true;
        handleChange(courseValue, isCourse);
        setCourseHandler(courseValue);
    };
    var localSetUPFCourseHandler = function localSetUPFCourseHandler(e) {
        var upfCourseValue = e.target.value;
        var isUPFCourse = true;
        handleChange(upfCourseValue, isUPFCourse);
        setUPFCourseHandler(upfCourseValue);
    };

    var localSetNewCourseHandler = function localSetNewCourseHandler(e) {
        var newCourseValue = e.target.value;
        setHasEdited(true);
        setNewCourseHandler(newCourseValue);
    };

    var parentClasses = 'checkbox__container--groups' + (isShowAllGroup ? ' checkbox__container--groups-all' : '');

    // Text truncation methods and variables
    var checkboxTitle = classGroupItem.name;
    var classGroupId = classGroupItem.groupId;

    var initialName = classGroupItem.name;
    var labelText = checkboxTitle;

    if (classGroupItem.isDefault) {
        // remove the asterisk from the default group if it's the default
        initialName = (0, _utils.getDefaultGroupName)(initialName);
    }

    if (isShowAllGroup) {
        labelText = _react2.default.createElement(_react3.Trans, { id: 'Groups - Show All - label' });
    } else if (labelText.length > _enums.MAX_GROUP_NAME_DISPLAY) {
        labelText = labelText.substring(0, _enums.MAX_GROUP_NAME_DISPLAY) + '...';
    }

    // Course Specific props to handle the data/display
    var courseSpecificProps = {
        // Countries
        setCountryHandler: localSetCountryHandler,
        countrySelectValue: countrySelectValue,
        countrySelectOptions: countrySelectOptions,
        // Years/Grades
        setYearHandler: localSetYearHandler,
        yearSelectValue: yearSelectValue,
        yearSelectOptions: yearSelectOptions,
        // Courses
        setCourseHandler: localSetCourseHandler,
        courseSelectValue: courseSelectValue,
        courseSelectOptions: courseSelectOptions,
        // - UPF Course
        setUPFCourseHandler: localSetUPFCourseHandler,
        upfCourseSelectValue: upfCourseSelectValue,
        upfCourseSelectOptions: upfCourseSelectOptions,
        // New Courses
        setNewCourseHandler: localSetNewCourseHandler,
        newCourseSelectValue: newCourseSelectValue,
        newCourseSelectOptions: newCourseSelectOptions
    };

    return _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        !groupModalVisibility && _react2.default.createElement(
            _checkbox2.default,
            {
                uid: validUid + '-groupFilter-' + index,
                inputType: _checkbox.LABEL_STYLES.visible,
                labelForwardRef: labelCheckboxRef,
                labelText: labelText,
                callback: groupFilterHandler,
                value: classGroupItem.groupId,
                isChecked: classGroupItem.isSelected,
                labelProps: labelText !== checkboxTitle ? { title: checkboxTitle } : false,
                numberOfStudents: classGroupItem.studentCount,
                isGroupCheckbox: true,
                parentClasses: parentClasses },
            !isShowAllGroup ? _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'groups__group-edit-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'groups__group-student-count-container' },
                        _react2.default.createElement(_imageAsset2.default, {
                            type: 'personIcon',
                            parentTitle: 'person-icon',
                            parentClass: 'groups__group-student-count'
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'groups__group-count' },
                            classGroupItem.studentCount
                        )
                    ),
                    _react2.default.createElement(_button2.default, {
                        buttonStyle: _button.BUTTON_STYLES.iconText,
                        iconName: 'editIcon',
                        imageClassName: 'editIcon-image',
                        visibleText: 'Edit',
                        ariaProps: { 'aria-label': i18n._( /*i18n*/{
                                id: 'Groups - Edit group'
                            }) },
                        importedClasses: 'button--edit-group',
                        callback: showCurrentEditGroupModal
                    })
                )
            ) : ''
        ),
        groupModalId === currentGroupId && groupModalVisibility ? _react2.default.createElement(
            _editGroupModal2.default,
            {
                title: _react2.default.createElement(_react3.Trans, { id: 'Group Modal - edit - title' }),
                closeHandler: closeHandler,
                parentClasses: 'modal--edit-groups' },
            _react2.default.createElement(_groupModal2.default, _extends({
                inputId: 'edit-group-input' + classGroupId,
                initialName: initialName,
                currentId: classGroupId,
                productId: productId,
                saveHandler: localEditGroupHandler,
                closeHandler: closeHandler,
                deleteHandler: localDeleteHandler,
                showDeleteButton: classGroupItem.isDefault === false,
                hasEdited: hasEdited,
                showNewCourses: showNewCourses,
                newCoursesAvailabilityCriteria: newCoursesAvailabilityCriteria,
                isNewGroup: false
            }, courseSpecificProps))
        ) : ''
    );
}

GroupSelectionItem.propTypes = {
    classGroupItem: _propTypes2.default.object.isRequired,
    showModal: _propTypes2.default.func.isRequired,
    index: _propTypes2.default.number.isRequired,
    groupModalVisibility: _propTypes2.default.bool.isRequired,
    productId: _propTypes2.default.number.isRequired,
    groupModalId: _propTypes2.default.number.isRequired,
    editGroupHandler: _propTypes2.default.func.isRequired,
    deleteGroupHandler: _propTypes2.default.func.isRequired,
    updateGroupCheckbox: _propTypes2.default.func.isRequired,
    setShownPassword: _propTypes2.default.func,
    showNewCourses: _propTypes2.default.bool,
    newCoursesAvailabilityCriteria: _propTypes2.default.object
};

exports.default = GroupSelectionItem;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "bFbq":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/a0e217ad4d6373bd441936e6737d2909.svg";

/***/ }),

/***/ "bQC/":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
var ___CSS_LOADER_GET_URL_IMPORT___ = __webpack_require__("LsW0");
var ___CSS_LOADER_URL_IMPORT_0___ = __webpack_require__("cRa8");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.i, ".tooltip {\n  position: absolute;\n  z-index: 1;\n  border: 1px solid #c2c2c2;\n  -webkit-box-shadow: 2px 2px 0.5rem rgba(0, 0, 0, .3);\n          box-shadow: 2px 2px 0.5rem rgba(0, 0, 0, .3);\n  border-radius: 0.5rem;\n  width: 200px;\n  max-width: 200px;\n  background-color: #eaf3f9;\n  padding: 16px;\n  padding: 1rem;\n  font-size: 13px;\n  font-size: 0.8125rem;\n  white-space: normal;\n  -webkit-transition: all 1s ease-in;\n  transition: all 1s ease-in; }\n  @supports ((width: -webkit-max-content) or (width: -moz-max-content) or (width: max-content)) {\n    .tooltip {\n      width: -webkit-max-content;\n      width: -moz-max-content;\n      width: max-content; } }\n  .tooltip::after {\n    display: block;\n    position: absolute;\n    width: 16px;\n    width: 1rem;\n    height: 16px;\n    height: 1rem;\n    background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat 0 0;\n    content: ''; }\n  .tooltip--top {\n    bottom: calc(100% + 1rem);\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n            transform: translateX(-50%); }\n  .tooltip--top::after {\n      top: 100%;\n      left: 50%;\n      -webkit-transform: translate(-50%, -0.5rem) rotate(225deg);\n              transform: translate(-50%, -0.5rem) rotate(225deg); }\n  .tooltip--right {\n    top: 50%;\n    left: calc(100% + 1rem);\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%); }\n  .tooltip--right::after {\n      top: 50%;\n      right: 100%;\n      -webkit-transform: translate(0.5rem, -50%) rotate(315deg);\n              transform: translate(0.5rem, -50%) rotate(315deg); }\n  .tooltip--bottom {\n    top: calc(100% + 1rem);\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n            transform: translateX(-50%); }\n  .tooltip--bottom::after {\n      bottom: 100%;\n      left: 50%;\n      -webkit-transform: translate(-50%, 0.5rem) rotate(45deg);\n              transform: translate(-50%, 0.5rem) rotate(45deg); }\n  .tooltip--left {\n    top: 50%;\n    right: calc(100% + 1rem);\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%); }\n  .tooltip--left::after {\n      top: 50%;\n      left: 100%;\n      -webkit-transform: translate(-0.5rem, -50%) rotate(135deg);\n              transform: translate(-0.5rem, -50%) rotate(135deg); }\n  .tooltip__container {\n    display: inline-block;\n    position: relative; }\n  .tooltip__text {\n    margin-bottom: 8px;\n    margin-bottom: 0.5rem;\n    line-height: 1.2em; }\n  .tooltip__text:last-child {\n      margin-bottom: 0; }\n", ""]);
// Exports
exports.locals = {
	"tooltip": "tooltip",
	"tooltip--top": "tooltip--top",
	"tooltip--right": "tooltip--right",
	"tooltip--bottom": "tooltip--bottom",
	"tooltip--left": "tooltip--left",
	"tooltip__container": "tooltip__container",
	"tooltip__text": "tooltip__text"
};
module.exports = exports;


/***/ }),

/***/ "c6zo":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/b271d2df57945515e355257e08e4c2c0.svg";

/***/ }),

/***/ "cDhN":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/63a144b61196849f3989daf1bea09674.svg";

/***/ }),

/***/ "cEic":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactInlinesvg = __webpack_require__("Bl3B");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _warningIcon = __webpack_require__("Oi3E");

var _warningIcon2 = _interopRequireDefault(_warningIcon);

var _closeIcon = __webpack_require__("Qy98");

var _closeIcon2 = _interopRequireDefault(_closeIcon);

var _toast = __webpack_require__("Vnjy");

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toast = function Toast(_ref) {
    var message = _ref.message,
        _ref$icon = _ref.icon,
        icon = _ref$icon === undefined ? _warningIcon2.default : _ref$icon,
        _ref$variant = _ref.variant,
        variant = _ref$variant === undefined ? 'error' : _ref$variant,
        _ref$showToast = _ref.showToast,
        showToast = _ref$showToast === undefined ? false : _ref$showToast,
        onClose = _ref.onClose,
        _ref$duration = _ref.duration,
        duration = _ref$duration === undefined ? 5000 : _ref$duration,
        _ref$showCloseButton = _ref.showCloseButton,
        showCloseButton = _ref$showCloseButton === undefined ? false : _ref$showCloseButton;

    (0, _react.useEffect)(function () {
        if (!showToast) return undefined;

        var id = setTimeout(onClose, duration);
        return function () {
            return clearTimeout(id);
        };
    }, [showToast, duration, onClose]);

    if (!showToast) return null;

    return _react2.default.createElement(
        'div',
        { className: _toast2.default.container },
        _react2.default.createElement(
            'div',
            { className: _toast2.default.toast + ' ' + _toast2.default[variant] },
            _react2.default.createElement(_reactInlinesvg2.default, { src: icon, width: '32px', height: '32px', display: 'flex' }),
            _react2.default.createElement(
                'div',
                { className: _toast2.default.message },
                message
            ),
            _react2.default.createElement(
                'div',
                {
                    onClick: onClose,
                    role: 'button',
                    tabIndex: 0,
                    className: _toast2.default.close
                },
                showCloseButton && _react2.default.createElement(_reactInlinesvg2.default, { src: _closeIcon2.default, width: '20px', height: '20px' })
            )
        )
    );
};

Toast.propTypes = {
    showCloseButton: _propTypes2.default.bool,
    message: _propTypes2.default.string,
    icon: _propTypes2.default.string,
    variant: _propTypes2.default.oneOf(['success', 'error']),
    showToast: _propTypes2.default.bool,
    onClose: _propTypes2.default.func,
    duration: _propTypes2.default.number
};

Toast.defaultProps = {
    onClose: function onClose() {}
};

exports.default = (0, _reactStyleable2.default)(_toast2.default)(Toast);

/***/ }),

/***/ "cRa8":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/69f93535ecf644573af392c0750dfb66.png";

/***/ }),

/***/ "cuvN":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("Dys2");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "d2jJ":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/346813f28a14ee1177140ac68f217b1d.svg";

/***/ }),

/***/ "e1q7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Components


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _selectLabel = __webpack_require__("4H+z");

var _selectLabel2 = _interopRequireDefault(_selectLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectCourse(_ref) {
    var id = _ref.id,
        title = _ref.title,
        value = _ref.value,
        options = _ref.options,
        isDisabled = _ref.isDisabled,
        handler = _ref.handler,
        selectLabelProps = _ref.selectLabelProps,
        isRequired = _ref.isRequired,
        importedClasses = _ref.importedClasses;

    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            'label',
            { htmlFor: id, className: 'form__label edit-group-input' },
            title
        ),
        _react2.default.createElement(_selectLabel2.default, _extends({
            value: value,
            listOfOptions: options,
            isRequired: isRequired,
            isSelectDisabled: isDisabled,
            id: id,
            selectHandler: handler,
            importedClasses: importedClasses
        }, selectLabelProps))
    );
}

SelectCourse.propTypes = {
    id: _propTypes2.default.string,
    title: _propTypes2.default.object,
    value: _propTypes2.default.string,
    options: _propTypes2.default.array,
    isDisabled: _propTypes2.default.bool,
    isRequired: _propTypes2.default.bool,
    handler: _propTypes2.default.func,
    importedClasses: _propTypes2.default.string,
    // This props is such as propertyName, visibleProperty
    selectLabelProps: _propTypes2.default.shape({
        propertyName: _propTypes2.default.string,
        visibleProperty: _propTypes2.default.string
    })
};

SelectCourse.defaultProps = {
    isRequired: true
};

exports.default = SelectCourse;

/***/ }),

/***/ "e4+b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NO_UPF_COURSE_FOUND_ID = exports.DEFAULT_NEW_COURSE_ID = exports.RESET_MULTI_YEAR_GROUPS_FETCH = exports.UPDATE_MULTI_YEAR_GROUPS_CREATED_COUNT = exports.CREATE_MULTI_YEAR_GROUPS = exports.EDIT_GROUP_INFORMATION_END = exports.EDIT_GROUP_INFORMATION_START = exports.GET_DEFAULT_COURSE = exports.RESET_EDIT_INFORMATION = exports.UPDATE_GROUP_SELECTION = exports.EDIT_GROUP_NAME = undefined;

var _utils = __webpack_require__("6QRH");

var _enums = __webpack_require__("royT");

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _toastActions = __webpack_require__("sFKd");

var _toastActions2 = _interopRequireDefault(_toastActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Helpers


var EDIT_GROUP_NAME = exports.EDIT_GROUP_NAME = 'EDIT_GROUP_NAME';
var UPDATE_GROUP_SELECTION = exports.UPDATE_GROUP_SELECTION = 'UPDATE_GROUP_SELECTION';
var RESET_EDIT_INFORMATION = exports.RESET_EDIT_INFORMATION = 'RESET_EDIT_INFORMATION';

// EDIT GROUP
var GET_DEFAULT_COURSE = exports.GET_DEFAULT_COURSE = 'GET_DEFAULT_COURSE';
var EDIT_GROUP_INFORMATION_START = exports.EDIT_GROUP_INFORMATION_START = 'EDIT_GROUP_INFORMATION_START';
var EDIT_GROUP_INFORMATION_END = exports.EDIT_GROUP_INFORMATION_END = 'EDIT_GROUP_INFORMATION_END';

var CREATE_MULTI_YEAR_GROUPS = exports.CREATE_MULTI_YEAR_GROUPS = 'CREATE_MULTI_YEAR_GROUPS';
var UPDATE_MULTI_YEAR_GROUPS_CREATED_COUNT = exports.UPDATE_MULTI_YEAR_GROUPS_CREATED_COUNT = 'UPDATE_MULTI_YEAR_GROUPS_CREATED_COUNT';
var RESET_MULTI_YEAR_GROUPS_FETCH = exports.RESET_MULTI_YEAR_GROUPS_FETCH = 'RESET_MULTI_YEAR_GROUPS_FETCH';

var DEFAULT_NEW_COURSE_ID = exports.DEFAULT_NEW_COURSE_ID = '00000000-0000-0000-0000-000000000000';
var NO_UPF_COURSE_FOUND_ID = exports.NO_UPF_COURSE_FOUND_ID = '0';

// Add Group
var addNewGroup = function addNewGroup(_ref) {
    var classroomId = _ref.classroomId,
        groupName = _ref.groupName,
        courseId = _ref.courseId,
        upfCourseId = _ref.upfCourseId,
        newCourseId = _ref.newCourseId;
    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
            var UPFCourseId, newCourseID, addNewGroupResponse, message, error;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (_resources2.default.addNewGroup) {
                                _context.next = 2;
                                break;
                            }

                            throw new Error('DeleteGroup resource is not available');

                        case 2:
                            _context.prev = 2;
                            UPFCourseId = typeof upfCourseId === 'number' ? upfCourseId : -1;
                            newCourseID = newCourseId || DEFAULT_NEW_COURSE_ID;
                            _context.next = 7;
                            return _resources2.default.addNewGroup.post({ classroomId: classroomId }).headers({ Locale: (0, _utils.getLocale)() }).withBody({}).withParams({
                                name: groupName,
                                courseId: courseId,
                                upfCourseId: UPFCourseId,
                                conquestCourseId: newCourseID,
                                useUpfSchoolDefault: UPFCourseId === -1
                            }).send();

                        case 7:
                            addNewGroupResponse = _context.sent;

                            if (addNewGroupResponse) {
                                _context.next = 10;
                                break;
                            }

                            throw new Error('Network error: No response received from server');

                        case 10:
                            if (!(!addNewGroupResponse.valid || addNewGroupResponse.status >= 400 && addNewGroupResponse.status <= 599)) {
                                _context.next = 16;
                                break;
                            }

                            message = addNewGroupResponse && addNewGroupResponse.data && addNewGroupResponse.data.message || addNewGroupResponse && addNewGroupResponse.error && addNewGroupResponse.error.message || 'Failed to create group. Status: ' + addNewGroupResponse.status;
                            error = new Error(message);

                            error.status = addNewGroupResponse.status;
                            error.response = addNewGroupResponse;

                            throw error;

                        case 16:

                            dispatch(_toastActions2.default.showToast({
                                variant: 'success',
                                messageId: 'New Group Created',
                                autoCloseMs: 6000
                            }));
                            // Valid return
                            return _context.abrupt('return', addNewGroupResponse);

                        case 20:
                            _context.prev = 20;
                            _context.t0 = _context['catch'](2);

                            dispatch(_toastActions2.default.showToast({
                                variant: 'error',
                                messageId: 'Error Updating Group',
                                autoCloseMs: 6000
                            }));
                            throw _context.t0;

                        case 24:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[2, 20]]);
        }));

        return function (_x) {
            return _ref2.apply(this, arguments);
        };
    }();
};

// Edit Group name
var editGroupName = function editGroupName(_ref3) {
    var classroomId = _ref3.classroomId,
        groupId = _ref3.groupId,
        groupName = _ref3.groupName;
    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
            var editGroupNameResponse, message, error, editGroupAction;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (_resources2.default.editGroupCourses) {
                                _context2.next = 2;
                                break;
                            }

                            throw new Error('edit Group resource is not available');

                        case 2:
                            _context2.prev = 2;
                            _context2.next = 5;
                            return _resources2.default.editGroupCourses.put({ classroomId: classroomId, groupId: groupId }).headers({ Locale: (0, _utils.getLocale)() }).withBody({
                                name: groupName
                            })
                            // Prevent a .raw() chain method so that errors can be handled properly
                            //      -> although the user will get a console error, it's a trade off we need
                            .send();

                        case 5:
                            editGroupNameResponse = _context2.sent;

                            if (editGroupNameResponse) {
                                _context2.next = 8;
                                break;
                            }

                            throw new Error('Network error: No response received from server');

                        case 8:
                            if (!(!editGroupNameResponse.valid || editGroupNameResponse.status >= 400 && editGroupNameResponse.status <= 599)) {
                                _context2.next = 14;
                                break;
                            }

                            message = editGroupNameResponse && editGroupNameResponse.data && editGroupNameResponse.data.message || editGroupNameResponse && editGroupNameResponse.error && editGroupNameResponse.error.message || 'Failed to edit group. Status: ' + editGroupNameResponse.status;
                            error = new Error(message);

                            error.status = editGroupNameResponse.status;
                            error.response = editGroupNameResponse;

                            throw error;

                        case 14:
                            editGroupAction = (0, _utils.actionCreator)(EDIT_GROUP_NAME, {
                                data: editGroupNameResponse.data
                            });

                            dispatch(editGroupAction);

                            return _context2.abrupt('return', editGroupNameResponse);

                        case 19:
                            _context2.prev = 19;
                            _context2.t0 = _context2['catch'](2);

                            if (navigator.onLine) {
                                _context2.next = 23;
                                break;
                            }

                            throw new Error('Network unavailable. Please check your internet connection.');

                        case 23:
                            throw _context2.t0;

                        case 24:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[2, 19]]);
        }));

        return function (_x2) {
            return _ref4.apply(this, arguments);
        };
    }();
};

// Delete Group
var deleteExistingGroup = function deleteExistingGroup(_ref5) {
    var classroomId = _ref5.classroomId,
        groupId = _ref5.groupId;
    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
            var deleteGroupResponse, message, error;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (_resources2.default.deleteGroup) {
                                _context3.next = 2;
                                break;
                            }

                            throw new Error('DeleteGroup resource is not available');

                        case 2:
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _resources2.default.deleteGroup.delete({ classroomId: classroomId, groupId: groupId }).headers({ Locale: (0, _utils.getLocale)() }).raw().send();

                        case 5:
                            deleteGroupResponse = _context3.sent;

                            if (deleteGroupResponse) {
                                _context3.next = 8;
                                break;
                            }

                            throw new Error('Network error: No response received from server');

                        case 8:
                            if (!(!deleteGroupResponse.valid || deleteGroupResponse.status >= 400 && deleteGroupResponse.status <= 599)) {
                                _context3.next = 14;
                                break;
                            }

                            message = deleteGroupResponse && deleteGroupResponse.data && deleteGroupResponse.data.message || deleteGroupResponse && deleteGroupResponse.error && deleteGroupResponse.error.message || 'Failed to delete group. Status: ' + deleteGroupResponse.status;
                            error = new Error(message);

                            error.status = deleteGroupResponse.status;
                            error.response = deleteGroupResponse;

                            throw error;

                        case 14:

                            dispatch(_toastActions2.default.showToast({
                                variant: 'success',
                                messageId: 'Group Deleted',
                                autoCloseMs: 6000
                            }));
                            return _context3.abrupt('return', deleteGroupResponse);

                        case 18:
                            _context3.prev = 18;
                            _context3.t0 = _context3['catch'](2);

                            dispatch(_toastActions2.default.showToast({
                                variant: 'error',
                                messageId: 'Error Updating Group',
                                autoCloseMs: 6000
                            }));
                            throw _context3.t0;

                        case 22:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined, [[2, 18]]);
        }));

        return function (_x3) {
            return _ref6.apply(this, arguments);
        };
    }();
};

// Edit Group Course
/**
 * prerequisite:
 * - requires to have information about the courseId, which is in courses-actions.js
 * @param classroomId
 * @param groupId
 * @param courseId
 * @param upfCourseId
 * @param newCourseId
 */
var editGroupCourse = function editGroupCourse(_ref7) {
    var classroomId = _ref7.classroomId,
        groupId = _ref7.groupId,
        courseId = _ref7.courseId,
        upfCourseId = _ref7.upfCourseId,
        newCourseId = _ref7.newCourseId;
    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
            var UPFCourseId, newCourseID, editGroupCourseResponse, message, error;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (_resources2.default.editGroupCourses) {
                                _context4.next = 2;
                                break;
                            }

                            throw new Error('EditGroup resource is not available');

                        case 2:
                            _context4.prev = 2;
                            UPFCourseId = typeof upfCourseId === 'number' ? upfCourseId : 0;
                            newCourseID = newCourseId || DEFAULT_NEW_COURSE_ID;
                            _context4.next = 7;
                            return _resources2.default.editGroupCourses.put({ classroomId: classroomId, groupId: groupId }).headers({ Locale: (0, _utils.getLocale)() }).withBody({
                                courseId: courseId,
                                upfCourseId: UPFCourseId,
                                useUpfSchoolDefault: UPFCourseId === -1,
                                conquestCourseId: newCourseID
                            }).raw().send();

                        case 7:
                            editGroupCourseResponse = _context4.sent;

                            if (!(!editGroupCourseResponse.valid || editGroupCourseResponse.status >= 400 && editGroupCourseResponse.status <= 599)) {
                                _context4.next = 14;
                                break;
                            }

                            message = editGroupCourseResponse && editGroupCourseResponse.data && editGroupCourseResponse.data.message || editGroupCourseResponse && editGroupCourseResponse.error && editGroupCourseResponse.error.message || 'Failed to edit group. Status: ' + editGroupCourseResponse.status;
                            error = new Error(message);

                            error.status = editGroupCourseResponse.status;
                            error.response = editGroupCourseResponse;

                            throw error;

                        case 14:

                            dispatch(_toastActions2.default.showToast({
                                variant: 'success',
                                messageId: 'Group Updated',
                                autoCloseMs: 6000
                            }));
                            // Valid return
                            return _context4.abrupt('return', editGroupCourseResponse);

                        case 18:
                            _context4.prev = 18;
                            _context4.t0 = _context4['catch'](2);

                            dispatch(_toastActions2.default.showToast({
                                variant: 'error',
                                messageId: 'Error Updating Group',
                                autoCloseMs: 6000
                            }));
                            throw _context4.t0;

                        case 22:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, undefined, [[2, 18]]);
        }));

        return function (_x4) {
            return _ref8.apply(this, arguments);
        };
    }();
};

/** EDIT GROUP INFORMATION RETRIEVAL CODE
 * A list of requests trying to get information of the current groupd to get their course details
 * @param classroomId
 * @param groupId
 * @param productId
 */
var getEditGroupCourseInformation = function getEditGroupCourseInformation(_ref9) {
    var classId = _ref9.classId,
        productId = _ref9.productId,
        groupId = _ref9.groupId;
    return function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch) {
            var getGroupInformationStartAction, getGroupsResponse, message, error, _getGroupsResponse$da, countries, yearGroups, courses, groupUpfCourse, groupCourse, upfCourses, groupConquestCourse, conquestCourses, groupCountry, groupCourseYear, getCourseCountriesAction, getCourseData, courseId, yearGroup, countryName, upfCourse, newCourse, isSchoolCourse, groupCountryCode, courseInformation, courseSelectValue, yearSelectValue, upfCourseSelectValue, newCourseSelectValue, countrySelectValue, groupUpfCourseOption, groupCourseOption, groupNewCourseOption, getGroupInformationEndAction;

            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (_resources2.default.classroomGroups) {
                                _context5.next = 2;
                                break;
                            }

                            throw new Error('getEditGroupCourseInformation resource is not available');

                        case 2:
                            _context5.prev = 2;
                            getGroupInformationStartAction = (0, _utils.actionCreator)(EDIT_GROUP_INFORMATION_START);
                            _context5.next = 6;
                            return dispatch(getGroupInformationStartAction);

                        case 6:
                            _context5.next = 8;
                            return _resources2.default.classroomGroups.get({
                                classId: classId,
                                productId: productId,
                                groupId: groupId
                            }).withParams({
                                includeGlobalCourses: true
                            }).headers({ Locale: (0, _utils.getLocale)() }).send();

                        case 8:
                            getGroupsResponse = _context5.sent;

                            if (!(!getGroupsResponse.valid || getGroupsResponse.status >= 400 && getGroupsResponse.status <= 599)) {
                                _context5.next = 15;
                                break;
                            }

                            message = getGroupsResponse && getGroupsResponse.data && getGroupsResponse.data.message || getGroupsResponse && getGroupsResponse.error && getGroupsResponse.error.message || 'Failed to edit group. Status: ' + getGroupsResponse.status;
                            error = new Error(message);

                            error.status = getGroupsResponse.status;
                            error.response = getGroupsResponse;

                            throw error;

                        case 15:
                            _getGroupsResponse$da = getGroupsResponse.data, countries = _getGroupsResponse$da.countries, yearGroups = _getGroupsResponse$da.yearGroups, courses = _getGroupsResponse$da.courses, groupUpfCourse = _getGroupsResponse$da.groupUpfCourse, groupCourse = _getGroupsResponse$da.groupCourse, upfCourses = _getGroupsResponse$da.upfCourses, groupConquestCourse = _getGroupsResponse$da.groupConquestCourse, conquestCourses = _getGroupsResponse$da.conquestCourses, groupCountry = _getGroupsResponse$da.groupCountry, groupCourseYear = _getGroupsResponse$da.groupCourseYear;
                            getCourseCountriesAction = (0, _utils.actionCreator)(GET_DEFAULT_COURSE, {
                                countryList: countries,
                                yearList: yearGroups,
                                courseList: courses,
                                groupUpfCourse: groupUpfCourse,
                                groupCourse: groupCourse,
                                upfCourseList: productId === _enums.PRODUCT_IDS.Mathletics ? upfCourses : '',
                                groupNewCourse: groupConquestCourse,
                                newCourseList: conquestCourses,
                                countryCode: groupCountry.code,
                                year: groupCourseYear.yearGroupEnum
                            });


                            dispatch(getCourseCountriesAction);

                            // Course data variables
                            getCourseData = getGroupsResponse.data;
                            courseId = getCourseData.groupCourse.id.toString();
                            yearGroup = getCourseData.groupCourseYear.yearGroupEnum.toString();
                            countryName = getCourseData.groupCountry.code.toString();
                            upfCourse = getCourseData.groupUpfCourse === null ? '-1' : getCourseData.groupUpfCourse.id.toString();
                            newCourse = getCourseData.groupConquestCourse === null ? DEFAULT_NEW_COURSE_ID : getCourseData.groupConquestCourse.id.toString();
                            isSchoolCourse = getCourseData.isSchoolCourse;
                            groupCountryCode = groupCountry.code;
                            courseInformation = {
                                courseSelectValue: courseId,
                                yearSelectValue: yearGroup,
                                countrySelectValue: countryName,
                                upfCourseSelectValue: upfCourse,
                                newCourseSelectValue: newCourse
                            };

                            // eslint-disable-next-line max-len

                            courseSelectValue = courseInformation.courseSelectValue, yearSelectValue = courseInformation.yearSelectValue, upfCourseSelectValue = courseInformation.upfCourseSelectValue, newCourseSelectValue = courseInformation.newCourseSelectValue;
                            countrySelectValue = isSchoolCourse ? '' : courseInformation.countrySelectValue;
                            groupUpfCourseOption = getCourseData.groupUpfCourse;
                            groupCourseOption = getCourseData.groupCourse;
                            groupNewCourseOption = getCourseData.groupConquestCourse;
                            getGroupInformationEndAction = (0, _utils.actionCreator)(EDIT_GROUP_INFORMATION_END, {
                                data: {
                                    countrySelectValue: countrySelectValue,
                                    courseSelectValue: courseSelectValue,
                                    groupCourseOption: groupCourseOption,
                                    groupUpfCourseOption: groupUpfCourseOption,
                                    upfCourseSelectValue: upfCourseSelectValue,
                                    groupNewCourseOption: groupNewCourseOption,
                                    newCourseSelectValue: newCourseSelectValue,
                                    yearSelectValue: yearSelectValue,
                                    groupCountryCode: groupCountryCode
                                }
                            });
                            _context5.next = 35;
                            return dispatch(getGroupInformationEndAction);

                        case 35:
                            return _context5.abrupt('return', {
                                isSchoolCoursesEnabled: isSchoolCourse,
                                groupCountryCode: groupCountryCode
                            });

                        case 38:
                            _context5.prev = 38;
                            _context5.t0 = _context5['catch'](2);

                            dispatch(_toastActions2.default.showToast({
                                variant: 'error',
                                messageId: 'Error Updating Group',
                                autoCloseMs: 6000
                            }));
                            throw _context5.t0;

                        case 42:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, undefined, [[2, 38]]);
        }));

        return function (_x5) {
            return _ref10.apply(this, arguments);
        };
    }();
};

/**
 * A list of requests trying to get information of the current groupd to get their course details
 * @param defaultData
 */
var getDefaultCourseInformation = function getDefaultCourseInformation(_ref11) {
    var defaultData = _ref11.defaultData;
    return function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch) {
            var getGroupInformationStartAction, isSchoolCourse, groupCountryCode, countryName, yearGroup, courseId, conquestId, courseInformation, courseSelectValue, yearSelectValue, newCourseSelectValue, countrySelectValue, getGroupInformationEndAction;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            if (_resources2.default.getDefaultCourse) {
                                _context6.next = 2;
                                break;
                            }

                            throw new Error('getEditGroupCourseInformation resource is not available');

                        case 2:
                            _context6.prev = 2;
                            getGroupInformationStartAction = (0, _utils.actionCreator)(EDIT_GROUP_INFORMATION_START);
                            _context6.next = 6;
                            return dispatch(getGroupInformationStartAction);

                        case 6:
                            isSchoolCourse = void 0;
                            groupCountryCode = void 0;


                            console.log('defaultData', defaultData);

                            if (!defaultData) {
                                _context6.next = 22;
                                break;
                            }

                            // To display rest of the data in select box if any one of the data(Country/Year/Course) is missing from BE
                            countryName = defaultData.data.defaultCountry.code !== null ? defaultData.data.defaultCountry.code : '';
                            yearGroup = defaultData.data.defaultYear !== null ? defaultData.data.defaultYear.yearGroupEnum.toString() : '';
                            courseId = defaultData.data.defaultCourse !== null ? defaultData.data.defaultCourse.id.toString() : '';
                            conquestId = defaultData.data.defaultConquestCourse !== null ? defaultData.data.defaultConquestCourse.id : DEFAULT_NEW_COURSE_ID;

                            isSchoolCourse = defaultData.data.isSchoolCourse;
                            groupCountryCode = defaultData.data.defaultCountry.code;

                            courseInformation = {
                                courseSelectValue: courseId,
                                yearSelectValue: yearGroup,
                                countrySelectValue: countryName,
                                newCourseSelectValue: conquestId
                            };

                            // Set default country, year and course values

                            courseSelectValue = courseInformation.courseSelectValue, yearSelectValue = courseInformation.yearSelectValue, newCourseSelectValue = courseInformation.newCourseSelectValue;
                            countrySelectValue = isSchoolCourse ? '' : courseInformation.countrySelectValue;
                            getGroupInformationEndAction = (0, _utils.actionCreator)(EDIT_GROUP_INFORMATION_END, {
                                data: {
                                    courseSelectValue: courseSelectValue,
                                    yearSelectValue: yearSelectValue,
                                    countrySelectValue: countrySelectValue,
                                    upfCourseSelectValue: '-1',
                                    newCourseSelectValue: newCourseSelectValue,
                                    groupCountryCode: groupCountryCode
                                }
                            });
                            _context6.next = 22;
                            return dispatch(getGroupInformationEndAction);

                        case 22:
                            return _context6.abrupt('return', {
                                isSchoolCoursesEnabled: isSchoolCourse,
                                groupCountryCode: groupCountryCode
                            });

                        case 25:
                            _context6.prev = 25;
                            _context6.t0 = _context6['catch'](2);

                            dispatch(_toastActions2.default.showToast({
                                variant: 'error',
                                messageId: 'Error Updating Group',
                                autoCloseMs: 6000
                            }));
                            throw _context6.t0;

                        case 29:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, undefined, [[2, 25]]);
        }));

        return function (_x6) {
            return _ref12.apply(this, arguments);
        };
    }();
};

var updateGroupCheckbox = function updateGroupCheckbox(_ref13) {
    var value = _ref13.value,
        isSelected = _ref13.isSelected;
    return function () {
        var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch) {
            var updateGroupAction;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            updateGroupAction = (0, _utils.actionCreator)(UPDATE_GROUP_SELECTION, {
                                value: value,
                                isSelected: isSelected
                            });

                            dispatch(updateGroupAction);

                        case 2:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, undefined);
        }));

        return function (_x7) {
            return _ref14.apply(this, arguments);
        };
    }();
};

var updateStudentGroup = function updateStudentGroup(_ref15) {
    var newGroupId = _ref15.newGroupId,
        userIds = _ref15.userIds,
        classId = _ref15.classId;
    return function () {
        var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch) {
            var changeGroupResponse, message, error, updateGroupAction;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            if (_resources2.default.assignGroup) {
                                _context8.next = 2;
                                break;
                            }

                            throw new Error('getEditGroupCourseInformation resource is not available');

                        case 2:
                            _context8.prev = 2;
                            _context8.next = 5;
                            return _resources2.default.assignGroup.patch({
                                classId: classId,
                                groupId: newGroupId
                            }).headers({ Locale: (0, _utils.getLocale)() }).withBody(userIds).raw().send();

                        case 5:
                            changeGroupResponse = _context8.sent;

                            if (!(!changeGroupResponse.valid || changeGroupResponse.status >= 400 && changeGroupResponse.status <= 599)) {
                                _context8.next = 12;
                                break;
                            }

                            message = changeGroupResponse && changeGroupResponse.data && changeGroupResponse.data.message || changeGroupResponse && changeGroupResponse.error && changeGroupResponse.error.message || 'Failed to edit group. Status: ' + changeGroupResponse.status;
                            error = new Error(message);

                            error.status = changeGroupResponse.status;
                            error.response = changeGroupResponse;

                            throw error;

                        case 12:
                            updateGroupAction = (0, _utils.actionCreator)('STUDENT_GROUP_CHANGED', {
                                newGroupId: newGroupId,
                                userIds: userIds
                            });

                            dispatch(updateGroupAction);

                            return _context8.abrupt('return', changeGroupResponse.valid);

                        case 17:
                            _context8.prev = 17;
                            _context8.t0 = _context8['catch'](2);

                            dispatch(_toastActions2.default.showToast({
                                variant: 'error',
                                messageId: 'Error Updating Group',
                                autoCloseMs: 6000
                            }));
                            throw _context8.t0;

                        case 21:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, undefined, [[2, 17]]);
        }));

        return function (_x8) {
            return _ref16.apply(this, arguments);
        };
    }();
};

var resetEditInformationHandler = function resetEditInformationHandler() {
    return function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(dispatch) {
            var updateGroupAction;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            updateGroupAction = (0, _utils.actionCreator)(RESET_EDIT_INFORMATION);

                            dispatch(updateGroupAction);

                        case 2:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, undefined);
        }));

        return function (_x9) {
            return _ref17.apply(this, arguments);
        };
    }();
};

var resetMultiYearGroupFetch = function resetMultiYearGroupFetch() {
    return function () {
        var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(dispatch) {
            var updateGroupAction;
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            updateGroupAction = (0, _utils.actionCreator)(RESET_MULTI_YEAR_GROUPS_FETCH);

                            dispatch(updateGroupAction);

                        case 2:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, undefined);
        }));

        return function (_x10) {
            return _ref18.apply(this, arguments);
        };
    }();
};

var createMultiYearGroups = function createMultiYearGroups(_ref19) {
    var classId = _ref19.classId;
    return function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(dispatch) {
            var actionGroup, createMultiYearGroupsResponse, multiYearGroupCountAction;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            if (!_resources2.default.createMultiYearGroups) {
                                _context11.next = 11;
                                break;
                            }

                            actionGroup = (0, _utils.actionCreator)(CREATE_MULTI_YEAR_GROUPS);
                            _context11.next = 4;
                            return dispatch(actionGroup);

                        case 4:
                            _context11.next = 6;
                            return _resources2.default.createMultiYearGroups.post({ classId: classId }).headers({ Locale: (0, _utils.getLocale)() }).withBody({}).withParams({
                                productId: _enums.PRODUCT_IDS.Mathletics
                            }).send();

                        case 6:
                            createMultiYearGroupsResponse = _context11.sent;
                            multiYearGroupCountAction = (0, _utils.actionCreator)(UPDATE_MULTI_YEAR_GROUPS_CREATED_COUNT, {
                                data: {
                                    count: createMultiYearGroupsResponse.data.createdGroupsCount
                                }
                            });
                            _context11.next = 10;
                            return dispatch(multiYearGroupCountAction);

                        case 10:

                            dispatch(_toastActions2.default.showToast({
                                variant: 'success',
                                messageId: 'One Roster - Toaster - Students have been rearranged - {numberOfGroups}',
                                values: { numberOfGroups: createMultiYearGroupsResponse.data.createdGroupsCount },
                                autoCloseMs: 6000
                            }));

                        case 11:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, undefined);
        }));

        return function (_x11) {
            return _ref20.apply(this, arguments);
        };
    }();
};

exports.default = {
    addNewGroup: addNewGroup,
    editGroupName: editGroupName,
    deleteExistingGroup: deleteExistingGroup,
    editGroupCourse: editGroupCourse,
    getEditGroupCourseInformation: getEditGroupCourseInformation,
    getDefaultCourseInformation: getDefaultCourseInformation,
    updateStudentGroup: updateStudentGroup,
    updateGroupCheckbox: updateGroupCheckbox,
    resetEditInformationHandler: resetEditInformationHandler,
    createMultiYearGroups: createMultiYearGroups,
    resetMultiYearGroupFetch: resetMultiYearGroupFetch
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "fPvb":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/f4e7bd300d174843b362a10db2961ae6.svg";

/***/ }),

/***/ "fVnV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("QruM");

var _react2 = __webpack_require__("GiK3");

var _react3 = _interopRequireDefault(_react2);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _threeEssentailsButton = __webpack_require__("Lgqb");

var _threeEssentailsButton2 = _interopRequireDefault(_threeEssentailsButton);

var _consoleModalContext = __webpack_require__("U07W");

var _consoleModalContext2 = _interopRequireDefault(_consoleModalContext);

var _organiseClassGroupsModal = __webpack_require__("2C6i");

var _organiseClassGroupsModal2 = _interopRequireDefault(_organiseClassGroupsModal);

var _enums = __webpack_require__("royT");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var OneRosterOrganiseClassGroups = function OneRosterOrganiseClassGroups(_ref) {
    var createMultiYearGroups = _ref.createMultiYearGroups,
        classroomId = _ref.classroomId,
        updateCurrentClassId = _ref.updateCurrentClassId,
        hasContentLoaded = _ref.hasContentLoaded,
        resetMultiYearGroupFetch = _ref.resetMultiYearGroupFetch,
        isMultiLevelGroupsCreated = _ref.isMultiLevelGroupsCreated,
        isGroupModal = _ref.isGroupModal;

    var _useContext = (0, _react2.useContext)(_consoleModalContext2.default),
        setShowConsoleModal = _useContext.setShowConsoleModal,
        setConsoleModalContent = _useContext.setConsoleModalContent;

    var closeOrganiseClassGroupsModal = function closeOrganiseClassGroupsModal() {
        setShowConsoleModal(false);
    };

    var clickHandler = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            window.scroll(0, 0);
                            _context.next = 3;
                            return createMultiYearGroups({ classId: classroomId });

                        case 3:
                            _context.next = 5;
                            return updateCurrentClassId({ productId: _enums.PRODUCT_IDS.Mathletics, classId: classroomId });

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function clickHandler() {
            return _ref2.apply(this, arguments);
        };
    }();

    (0, _react2.useEffect)(function () {
        if (isMultiLevelGroupsCreated) {
            closeOrganiseClassGroupsModal(true);
        }
    }, [isMultiLevelGroupsCreated]);

    var showOrganiseClassGroupsModal = function showOrganiseClassGroupsModal() {
        setShowConsoleModal(true);
        resetMultiYearGroupFetch();

        setConsoleModalContent(_react3.default.createElement(_organiseClassGroupsModal2.default, {
            classroomId: classroomId,
            clickHandler: clickHandler,
            title: _react3.default.createElement(_react.Trans, { id: 'One Roster - Organise Class Groups - Modal Header' }),
            description: _react3.default.createElement(_react.Trans, { id: 'One Roster - Organise Class Groups - Modal Body' }),
            closeHandler: closeOrganiseClassGroupsModal,
            hasContentLoaded: hasContentLoaded,
            isMultiLevelGroupsCreated: isMultiLevelGroupsCreated
        }));
    };

    return _react3.default.createElement(
        'div',
        { className: 'groups__button-container' },
        _react3.default.createElement(_threeEssentailsButton2.default, {
            clickHandler: showOrganiseClassGroupsModal,
            title: _react3.default.createElement(_react.Trans, { id: 'One Roster - Organise class groups' }),
            show3EIcon: false,
            buttonClassName: '' + (isGroupModal ? 'edit_group_name_autoselect' : 'edit_group_name'),
            showArrow: false
        })
    );
};

OneRosterOrganiseClassGroups.propTypes = {
    createMultiYearGroups: _propTypes2.default.func.isRequired,
    classroomId: _propTypes2.default.number.isRequired,
    updateCurrentClassId: _propTypes2.default.func.isRequired,
    resetMultiYearGroupFetch: _propTypes2.default.func.isRequired,
    hasContentLoaded: _propTypes2.default.bool,
    isMultiLevelGroupsCreated: _propTypes2.default.bool,
    isGroupModal: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
    var isMultiLevelGroupsCreated = state.consoleReducer.isMultiLevelGroupsCreated;


    return {
        isMultiLevelGroupsCreated: isMultiLevelGroupsCreated
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(OneRosterOrganiseClassGroups);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "ffwl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _isEqual = __webpack_require__("hygk");

var _isEqual2 = _interopRequireDefault(_isEqual);

var _linguiCdn = __webpack_require__("siuH");

__webpack_require__("YkNq");

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _selectLabel = __webpack_require__("4H+z");

var _selectLabel2 = _interopRequireDefault(_selectLabel);

var _addStudentsList = __webpack_require__("LaDp");

var _addStudentsList2 = _interopRequireDefault(_addStudentsList);

var _emptyDataMessage = __webpack_require__("JZJN");

var _emptyDataMessage2 = _interopRequireDefault(_emptyDataMessage);

var _addStudentsListBody = __webpack_require__("hI0V");

var _addStudentsListBody2 = _interopRequireDefault(_addStudentsListBody);

var _genericModal = __webpack_require__("51N/");

var _genericModal2 = _interopRequireDefault(_genericModal);

var _consoleModalContext = __webpack_require__("U07W");

var _consoleModalContext2 = _interopRequireDefault(_consoleModalContext);

var _consoleActions = __webpack_require__("SC2c");

var _consoleActions2 = _interopRequireDefault(_consoleActions);

var _enums = __webpack_require__("royT");

__webpack_require__("cuvN");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Styles


// Components


// Context


// Actions


// Helpers


// Styles


function setUpClassDropdown(_ref) {
    var currentClasses = _ref.currentClasses,
        classDefaultLabel = _ref.classDefaultLabel;

    // Set id = -1 for 'Select Class' option so that user can select all students again
    var listOfClassesDefault = [{
        value: _enums.INVALID_CLASSNAME,
        label: classDefaultLabel
    }];
    var listOfClasses = currentClasses.map(function (oneClass) {
        return {
            value: oneClass.id,
            label: oneClass.name
        };
    });

    return [].concat(listOfClassesDefault, _toConsumableArray(listOfClasses));
}

// This will get back the available students that are not disabled
function getAvailableStudents(_ref2) {
    var currentStudents = _ref2.currentStudents,
        currentStudentIds = _ref2.currentStudentIds;

    var filteredCurrentStudents = currentStudents.map(function (student) {
        return student.userProfileId;
    });
    var availableStudents = filteredCurrentStudents.filter(function (student) {
        return !currentStudentIds.includes(student);
    });

    return availableStudents.map(function (studentId) {
        return parseInt(studentId, 10);
    });
}

/*
    This function searches for the searched field in case that it's empty it would return false
    and display no students found
 */
function hasVisibleStudents(currentStudents, searchString) {
    var searchedStudent = currentStudents.filter(function (student) {
        // To make searching students independent of case sensitiveness
        var searchStudent = student.lastName.concat(' ', student.firstName).toLowerCase();
        searchString = searchString.toLowerCase();
        if (searchStudent.includes(searchString)) {
            return student;
        }
        return false;
    });
    return searchedStudent;
}

function AddStudents(props) {
    var _this = this;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    // Props


    var currentClassId = props.currentClassId,
        productId = props.productId,
        getInitialAddStudent = props.getInitialAddStudent,
        getAddStudentClasses = props.getAddStudentClasses,
        updateCurrentClassId = props.updateCurrentClassId,
        assignClassStudent = props.assignClassStudent;

    // State variables

    var _useState = (0, _react.useState)(null),
        _useState2 = _slicedToArray(_useState, 2),
        bottomErrorMessage = _useState2[0],
        setBottomErrorMessage = _useState2[1];
    // Required fields for add students


    var _useState3 = (0, _react.useState)(true),
        _useState4 = _slicedToArray(_useState3, 2),
        showInitialMessage = _useState4[0],
        setShowInitialMessage = _useState4[1];

    var _useState5 = (0, _react.useState)([]),
        _useState6 = _slicedToArray(_useState5, 2),
        currentClasses = _useState6[0],
        setCurrentClasses = _useState6[1];

    var _useState7 = (0, _react.useState)([]),
        _useState8 = _slicedToArray(_useState7, 2),
        currentClassGroups = _useState8[0],
        setCurrentClassGroups = _useState8[1];

    var _useState9 = (0, _react.useState)([]),
        _useState10 = _slicedToArray(_useState9, 2),
        studentClassData = _useState10[0],
        setStudentClassData = _useState10[1];

    var _useState11 = (0, _react.useState)([{
        id: '',
        name: i18n._( /*i18n*/{
            id: 'Select - Default Group Option'
        })
    }]),
        _useState12 = _slicedToArray(_useState11, 2),
        availableGroups = _useState12[0],
        setAvailableGroups = _useState12[1];
    // this variable will determine the students that should be disabled


    var _useState13 = (0, _react.useState)([]),
        _useState14 = _slicedToArray(_useState13, 2),
        currentStudentIds = _useState14[0],
        setCurrentStudentIds = _useState14[1];

    var _useState15 = (0, _react.useState)([]),
        _useState16 = _slicedToArray(_useState15, 2),
        currentStudents = _useState16[0],
        setCurrentStudents = _useState16[1];

    var _useState17 = (0, _react.useState)([]),
        _useState18 = _slicedToArray(_useState17, 2),
        allGroupStudents = _useState18[0],
        setAllGroupStudents = _useState18[1];

    // Top Section - variables
    // To set value to 'Select Class' by default


    var _useState19 = (0, _react.useState)(_enums.INVALID_CLASSNAME),
        _useState20 = _slicedToArray(_useState19, 2),
        selectClassValue = _useState20[0],
        setSelectClassValue = _useState20[1];

    var _useState21 = (0, _react.useState)(''),
        _useState22 = _slicedToArray(_useState21, 2),
        selectGroupValue = _useState22[0],
        setSelectGroupValue = _useState22[1];

    var _useState23 = (0, _react.useState)(''),
        _useState24 = _slicedToArray(_useState23, 2),
        searchStudentName = _useState24[0],
        setSearchStudentName = _useState24[1];

    // Selected students


    var _useState25 = (0, _react.useState)(''),
        _useState26 = _slicedToArray(_useState25, 2),
        sourceGroupId = _useState26[0],
        setSourceGroupId = _useState26[1];

    var _useState27 = (0, _react.useState)(''),
        _useState28 = _slicedToArray(_useState27, 2),
        currentGroupName = _useState28[0],
        setCurrentGroupName = _useState28[1];

    var _useState29 = (0, _react.useState)({}),
        _useState30 = _slicedToArray(_useState29, 2),
        selectedStudents = _useState30[0],
        setSelectedStudents = _useState30[1];

    var _useState31 = (0, _react.useState)(false),
        _useState32 = _slicedToArray(_useState31, 2),
        selectAllValue = _useState32[0],
        setSelectAllValue = _useState32[1];

    var _useState33 = (0, _react.useState)(false),
        _useState34 = _slicedToArray(_useState33, 2),
        isApplyButtonDisabled = _useState34[0],
        setIsApplyButtonDisabled = _useState34[1];

    var _useState35 = (0, _react.useState)([]),
        _useState36 = _slicedToArray(_useState35, 2),
        classData = _useState36[0],
        setClassData = _useState36[1];

    // Context


    var _useContext = (0, _react.useContext)(_consoleModalContext2.default),
        setShowConsoleModal = _useContext.setShowConsoleModal,
        setConsoleModalContent = _useContext.setConsoleModalContent;

    // Effects
    // Effect to retrieve the available classes and initial groups which is at the bottom


    (0, _react.useEffect)(function () {
        var isCancelled = false;
        var fetchInitialStudentDetail = function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var newStudentsData, classes, students, updatedCurrentClass, currentClassData, classGroups, filteredClassGroups, currentProfileIds;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return getInitialAddStudent({
                                    productId: productId,
                                    currentClassId: currentClassId
                                });

                            case 2:
                                newStudentsData = _context.sent;
                                classes = newStudentsData.classes, students = newStudentsData.students;

                                // Set Class data and Student data for global use

                                setClassData(classes);
                                setStudentClassData(students);

                                if (!isCancelled && newStudentsData) {
                                    // Set the appropriate data for Student Management
                                    updatedCurrentClass = classes.map(function (item) {
                                        if (item.id === 0) {
                                            var name = i18n._( /*i18n*/{
                                                id: 'Select - unassign label'
                                            });
                                            return {
                                                id: item.id,
                                                name: name
                                            };
                                        }
                                        return {
                                            id: item.id,
                                            name: item.name
                                        };
                                    });

                                    setCurrentClasses(updatedCurrentClass);
                                    // Set student data on initial load when Add Student button is clicked
                                    setCurrentStudents(students);
                                }

                                _context.next = 9;
                                return getAddStudentClasses({
                                    classId: currentClassId,
                                    productId: productId
                                });

                            case 9:
                                currentClassData = _context.sent;
                                classGroups = currentClassData.classGroups;


                                if (!isCancelled && currentClassData) {
                                    // Set default group ID to be 1 (defaultGroupId) in bottom select box of dialog
                                    setSourceGroupId(_enums.DEFAULT_GROUP_ID);

                                    // To make the classgroups object suitable for select box input
                                    filteredClassGroups = classGroups.filter(function (item) {
                                        return item.groupId !== _enums.ALL_GROUP_ID;
                                    }).map(function (item) {
                                        return { id: item.groupId, name: [item.name] };
                                    });


                                    setCurrentClassGroups([{
                                        id: '',
                                        name: i18n._( /*i18n*/{
                                            id: 'Select - Default Group Option'
                                        })
                                    }].concat(_toConsumableArray(filteredClassGroups)));
                                    currentProfileIds = currentClassData.students.map(function (student) {
                                        return student.userProfileId;
                                    });

                                    setCurrentStudentIds(currentProfileIds);
                                } else {
                                    setBottomErrorMessage(i18n._( /*i18n*/{
                                        id: 'Error Message - Unable to proceed'
                                    }));
                                }

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function fetchInitialStudentDetail() {
                return _ref3.apply(this, arguments);
            };
        }();

        fetchInitialStudentDetail();

        return function () {
            isCancelled = true;
        };
    }, []);

    // Effect to retrieve the groups in the top section
    (0, _react.useEffect)(function () {
        var isCancelled = false;
        var fetchStudentDetails = function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _ret;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(!isCancelled && studentClassData)) {
                                    _context2.next = 4;
                                    break;
                                }

                                _ret = function () {
                                    // To make the classgroups object suitable for select box input

                                    /* To reset all students data when user selects 'Select Class' option in drop down */
                                    if (parseInt(selectClassValue, 10) === -1) {
                                        // Reset All Students data on click on 'Select Class' option in class drop down
                                        setCurrentStudents(studentClassData);
                                        return {
                                            v: void 0
                                        };
                                    }

                                    /*  Find the group list based on value selected in the group select and
                                        map respective group data to groupListArray */
                                    var groupList = classData.filter(function (item) {
                                        return item.id === parseInt(selectClassValue, 10);
                                    })[0].classroomGroups;
                                    var revisedClassGroups = groupList ? groupList.map(function (item) {
                                        return { id: item.id, name: [item.name] };
                                    }) : {};

                                    // Set the appropriate group data for in select box in top section
                                    setAvailableGroups([{
                                        id: 0,
                                        name: i18n._( /*i18n*/{
                                            id: 'Select - Default Group Option'
                                        })
                                    }].concat(_toConsumableArray(revisedClassGroups)));

                                    // To display all groups or default group initially assigning 1
                                    setSelectGroupValue(0);

                                    /*  To find studentList in Class list from the global Class object
                                        based on value selected in Select Class Box */
                                    var studentListArray = classData.filter(function (item) {
                                        return item.id === parseInt(selectClassValue, 10);
                                    });

                                    var studentList = studentListArray.map(function (item) {
                                        return { id: item.studentsProfileId };
                                    })[0].id;

                                    var studentClassList = [];
                                    /*
                                        Find student data from main list(studentClassData)matching the student list
                                        created above to display students belonging to particular class
                                        based on value selected in drop down
                                    */

                                    var _loop = function _loop(index) {
                                        var data = studentClassData.filter(function (item) {
                                            return item.userProfileId === studentList[index];
                                        });
                                        if (data.length > 0) {
                                            studentClassList.push(data[0]);
                                        }
                                    };

                                    for (var index in studentList) {
                                        _loop(index);
                                    }
                                    setCurrentStudents(studentClassList);
                                    // To set the All Groups students data for 'Select Group' option in Group drop down list
                                    setAllGroupStudents(studentClassList);
                                    /*
                                        When there's only 1 group in the response and the id is set to be the default group,
                                        set the name in the select box to be that name
                                     */
                                    if (classData.length === 1 && classData[0].groupId === _enums.DEFAULT_GROUP_ID) {
                                        setSelectGroupValue(1);
                                    }
                                }();

                                if (!((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object")) {
                                    _context2.next = 4;
                                    break;
                                }

                                return _context2.abrupt('return', _ret.v);

                            case 4:

                                // Reset the initial message, in order for the message to not be shown again
                                if (showInitialMessage === true) {
                                    setShowInitialMessage(false);
                                }

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }));

            return function fetchStudentDetails() {
                return _ref4.apply(this, arguments);
            };
        }();

        if (selectClassValue !== '') {
            setCurrentGroupName('');
            fetchStudentDetails();
        } else {
            // If the select value of the class is empty, reset the current students
            setCurrentStudents([]);
            setSelectGroupValue('');
            setCurrentGroupName('');
        }

        return function () {
            isCancelled = true;
        };
    }, [selectClassValue]);

    // Effect to retrieve the students after the group has changed
    (0, _react.useEffect)(function () {
        var isCancelled = false;
        var studentGroupData = void 0;
        var fetchStudentDetails = function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var _ret3, groupNameItem, firstValue;

                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (isCancelled) {
                                    _context3.next = 9;
                                    break;
                                }

                                if (!(parseInt(selectGroupValue, 10) === 0)) {
                                    _context3.next = 5;
                                    break;
                                }

                                // To display students from all groups
                                studentGroupData = allGroupStudents;
                                _context3.next = 8;
                                break;

                            case 5:
                                _ret3 = function () {
                                    // To display students from a particular group

                                    /*  Find the group list based on value selected in the group select and
                                        map respective group data to groupListArray */
                                    var groupList = selectClassValue !== _enums.INVALID_CLASSNAME ? classData.filter(function (item) {
                                        return item.id === parseInt(selectClassValue, 10);
                                    })[0].classroomGroups : null;
                                    if (groupList === null) {
                                        return {
                                            v: void 0
                                        };
                                    }
                                    /*  To find studentList in Class list from the global Class object
                                        based on value selected in Select Class Box */
                                    var groupListArray = groupList.filter(function (item) {
                                        return item.id === parseInt(selectGroupValue, 10);
                                    });

                                    var studentListArray = groupListArray.map(function (item) {
                                        return { id: item.studentsProfileId };
                                    });

                                    var studentList = studentListArray === '' ? studentListArray : studentListArray[0].id;
                                    var studentClassList = [];

                                    /*
                                        Find student data from main list(studentClassData)matching the student list
                                        created above to display students belonging to particular class
                                        based on value selected in Group drop down
                                    */

                                    var _loop2 = function _loop2(index) {
                                        var data = studentClassData.filter(function (item) {
                                            return item.userProfileId === studentList[index];
                                        });
                                        if (data.length > 0) {
                                            studentClassList.push(data[0]);
                                        }
                                    };

                                    for (var index in studentList) {
                                        _loop2(index);
                                    }
                                    studentGroupData = studentClassList;
                                }();

                                if (!((typeof _ret3 === 'undefined' ? 'undefined' : _typeof(_ret3)) === "object")) {
                                    _context3.next = 8;
                                    break;
                                }

                                return _context3.abrupt('return', _ret3.v);

                            case 8:
                                // The response is valid
                                if (studentGroupData) {
                                    // Set the appropriate data for Student Management
                                    setCurrentStudents(studentGroupData);
                                    setSelectedStudents({});

                                    // Set the correct name for the group name column
                                    groupNameItem = availableGroups.filter(function (item) {
                                        return item.id === parseInt(selectGroupValue, 10);
                                    });

                                    if (groupNameItem.length > 0) {
                                        firstValue = groupNameItem[0];

                                        if (firstValue.id !== _enums.ALL_GROUP_ID) {
                                            setCurrentGroupName(firstValue.name);
                                        } else {
                                            // As this case is for the "all groups", set the group name to be an empty string
                                            setCurrentGroupName('');
                                        }
                                    }
                                } else {
                                    // Otherwise if it's invalid data, return back an empty list of current students
                                    setCurrentStudents([]);
                                    setSelectedStudents({});
                                }

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this);
            }));

            return function fetchStudentDetails() {
                return _ref5.apply(this, arguments);
            };
        }();

        if (selectClassValue !== '') {
            fetchStudentDetails();
        }

        return function () {
            isCancelled = true;
        };
    }, [selectGroupValue]);

    // Effect to determine the buttons disabled state based on the list of selected students
    (0, _react.useEffect)(function () {
        var selectedStudentsLength = Object.keys(selectedStudents).length;

        setIsApplyButtonDisabled(selectedStudentsLength === 0 || sourceGroupId === '');
    }, [selectedStudents, sourceGroupId, selectAllValue]);

    var classDefaultLabel = i18n._( /*i18n*/{
        id: 'Class Dropdown - header'
    });
    var listOfClassesOptions = setUpClassDropdown({ currentClasses: currentClasses, classDefaultLabel: classDefaultLabel });

    var selectAllCheckboxHandler = function selectAllCheckboxHandler() {
        var newSelectValue = !selectAllValue;
        var filteredCurrentStudents = currentStudents.filter(function (student) {
            return student.fullName.toLowerCase().includes(searchStudentName.toLowerCase());
        });
        var availableStudents = getAvailableStudents({
            currentStudents: filteredCurrentStudents,
            currentStudentIds: currentStudentIds
        });

        for (var index in availableStudents) {
            var studentId = availableStudents[index];
            var selectedValue = _typeof(selectedStudents[studentId]) === 'object' ? selectedStudents[studentId] : {
                actionType: _addStudentsListBody.MOVE_VALUE
            };

            if (newSelectValue) {
                selectedStudents[studentId] = selectedValue;
            } else {
                delete selectedStudents[studentId];
            }
        }

        // Reverse the value of the select all
        setSelectAllValue(newSelectValue);
    };

    var individualCheckboxHandler = function individualCheckboxHandler(studentId, actionType) {
        var tempSelectedStudents = _extends({}, selectedStudents);

        // If there wasn't a student without the id, then find it and remove it
        if (!tempSelectedStudents[studentId]) {
            tempSelectedStudents[studentId] = {
                actionType: actionType
            };
        } else if (actionType === undefined) {
            // If it was deselected, set the and the actionType is udnefined, remove the studentId
            delete tempSelectedStudents[studentId];
        } else {
            tempSelectedStudents[studentId] = {
                actionType: actionType
            };
        }

        setSelectedStudents(tempSelectedStudents);

        // test if the checkbox conflicts with the select all
        var filteredCurrentStudents = currentStudents.filter(function (student) {
            return student.fullName.toLowerCase().includes(searchStudentName.toLocaleLowerCase());
        });

        var filteredStudentIds = Object.keys(tempSelectedStudents).map(function (student) {
            return parseInt(student, 10);
        });
        if (!(0, _isEqual2.default)(filteredStudentIds, filteredCurrentStudents)) {
            setSelectAllValue(false);
        }
    };
    var moveCopyHandler = function moveCopyHandler(studentId, actionType) {
        var tempSelectedStudents = _extends({}, selectedStudents);

        tempSelectedStudents[studentId] = {
            actionType: actionType
        };

        setSelectedStudents(tempSelectedStudents);
    };
    var closeConfirmationModal = function closeConfirmationModal() {
        setShowConsoleModal(false);
    };
    var selectHandlerClasses = function selectHandlerClasses(e) {
        return setSelectClassValue(e.target.value);
    };
    var selectHandlerGroups = function selectHandlerGroups(e) {
        return setSelectGroupValue(e.target.value);
    };
    var inputHandlerName = function inputHandlerName(e) {
        return setSearchStudentName(e.target.value);
    };
    var updateCurrentGroup = function updateCurrentGroup(e) {
        return setSourceGroupId(e.target.value);
    };

    var params = {
        currentClassId: currentClassId,
        selectClassValue: selectClassValue,
        sourceGroupId: sourceGroupId
    };

    var setUpSaveInformation = function setUpSaveInformation() {
        var tempStudents = _extends({}, selectedStudents);
        var tempUpdateStudents = {};
        var studentIndex = 0;

        // To create an array of student data to move/copy action

        var _loop3 = function _loop3(studentId) {
            var parsedStudentId = parseInt(studentId, 10);
            // To find selected student(checkbox clicked) from student list
            var selectedStudent = studentClassData.filter(function (item) {
                return item.userProfileId === parsedStudentId;
            });
            // To get all classes of the student selected
            var classArrayList = selectedStudent[0].assignedClasses.map(function (item) {
                return item.classId;
            });
            if (tempStudents[studentId].actionType === _addStudentsListBody.MOVE_VALUE || tempStudents[studentId].actionType === _addStudentsListBody.COPY_VALUE) {
                /* If student is selected in "Select Class" option,
                get all the classes of that student for move/copy functionality */
                if (classArrayList.length > 1 && selectClassValue === _enums.INVALID_CLASSNAME) {
                    for (var classIndex in classArrayList) {
                        tempUpdateStudents[studentIndex] = {
                            destinationClassId: parseInt(params.currentClassId, 10),
                            destinationGroupId: parseInt(params.sourceGroupId, 10),
                            sourceClassId: parseInt(classArrayList[classIndex], 10),
                            studentProfileId: parsedStudentId,
                            actionType: _enums.actionTypeIds[tempStudents[studentId].actionType]
                        };
                        studentIndex += 1;
                    }
                } else if (classArrayList.length === 0) {
                    // Set source id = 0 for students belonging to 'Unassigned Class'
                    tempUpdateStudents[parsedStudentId] = {
                        destinationClassId: parseInt(params.currentClassId, 10),
                        destinationGroupId: parseInt(params.sourceGroupId, 10),
                        sourceClassId: 0,
                        studentProfileId: parsedStudentId,
                        actionType: _enums.actionTypeIds[tempStudents[studentId].actionType]
                    };
                } else {
                    /* Set source class id to value from where student should be move/copy
                    when class is selected from drop down of Class drop down list. If the student
                    is moved from all students list, assign the value of classId from the
                    classArraylist. If particular class is selected from dropdown and then student
                    is moved, then assign the value of classId from the dropdown class selected */
                    var classId = selectClassValue === _enums.INVALID_CLASSNAME ? classArrayList[0] : selectClassValue;
                    tempUpdateStudents[parsedStudentId] = {
                        destinationClassId: parseInt(params.currentClassId, 10),
                        destinationGroupId: parseInt(params.sourceGroupId, 10),
                        sourceClassId: parseInt(classId, 10),
                        studentProfileId: parsedStudentId,
                        actionType: _enums.actionTypeIds[tempStudents[studentId].actionType]
                    };
                }
            }
        };

        for (var studentId in tempStudents) {
            _loop3(studentId);
        }

        return {
            tempUpdateStudents: tempUpdateStudents
        };
    };

    var saveHandler = function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
            var _setUpSaveInformation, tempUpdateStudents, listOfStudentsToUpdate, assignStudents, assignStudentsBody, addStudentsResponse;

            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            // Prevent redirect from the default behaviour of a form
                            e.preventDefault();

                            // Set up the list of copy/move students
                            _setUpSaveInformation = setUpSaveInformation(), tempUpdateStudents = _setUpSaveInformation.tempUpdateStudents;

                            // Map studentId with tempUpdateStudents array to remove studentId index

                            listOfStudentsToUpdate = Object.keys(tempUpdateStudents);
                            assignStudents = listOfStudentsToUpdate.map(function (student) {
                                return tempUpdateStudents[student];
                            });
                            assignStudentsBody = {
                                assignStudents: assignStudents
                            };
                            _context4.next = 7;
                            return assignClassStudent(assignStudentsBody);

                        case 7:
                            addStudentsResponse = _context4.sent;


                            // Success/Error handling
                            if (addStudentsResponse !== false) {
                                setConsoleModalContent(_react2.default.createElement(
                                    _genericModal2.default,
                                    {
                                        title: _react2.default.createElement(_react3.Trans, { id: 'Add Modal - Success Title' }),
                                        closeHandler: closeConfirmationModal,
                                        parentClasses: 'modal--small',
                                        type: _genericModal.MODAL_TYPE.floating },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form__message' },
                                        _react2.default.createElement(_react3.Trans, { id: 'Add Modal - Success Message' }),
                                        ' ',
                                        _react2.default.createElement('span', { className: 'add-students__tick' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form__row form__row--buttons' },
                                        _react2.default.createElement(_button2.default, {
                                            callback: closeConfirmationModal,
                                            visibleText: i18n._( /*i18n*/{
                                                id: 'Button - Ok'
                                            }) })
                                    )
                                ));
                                updateCurrentClassId({ productId: productId, classId: currentClassId });
                            } else {
                                // If there was an error, show a message that something happened
                                setBottomErrorMessage(i18n._( /*i18n*/{
                                    id: 'Update students - Error message'
                                }));
                            }

                        case 9:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this);
        }));

        return function saveHandler(_x) {
            return _ref6.apply(this, arguments);
        };
    }();

    /*
        This effect will reset the selected students' checkbox and the select all,
        to start clean whenever the class changes or group changes
     */
    (0, _react.useEffect)(function () {
        setSelectedStudents({});
        setSelectAllValue(false);
    }, [selectClassValue, selectGroupValue]);

    (0, _react.useEffect)(function () {
        // remove the selected student if it's part of the name when the teacher has selected them
        var searchName = searchStudentName.toLowerCase();
        currentStudents.map(function (student) {
            var studentFullName = student.fullName.toLowerCase();
            if (!studentFullName.includes(searchName)) {
                if (selectedStudents[student.userProfileId]) {
                    delete selectedStudents[student.userProfileId];
                }
            }
            return student;
        });

        var filteredCurrentStudents = currentStudents.filter(function (student) {
            var studentFullName = student.fullName.toLowerCase();
            return studentFullName.includes(searchName);
        });

        var filteredStudentIds = Object.keys(selectedStudents).map(function (studentId) {
            if (selectedStudents[studentId]) {
                return parseInt(studentId, 10);
            }

            return false;
        }).filter(function (item) {
            return item !== false;
        });

        if (!(0, _isEqual2.default)(filteredStudentIds, filteredCurrentStudents)) {
            setSelectAllValue(false);
        }
    }, [searchStudentName]);

    var isUnassignedStudents = selectClassValue === '' || selectClassValue === '' + _enums.ALL_GROUP_ID || availableGroups.length === 0 || selectClassValue === _enums.INVALID_CLASSNAME;
    var listOfRows = currentStudents && currentStudents.length > 0 && hasVisibleStudents(currentStudents, searchStudentName) ? currentStudents.map(function (row, index) {
        var isDisabled = currentStudentIds.includes(row.userProfileId);
        var searchStudent = searchStudentName.toLocaleLowerCase();
        // to show students selected in search text box(not case sensitive)
        var isVisible = row.lastName.concat(' ', row.firstName).toLowerCase().includes(searchStudent);
        var isSelected = _typeof(selectedStudents[row.userProfileId]) === 'object';
        var revisedFullName = row.lastName.concat(', ', row.firstName);
        var studentGroupName = [];
        var studentClassName = [];
        // Make selectClassValue blank if user clicks on Select Class option to populate all students
        var classValueSelected = selectClassValue === _enums.INVALID_CLASSNAME ? '' : selectClassValue;
        var classSelected = parseInt(classValueSelected, 10);
        if (row.assignedClasses) {
            if (row.assignedClasses.length > 0) {
                /* To show only one class name which is selected in Class Select box
                or to show all the class names to which students belong when clicked on Select Class option */
                row.assignedClasses.map(function (item, classindex) {
                    if (classSelected === item.classId || isNaN(classSelected)) {
                        studentClassName[classindex] = item.className;
                        studentGroupName[classindex] = item.groupName;
                    }
                    return {
                        studentClassName: studentClassName,
                        studentGroupName: studentGroupName
                    };
                });
            } else {
                studentClassName = ['-'];
                studentGroupName = ['-'];
            }
        }
        return _react2.default.createElement(_addStudentsListBody2.default, {
            key: 'move-students-' + row.userProfileId + '-' + row.fullName,
            userId: row.userProfileId,
            index: index,
            isSelected: isSelected,
            isVisible: isVisible,
            fullName: revisedFullName,
            classValue: studentClassName,
            groupName: currentGroupName === '' ? studentGroupName : currentGroupName,
            checkboxHandler: individualCheckboxHandler,
            moveCopyHandler: moveCopyHandler,
            isDisabled: isDisabled
        });
    }) : [_react2.default.createElement(_emptyDataMessage2.default, {
        key: 'emptyRowAdd',
        showInitialAddMessage: showInitialMessage,
        initialMessage: _react2.default.createElement(_react3.Trans, { id: 'Add Modal - initial message' }),
        colSpan: 5
    })];

    // External Components
    var tableComponent = _react2.default.createElement(
        'table',
        { className: 'table add-students__search' },
        _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    { className: 'table__cell table__cell--naked' },
                    _react2.default.createElement(_selectLabel2.default, {
                        id: 'add-search-classes',
                        srLabel: i18n._( /*i18n*/{
                            id: 'Add Modal - Search - Classes'
                        }),
                        listOfOptions: listOfClassesOptions,
                        propertyName: 'value',
                        visibleProperty: 'label',
                        value: selectClassValue,
                        selectHandler: selectHandlerClasses })
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'table__cell table__cell--naked' },
                    _react2.default.createElement(_selectLabel2.default, {
                        id: 'add-search-groups',
                        srLabel: i18n._( /*i18n*/{
                            id: 'Add Modal - Search - Groups'
                        }),
                        listOfOptions: availableGroups,
                        propertyName: 'id',
                        visibleProperty: 'name',
                        value: selectGroupValue,
                        isSelectDisabled: isUnassignedStudents,
                        selectHandler: selectHandlerGroups })
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'table__cell table__cell--naked' },
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'add-search-name', className: 'sr-only' },
                        _react2.default.createElement(_react3.Trans, { id: 'Add Modal - Search - Enter name' })
                    ),
                    _react2.default.createElement('input', {
                        type: 'text',
                        id: 'add-search-name',
                        value: searchStudentName,
                        placeholder: i18n._( /*i18n*/{
                            id: 'Add Modal - Search - Enter name'
                        }),
                        onChange: inputHandlerName,
                        className: 'form__input',
                        autoComplete: 'off'
                    })
                )
            )
        )
    );

    return _react2.default.createElement(
        _react.Fragment,
        null,
        tableComponent,
        _react2.default.createElement(
            'div',
            { className: 'modal__variable-height' },
            _react2.default.createElement(_addStudentsList2.default, {
                selectAllValue: selectAllValue,
                selectAllCheckboxHandler: selectAllCheckboxHandler,
                numberOfStudents: currentStudents.length,
                listOfRows: listOfRows
            })
        ),
        _react2.default.createElement(_react3.Trans, { id: 'Add or Move Modal - note message - product ' + productId, defaults: '<0><1>Title</1>Message</0>',
            components: [_react2.default.createElement('p', { className: 'form__message' }), _react2.default.createElement('span', { className: 'form__note' })]
        }),
        _react2.default.createElement(
            'div',
            { className: 'form__row form__row--buttons' },
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'add-to-group', className: 'form__message form__message--label' },
                    _react2.default.createElement(_react3.Trans, { id: 'Add Modal - add to this group' })
                ),
                _react2.default.createElement(_selectLabel2.default, {
                    id: 'add-to-group',
                    listOfOptions: currentClassGroups,
                    propertyName: 'id',
                    visibleProperty: 'name',
                    selectHandler: updateCurrentGroup,
                    value: sourceGroupId,
                    isRequired: true,
                    importedClasses: 'select--content' })
            ),
            _react2.default.createElement(_button2.default, {
                callback: saveHandler,
                isBtnDisabled: isApplyButtonDisabled,
                visibleText: i18n._( /*i18n*/{
                    id: 'Add Modal - Apply'
                }) })
        ),
        bottomErrorMessage ? _react2.default.createElement(
            'div',
            { className: 'form__row' },
            _react2.default.createElement(
                'p',
                { className: 'form__error-message form__error-message--bottom' },
                bottomErrorMessage
            )
        ) : ''
    );
}

AddStudents.propTypes = {
    currentClassId: _propTypes2.default.number.isRequired,
    // State props
    productId: _propTypes2.default.number,
    // Action props
    getInitialAddStudent: _propTypes2.default.func,
    getAddStudentClasses: _propTypes2.default.func,
    updateCurrentClassId: _propTypes2.default.func,
    assignClassStudent: _propTypes2.default.func
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from MessageModalCombinedReducers.
 */
function mapStateToProps(state) {
    var productId = state.consoleReducer.productId;


    return {
        productId: productId
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getInitialAddStudent: _consoleActions2.default.getInitialAddStudent,
        getInitialClassAddStudent: _consoleActions2.default.getInitialClassAddStudent,
        getAddStudentClasses: _consoleActions2.default.getAddStudentClasses,
        getAddStudentDetails: _consoleActions2.default.getAddStudentDetails,
        updateCurrentClassId: _consoleActions2.default.updateCurrentClassId,
        assignClassStudent: _consoleActions2.default.assignClassStudent
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddStudents);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "g6JL":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/d01d2649c1dac12e6e7579b45c2689d4.svg";

/***/ }),

/***/ "gMoa":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/ad51f89999f3d9de409a1848e6a45651.svg";

/***/ }),

/***/ "hB8d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = __webpack_require__("Bl3B");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _lodash = __webpack_require__("M4fF");

var _ico_more = __webpack_require__("c6zo");

var _ico_more2 = _interopRequireDefault(_ico_more);

var _ico_actions_certs = __webpack_require__("SAlD");

var _ico_actions_certs2 = _interopRequireDefault(_ico_actions_certs);

var _icon_classes = __webpack_require__("WCb1");

var _icon_classes2 = _interopRequireDefault(_icon_classes);

var _ico_move_copy = __webpack_require__("5opF");

var _ico_move_copy2 = _interopRequireDefault(_ico_move_copy);

var _ico_cards = __webpack_require__("zDW0");

var _ico_cards2 = _interopRequireDefault(_ico_cards);

var _ico_pencil = __webpack_require__("/T4H");

var _ico_pencil2 = _interopRequireDefault(_ico_pencil);

var _ico_action_excel = __webpack_require__("gMoa");

var _ico_action_excel2 = _interopRequireDefault(_ico_action_excel);

var _ico_groups_expand = __webpack_require__("12dE");

var _ico_groups_expand2 = _interopRequireDefault(_ico_groups_expand);

var _ico_groups_minimise = __webpack_require__("nEbz");

var _ico_groups_minimise2 = _interopRequireDefault(_ico_groups_minimise);

var _ico_icon_video = __webpack_require__("3lbZ");

var _ico_icon_video2 = _interopRequireDefault(_ico_icon_video);

var _ico_maximise_dark = __webpack_require__("d2jJ");

var _ico_maximise_dark2 = _interopRequireDefault(_ico_maximise_dark);

var _ico_minimise_dark = __webpack_require__("xEM8");

var _ico_minimise_dark2 = _interopRequireDefault(_ico_minimise_dark);

var _ico_move = __webpack_require__("T7vb");

var _ico_move2 = _interopRequireDefault(_ico_move);

var _ico_move_arrow = __webpack_require__("87Sf");

var _ico_move_arrow2 = _interopRequireDefault(_ico_move_arrow);

var _ico_plus = __webpack_require__("1YY9");

var _ico_plus2 = _interopRequireDefault(_ico_plus);

var _ico_new = __webpack_require__("KOQ+");

var _ico_new2 = _interopRequireDefault(_ico_new);

var _ico_movecopy = __webpack_require__("oeDL");

var _ico_movecopy2 = _interopRequireDefault(_ico_movecopy);

var _ico_move_remove = __webpack_require__("T0He");

var _ico_move_remove2 = _interopRequireDefault(_ico_move_remove);

var _ico_sort_down = __webpack_require__("1yAK");

var _ico_sort_down2 = _interopRequireDefault(_ico_sort_down);

var _ico_sort_up = __webpack_require__("cDhN");

var _ico_sort_up2 = _interopRequireDefault(_ico_sort_up);

var _ico_three_essentials = __webpack_require__("g6JL");

var _ico_three_essentials2 = _interopRequireDefault(_ico_three_essentials);

var _ico_arrow = __webpack_require__("vXyf");

var _ico_arrow2 = _interopRequireDefault(_ico_arrow);

var _ico_manage_students = __webpack_require__("41oH");

var _ico_manage_students2 = _interopRequireDefault(_ico_manage_students);

var _ico_success = __webpack_require__("0WBn");

var _ico_success2 = _interopRequireDefault(_ico_success);

var _ico_groups = __webpack_require__("tpQ9");

var _ico_groups2 = _interopRequireDefault(_ico_groups);

var _ico_edit = __webpack_require__("fPvb");

var _ico_edit2 = _interopRequireDefault(_ico_edit);

var _ico_person = __webpack_require__("5/30");

var _ico_person2 = _interopRequireDefault(_ico_person);

var _ico_close = __webpack_require__("W3S+");

var _ico_close2 = _interopRequireDefault(_ico_close);

var _ico_lightning_bolt = __webpack_require__("uPEL");

var _ico_lightning_bolt2 = _interopRequireDefault(_ico_lightning_bolt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Can't be just 'new'
var assets = {
    actions: _ico_more2.default,
    certificates: _ico_actions_certs2.default,
    plus: _ico_plus2.default,
    classes: _icon_classes2.default,
    copy: _ico_move_copy2.default,
    download: _ico_cards2.default,
    edit: _ico_pencil2.default,
    excel: _ico_action_excel2.default,
    groupmaximise: _ico_groups_expand2.default,
    groupminimise: _ico_groups_minimise2.default,
    infocircle: _ico_icon_video2.default,
    maximise: _ico_maximise_dark2.default,
    minimise: _ico_minimise_dark2.default,
    movedouble: _ico_move2.default,
    moveright: _ico_move_arrow2.default,
    newIcon: _ico_new2.default,
    movecopy: _ico_movecopy2.default,
    remove: _ico_move_remove2.default,
    sortdown: _ico_sort_down2.default,
    sortup: _ico_sort_up2.default,
    arrow: _ico_arrow2.default,
    threeEssentials: _ico_three_essentials2.default,
    manageStudents: _ico_manage_students2.default,
    successIcon: _ico_success2.default,
    groupIcon: _ico_groups2.default,
    editIcon: _ico_edit2.default,
    personIcon: _ico_person2.default,
    closeIcon: _ico_close2.default,
    lightningBoltIcon: _ico_lightning_bolt2.default
};
var ASSET_NAMES = (0, _lodash.keys)(assets);

var ImageAsset = function ImageAsset(_ref) {
    var parentTitle = _ref.parentTitle,
        parentClass = _ref.parentClass,
        type = _ref.type;

    var asset = '';
    var svgSrc = assets[type];
    switch (type) {
        default:
            if (svgSrc) {
                asset = _react2.default.createElement(_reactInlinesvg2.default, { cacheGetRequests: true, src: svgSrc });
            }
    }
    return _react2.default.createElement(
        'span',
        { title: parentTitle, className: '' + (parentClass || 'image-asset') },
        asset
    );
};

ImageAsset.propTypes = {
    parentTitle: _propTypes2.default.string,
    parentClass: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(ASSET_NAMES).isRequired
};

exports.default = ImageAsset;

/***/ }),

/***/ "hI0V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.COPY_VALUE = exports.MOVE_VALUE = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Components


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _linguiCdn = __webpack_require__("siuH");

var _checkbox = __webpack_require__("0yfC");

var _checkbox2 = _interopRequireDefault(_checkbox);

var _radioButton = __webpack_require__("EUcZ");

var _radioButton2 = _interopRequireDefault(_radioButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MOVE_VALUE = exports.MOVE_VALUE = 'move';
var COPY_VALUE = exports.COPY_VALUE = 'copy';

function AddStudentsListBody(props) {
    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;
    // Props


    var userId = props.userId,
        index = props.index,
        fullName = props.fullName,
        groupName = props.groupName,
        classValue = props.classValue,
        isVisible = props.isVisible,
        isDisabled = props.isDisabled,
        checkboxHandler = props.checkboxHandler,
        isSelected = props.isSelected,
        moveCopyHandler = props.moveCopyHandler;

    var _useState = (0, _react.useState)(MOVE_VALUE),
        _useState2 = _slicedToArray(_useState, 2),
        actionType = _useState2[0],
        setActionType = _useState2[1];

    var selectIndividualStudent = function selectIndividualStudent() {
        var localActionType = !isSelected ? actionType : undefined;
        checkboxHandler(userId, localActionType);
    };
    var radioButtonHandler = function radioButtonHandler(e) {
        var moveValue = e.target.value;
        setActionType(moveValue);
        moveCopyHandler(userId, moveValue);
    };
    var listOfButtons = [{ name: i18n._( /*i18n*/{
            id: 'Add Modal - actions move'
        }), value: MOVE_VALUE }, { name: i18n._( /*i18n*/{
            id: 'Add Modal - actions copy'
        }), value: COPY_VALUE }];

    // Reset actionType value to be back to Move
    (0, _react.useEffect)(function () {
        setActionType(MOVE_VALUE);
    }, [isSelected]);

    var className = classValue.map(function (item) {
        var classId = 'classes'.concat(item);
        classId = classId.concat(userId);
        return _react2.default.createElement(
            'li',
            { key: classId },
            item
        );
    });

    var groupId = 0;
    var groupNameValue = groupName.map(function (item) {
        groupId += 1;
        return _react2.default.createElement(
            'li',
            { key: groupId },
            item
        );
    });

    return isVisible ? _react2.default.createElement(
        'tr',
        {
            className: 'table__row ' + (isSelected ? 'table__row--selected' : '') + ' ' + (isDisabled ? 'table__row--disabled' : '') },
        _react2.default.createElement(
            'td',
            { className: 'table__cell table__cell--checkbox' },
            _react2.default.createElement(_checkbox2.default, {
                uid: 'a-' + userId,
                isChecked: isSelected,
                isDisabled: isDisabled,
                callback: selectIndividualStudent,
                labelText: fullName + '-' + index,
                inputType: _checkbox.LABEL_STYLES.hidden })
        ),
        _react2.default.createElement(
            'td',
            { className: 'table__cell table__cell--add-student' },
            _react2.default.createElement(
                'span',
                { title: fullName, className: 'text-ellipsis' },
                fullName
            )
        ),
        _react2.default.createElement(
            'td',
            { className: 'table__cell' },
            _react2.default.createElement(
                'ul',
                null,
                className
            )
        ),
        _react2.default.createElement(
            'td',
            { className: 'table__cell' },
            _react2.default.createElement(
                'ul',
                null,
                groupNameValue
            )
        ),
        _react2.default.createElement(
            'td',
            { className: 'table__cell' },
            _react2.default.createElement(
                'span',
                { className: 'sr-only', id: 'add-action-' + userId },
                _react2.default.createElement(_react3.Trans, { id: 'Add Modal - action to perform for - {fullName}', defaults: '1 {fullName}',
                    values: {
                        fullName: fullName
                    }
                })
            ),
            _react2.default.createElement(_radioButton2.default, {
                id: 'add-actions-' + userId,
                groupName: 'add-actions-' + fullName + '-' + userId + '-' + isSelected,
                ariaProps: {
                    'aria-describedby': 'add-action-' + userId
                },
                value: actionType,
                isDisabled: !isSelected,
                listOfButtons: listOfButtons,
                changeHandler: radioButtonHandler
            })
        )
    ) : _react2.default.createElement('tr', null);
}

AddStudentsListBody.propTypes = {
    userId: _propTypes2.default.number,
    index: _propTypes2.default.number,
    fullName: _propTypes2.default.string,
    groupName: _propTypes2.default.array,
    classValue: _propTypes2.default.array,
    moveCopyHandler: _propTypes2.default.func,
    checkboxHandler: _propTypes2.default.func,
    isVisible: _propTypes2.default.bool,
    isSelected: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool
};

exports.default = AddStudentsListBody;

/***/ }),

/***/ "hIya":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".form {\n  line-height: 2.5em;\n  font-size: 12px;\n  font-size: 0.75rem; }\n  .form--naked {\n    display: inline;\n    line-height: inherit;\n    font-size: inherit; }\n  .form__row {\n    margin-top: 10px; }\n  .form__row--buttons {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      gap: 16px;\n      margin-top: 16px; }\n  .form__row--buttons .button {\n        margin: 0 8px;\n        margin: 0 0.5rem; }\n  .form__message {\n    margin: 16px 0;\n    margin: 1rem 0;\n    text-align: center;\n    font-size: 12px;\n    font-size: 0.75rem; }\n  .form__message--label {\n      margin-right: 8px;\n      margin-right: 0.5rem; }\n  .form__note {\n    font-weight: 600; }\n  .form__error-message {\n    line-height: 1.5em;\n    font-size: 12px;\n    font-size: 0.75rem;\n    color: #bb1616; }\n  .form__error-message--bottom {\n      text-align: center; }\n  .form__label {\n    display: block;\n    font-family: Poppins, sans-serif;\n    font-weight: 500 !important;\n    color: #000; }\n  .form__input {\n    border: 1px solid #c2c2c2;\n    border-radius: 4px;\n    width: calc(100% - 0.37rem - 2px);\n    padding: 2.96px;\n    padding: 0.185rem;\n    font-size: 12px;\n    font-size: 0.75rem; }\n  .form__input:not(:disabled):hover, .form__input:not(:disabled):focus {\n      border-color: #000;\n      outline: none; }\n", ""]);
// Exports
exports.locals = {
	"form": "form",
	"form--naked": "form--naked",
	"form__row": "form__row",
	"form__row--buttons": "form__row--buttons",
	"button": "button",
	"form__message": "form__message",
	"form__message--label": "form__message--label",
	"form__note": "form__note",
	"form__error-message": "form__error-message",
	"form__error-message--bottom": "form__error-message--bottom",
	"form__label": "form__label",
	"form__input": "form__input"
};
module.exports = exports;


/***/ }),

/***/ "hnRf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* global document */


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useOutsideClick(refs, onClickOutside) {
    var _React$useState = _react2.default.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        isActive = _React$useState2[0],
        setActive = _React$useState2[1];

    var isOutside = _react2.default.useCallback(function (e) {
        var test = refs.map(function (ref) {
            // For busy-indicator in particular since it's an overlay bypass this and return false
            if (e.target && e.target.className === 'busy-indicator') {
                return false;
            }

            return ref.current !== null && !ref.current.contains(e.target);
        });

        return test.every(Boolean);
    }, [refs]);

    var mousedown = _react2.default.useCallback(function (e) {
        if (isOutside(e)) {
            setActive(true);
            onClickOutside(e);
        }
    }, [isOutside, onClickOutside]);

    var mouseup = _react2.default.useCallback(function (e) {
        if (isOutside(e)) {
            setActive(false);
        }
    }, [isOutside]);

    _react2.default.useEffect(function () {
        document.addEventListener('mousedown', mousedown);
        document.addEventListener('mouseup', mouseup);

        return function () {
            document.removeEventListener('mousedown', mousedown);
            document.removeEventListener('mouseup', mouseup);
        };
    }, [refs, onClickOutside]);

    return [isActive];
}

exports.default = useOutsideClick;

/***/ }),

/***/ "iV3T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-console */

var _resource = __webpack_require__("P7H2");

var _resource2 = _interopRequireDefault(_resource);

var _localResourceConfig = __webpack_require__("2z6x");

var _localResourceConfig2 = _interopRequireDefault(_localResourceConfig);

var _appConfig = __webpack_require__("N5/L");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasicResources = function () {
    function BasicResources() {
        _classCallCheck(this, BasicResources);
    }

    _createClass(BasicResources, null, [{
        key: 'initialise',
        value: function initialise(envName, credentials) {
            var env = (0, _resource2.default)({
                name: envName,
                application: _appConfig.appName,
                // eslint-disable-next-line no-underscore-dangle
                config: window._env_
            });
            var location = window.location;
            var runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);

            if (runningOnDeveloperMachine) {
                if (envName === 'local') {
                    // This implies we'll be hitting the mock REST server,
                    // which does not require authentication.

                    env.bypassAuthentication();
                    env.setConfiguration(_localResourceConfig2.default);
                } else if (credentials.authToken) {
                    env.authToken = credentials.authToken;
                } else {
                    env.setCredentials(credentials.username, credentials.password);
                }
            } else if (credentials.authToken) {
                env.authToken = credentials.authToken;
            } else if (credentials.username && credentials.password) {
                env.username = credentials.username;
                env.password = credentials.password;
            } else {
                // The caller should have provided a valid set of credentials, so
                // hopefully this will never happen.

                console.log('BasicResources.initialise() - to execute, we need either an authToken or' + ' a username/password pair.  The credentials object that was provided does not' + ' contain either.  So, expect things to fail badly :-(.');
            }

            return env;
        }
    }]);

    return BasicResources;
}();

exports.default = BasicResources;

/***/ }),

/***/ "jU6I":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/19818a114e5605dd90e12504b0d14849.svg";

/***/ }),

/***/ "kpGz":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/76e91e4c1a2bd3cd89e1f2a090b3281c.svg";

/***/ }),

/***/ "l3NX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Components


// Helpers


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _linguiCdn = __webpack_require__("siuH");

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _form = __webpack_require__("oS56");

var _form2 = _interopRequireDefault(_form);

var _threeEssentailsButton = __webpack_require__("Lgqb");

var _threeEssentailsButton2 = _interopRequireDefault(_threeEssentailsButton);

var _genericModal = __webpack_require__("51N/");

var _genericModal2 = _interopRequireDefault(_genericModal);

var _enums = __webpack_require__("royT");

var _utils = __webpack_require__("6QRH");

var _useIsOneRosterActivatedSchool = __webpack_require__("rSj7");

var _useIsOneRosterActivatedSchool2 = _interopRequireDefault(_useIsOneRosterActivatedSchool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function StudentPassword(_ref) {
    var _this = this;

    var id = _ref.id,
        userId = _ref.userId,
        password = _ref.password,
        changePassword = _ref.changePassword,
        shownPassword = _ref.shownPassword,
        setShownPassword = _ref.setShownPassword,
        oneRosterUserId = _ref.oneRosterUserId;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var defaultPasswordText = '********';
    var isOneRosterActivatedSchool = (0, _useIsOneRosterActivatedSchool2.default)();

    // States

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        showText = _useState2[0],
        setShowText = _useState2[1];

    var _useState3 = (0, _react.useState)(true),
        _useState4 = _slicedToArray(_useState3, 2),
        showEditButton = _useState4[0],
        setShowEditButton = _useState4[1];

    var _useState5 = (0, _react.useState)(password),
        _useState6 = _slicedToArray(_useState5, 2),
        updatedPassword = _useState6[0],
        setUpdatedPassword = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        _useState8 = _slicedToArray(_useState7, 2),
        disableSaveButton = _useState8[0],
        setDisableSaveButton = _useState8[1];

    var _useState9 = (0, _react.useState)(''),
        _useState10 = _slicedToArray(_useState9, 2),
        errorMessage = _useState10[0],
        setErrorMessage = _useState10[1];

    // Handler


    var showPasswordHandler = function showPasswordHandler() {
        setShowText(function (prevShowText) {
            return !prevShowText;
        });
        setShowEditButton(true);
        setShownPassword(showText ? '' : id);
    };
    // This is to reset showText when password is hidden through another line. BA 2020-04-16
    (0, _react.useEffect)(function () {
        setShowText(shownPassword === id);
    }, [shownPassword]);

    var saveHandler = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
            var newPassword, value;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            // Prevent redirect from the default behaviour of a form
                            e.preventDefault();
                            newPassword = updatedPassword.trim();
                            _context.next = 4;
                            return changePassword({
                                userProfileId: userId,
                                newPassword: newPassword
                            });

                        case 4:
                            value = _context.sent;


                            if (value === true) {
                                setUpdatedPassword(newPassword);
                                setShowEditButton(function (prevShowEditButton) {
                                    return !prevShowEditButton;
                                });
                            } else if (value && value.message) {
                                setErrorMessage((0, _utils.getCorrectErrorMessage)(value, i18n));
                            } else {
                                // Covering generic, unexpected error
                                setErrorMessage('error');
                            }

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function saveHandler(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    var showEditButtonHandler = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!showEditButton) {
                                _context2.next = 5;
                                break;
                            }

                            setShowEditButton(function (prevShowEditButton) {
                                return !prevShowEditButton;
                            });
                            setUpdatedPassword(password);
                            _context2.next = 7;
                            break;

                        case 5:
                            _context2.next = 7;
                            return saveHandler(e);

                        case 7:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function showEditButtonHandler(_x2) {
            return _ref3.apply(this, arguments);
        };
    }();

    var passwordOnChangeHandler = function passwordOnChangeHandler(e) {
        var myInput = e.target;
        var myValue = myInput.value;
        setUpdatedPassword(myValue);
        setDisableSaveButton(myValue.length === 0);
    };

    var closeErrorModal = function closeErrorModal() {
        setErrorMessage('');
    };

    var onEditPasswordClickHandler = function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return _resources2.default.getConfigurationItem('THREE_ESSENTIALS_MANAGE_STUDENTS').then(function (manageStudentsUrl) {
                                window.open(manageStudentsUrl + '/uid/' + oneRosterUserId + '/edit');
                            });

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this);
        }));

        return function onEditPasswordClickHandler() {
            return _ref4.apply(this, arguments);
        };
    }();

    // Components
    var passwordHidden = _react2.default.createElement(
        _react.Fragment,
        null,
        defaultPasswordText,
        _react2.default.createElement(
            'div',
            { className: 'table__buttons-container' },
            _react2.default.createElement(_button2.default, {
                buttonStyle: _button.BUTTON_STYLES.iconBackground,
                importedClasses: 'button--password button--eye-hidden',
                callback: showPasswordHandler,
                ariaProps: {
                    role: 'switch',
                    'aria-label': i18n._( /*i18n*/{
                        id: 'Password - Show password'
                    }),
                    'aria-checked': showText
                } })
        )
    );

    var buttonEyeVisible = _react2.default.createElement(_button2.default, {
        buttonStyle: _button.BUTTON_STYLES.iconBackground,
        importedClasses: 'button--password button--eye-visible',
        callback: showPasswordHandler,
        ariaProps: {
            role: 'switch',
            'aria-label': i18n._( /*i18n*/{
                id: 'Password - Show password'
            }),
            'aria-checked': showText
        } });

    var passwordReadable = _react2.default.createElement(
        _react.Fragment,
        null,
        password,
        _react2.default.createElement(
            'div',
            { className: 'table__buttons-container table__buttons-container--center' },
            !isOneRosterActivatedSchool ? _react2.default.createElement(_button2.default, {
                buttonStyle: _button.BUTTON_STYLES.iconBackground,
                importedClasses: 'button--password button--edit',
                isBtnDisabled: !showEditButton && disableSaveButton,
                callback: showEditButtonHandler,
                buttonType: 'button',
                ariaProps: {
                    'aria-label': i18n._( /*i18n*/{
                        id: 'Password - Edit password'
                    })
                } }) : _react2.default.createElement(_threeEssentailsButton2.default, {
                clickHandler: onEditPasswordClickHandler,
                title: i18n._( /*i18n*/{
                    id: 'Password - Edit'
                }),
                show3EIcon: false,
                buttonClassName: 'edit_password'
            }),
            buttonEyeVisible
        )
    );

    var passwordEditable = _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            _form2.default,
            { formHandler: saveHandler, parentClasses: 'form--naked', id: 'form-password-' + id },
            _react2.default.createElement(
                'label',
                { htmlFor: 'password-' + id },
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    _react2.default.createElement(_react3.Trans, { id: 'Password - Password to edit' }),
                    id
                )
            ),
            isOneRosterActivatedSchool ? _react2.default.createElement(
                'label',
                { htmlFor: 'password-' + id },
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    updatedPassword
                )
            ) : _react2.default.createElement('input', {
                type: 'text',
                id: 'password-' + id,
                value: updatedPassword
                // eslint-disable-next-line jsx-a11y/no-autofocus
                , autoFocus: true,
                className: 'form__input form__input--password',
                maxLength: _enums.CONFIG_VARS.passwordMaxLength,
                onChange: passwordOnChangeHandler
            })
        ),
        _react2.default.createElement(
            'div',
            { className: 'table__buttons-container' },
            _react2.default.createElement(_button2.default, {
                buttonStyle: _button.BUTTON_STYLES.iconBackground,
                importedClasses: 'button--password button--tick',
                isBtnDisabled: !showEditButton && disableSaveButton,
                callback: showEditButtonHandler,
                buttonType: 'submit',
                ariaProps: {
                    'aria-label': i18n._( /*i18n*/{
                        id: 'Password - Save password'
                    })
                } }),
            buttonEyeVisible
        )
    );

    var passwordVisible = showEditButton ? passwordReadable : passwordEditable;

    return _react2.default.createElement(
        _react.Fragment,
        null,
        showText && (shownPassword === '' || shownPassword === id) ? passwordVisible : passwordHidden,
        errorMessage !== '' && _react2.default.createElement(
            _genericModal2.default,
            {
                title: _react2.default.createElement(_react3.Trans, { id: 'Error Message - Title' }),
                type: _genericModal.MODAL_TYPE.floating,
                closeHandler: closeErrorModal },
            _react2.default.createElement(
                'p',
                { className: 'modal__text modal__text--error' },
                _react2.default.createElement(_react3.Trans, { id: 'Error Message - Unable to proceed' })
            ),
            _react2.default.createElement(
                'div',
                { className: 'form__row form__row--buttons' },
                _react2.default.createElement(_button2.default, {
                    buttonStyle: _button.BUTTON_STYLES.text,
                    callback: closeErrorModal,
                    visibleText: _react2.default.createElement(_react3.Trans, { id: 'Button - Ok' }) })
            )
        )
    );
}

StudentPassword.propTypes = {
    id: _propTypes2.default.string,
    userId: _propTypes2.default.number.isRequired,
    password: _propTypes2.default.string,
    changePassword: _propTypes2.default.func.isRequired,
    shownPassword: _propTypes2.default.string,
    setShownPassword: _propTypes2.default.func,
    oneRosterUserId: _propTypes2.default.string
};

exports.default = StudentPassword;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "mkq6":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("oAR/");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "mrq4":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".three_essentials_button {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 48px;\n  border-radius: 40px;\n  border: none;\n  padding: 10px 16px;\n  gap: 12px;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  background: linear-gradient(104deg, #00abe8 -2.03%, #007acc 43.7%, #0063a7 105.46%);\n  width: 290px;\n  max-width: -webkit-fit-content;\n  max-width: -moz-fit-content;\n  max-width: fit-content;\n  color: #fff;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 28px;\n  margin-left: 14px; }\n  .three_essentials_button.modal_manage {\n    margin-left: 0; }\n  .three_essentials_button.edit_class_name {\n    height: 32px;\n    min-width: 167px;\n    font-size: 14px;\n    line-height: 20px;\n    padding: 10px 12px;\n    gap: 8px;\n    text-transform: capitalize; }\n  .three_essentials_button.edit_group_name {\n    height: 32px;\n    min-width: 186px;\n    font-size: 14px;\n    line-height: 20px;\n    padding: 10px 12px;\n    gap: 8px;\n    text-transform: capitalize; }\n  .three_essentials_button.edit_group_name_autoselect {\n    border-radius: 12px;\n    border: 1px solid #4dc4ef;\n    background: #fff;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 8px 16px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 8px;\n    -ms-flex-item-align: stretch;\n        align-self: stretch;\n    height: 40px;\n    width: 100%;\n    max-width: none;\n    margin: 0;\n    color: #0063a7;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; }\n  .three_essentials_button.edit_group_name_autoselect:hover {\n      background: #ecf9fe; }\n  .three_essentials_button.edit_password {\n    height: 26px;\n    width: 78px;\n    min-width: inherit;\n    padding: 3px 12px;\n    margin-left: 0;\n    line-height: 20px;\n    font-size: 14px;\n    gap: 8px; }\n  .three_essentials_button.edit_password .three_essentials_button__icon {\n      margin-top: 0;\n      width: 20px;\n      height: 20px; }\n  .three_essentials_button.edit_password .three_essentials_button__icon svg {\n        width: 100%;\n        height: 100%; }\n  .three_essentials_button.footer-download {\n    background: #374e60;\n    height: 30px;\n    font-size: 12px;\n    line-height: 20px;\n    padding: 5px 16px;\n    gap: 5px; }\n  .three_essentials_button.footer-download .three_essentials_button__3e-icon .isvg.loaded svg {\n      width: 70px;\n      height: 24px; }\n  .three_essentials_button__icon {\n    margin-top: 5px; }\n  .three_essentials_button:hover {\n    background: linear-gradient(102.49deg, #007acc 0%, #014b8b 100%); }\n  .three_essentials_button:active {\n    background: linear-gradient(102.49deg, #014b8b 0%, #014b8b 100%); }\n", ""]);
// Exports
exports.locals = {
	"three_essentials_button": "three_essentials_button",
	"modal_manage": "modal_manage",
	"edit_class_name": "edit_class_name",
	"edit_group_name": "edit_group_name",
	"edit_group_name_autoselect": "edit_group_name_autoselect",
	"edit_password": "edit_password",
	"three_essentials_button__icon": "three_essentials_button__icon",
	"footer-download": "footer-download",
	"three_essentials_button__3e-icon": "three_essentials_button__3e-icon",
	"isvg": "isvg",
	"loaded": "loaded"
};
module.exports = exports;


/***/ }),

/***/ "nEbz":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/6fd8eaf0006500c101efc8fb1743b0e2.svg";

/***/ }),

/***/ "nIya":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("v4dI");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "nPBh":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/d55139b0100732da65d78f8ad9eb7718.svg";

/***/ }),

/***/ "nXVl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _genericModal = __webpack_require__("51N/");

var _genericModal2 = _interopRequireDefault(_genericModal);

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
function StudentChangeGroup(_ref) {
    var closeHandler = _ref.closeHandler,
        applyHandler = _ref.applyHandler,
        changeGroupErrorMessage = _ref.changeGroupErrorMessage,
        productId = _ref.productId;

    productId = productId || 1;
    return _react2.default.createElement(
        _genericModal2.default,
        {
            title: _react2.default.createElement(_react3.Trans, { id: 'Change Group - title' }),
            type: _genericModal.MODAL_TYPE.floating,
            parentClasses: 'modal--small',
            closeHandler: closeHandler },
        _react2.default.createElement(_react3.Trans, { id: 'Change Group - message - product ' + productId, defaults: '<0><1>1</1> 0</0>',
            components: [_react2.default.createElement('p', { className: 'modal__message' }), _react2.default.createElement('strong', null)]
        }),
        _react2.default.createElement(
            'div',
            { className: 'form__row form__row--buttons' },
            _react2.default.createElement(_button2.default, {
                buttonStyle: _button.BUTTON_STYLES.text,
                callback: applyHandler,
                visibleText: _react2.default.createElement(_react3.Trans, { id: 'Change Group - button' })
            })
        ),
        changeGroupErrorMessage ? _react2.default.createElement(
            'div',
            { className: 'form__row' },
            _react2.default.createElement(
                'p',
                { className: 'form__error-message form__error-message--bottom' },
                changeGroupErrorMessage
            )
        ) : ''
    );
}

StudentChangeGroup.propTypes = {
    closeHandler: _propTypes2.default.func,
    applyHandler: _propTypes2.default.func,
    changeGroupErrorMessage: _propTypes2.default.string,
    productId: _propTypes2.default.string
};

exports.default = StudentChangeGroup;

/***/ }),

/***/ "nhla":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("Z88W");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "o3FG":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".modal {\n  position: absolute;\n  z-index: 1;\n  background-color: #fff;\n  padding: 40px;\n  border: 2px solid #f7d064;\n  border-radius: 16px;\n  -webkit-box-shadow: 0 2px 10px -3px rgba(0, 0, 0, .2);\n          box-shadow: 0 2px 10px -3px rgba(0, 0, 0, .2); }\n  .modal__overlay {\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, .5); }\n  .modal--floating {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    left: 50%;\n    top: 50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    width: 750px;\n    max-height: 65vh; }\n  .modal--floating::before, .modal--floating::after {\n      display: none; }\n  .modal--floating .modal__title {\n      margin-bottom: 16px;\n      margin-bottom: 1rem; }\n  .modal--floating .modal__text {\n      margin-bottom: 1em;\n      text-align: center; }\n  .modal--floating .form__row--buttons {\n      margin-top: 24px;\n      margin-top: 1.5rem; }\n  .modal--small {\n    width: 480px;\n    width: 30rem; }\n  .modal__header {\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start; }\n  .modal__title {\n    line-height: 52px;\n    font-size: 40px;\n    font-weight: 400;\n    color: #0063a7; }\n  .modal__description {\n    line-height: 28px;\n    font-family: Poppins, sans-serif;\n    font-weight: 400 !important;\n    font-size: 20px;\n    font-weight: 400;\n    color: #5c6c7f;\n    margin-bottom: 48px; }\n  .modal__button-container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    width: 100%; }\n  .modal__button-container__button-style {\n      margin-right: 24px;\n      min-width: 180px; }\n  .modal__variable-height {\n    -ms-flex-negative: 1;\n        flex-shrink: 1;\n    /* stylelint-disable */\n    /* IE11 doesn't support the short-hand property \"flex\" properly, 40vh is a semi-magic number. BA 2020-02-25 */\n    -webkit-box-flex: 0;\n        -ms-flex-positive: 0;\n            flex-grow: 0;\n    -ms-flex-preferred-size: 40vh;\n        flex-basis: 40vh;\n    /* stylelint-enable */\n    /* This is what other browsers apply, basically leaving them do the math. BA 2020-02-25 */\n    overflow-y: auto;\n    padding-bottom: 1px;\n    border-top: 1px solid #c2c2c2;\n    border-bottom: 1px solid #c2c2c2; }\n  @supports (flex-basis: calc(70vh - 5px)) {\n      .modal__variable-height {\n        -ms-flex-preferred-size: auto;\n            flex-basis: auto; } }\n  .modal__message {\n    font-size: 12px;\n    font-size: 0.75rem;\n    text-align: center; }\n  .modal__text--error {\n    color: #bb1616; }\n", ""]);
// Exports
exports.locals = {
	"modal": "modal",
	"modal__overlay": "modal__overlay",
	"modal--floating": "modal--floating",
	"modal__title": "modal__title",
	"modal__text": "modal__text",
	"form__row--buttons": "form__row--buttons",
	"modal--small": "modal--small",
	"modal__header": "modal__header",
	"modal__description": "modal__description",
	"modal__button-container": "modal__button-container",
	"modal__button-container__button-style": "modal__button-container__button-style",
	"modal__variable-height": "modal__variable-height",
	"modal__message": "modal__message",
	"modal__text--error": "modal__text--error"
};
module.exports = exports;


/***/ }),

/***/ "oAR/":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".select--classes {\n  margin: 0 8px;\n  margin: 0 0.5rem;\n  max-width: 180px;\n  min-height: 30px;\n  min-height: 1.875rem; }\n\n.classes__button-container {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: relative; }\n\n.classes__button-container .modal {\n    top: calc(100% + 0.5rem);\n    -webkit-transform: translateX(-50%);\n            transform: translateX(-50%);\n    width: 208px;\n    width: 13rem; }\n\n.classes__button-container .modal::before {\n      left: calc(50% - 5px); }\n\n.classes__button-container .modal::after {\n      left: calc(50% - 7px); }\n", ""]);
// Exports
exports.locals = {
	"select--classes": "select--classes",
	"classes__button-container": "classes__button-container",
	"modal": "modal"
};
module.exports = exports;


/***/ }),

/***/ "oHFR":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/4ce2ee74b444e6c1dd7996ffe5c4acb6.svg";

/***/ }),

/***/ "oS56":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("YkNq");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Form(_ref) {
    var formHandler = _ref.formHandler,
        parentClasses = _ref.parentClasses,
        children = _ref.children;

    var formClasses = 'form ' + parentClasses;
    return _react2.default.createElement(
        'form',
        { className: formClasses, onSubmit: formHandler },
        children
    );
}

// Styles


Form.propTypes = {
    formHandler: _propTypes2.default.func,
    parentClasses: _propTypes2.default.string,
    children: _propTypes2.default.any
};

exports.default = Form;

/***/ }),

/***/ "oeDL":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/5c8c28308eedac758391483f86ea5c78.svg";

/***/ }),

/***/ "onbX":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("BUg0");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "otLx":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/3ac3d0c4fef656830851d20d43787b8e.svg";

/***/ }),

/***/ "qRV2":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("Lh61");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "rSj7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _querystring = __webpack_require__("1nuA");

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useIsOneRosterActivatedSchool() {
    var location = window.location;
    var queryParams = location.search;

    var query = queryParams.replace('?', '');
    var params = _querystring2.default.parse(query);

    return params.isOneRosterActivatedSchool === 'true';
}

exports.default = useIsOneRosterActivatedSchool;

/***/ }),

/***/ "royT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * This is required to edit a group as the students may have pending tasks...
 * @type {{0: string, 1: string}}
 */
var UPDATE_COURSE_TYPES = exports.UPDATE_COURSE_TYPES = {
    0: 'CancelTask',
    1: 'CarryOver'
};

// These values are to persist query params throughout the life of the application
var CONSERVE_PARAMS = exports.CONSERVE_PARAMS = ['username', 'password', 'userToken', 'env', 'productId', 'authToken'];

// All groups/Show all in the groups section has a GroupId of 0
var ALL_GROUP_ID = exports.ALL_GROUP_ID = 0;
var DEFAULT_GROUP_ID = exports.DEFAULT_GROUP_ID = 1;

var CONFIG_VARS = exports.CONFIG_VARS = {
    classNameMaxLength: 200,
    groupNameMaxLength: 200, // TODO: find the exact limitation (ask back-end). BA 2020-01-06
    passwordMaxLength: 25
};

// ERROR CODES
var ERROR_CODES = exports.ERROR_CODES = {
    UnexpectedResponseContent: 'UnexpectedResponseContent'
};

var MAX_GROUP_LENGTH = exports.MAX_GROUP_LENGTH = 12;

// Variables to decide which is the new group and the default group
var DEFAULT_GROUP_MODAL_ID = exports.DEFAULT_GROUP_MODAL_ID = -2;
var NEW_GROUP_MODAL_ID = exports.NEW_GROUP_MODAL_ID = -1;
var MAX_GROUP_NAME_DISPLAY = exports.MAX_GROUP_NAME_DISPLAY = 36;
var ADMIN_COURSE_AUTHOR = exports.ADMIN_COURSE_AUTHOR = 'Mathletics';

// ProductIds
var PRODUCT_IDS = exports.PRODUCT_IDS = {
    Mathletics: 1,
    Spellodrome: 3,
    Phonics: 8,
    Mathletica: 9,
    Readiwriter: 10
};
var DEFAULT_PRODUCT_ID = exports.DEFAULT_PRODUCT_ID = 1;

// Key Codes/Name
var ESCAPE_KEY_CODE = exports.ESCAPE_KEY_CODE = 27;
var ESCAPE_KEY_NAME = exports.ESCAPE_KEY_NAME = 'Escape';

// Action Type for students
var actionTypeIds = exports.actionTypeIds = {
    copy: 1,
    move: 2,
    remove: 3
};

// Default Id for 'Select Class' dropdown
var INVALID_CLASSNAME = exports.INVALID_CLASSNAME = '-1';

var DEFAULT_UPF_COURSE_ID = exports.DEFAULT_UPF_COURSE_ID = 0;

/***/ }),

/***/ "sFKd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HIDE_TOAST = exports.SHOW_TOAST = undefined;

var _utils = __webpack_require__("6QRH");

var SHOW_TOAST = exports.SHOW_TOAST = 'SHOW_TOAST';
var HIDE_TOAST = exports.HIDE_TOAST = 'HIDE_TOAST';

var showToast = function showToast(_ref) {
    var _ref$variant = _ref.variant,
        variant = _ref$variant === undefined ? 'success' : _ref$variant,
        _ref$messageId = _ref.messageId,
        messageId = _ref$messageId === undefined ? '' : _ref$messageId,
        _ref$values = _ref.values,
        values = _ref$values === undefined ? {} : _ref$values,
        _ref$autoCloseMs = _ref.autoCloseMs,
        autoCloseMs = _ref$autoCloseMs === undefined ? 6000 : _ref$autoCloseMs;
    return (0, _utils.actionCreator)(SHOW_TOAST, {
        id: Date.now() + '_' + Math.random(),
        variant: variant,
        messageId: messageId,
        values: values,
        autoCloseMs: autoCloseMs
    });
};

var hideToast = function hideToast(id) {
    return (0, _utils.actionCreator)(HIDE_TOAST, { id: id });
};

exports.default = {
    showToast: showToast,
    hideToast: hideToast
};

/***/ }),

/***/ "shXg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__("GiK3");

function useKeyPress(_ref) {
    var targetKeyName = _ref.targetKeyName,
        targetKeyCode = _ref.targetKeyCode;

    // TODO Possibly  hook to shared components for all games to use

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        keyPressed = _useState2[0],
        setKeyPressed = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        eventListenerAdded = _useState4[0],
        setEventListenerAdded = _useState4[1];

    (0, _react.useEffect)(function () {
        // use keyCode as fallback for Safari 9
        // Set local state 'keyPressed' to true when target key is pressed
        var downHandler = function downHandler(_ref2) {
            var key = _ref2.key,
                keyCode = _ref2.keyCode;

            if (key && key === targetKeyName || keyCode && keyCode === targetKeyCode) {
                setKeyPressed(true);
            }
        };

        // Set local state 'keyPressed' to false when target key is released
        var upHandler = function upHandler(_ref3) {
            var key = _ref3.key,
                keyCode = _ref3.keyCode;

            if (key && key === targetKeyName || keyCode && keyCode === targetKeyCode) {
                setKeyPressed(false);
            }
        };

        // Add the event listeners only once
        if (!eventListenerAdded) {
            window.addEventListener('keydown', downHandler);
            window.addEventListener('keyup', upHandler);
            setEventListenerAdded(true);
        }

        // Remove event listeners when the component unmounts
        return function () {
            window.removeEventListener('keydown', downHandler);
            window.removeEventListener('keyup', upHandler);
        };
    }, [targetKeyName, targetKeyCode] // Hook will be executed if one of these two parameters change
    );

    return [keyPressed, setKeyPressed];
}

exports.default = useKeyPress;

/***/ }),

/***/ "tpQ9":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/1ebd2f269ba5f8bd210eb5da365a0a97.svg";

/***/ }),

/***/ "uPEL":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/71d183cc6ae20a3e5fc69388fe012b53.svg";

/***/ }),

/***/ "v4dI":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "/* React Core CSS */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block; }\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline; }\naudio:not([controls]) {\n  display: none;\n  height: 0; }\n[hidden],\ntemplate {\n  display: none; }\na {\n  background-color: transparent; }\na:active,\na:hover {\n  outline: 0; }\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted; }\nb,\nstrong {\n  font-weight: inherit; }\nb,\nstrong {\n  font-weight: bolder; }\ndfn {\n  font-style: italic; }\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0; }\nmark {\n  background-color: #ff0;\n  color: #000; }\nsmall {\n  font-size: 80%; }\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline; }\nsup {\n  top: -0.5em; }\nsub {\n  bottom: -0.25em; }\nimg {\n  border: 0; }\nsvg:not(:root) {\n  overflow: hidden; }\nfigure {\n  margin: 1em 40px; }\nhr {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  height: 0;\n  overflow: visible; }\npre {\n  overflow: auto; }\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace;\n  font-size: 1em; }\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit;\n  margin: 0; }\nbutton {\n  overflow: visible; }\nbutton,\nselect {\n  text-transform: none; }\nbutton,\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer; }\nbutton[disabled] {\n  cursor: default; }\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0; }\nbutton:-moz-focusring,\ninput:-moz-focusring {\n  outline: 1px dotted ButtonText; }\ninput {\n  line-height: normal; }\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0; }\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; }\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em; }\nlegend {\n  border: 0;\n  padding: 0; }\ntextarea {\n  overflow: auto; }\noptgroup {\n  font-weight: bold; }\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font-family: inherit;\n  vertical-align: baseline; }\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block; }\nol,\nul {\n  list-style: none; }\nblockquote,\nq {\n  quotes: none; }\nblockquote::before,\nblockquote::after,\nq::before,\nq::after {\n  content: '';\n  content: none; }\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\n/* latin-ext */\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: local(\"Poppins Regular\"), local(\"Poppins-Regular\"), url(https://fonts.gstatic.com/s/poppins/v5/F4YWuALHubF63LLQPw0rMfY6323mHUZFJMgTvxaG2iE.woff2) format(\"woff2\");\n  unicode-range: U+0100-024F, U+1E00-1EFF, U+20A0-20AB, U+20AD-20CF, U+2C60-2C7F, U+A720-A7FF; }\n/* latin */\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: local(\"Poppins Regular\"), local(\"Poppins-Regular\"), url(https://fonts.gstatic.com/s/poppins/v5/HLBysyo0MQBO_7E-DWLwzg.woff2) format(\"woff2\");\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215; }\n/* latin-ext */\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: local(\"Poppins Medium\"), local(\"Poppins-Medium\"), url(https://fonts.gstatic.com/s/poppins/v5/UGh2YG8gx86rRGiAZYIbVyEAvth_LlrfE80CYdSH47w.woff2) format(\"woff2\");\n  unicode-range: U+0100-024F, U+1E00-1EFF, U+20A0-20AB, U+20AD-20CF, U+2C60-2C7F, U+A720-A7FF; }\n/* latin */\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: local(\"Poppins Medium\"), local(\"Poppins-Medium\"), url(https://fonts.gstatic.com/s/poppins/v5/yQWaOD4iNU5NTY0apN-qj_k_vArhqVIZ0nv9q090hN8.woff2) format(\"woff2\");\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215; }\n/* latin-ext */\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: local(\"Poppins SemiBold\"), local(\"Poppins-SemiBold\"), url(https://fonts.gstatic.com/s/poppins/v5/9VWMTeb5jtXkNoTv949NpSEAvth_LlrfE80CYdSH47w.woff2) format(\"woff2\");\n  unicode-range: U+0100-024F, U+1E00-1EFF, U+20A0-20AB, U+20AD-20CF, U+2C60-2C7F, U+A720-A7FF; }\n/* latin */\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: local(\"Poppins SemiBold\"), local(\"Poppins-SemiBold\"), url(https://fonts.gstatic.com/s/poppins/v5/zO07Oxe3SOlw0l2YX2sdIfk_vArhqVIZ0nv9q090hN8.woff2) format(\"woff2\");\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215; }\n[hidden] {\n  display: none !important; }\n.sr-only {\n  position: absolute;\n  margin: -1px;\n  border: 0;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  -webkit-clip-path: polygon(0 0, 0 0, 0 0);\n          clip-path: polygon(0 0, 0 0, 0 0);\n  padding: 0;\n  white-space: nowrap; }\n/**\nSources\n    - https://cloudfour.com/thinks/see-no-evil-hidden-content-and-accessibility/\n    - https://github.com/ampproject/amphtml/blob/master/css/amp.css\n */\nbody::before {\n  display: none;\n  content: 'tablet-portrait'; }\n@media screen and (min-width: 769px) {\n    body::before {\n      content: 'tablet-landscape'; } }\n@media screen and (min-width: 1025px) {\n    body::before {\n      content: 'laptop'; } }\n@media screen and (min-width: 1074px) {\n    body::before {\n      content: 'laptop extendedLaptop'; } }\n.flex-grid {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n.flex-grid--split {\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start; }\n.flex-grid--occupy > * {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    margin-right: 16px;\n    margin-right: 1rem; }\n.flex-grid--occupy > *:last-child {\n      margin-right: 0; }\n.text-ellipsis {\n  display: block;\n  max-width: 100%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden; }\nbody {\n  margin: 0;\n  background-color: #eef2f5;\n  font-family: Poppins, sans-serif;\n  font-weight: 400 !important;\n  color: #000; }\n.application {\n  background-color: #eef2f5;\n  min-height: 100vh; }\n.version-number {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  z-index: 10;\n  color: #aaa;\n  font-size: 9px; }\n", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "vXyf":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/bfec151e11d8a715fc38f4b3c4755a71.svg";

/***/ }),

/***/ "viEY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _basicResources = __webpack_require__("iV3T");

var _basicResources2 = _interopRequireDefault(_basicResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should generally call its initialise() method, to set
// up the environment and create all of the resources the application will use.

// In some (hopefully, rare) situations, it may be required that the environment is provided
// from a parent application. In these situations, call createResources(parentEnv) directly,
// and pass it the Resources.env object that is the environment required.
var Resources = function () {
    function Resources() {
        _classCallCheck(this, Resources);
    }

    _createClass(Resources, null, [{
        key: 'createResources',

        // createResources() should create a static field for each resource:
        //
        //    const env = parentEnv || Resources.env;
        //
        //    Resources.colours = env.resource('Colours')
        //                           .baseUrl('@AvatarAdminBaseUrl')
        //                           .service('colours');
        //
        //
        // Application code can then access those resources like so:
        //
        //    const allColours = Resource.colours.get().send();

        value: function createResources(parentEnv) {
            var _this = this;

            if (parentEnv) {
                Resources.env = parentEnv;
            }

            // TODO: 5. ADD STATIC PROPERTIES FOR EACH OF YOUR RESOURCES
            //
            // You should replace this placeholder resource with the ones you
            // actually need in your application.
            var env = Resources.env;

            // List down all the base urls applicable for the application
            var SIGN_IN_CARDS_BASE_URL = '@SignInCardGatewayEndpoint';
            // new gateway endpoint
            var STUDENT_MANAGER_BASE_URL = '@StudentManagerGatewayEndpoint';

            // Classes
            Resources.getTeacherClasses = env.resource('getTeacherClasses').baseUrl(STUDENT_MANAGER_BASE_URL).service('classrooms/products/{productId}');

            Resources.editClassName = env.resource('editClassName').baseUrl(STUDENT_MANAGER_BASE_URL).service('classrooms/{classroomId}');

            // Groups
            Resources.addNewGroup = env.resource('addNewGroup').baseUrl(STUDENT_MANAGER_BASE_URL).service('classrooms/{classroomId}/groups');

            Resources.editGroupCourses = env.resource('editGroupCourses').baseUrl(STUDENT_MANAGER_BASE_URL).service('{classroomId}/groups/{groupId}');

            Resources.deleteGroup = env.resource('deleteGroup').baseUrl(STUDENT_MANAGER_BASE_URL).service('{classroomId}/groups/{groupId}');

            Resources.classroomGroups = env.resource('classroomGroups').baseUrl(STUDENT_MANAGER_BASE_URL).service('classrooms/{classId}/products/{productId}/groups/{groupId}');

            // Courses
            Resources.getDefaultCourse = env.resource('getDefaultCourse').baseUrl(STUDENT_MANAGER_BASE_URL).service('/classrooms/{classId}/products/{productId}/groups/default-data');

            Resources.getCourseYears = env.resource('getCourseYears').baseUrl(STUDENT_MANAGER_BASE_URL).service('yearGroups');

            Resources.getCourses = env.resource('getCourses').baseUrl(STUDENT_MANAGER_BASE_URL).service('courses');

            Resources.getSchoolCourses = env.resource('getSchoolCourses').baseUrl(STUDENT_MANAGER_BASE_URL).service('courses/schoolCourses');

            // Sign In Cards
            Resources.downloadStudentSignInCards = env.resource('downloadStudentSignInCards').baseUrl(SIGN_IN_CARDS_BASE_URL).service('api/v1/products/{productId}/studentSignInCards');

            Resources.getDownloadStudentSignInCards = env.resource('getDownloadStudentSignInCards').baseUrl(SIGN_IN_CARDS_BASE_URL).service('api/v1/products/{productId}/studentSignInCards/{downloadKey}');

            // CTA Tools actions
            Resources.exportStudents = env.resource('exportStudents').baseUrl(STUDENT_MANAGER_BASE_URL).service('students/classrooms/{currentClassId}/products/{productId}/csv?AuthToken={authToken}');

            // Students
            Resources.changePassword = env.resource('changePassword').baseUrl(STUDENT_MANAGER_BASE_URL).service('students/changePassword');

            Resources.getConfigurationItem = function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(key) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    return _context.abrupt('return', env.getConfigurationItem(key));

                                case 1:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }();

            Resources.getStudentMoveCopyData = env.resource('getStudentMoveCopyData').baseUrl(STUDENT_MANAGER_BASE_URL).service('classrooms/school-classrooms/products/{productId}');

            Resources.getStudentManagementData = env.resource('getStudentManagementData').baseUrl(STUDENT_MANAGER_BASE_URL).service('schools/products/{productId}/schoolInfo');

            Resources.getAddStudentClasses = env.resource('getAddStudentClasses').baseUrl(STUDENT_MANAGER_BASE_URL).service('classrooms/{classId}/products/{productId}');

            Resources.assignClassStudent = env.resource('assignClassStudent').baseUrl(STUDENT_MANAGER_BASE_URL).service('students/assign');

            Resources.assignGroup = env.resource('assignGroup').baseUrl(STUDENT_MANAGER_BASE_URL).service('students/classrooms/{classId}/groups/{groupId}');

            Resources.createMultiYearGroups = env.resource('createMultiYearGroups').baseUrl(STUDENT_MANAGER_BASE_URL).service('classrooms/{classId}/multi-year-groups');
        }

        // Initialise the environment and resources, based on the provided
        // environment name.  We return the environment so the caller has
        // access to everything, in particular the authToken if one was
        // passed in the query parameters.

    }, {
        key: 'initialise',
        value: function initialise(envName, credentials) {
            Resources.env = _basicResources2.default.initialise(envName, credentials);

            Resources.createResources();

            return Resources.env;
        }
    }]);

    return Resources;
}();

exports.default = Resources;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "wBpP":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/fde216094f79affbf8b7bdee777a36ff.svg";

/***/ }),

/***/ "wo/1":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("MG2x");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "wyHS":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("yGwj");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 5; }\n  .container .toast {\n    padding: 32px;\n    z-index: 4;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    position: absolute;\n    width: 100%;\n    max-width: -webkit-fit-content;\n    max-width: -moz-fit-content;\n    max-width: fit-content;\n    top: 50px;\n    height: 64px;\n    border-radius: 12px;\n    border: 2px solid white;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    -webkit-animation-name: toastAnimation;\n            animation-name: toastAnimation;\n    -webkit-animation-duration: 1s;\n            animation-duration: 1s; }\n  .container .toast .message {\n      margin: 0 12px;\n      font-size: 18px;\n      font-weight: 400;\n      line-height: 140%;\n      color: #430006; }\n  .container .toast .close {\n      cursor: pointer; }\n  .container .success {\n    background-color: #9be49d; }\n  .container .error {\n    background-color: #f0939b; }\n  @-webkit-keyframes toastAnimation {\n  from {\n    top: -100px; }\n  to {\n    top: 50px; } }\n  @keyframes toastAnimation {\n  from {\n    top: -100px; }\n  to {\n    top: 50px; } }\n", ""]);
// Exports
exports.locals = {
	"container": "container",
	"toast": "toast",
	"toastAnimation": "toastAnimation",
	"message": "message",
	"close": "close",
	"success": "success",
	"error": "error"
};
module.exports = exports;


/***/ }),

/***/ "x2Ia":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Styles


// Components


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react3 = __webpack_require__("QruM");

var _linguiCdn = __webpack_require__("siuH");

__webpack_require__("mkq6");

var _selectLabel = __webpack_require__("4H+z");

var _selectLabel2 = _interopRequireDefault(_selectLabel);

var _genericModal = __webpack_require__("51N/");

var _genericModal2 = _interopRequireDefault(_genericModal);

var _editClass = __webpack_require__("5eev");

var _editClass2 = _interopRequireDefault(_editClass);

var _button = __webpack_require__("VrhF");

var _button2 = _interopRequireDefault(_button);

var _threeEssentailsButton = __webpack_require__("Lgqb");

var _threeEssentailsButton2 = _interopRequireDefault(_threeEssentailsButton);

var _useIsOneRosterActivatedSchool = __webpack_require__("rSj7");

var _useIsOneRosterActivatedSchool2 = _interopRequireDefault(_useIsOneRosterActivatedSchool);

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function Classes(_ref) {
    var _this = this;

    var classes = _ref.classes,
        productId = _ref.productId,
        currentClassName = _ref.currentClassName,
        currentClassId = _ref.currentClassId,
        updateCurrentClassId = _ref.updateCurrentClassId,
        editClassName = _ref.editClassName,
        setIsMinimised = _ref.setIsMinimised,
        externalClassroomId = _ref.externalClassroomId,
        isSisSchool = _ref.isSisSchool;

    var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
        i18n = _useLocalisation.i18n;

    var isOneRosterActivatedSchool = (0, _useIsOneRosterActivatedSchool2.default)();
    // States

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isSelectDropdownDisabled = _useState2[0],
        setIsSelectDropdownDisabled = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        showModal = _useState4[0],
        setShowModal = _useState4[1];

    // Handlers


    var classDropdownOnChangeHandler = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
            var classId;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            classId = parseInt(e.target.value, 10);
                            _context.next = 3;
                            return setIsSelectDropdownDisabled(true);

                        case 3:
                            _context.next = 5;
                            return updateCurrentClassId({ productId: productId, classId: classId });

                        case 5:
                            _context.next = 7;
                            return setIsSelectDropdownDisabled(false);

                        case 7:
                            setIsMinimised(false);

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function classDropdownOnChangeHandler(_x) {
            return _ref2.apply(this, arguments);
        };
    }();
    var showEditModal = function showEditModal() {
        setShowModal(!showModal);
    };

    var onOneRosterEditHandler = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _resources2.default.getConfigurationItem('THREE_ESSENTIALS_MANAGE_CLASSES').then(function (manageClassesUrl) {
                                window.open(manageClassesUrl + 'uid/' + externalClassroomId + '/edit');
                            });

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function onOneRosterEditHandler() {
            return _ref3.apply(this, arguments);
        };
    }();

    var getEditClassModal = function getEditClassModal() {
        if (showModal) {
            return _react2.default.createElement(
                _genericModal2.default,
                {
                    title: _react2.default.createElement(_react3.Trans, { id: 'Class Dropdown - edit title' }),
                    closeHandler: showEditModal },
                _react2.default.createElement(_editClass2.default, {
                    currentClassName: currentClassName,
                    currentClassId: currentClassId,
                    editClassName: editClassName,
                    closeHandler: showEditModal
                })
            );
        }
        return null;
    };

    var getThreeEssentailsButton = function getThreeEssentailsButton() {
        if (isSisSchool !== false) return null;

        if (isOneRosterActivatedSchool) {
            return _react2.default.createElement(_threeEssentailsButton2.default, {
                clickHandler: onOneRosterEditHandler,
                title: _react2.default.createElement(_react3.Trans, { id: 'Class Dropdown - edit title' }),
                show3EIcon: false,
                buttonClassName: 'edit_class_name'
            });
        }
        return _react2.default.createElement(_button2.default, {
            buttonStyle: _button.BUTTON_STYLES.iconSVG,
            importedClasses: 'button--classes',
            iconName: 'edit',
            callback: showEditModal,
            ariaProps: {
                'aria-label': i18n._( /*i18n*/{
                    id: 'Class Dropdown - edit title'
                })
            }
        });
    };

    var hasClasses = classes && classes.length > 0;

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_selectLabel2.default, {
            propertyName: 'classId',
            value: currentClassId,
            isSelectDisabled: isSelectDropdownDisabled,
            selectHandler: classDropdownOnChangeHandler,
            listOfOptions: classes,
            id: 'consoleClassSelector',
            importedClasses: 'select--classes'
        }),
        hasClasses ? _react2.default.createElement(
            'div',
            { className: 'classes__button-container' },
            getThreeEssentailsButton(),
            getEditClassModal()
        ) : null
    );
}

Classes.propTypes = {
    classes: _propTypes2.default.array,
    productId: _propTypes2.default.string,
    currentClassName: _propTypes2.default.string,
    currentClassId: _propTypes2.default.number,
    editClassName: _propTypes2.default.func,
    updateCurrentClassId: _propTypes2.default.func,
    setIsMinimised: _propTypes2.default.func,
    externalClassroomId: _propTypes2.default.string,
    isSisSchool: _propTypes2.default.bool
};

exports.default = Classes;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "x4K0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _reactRouterDom = __webpack_require__("KXFW");

var _react3 = __webpack_require__("QruM");

var _pCssTemplates = __webpack_require__("PvMP");

var _pCssTemplates2 = _interopRequireDefault(_pCssTemplates);

var _errorHandling = __webpack_require__("FLtZ");

var _errorHandling2 = _interopRequireDefault(_errorHandling);

var _utils = __webpack_require__("6QRH");

__webpack_require__("nIya");

var _basicApp = __webpack_require__("SgkA");

var _basicApp2 = _interopRequireDefault(_basicApp);

var _console = __webpack_require__("M8vz");

var _console2 = _interopRequireDefault(_console);

var _busyIndicator = __webpack_require__("Z9nB");

var _busyIndicator2 = _interopRequireDefault(_busyIndicator);

var _enums = __webpack_require__("royT");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */

// Containers


// catalog imports


var EntryApp = function (_BasicApp) {
    _inherits(EntryApp, _BasicApp);

    function EntryApp() {
        _classCallCheck(this, EntryApp);

        return _possibleConstructorReturn(this, (EntryApp.__proto__ || Object.getPrototypeOf(EntryApp)).apply(this, arguments));
    }

    _createClass(EntryApp, [{
        key: 'render',
        value: function render(store, i18n) {
            // TODO: 4. DEFINE THE TOP-LEVEL ROUTES FOR YOUR APPLICATION'S COMPONENTS HERE

            // When executing on demo, QA, or production, the host app will inject a property
            // called pppAppConfig into the global window variable.  This will provide the
            // base name of the app.  Most of the time that will be an empty string, but in
            // case it is not, we will extract it and pass it to the router, below.
            // eslint-disable-next-line no-underscore-dangle
            var appConfig = window._env_;
            var productId = (0, _utils.getParam)('productId') || _enums.DEFAULT_PRODUCT_ID;

            var pppAppConfig = (0, _utils.getProductById)(appConfig, productId);
            _pCssTemplates2.default.loadCssPath(pppAppConfig.ThemeCssUrl);

            var BASE_NAME = appConfig ? appConfig.BaseName : '';

            // Add an interceptor to handle errors when accessing resources
            _errorHandling2.default.addResourceResponseErrorInterceptor(store.dispatch);

            // NOTE: We have used a "render" attribute, rather than "component" to specify what
            //       should be rendered.  This allows us to pass options to the component. You
            //       can obviously simplify things if your components don't need any.

            return _react2.default.createElement(
                _react3.I18nProvider,
                { i18n: i18n },
                _react2.default.createElement(
                    _reactRedux.Provider,
                    { store: store },
                    _react2.default.createElement(
                        _reactRouterDom.BrowserRouter,
                        { history: _reactRouterDom.browserHistory, basename: BASE_NAME },
                        _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            _react2.default.createElement(_reactRouterDom.Route, {
                                exact: true,
                                path: '/',
                                render: function render() {
                                    return _react2.default.createElement(_console2.default, null);
                                } }),
                            _react2.default.createElement(_busyIndicator2.default, null)
                        )
                    )
                )
            );
        }
    }]);

    return EntryApp;
}(_basicApp2.default);

exports.default = EntryApp;


window.EntryApp = EntryApp;

/***/ }),

/***/ "xEM8":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/cba5dfffeff72f0804c9a112c811517b.svg";

/***/ }),

/***/ "xW01":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("7vkv");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "y9tH":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("bQC/");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "yG5+":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/a0e217ad4d6373bd441936e6737d2909.svg";

/***/ }),

/***/ "zDW0":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/4c1f7a71fb6bce7b923771e001fe40fd.svg";

/***/ }),

/***/ "zZcj":
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__("2KPK");
            var content = __webpack_require__("8QCl");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};

/***/ })

},[1]);


// WEBPACK FOOTER //
// entry-app.b9cad335d17def342831.js